/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface BizPpurioHistoryControllerFindBizPpurioHistoryResponse {
  code: number;
  data: {
    list: {
      _id: string;
      requestType?: string;
      hospital?: {
        _id?: string | null;
        name?: string | null;
        shortName?: string | null;
        businessName?: string | null;
        smsPhone?: string | null;
      };
      hservice?: {
        _id?: string | null;
        name?: string | null;
        phone?: string | null;
      };
      reservationID?: string | null;
      automationReservedMessageId?: string | null;
      originalContent?: string | null;
      replacedContent?: string | null;
      temp_refkey?: string | null;
      rq_account?: string | null;
      rq_type?: string | null;
      rq_from?: string | null;
      rq_to?: string | null;
      rq_content?: any;
      rq_country?: string | null;
      rq_templatecode?: string | null;
      drs_code?: string | null;
      drs_description?: string | null;
      drs_messagekey?: string | null;
      drs_refkey?: string | null;
      rs_device?: string | null;
      rs_cmsgid?: string | null;
      rs_msgid?: string | null;
      rs_media?: string | null;
      rs_phone?: string | null;
      rs_to_name?: string | null;
      rs_unixtime?: string | null;
      rs_result?: string | null;
      rs_userdata?: string | null;
      rs_wapinfo?: string | null;
      rs_telres?: string | null;
      rs_teltime?: string | null;
      rs_kaores?: string | null;
      rs_kaotime?: string | null;
      rs_rcsres?: string | null;
      rs_rcstime?: string | null;
      rs_retry_flag?: string | null;
      rs_resend_flag?: string | null;
      rs_refkey?: string | null;
      success?: boolean | null;
      failReason?: string | null;
      retrySuccess?: boolean | null;
      retryFailReason?: string | null;
      createdAt?: string;
      updatedAt?: string | null;
      completedAt?: string | null;
      isTC?: boolean | null;
    }[];
    countPerPage: number;
    currentPage: number;
    totalPages: number;
    totalCount: number;
  };
  message: string;
}

export interface KakaoTemplateTransferControllerRunBatchBodyRequest {
  /**
   * @min 0
   * @exclusiveMin true
   */
  limit?: number;
  /** @min 0 */
  updatedAtInterval?: number | null;
}

export interface KakaoTemplateTransferControllerRunBatchResponse {
  code: number;
  data: {
    skipped?: boolean;
    reason?: string | null;
    processed?: number;
    swapped?: number;
    rejected?: number;
    stillInspecting?: number;
    errored?: number;
    skippedCount?: number;
    hospitals?: number;
  };
  message: string;
}

export interface KakaoTemplateTransferControllerSkipTemplateBodyRequest {
  /** SKIPPED 로 전환할 신규 템플릿 코드 */
  newTemplateCode: string;
  /** skip 사유 (자연어) */
  skipReason: string;
}

export interface KakaoTemplateTransferControllerSkipTemplateResponse {
  code: number;
  data: {
    /** 갱신된 transfer 레코드 수 */
    updated: number;
  };
  message: string;
}

export interface KakaoTemplateTransferControllerRefreshTemplateStatusBodyRequest {
  /** 상태를 재동기화할 신규 템플릿 코드 */
  newTemplateCode: string;
}

export interface KakaoTemplateTransferControllerRefreshTemplateStatusResponse {
  code: number;
  data: {
    /** 갱신된 transfer 레코드 수 */
    updated: number;
  };
  message: string;
}

export interface KakaoTemplateTransferControllerFindHospitalsResponse {
  code: number;
  data: {
    list: {
      hospitalID: string;
      name?: string | null;
      shortName?: string | null;
      searchableChannelIds: string[];
      groups: {
        groupKey: string;
        name: string;
      }[];
      groupTransferStatus: string;
      totalTargetCount: number;
      inspectingCount: number;
      rejectedCount: number;
      swappedCount: number;
      skippedCount: number;
      failedCount: number;
      startedAt?: string | null;
      swappedAt?: string | null;
    }[];
    totalCount: number;
    limit: number;
    offset: number;
  };
  message: string;
}

export interface KakaoTemplateTransferControllerFindTemplatesResponse {
  code: number;
  data: {
    list: any[];
    totalCount: number;
    limit: number;
    offset: number;
  };
  message: string;
}

export interface AdminAutomationHospitalControllerFindWithKakaoTemplateStatusResponse {
  code: number;
  data: {
    /** 필터 적용 후 전체 자동화 수 (페이지네이션 무관) */
    total: number;
    /** 현재 페이지 (1부터 시작. limit 미지정/0이면 항상 1) */
    page: number;
    /** 전체 페이지 수 (limit 미지정/0이면 1, 결과 없으면 0) */
    totalPages: number;
    items: {
      /** Algorithms ID */
      _id: string;
      /** 병원 ID */
      hospitalID?: string | null;
      /** 병원 이름 */
      hospitalName?: string | null;
      /** 병원 짧은 이름 */
      hospitalShortName?: string | null;
      /** 알고리즘 이름 */
      name: string;
      memo?: string | null;
      /** 자동화 유형 */
      type: string;
      isActive?: boolean | null;
      targetTreatmentTags: {
        _id: string;
        categoryName?: string | null;
      }[];
      appliedNationalities: {
        _id: string;
        koreanCountryName?: string | null;
        englishCountryName?: string | null;
      }[];
      messages: {
        /** Algorithm_Message ID */
        _id: string;
        /** 메시지 이름 */
        name: string;
        sendingType?: string | null;
        contentType?: string | null;
        /** 메시지 본문 */
        content?: {
          text?: string | null;
          image?: string | null;
          video?: string | null;
          workoutVideo?: string | null;
          homecareContent?: string | null;
          event?: string | null;
          survey?: {
            question?: string | null;
            answers?: string[] | null;
          };
        };
        daysAfter?: number | null;
        timeOfDay?: string | null;
        showConsultationGuide?: boolean | null;
        consultationGuide?: string | null;
        /** 연결된 카카오 템플릿. 알림톡 미연동 메시지는 없음 */
        kakaoTemplateHistory?: {
          /** Kakao_Template_History ID */
          _id: string;
          templateCode?: string | null;
          templateName?: string | null;
          /** 발신 프로필/그룹 키 */
          senderKey?: string | null;
          /** 발신 키 타입 (S/G). 원본에 없으면 isGroupTemplate 로 파생 */
          senderKeyType?: string | null;
          serviceStatus?: string | null;
          inspectionStatus?: string | null;
          templateStatus?: string | null;
          isGroupTemplate?: boolean | null;
        };
      }[];
      kakaoTemplateStatusCount: {
        REG: number;
        REQ: number;
        REJ: number;
        STP: number;
        RDY: number;
        ACT: number;
        DMT: number;
        BLK: number;
        /** serviceStatus 가 비어있는(미동기) 템플릿 수 */
        UNKNOWN: number;
      };
      createdAt?: string | null;
      updatedAt?: string | null;
    }[];
  };
  message: string;
}

export interface AdminAutomationHospitalControllerCreateWithKakaoTemplateBodyRequest {
  /**
   * 병원 ID
   * @minLength 1
   */
  hospitalID: string;
  /**
   * 알고리즘 이름
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  /** 알고리즘 메모 */
  memo?: string | null;
  /** 활성화 여부 (기본 true) */
  isActive?: boolean | null;
  /**
   * 적용할 치료태그 이름 목록 (필수, 병원 내 치료태그명과 일치해야 함)
   * @minItems 1
   */
  targetTreatmentTagNames: string[];
  /** 적용할 국가 코드 목록 (ISO Alpha-2/Alpha-3, 예: KR/KOR). 미지정 시 전체 적용 */
  appliedNationalityCodes?: string[] | null;
  /** 카카오 템플릿 카테고리 코드. 미지정 시 '999999'(기타) */
  categoryCode?: string | null;
  /**
   * 메시지 목록 (최대 20개)
   * @maxItems 20
   * @minItems 1
   */
  messages: {
    /**
     * 메시지 이름
     * @minLength 1
     * @maxLength 50
     */
    name: string;
    /**
     * 메시지 내용 (애프터닥 변수 스타일 {{변수}} 사용)
     * @minLength 1
     * @maxLength 1000
     */
    text: string;
    /**
     * 발송 기준 경과일
     * @min 0
     */
    daysAfter: number;
    /**
     * 발송 시각 (HH:mm, zero-pad 필수. 발송 배치가 문자열 완전 일치로 매칭)
     * @pattern ^([01]\d|2[0-3]):[0-5]\d$
     */
    timeOfDay: string;
  }[];
}

export interface AdminAutomationHospitalControllerCreateWithKakaoTemplateResponse {
  code: number;
  data: {
    /** 생성된 Algorithms ID */
    algorithmId: string;
    /** 알고리즘 이름 */
    algorithmName: string;
    /** 병원 ID */
    hospitalID: string;
    kakaoLinkage: {
      /** 카카오 알림톡 연동 여부 */
      linked: boolean;
      /** 템플릿 등록을 건너뛴 사유 */
      skipReason?: string;
    };
    messages: {
      /** 생성된 Algorithm_Message ID */
      messageId: string;
      /** 메시지 이름 */
      name: string;
      /** 카카오 템플릿 등록 결과 */
      templateStatus: "REGISTERED" | "SKIPPED_NOT_LINKED" | "FAILED";
      /** 등록된 카카오 템플릿 코드 */
      templateCode?: string;
      /** 등록된 카카오 템플릿 이름 */
      templateName?: string;
      /** 템플릿 등록 실패 사유 */
      failReason?: string;
    }[];
  };
  message: string;
}

export interface AdminChatChannelLinkageControllerFindResponse {
  code: number;
  data: {
    hospitalID: string;
    hospitalName: string;
    channels: {
      /** 카카오 상담톡 */
      kakaoConsult: {
        /** ServiceSetting 기준 연동 허용 여부 */
        enabled: boolean;
        accounts: {
          /** 채널 계정 식별자 (상담톡 pf_id / 위챗·왓츠앱·라인 channelID / 톡톡 businessCenterID / 인스타 loginID) */
          accountID: string;
          /** 사람이 읽는 이름. 없으면 accountID 와 같은 값 */
          accountName: string;
          /** 연동 유지 여부. 채널별 해제 플래그의 역 */
          isLinked: boolean;
        }[];
      };
      /** 위챗 */
      wechat: {
        /** ServiceSetting 기준 연동 허용 여부 */
        enabled: boolean;
        accounts: {
          /** 채널 계정 식별자 (상담톡 pf_id / 위챗·왓츠앱·라인 channelID / 톡톡 businessCenterID / 인스타 loginID) */
          accountID: string;
          /** 사람이 읽는 이름. 없으면 accountID 와 같은 값 */
          accountName: string;
          /** 연동 유지 여부. 채널별 해제 플래그의 역 */
          isLinked: boolean;
        }[];
      };
      /** 네이버 톡톡 */
      talktalk: {
        /** ServiceSetting 기준 연동 허용 여부 */
        enabled: boolean;
        accounts: {
          /** 채널 계정 식별자 (상담톡 pf_id / 위챗·왓츠앱·라인 channelID / 톡톡 businessCenterID / 인스타 loginID) */
          accountID: string;
          /** 사람이 읽는 이름. 없으면 accountID 와 같은 값 */
          accountName: string;
          /** 연동 유지 여부. 채널별 해제 플래그의 역 */
          isLinked: boolean;
        }[];
      };
      /** 라인 */
      line: {
        /** ServiceSetting 기준 연동 허용 여부 */
        enabled: boolean;
        accounts: {
          /** 채널 계정 식별자 (상담톡 pf_id / 위챗·왓츠앱·라인 channelID / 톡톡 businessCenterID / 인스타 loginID) */
          accountID: string;
          /** 사람이 읽는 이름. 없으면 accountID 와 같은 값 */
          accountName: string;
          /** 연동 유지 여부. 채널별 해제 플래그의 역 */
          isLinked: boolean;
        }[];
      };
      /** 인스타그램 */
      instagram: {
        /** ServiceSetting 기준 연동 허용 여부 */
        enabled: boolean;
        accounts: {
          /** 채널 계정 식별자 (상담톡 pf_id / 위챗·왓츠앱·라인 channelID / 톡톡 businessCenterID / 인스타 loginID) */
          accountID: string;
          /** 사람이 읽는 이름. 없으면 accountID 와 같은 값 */
          accountName: string;
          /** 연동 유지 여부. 채널별 해제 플래그의 역 */
          isLinked: boolean;
        }[];
      };
      /** 왓츠앱 */
      whatsapp: {
        /** ServiceSetting 기준 연동 허용 여부 */
        enabled: boolean;
        accounts: {
          /** 채널 계정 식별자 (상담톡 pf_id / 위챗·왓츠앱·라인 channelID / 톡톡 businessCenterID / 인스타 loginID) */
          accountID: string;
          /** 사람이 읽는 이름. 없으면 accountID 와 같은 값 */
          accountName: string;
          /** 연동 유지 여부. 채널별 해제 플래그의 역 */
          isLinked: boolean;
        }[];
      };
    };
  }[];
  message: string;
}

export interface AdminChatChannelLinkageControllerCountResponse {
  code: number;
  /** 검색 조건에 해당하는 총 병원 수 */
  data: number;
  message: string;
}

export interface AdminKakaoControllerFindLinkageInfoResponse {
  code: number;
  data: {
    enabled: boolean;
    totalPatientCount: number;
    targetPatientCount: number;
    linkage?: {
      _id: string;
      channelID: string;
      channelName: string;
      status: "NOT_APPROVED" | "IN_REQUEST" | "APPROVED";
      unsubscriptionNumber?: string;
    };
  };
  message: string;
}

export interface AdminKakaoControllerUpdateLinkageInfoBodyRequest {
  hospitalID: string;
  enabled: boolean;
}

export interface AdminKakaoControllerApproveBrandMessageLinkageBodyRequest {
  hospitalID: string;
  enabled: boolean;
}

export interface AdminWechatControllerFindLinkageInfoResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    enabled: boolean;
    maxCount: number;
    linkages: {
      _id: string;
      channelID: string;
      channelName: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminWechatControllerUpdateLinkageInfoBodyRequest {
  hospitalID: string;
  enabled: boolean;
  /** @min 1 */
  maxCount: number;
  unlinkIDs: string[];
  reason?: string;
  userName?: string;
}

export interface AdminWhatsappControllerFindLinkageInfoResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    enabled: boolean;
    maxCount: number;
    linkages: {
      _id: string;
      channelID: string;
      channelName: string;
      displayPhoneNumber: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminWhatsappControllerUpdateLinkageInfoBodyRequest {
  hospitalID: string;
  enabled: boolean;
  /** @min 1 */
  maxCount: number;
  unlinkIDs: string[];
  reason?: string;
  userName?: string;
}

export interface AdminWhatsappControllerFindSetupUpdateHistoryResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hospitalID: string;
    userID: string;
    userName: string;
    count: number;
    reason: string;
    createdAt: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminLineControllerUpdateLinkageInfoBodyRequest {
  hospitalID: string;
  isApproved: boolean;
  /** @min 1 */
  maxChannelCount?: number;
  reason?: string;
  userID?: string;
  userName?: string;
  unlinkedTargetID: string[];
}

export interface AdminLineControllerUpdateLinkageInfoResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hospitalID: string;
    requesterName: string;
    requesterPhone: string;
    isApproved: boolean;
    maxChannelCount: number;
    reason?: string;
    linkedTargetIDs: string[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LineLinkageAccountsStatesHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hospitalID?: string;
    requesterName?: string;
    requesterPhone?: string;
    isRequested?: boolean;
    maxChannelCount?: number;
    isApproved?: boolean;
    lineConsultMaps: {
      _id?: string;
      lineChannelName?: string;
      lineChannelAccessToken?: string;
      lineUserID?: string;
      lineBotID?: string;
      linePremiumBotID?: string;
      isRemoved?: boolean;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminBrandMessagePointControllerGetBrandMessagePointListResponse {
  code: number;
  data: {
    list: {
      _id: string;
      writerID?: string;
      type:
        | "ADD_ADMIN"
        | "REMOVE_ADMIN"
        | "ADD_ORDER"
        | "REFUND_ORDER"
        | "USE_ALGORITHM"
        | "USE_ALGORITHM_MODIFY"
        | "REFUND_ALGORITHM"
        | "REFUND_MESSAGE_FAILED"
        | "REFUND_ALGORITHM_MODIFY"
        | "USE_AUTOMATION_BRAND_MESSAGE";
      /** 구분 */
      typeString?: string | null;
      /** 상태 */
      status?:
        | "pending"
        | "paid"
        | "ready"
        | "failed"
        | "cancelled"
        | "partialCancelled"
        | "expired"
        | "revoked"
        | null;
      /** 상태 */
      statusString?: string | null;
      isIncrement: boolean;
      point: number;
      balancedPoint: number;
      baseCredit?: number | null;
      bonusCredit?: number | null;
      amount?: number | null;
      orderID?: string | null;
      /** 결제 완료 시간 */
      paidAt?: string | null;
      /** 결제 실패 시간 */
      failedAt?: string | null;
      /** 취소 시간 */
      cancelledAt?: string | null;
      /** 등록자 */
      writerName?: string | null;
      /** 용도 / 결제수단 */
      reason?: string | null;
      algorithmId?: string | null;
      messageIds?: string[] | null;
      description?: string | null;
      credit?: number | null;
      balancedCredit?: number | null;
      hospitalID: string;
      hospitalName: string;
      createdAt: string;
      updatedAt?: string;
      kakaoChannelLinkageIDs?: string[];
    }[];
    totalCount: number;
    limit: number;
    offset: number;
  };
  message: string;
}

export interface AdminBrandMessagePointControllerGetBrandMessagePriceResponse {
  code: number;
  data: {
    price: number;
    vat: number;
    chargePerContent: {
      text?: number;
      image?: number;
      wideImage?: number;
      carouselFeeds?: number;
    };
  };
  message: string;
}

export interface AdminBrandMessagePointControllerGetBrandMessagePointDetailResponse {
  code: number;
  data: {
    _id: string;
    writerID?: string;
    type:
      | "ADD_ADMIN"
      | "REMOVE_ADMIN"
      | "ADD_ORDER"
      | "REFUND_ORDER"
      | "USE_ALGORITHM"
      | "USE_ALGORITHM_MODIFY"
      | "REFUND_ALGORITHM"
      | "REFUND_MESSAGE_FAILED"
      | "REFUND_ALGORITHM_MODIFY"
      | "USE_AUTOMATION_BRAND_MESSAGE";
    /** 구분 */
    typeString?: string | null;
    /** 상태 */
    status?: "pending" | "paid" | "ready" | "failed" | "cancelled" | "partialCancelled" | "expired" | "revoked" | null;
    /** 상태 */
    statusString?: string | null;
    isIncrement: boolean;
    point: number;
    balancedPoint: number;
    baseCredit?: number | null;
    bonusCredit?: number | null;
    amount?: number | null;
    orderID?: string | null;
    /** 결제 완료 시간 */
    paidAt?: string | null;
    /** 결제 실패 시간 */
    failedAt?: string | null;
    /** 취소 시간 */
    cancelledAt?: string | null;
    /** 등록자 */
    writerName?: string | null;
    /** 용도 / 결제수단 */
    reason?: string | null;
    algorithmId?: string | null;
    messageIds?: string[] | null;
    description?: string | null;
    credit?: number | null;
    balancedCredit?: number | null;
    hospitalID: string;
    hospitalName: string;
    createdAt: string;
    updatedAt?: string;
    kakaoChannelLinkageIDs?: string[];
  };
  message: string;
}

export interface AdminBrandMessagePointControllerGetHospitalPointResponse {
  code: number;
  data: {
    _id: string;
    hospitalID: string;
    hospitalName: string;
    credit: number;
    createdAt: string;
    updatedAt: string;
  };
  message: string;
}

export interface AdminBrandMessagePointControllerAddBrandMessagePointResponse {
  code: number;
  data: {
    brandMessagePoint: {
      _id: string;
      point: number;
    };
    history: {
      _id: string;
      type: string;
      point: number;
      balancedPoint: number;
      credit: number;
      balancedCredit: number;
    };
  };
  message: string;
}

export interface AdminBrandMessagePointControllerRemoveBrandMessagePointResponse {
  code: number;
  data: {
    brandMessagePoint: {
      _id: string;
      point: number;
    };
    history: {
      _id: string;
      type: string;
      point: number;
      balancedPoint: number;
      credit: number;
      balancedCredit: number;
    };
  };
  message: string;
}

export interface AdminBrandMessageProductControllerGetProductListResponse {
  code: number;
  data: {
    list: {
      _id: string;
      name: string;
      amount: number;
      bonusRate?: number | null;
      credit: number;
      bonusCredit: number;
      totalCredit: number;
      isActive: boolean;
      writerID?: string | null;
      modifierID?: string | null;
      createdAt: string;
      updatedAt: string;
    }[];
    totalCount: number;
    limit: number;
    offset: number;
  };
  message: string;
}

export interface AdminBrandMessageProductControllerCreateProductResponse {
  code: number;
  data: {
    _id: string;
    name: string;
    amount: number;
    bonusRate?: number | null;
    credit: number;
    bonusCredit: number;
    totalCredit: number;
    isActive: boolean;
    writerID?: string | null;
    modifierID?: string | null;
    createdAt: string;
    updatedAt: string;
  };
  message: string;
}

export interface AdminBrandMessageProductControllerPreviewProductResponse {
  code: number;
  data: {
    credit: number;
    bonusCredit: number;
    totalCredit: number;
    unitPrice: number;
  };
  message: string;
}

export interface AdminBrandMessageProductControllerGetProductDetailResponse {
  code: number;
  data: {
    _id: string;
    name: string;
    amount: number;
    bonusRate?: number | null;
    credit: number;
    bonusCredit: number;
    totalCredit: number;
    isActive: boolean;
    writerID?: string | null;
    modifierID?: string | null;
    createdAt: string;
    updatedAt: string;
  };
  message: string;
}

export interface AdminBrandMessageProductControllerUpdateProductResponse {
  code: number;
  data: {
    _id: string;
    name: string;
    amount: number;
    bonusRate?: number | null;
    credit: number;
    bonusCredit: number;
    totalCredit: number;
    isActive: boolean;
    writerID?: string | null;
    modifierID?: string | null;
    createdAt: string;
    updatedAt: string;
  };
  message: string;
}

export interface AdminBrandMessageProductControllerDeactivateProductResponse {
  code: number;
  data: {
    _id: string;
    name: string;
    amount: number;
    bonusRate?: number | null;
    credit: number;
    bonusCredit: number;
    totalCredit: number;
    isActive: boolean;
    writerID?: string | null;
    modifierID?: string | null;
    createdAt: string;
    updatedAt: string;
  };
  message: string;
}

export interface AdminBrandMessageProductControllerGetProductHistoryResponse {
  code: number;
  data: {
    list: {
      _id: string;
      productID: string;
      snapshot: {
        name: string;
        amount: number;
        bonusRate?: number | null;
        isActive: boolean;
      };
      modifierID: string;
      createdAt: string;
    }[];
  };
  message: string;
}

export interface AdminNicePaymentsCardBenefitControllerGetCardBenefitListResponse {
  code: number;
  data: {
    list: {
      _id: string;
      yearMonth: string;
      content: string;
      writerID?: string | null;
      modifierID?: string | null;
      createdAt: string;
      updatedAt: string;
    }[];
    totalCount: number;
    limit: number;
    offset: number;
  };
  message: string;
}

export interface AdminNicePaymentsCardBenefitControllerCreateCardBenefitResponse {
  code: number;
  data: {
    _id: string;
    yearMonth: string;
    content: string;
    writerID?: string | null;
    modifierID?: string | null;
    createdAt: string;
    updatedAt: string;
  };
  message: string;
}

export interface AdminNicePaymentsCardBenefitControllerGetCardBenefitDetailResponse {
  code: number;
  data: {
    _id: string;
    yearMonth: string;
    content: string;
    writerID?: string | null;
    modifierID?: string | null;
    createdAt: string;
    updatedAt: string;
  };
  message: string;
}

export interface AdminNicePaymentsCardBenefitControllerUpdateCardBenefitResponse {
  code: number;
  data: {
    _id: string;
    yearMonth: string;
    content: string;
    writerID?: string | null;
    modifierID?: string | null;
    createdAt: string;
    updatedAt: string;
  };
  message: string;
}

export interface AdminCallManagerControllerFindCallManagerIncomingPhoneNumbersResponse {
  code: number;
  data: {
    /** 전체 수신 번호 개수 */
    totalCount: number;
    items: {
      /** 매핑 이름 */
      name: string;
      /** AI 콜매니저 회선 번호 */
      aiCallManagerPhoneNumber: {
        /** 국가번호 */
        countryCode: string;
        /** 국가 내 번호 */
        nationalNumber: string;
      };
      /** 매핑된 병원 (다른 환경의 번호인 경우 null) */
      hospital: {
        /** 병원 ID */
        _id: string;
        /** 병원명 */
        name: string;
      } | null;
      /** Twilio webhook URL 기반 환경 (development: 개발, sandbox: 샌드박스, production: 운영, unknown: 확인필요) */
      environment: "development" | "sandbox" | "production" | "unknown";
      /** 매핑 수정일 (매핑 없으면 null) */
      updatedAt: string | null;
    }[];
  };
  message: string;
}

export interface AdminCallManagerControllerFindHospitalPhoneNumberMappingsResponse {
  code: number;
  data: {
    items: {
      /** 병원 전화번호 매핑 ID */
      _id: string;
      /** 이름 */
      name: string;
      /** 병원 대표번호 */
      hospitalMainNumber: {
        /** 국가번호 (+ 접두사) */
        countryCode: string;
        /** 국가 내 번호 (한국이면 0 접두사) */
        nationalNumber: string;
      };
      /** AI 전화번호 */
      aiCallManagerPhoneNumber: {
        /** 국가번호 (+ 접두사) */
        countryCode: string;
        /** 국가 내 번호 (한국이면 0 접두사) */
        nationalNumber: string;
      };
      /** 직원 수신 전화번호 목록 (내선 a,b,c 전체) */
      staffIncomingPhoneNumbers: {
        /** 국가번호 (+ 접두사) */
        countryCode: string;
        /** 국가 내 번호 (한국이면 0 접두사) */
        nationalNumber: string;
      }[];
      /** 알림 수신 담당자 User _id 목록 (string, DB에는 ObjectId로 저장) */
      notificationRecipientIds: string[];
      /** PBX 환경 여부 */
      isPbx?: boolean;
      /** PBX 동시 수용 회선 수 (1 이상) */
      lineCount?: number;
      /** 마지막 수정일시 */
      updatedAt: string | null;
    }[];
  };
  message: string;
}

export interface AdminCallManagerControllerCreateHospitalPhoneNumberMappingBodyRequest {
  /** 병원 ID */
  hospitalId: string;
  /** 별명 */
  name: string;
  hospitalMainNumber: {
    /**
     * 국가번호 (optional, 미입력 시 +82)
     * @default "82"
     */
    countryCode?: string;
    /** 국가 내 번호 (-, 공백 제거됨. 한국이면 0 포함 가능, 저장 시 0 제거) */
    nationalNumber: string;
  };
  aiCallManagerPhoneNumber: {
    /** 국가번호 (82 또는 +82, + 없어도 됨) */
    countryCode: string;
    /** 국가 내 번호 (-, 공백 제거됨) */
    nationalNumber: string;
  };
  /**
   * 직원 수신 전화번호 목록 (내선 1개 이상)
   * @minItems 1
   */
  staffIncomingPhoneNumbers: {
    /** 국가번호 (82 또는 +82, + 없어도 됨) */
    countryCode: string;
    /** 국가 내 번호 (-, 공백 제거됨) */
    nationalNumber: string;
  }[];
  notificationRecipientIds?: string[];
  /** PBX 환경 여부 */
  isPbx?: boolean;
  /**
   * PBX 동시 수용 회선 수 (1 이상)
   * @min 1
   */
  lineCount?: number;
}

export interface AdminCallManagerControllerCreateHospitalPhoneNumberMappingResponse {
  code: number;
  data: {
    /** 병원 전화번호 매핑 ID */
    _id: string;
    /** 이름 */
    name: string;
    hospitalMainNumber: {
      /** 국가번호 (+ 접두사) */
      countryCode: string;
      /** 국가 내 번호 (한국이면 0 접두사) */
      nationalNumber: string;
    };
    aiCallManagerPhoneNumber: {
      /** 국가번호 (+ 접두사) */
      countryCode: string;
      /** 국가 내 번호 (한국이면 0 접두사) */
      nationalNumber: string;
    };
    /** 직원 수신 전화번호 목록 */
    staffIncomingPhoneNumbers: {
      /** 국가번호 (+ 접두사) */
      countryCode: string;
      /** 국가 내 번호 (한국이면 0 접두사) */
      nationalNumber: string;
    }[];
    /** 알림 수신 담당자 User _id 목록 */
    notificationRecipientIds: string[];
    /** PBX 환경 여부 */
    isPbx?: boolean;
    /** PBX 동시 수용 회선 수 (1 이상) */
    lineCount?: number;
    /** 마지막 수정일시 */
    updatedAt: string | null;
  };
  message: string;
}

export interface AdminCallManagerControllerUpdateHospitalPhoneNumberMappingBodyRequest {
  /** 병원 전화번호 매핑 ID */
  mappingId: string;
  /** 별명 */
  name?: string;
  hospitalMainNumber?: {
    /**
     * 국가번호
     * @default "82"
     */
    countryCode?: string;
    /** 국가 내 번호 (-, 공백 제거됨) */
    nationalNumber: string;
  };
  aiCallManagerPhoneNumber?: {
    /** 국가번호 */
    countryCode: string;
    /** 국가 내 번호 (-, 공백 제거됨) */
    nationalNumber: string;
  };
  staffIncomingPhoneNumbers?: {
    /** 국가번호 */
    countryCode: string;
    /** 국가 내 번호 (-, 공백 제거됨) */
    nationalNumber: string;
  }[];
  notificationRecipientIds?: string[];
  /** PBX 환경 여부 */
  isPbx?: boolean;
  /**
   * PBX 동시 수용 회선 수 (1 이상)
   * @min 1
   */
  lineCount?: number;
}

export interface AdminCallManagerControllerUpdateHospitalPhoneNumberMappingResponse {
  code: number;
  data: {
    /** 병원 전화번호 매핑 ID */
    _id: string;
    /** 이름 */
    name: string;
    hospitalMainNumber: {
      /** 국가번호 (+ 접두사) */
      countryCode: string;
      /** 국가 내 번호 (한국이면 0 접두사) */
      nationalNumber: string;
    };
    aiCallManagerPhoneNumber: {
      /** 국가번호 (+ 접두사) */
      countryCode: string;
      /** 국가 내 번호 (한국이면 0 접두사) */
      nationalNumber: string;
    };
    /** 직원 수신 전화번호 목록 */
    staffIncomingPhoneNumbers: {
      /** 국가번호 (+ 접두사) */
      countryCode: string;
      /** 국가 내 번호 (한국이면 0 접두사) */
      nationalNumber: string;
    }[];
    /** 알림 수신 담당자 User _id 목록 */
    notificationRecipientIds: string[];
    /** PBX 환경 여부 */
    isPbx?: boolean;
    /** PBX 동시 수용 회선 수 (1 이상) */
    lineCount?: number;
    /** 마지막 수정일시 */
    updatedAt: string | null;
  };
  message: string;
}

export interface AdminCallManagerControllerDeleteHospitalPhoneNumberMappingBodyRequest {
  /** 병원 전화번호 매핑 ID */
  mappingId: string;
}

export interface AdminCallManagerControllerDeleteHospitalPhoneNumberMappingResponse {
  code: number;
  data: {
    /** 삭제 여부 (soft delete: isRemoved=true 설정) */
    deleted: boolean;
  };
  message: string;
}

export interface AdminMedipalAIControllerGetHospitalSettingsResponse {
  code: number;
  data: {
    /** AI 코치 기능 사용 여부 */
    usingAICoach: boolean;
    /** AI 글로벌 코디네이터 기능 사용 여부 */
    usingAIGlobalCoordinator: boolean;
    /** AI 콜 매니저 기능 사용 여부 */
    usingAICallManager: boolean;
    /** AI 코치 설정 마지막 수정 일시 */
    coachUpdatedAt?: string | null;
    /** AI 코치 설정 마지막 수정자 */
    coachUpdatedBy?: string | null;
    /** AI 글로벌 코디네이터 설정 마지막 수정 일시 */
    coordinatorUpdatedAt?: string | null;
    /** AI 글로벌 코디네이터 설정 마지막 수정자 */
    coordinatorUpdatedBy?: string | null;
    /** AI 콜 매니저 설정 마지막 수정 일시 */
    callManagerUpdatedAt?: string | null;
    /** AI 콜 매니저 설정 마지막 수정자 */
    callManagerUpdatedBy?: string | null;
    /** AI 콜 매니저 전화 설정 목록 */
    callManagerPhones: {
      /** 메디팔 AI 전화 설정 ID */
      id: string;
      /** 관리 화면에서 구분하기 위한 전화 설정 별칭 */
      alias: string;
      /** 병원 대표 또는 연결 대상 전화번호 */
      hospitalPhone: string;
      /** AI가 사용하는 발신/연결 전화번호 */
      aiPhone: string;
      /** AI 연결 후 착신 받을 전화번호 목록 */
      receiverPhones: string[];
      /** PBX 환경 여부 */
      isPbx?: boolean | null;
      /**
       * PBX 동시 수용 회선 수
       * @min 1
       */
      lineCount?: number | null;
      /** 마지막 수정 일시 */
      updatedAt?: string | null;
      /** 마지막 수정자 식별값 또는 이름 */
      updatedBy?: string | null;
    }[];
  };
  message: string;
}

export interface AdminMedipalAIControllerGetAIReservationStatusResponse {
  code: number;
  data: {
    /** AI 예약 기능 사용 여부 */
    isUsingAIReservation: boolean;
  };
  message: string;
}

export interface AdminMedipalAIControllerGetSubscriptionHistoriesResponse {
  code: number;
  data: {
    /** 앱별 최신 구독 신청 이력 목록 */
    items: {
      /** 앱 ID */
      appID: string;
      /** 앱 코드명 */
      codeName: string;
      /** 구독 신청 상태 (REQUESTED / APPROVED) */
      status: string;
      /** 구독 신청 일시 */
      requestedAt?: string | null;
      /** 신청자 이름 */
      requesterName?: string | null;
      /** 신청자 전화번호 */
      requesterPhone?: string | null;
      /** 신청자 로그인 ID */
      requesterLoginID?: string | null;
      /** 승인 일시 */
      approvedAt?: string | null;
      /** 승인자 */
      approvedBy?: string | null;
      /** 취소 신청자 이름 */
      cancelerName?: string | null;
      /** 취소 신청자 전화번호 */
      cancelerPhone?: string | null;
      /** 취소 신청자 로그인 ID */
      cancelerLoginID?: string | null;
      /** 취소 신청 일시 */
      cancelRequestedAt?: string | null;
      /** 삭제 여부 */
      isRemoved: boolean;
      /** 삭제 일시 */
      removedAt?: string | null;
      /** 삭제 처리자 */
      removedBy?: string | null;
    }[];
  };
  message: string;
}

export interface AdminMedipalAIControllerPatchHospitalSettingsBodyRequest {
  /** 해당 메디팔 AI 기능 활성화 여부 */
  enabled: boolean;
}

export interface AdminMedipalAIControllerPatchHospitalSettingsResponse {
  code: number;
  data: {
    /** 변경된 메디팔 AI 기능 코드 */
    featureCode: "ai-coach" | "ai-global-coordinator" | "ai-call-manager";
    /** 변경 후 기능 활성화 여부 */
    enabled: boolean;
    /** 설정 변경 일시 */
    updatedAt?: string | null;
    /** 설정 변경자 */
    updatedBy?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerGetHospitalCallManagerGreetingResponse {
  code: number;
  data: {
    /** 기본값 사용 여부. true면 서버 기본 인사말을 따른다(병원별 직접설정 해제). */
    useDefault: boolean;
    /** 직접설정 인사말 텍스트. {{hospitalName}} 치환문자 사용 가능. */
    greeting?: string | null;
    /** 서버 기본 인사말 텍스트. 기본값 선택 시 읽기 전용으로 표시한다. */
    defaultGreeting?: string | null;
    /** 마지막 저장 일시 */
    updatedAt?: string | null;
    /** 마지막 저장 계정 */
    updatedBy?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerPutHospitalCallManagerGreetingBodyRequest {
  /** 기본값 사용 여부 */
  useDefault: boolean;
  /**
   * 직접설정 인사말 텍스트 ({{hospitalName}} 치환문자 사용 가능)
   * @maxLength 1000
   */
  greeting?: string | null;
}

export interface AdminMedipalAIControllerPutHospitalCallManagerGreetingResponse {
  code: number;
  data: {
    /** 기본값 사용 여부. true면 서버 기본 인사말을 따른다(병원별 직접설정 해제). */
    useDefault: boolean;
    /** 직접설정 인사말 텍스트. {{hospitalName}} 치환문자 사용 가능. */
    greeting?: string | null;
    /** 서버 기본 인사말 텍스트. 기본값 선택 시 읽기 전용으로 표시한다. */
    defaultGreeting?: string | null;
    /** 마지막 저장 일시 */
    updatedAt?: string | null;
    /** 마지막 저장 계정 */
    updatedBy?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerGetHospitalCallManagerPhonesResponse {
  code: number;
  data: {
    /** 병원별 AI 콜 매니저 전화 설정 목록 */
    items: {
      /** 메디팔 AI 전화 설정 ID */
      id: string;
      /** 관리 화면에서 구분하기 위한 전화 설정 별칭 */
      alias: string;
      /** 병원 대표 또는 연결 대상 전화번호 */
      hospitalPhone: string;
      /** AI가 사용하는 발신/연결 전화번호 */
      aiPhone: string;
      /** AI 연결 후 착신 받을 전화번호 목록 */
      receiverPhones: string[];
      /** PBX 환경 여부 */
      isPbx?: boolean | null;
      /**
       * PBX 동시 수용 회선 수
       * @min 1
       */
      lineCount?: number | null;
      /** 마지막 수정 일시 */
      updatedAt?: string | null;
      /** 마지막 수정자 식별값 또는 이름 */
      updatedBy?: string | null;
    }[];
  };
  message: string;
}

export interface AdminMedipalAIControllerCreateHospitalCallManagerPhoneBodyRequest {
  /**
   * 관리 화면에서 구분하기 위한 전화 설정 별칭
   * @minLength 1
   */
  alias: string;
  /**
   * 병원 대표 또는 연결 대상 전화번호
   * @minLength 1
   */
  hospitalPhone: string;
  /**
   * AI가 사용하는 발신/연결 전화번호
   * @minLength 1
   */
  aiPhone: string;
  /**
   * AI 연결 후 착신 받을 전화번호 목록
   * @minItems 1
   */
  receiverPhones: string[];
  /** PBX 환경 여부 */
  isPbx?: boolean | null;
  /**
   * PBX 동시 수용 회선 수
   * @min 1
   */
  lineCount?: number | null;
}

export interface AdminMedipalAIControllerCreateHospitalCallManagerPhoneResponse {
  code: number;
  data: {
    /** 메디팔 AI 전화 설정 ID */
    id: string;
    /** 관리 화면에서 구분하기 위한 전화 설정 별칭 */
    alias: string;
    /** 병원 대표 또는 연결 대상 전화번호 */
    hospitalPhone: string;
    /** AI가 사용하는 발신/연결 전화번호 */
    aiPhone: string;
    /** AI 연결 후 착신 받을 전화번호 목록 */
    receiverPhones: string[];
    /** PBX 환경 여부 */
    isPbx?: boolean | null;
    /**
     * PBX 동시 수용 회선 수
     * @min 1
     */
    lineCount?: number | null;
    /** 마지막 수정 일시 */
    updatedAt?: string | null;
    /** 마지막 수정자 식별값 또는 이름 */
    updatedBy?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerUpdateHospitalCallManagerPhoneBodyRequest {
  /**
   * 관리 화면에서 구분하기 위한 전화 설정 별칭
   * @minLength 1
   */
  alias: string;
  /**
   * 병원 대표 또는 연결 대상 전화번호
   * @minLength 1
   */
  hospitalPhone: string;
  /**
   * AI가 사용하는 발신/연결 전화번호
   * @minLength 1
   */
  aiPhone: string;
  /**
   * AI 연결 후 착신 받을 전화번호 목록
   * @minItems 1
   */
  receiverPhones: string[];
  /** PBX 환경 여부 */
  isPbx?: boolean | null;
  /**
   * PBX 동시 수용 회선 수
   * @min 1
   */
  lineCount?: number | null;
}

export interface AdminMedipalAIControllerUpdateHospitalCallManagerPhoneResponse {
  code: number;
  data: {
    /** 메디팔 AI 전화 설정 ID */
    id: string;
    /** 관리 화면에서 구분하기 위한 전화 설정 별칭 */
    alias: string;
    /** 병원 대표 또는 연결 대상 전화번호 */
    hospitalPhone: string;
    /** AI가 사용하는 발신/연결 전화번호 */
    aiPhone: string;
    /** AI 연결 후 착신 받을 전화번호 목록 */
    receiverPhones: string[];
    /** PBX 환경 여부 */
    isPbx?: boolean | null;
    /**
     * PBX 동시 수용 회선 수
     * @min 1
     */
    lineCount?: number | null;
    /** 마지막 수정 일시 */
    updatedAt?: string | null;
    /** 마지막 수정자 식별값 또는 이름 */
    updatedBy?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerDeleteHospitalCallManagerPhoneResponse {
  code: number;
  data: {
    /** 전화 설정 삭제 성공 여부 */
    deleted: boolean;
  };
  message: string;
}

export interface AdminMedipalAIControllerFindStoreBannersResponse {
  code: number;
  data: {
    /** 조건에 맞는 전체 배너 수 */
    totalCount: number;
    /** 조회된 배너 목록 */
    items: {
      /** 스토어 배너 ID */
      id: string;
      /** 배너 생성 일시 */
      createdAt: string;
      /** 배너 노출 여부 */
      isExposed: boolean;
      /** 배너 제목 */
      title: string;
      /** 배너 클릭 시 이동할 링크 */
      moveLink?: string | null;
      /** 배너 이미지 파일 ID */
      fileId?: string | null;
      /** 배너 이미지 파일명 */
      imageName?: string | null;
      /** 배너 이미지 URL */
      imageUrl?: string | null;
    }[];
  };
  message: string;
}

export interface AdminMedipalAIControllerCreateStoreBannerBodyRequest {
  /**
   * 배너 제목
   * @minLength 1
   */
  title: string;
  /** 배너 클릭 시 이동할 링크 */
  moveLink?: string | null;
  /** 업로드된 배너 이미지 파일 ID */
  fileId?: string | null;
  /** 배너 즉시 노출 여부 */
  isExposed: boolean;
}

export interface AdminMedipalAIControllerCreateStoreBannerResponse {
  code: number;
  data: {
    /** 스토어 배너 ID */
    id: string;
    /** 배너 생성 일시 */
    createdAt: string;
    /** 배너 노출 여부 */
    isExposed: boolean;
    /** 배너 제목 */
    title: string;
    /** 배너 클릭 시 이동할 링크 */
    moveLink?: string | null;
    /** 배너 이미지 파일 ID */
    fileId?: string | null;
    /** 배너 이미지 파일명 */
    imageName?: string | null;
    /** 배너 이미지 URL */
    imageUrl?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerFindStoreBannerResponse {
  code: number;
  data: {
    /** 스토어 배너 ID */
    id: string;
    /** 배너 생성 일시 */
    createdAt: string;
    /** 배너 노출 여부 */
    isExposed: boolean;
    /** 배너 제목 */
    title: string;
    /** 배너 클릭 시 이동할 링크 */
    moveLink?: string | null;
    /** 배너 이미지 파일 ID */
    fileId?: string | null;
    /** 배너 이미지 파일명 */
    imageName?: string | null;
    /** 배너 이미지 URL */
    imageUrl?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerUpdateStoreBannerBodyRequest {
  /**
   * 배너 제목
   * @minLength 1
   */
  title: string;
  /** 배너 클릭 시 이동할 링크 */
  moveLink?: string | null;
  /** 업로드된 배너 이미지 파일 ID */
  fileId?: string | null;
  /** 배너 즉시 노출 여부 */
  isExposed: boolean;
}

export interface AdminMedipalAIControllerUpdateStoreBannerResponse {
  code: number;
  data: {
    /** 스토어 배너 ID */
    id: string;
    /** 배너 생성 일시 */
    createdAt: string;
    /** 배너 노출 여부 */
    isExposed: boolean;
    /** 배너 제목 */
    title: string;
    /** 배너 클릭 시 이동할 링크 */
    moveLink?: string | null;
    /** 배너 이미지 파일 ID */
    fileId?: string | null;
    /** 배너 이미지 파일명 */
    imageName?: string | null;
    /** 배너 이미지 URL */
    imageUrl?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerDeleteStoreBannerResponse {
  code: number;
  data: {
    /** 배너 삭제 성공 여부 */
    deleted: boolean;
  };
  message: string;
}

export interface AdminMedipalAIControllerGetUsageWeightsResponse {
  code: number;
  data: {
    /** 전체 가중치 설정 수 */
    totalCount: number;
    /** 가중치 설정 목록 */
    items: {
      /** 가중치 설정 ID */
      id: string;
      /** 메디팔 AI 기능별 사용량 가중치 그룹 목록 */
      featureGroups: {
        /** 가중치 그룹명 또는 기능명 */
        displayName: string;
        /** 앱 코드명 */
        appCodeName: string;
        /** 기능별 액션 가중치 목록 */
        actions: {
          /** 가중치가 적용되는 사용량 액션 타입 */
          usageType?:
            | "detect_language"
            | "get_tag_code"
            | "consultation_guide"
            | "consultation_logic"
            | "response_text"
            | "extract_search_tags"
            | "detect_language"
            | "get_tag_code"
            | "consultation_guide"
            | "response_translation"
            | "consultation_logic"
            | "response_text"
            | "call_realtime"
            | "call_summary";
          /** 가중치가 적용되는 사용량 액션 표시명 */
          displayName: string;
          /**
           * 액션별 사용량 가중치
           * @min 0
           */
          weight: number;
        }[];
      }[];
      /** 적용 시작일 */
      startDate: string;
      /** 적용 종료일 (null이면 무제한) */
      endDate?: string | null;
      /** 생성일 */
      createdAt?: string | null;
      /** 수정일 */
      updatedAt?: string | null;
      /** 마지막 수정자 */
      modifiedBy?: string | null;
    }[];
  };
  message: string;
}

export interface AdminMedipalAIControllerUpdateUsageWeightsBodyRequest {
  /** 저장할 메디팔 AI 기능별 사용량 가중치 그룹 목록 */
  featureGroups: {
    /** 가중치를 수정할 그룹명 또는 기능명 */
    displayName: string;
    /** 앱 코드명 */
    appCodeName: string;
    /** 수정할 기능별 액션 가중치 목록 */
    actions: {
      /** 가중치를 변경할 사용량 액션 타입 */
      usageType?:
        | "detect_language"
        | "get_tag_code"
        | "consultation_guide"
        | "consultation_logic"
        | "response_text"
        | "extract_search_tags"
        | "detect_language"
        | "get_tag_code"
        | "consultation_guide"
        | "response_translation"
        | "consultation_logic"
        | "response_text"
        | "call_realtime"
        | "call_summary";
      /**
       * 변경할 액션별 사용량 가중치
       * @min 0
       */
      weight: number;
    }[];
  }[];
  /** 적용 시작일 (YYYY-MM-DD 또는 ISO 8601 형식) */
  startDate: string;
  /** 적용 종료일 (YYYY-MM-DD 또는 ISO 8601 형식, 미지정 시 무제한) */
  endDate?: string | null;
}

export interface AdminMedipalAIControllerUpdateUsageWeightsResponse {
  code: number;
  data: {
    /** 전체 가중치 설정 수 */
    totalCount: number;
    /** 가중치 설정 목록 */
    items: {
      /** 가중치 설정 ID */
      id: string;
      /** 메디팔 AI 기능별 사용량 가중치 그룹 목록 */
      featureGroups: {
        /** 가중치 그룹명 또는 기능명 */
        displayName: string;
        /** 앱 코드명 */
        appCodeName: string;
        /** 기능별 액션 가중치 목록 */
        actions: {
          /** 가중치가 적용되는 사용량 액션 타입 */
          usageType?:
            | "detect_language"
            | "get_tag_code"
            | "consultation_guide"
            | "consultation_logic"
            | "response_text"
            | "extract_search_tags"
            | "detect_language"
            | "get_tag_code"
            | "consultation_guide"
            | "response_translation"
            | "consultation_logic"
            | "response_text"
            | "call_realtime"
            | "call_summary";
          /** 가중치가 적용되는 사용량 액션 표시명 */
          displayName: string;
          /**
           * 액션별 사용량 가중치
           * @min 0
           */
          weight: number;
        }[];
      }[];
      /** 적용 시작일 */
      startDate: string;
      /** 적용 종료일 (null이면 무제한) */
      endDate?: string | null;
      /** 생성일 */
      createdAt?: string | null;
      /** 수정일 */
      updatedAt?: string | null;
      /** 마지막 수정자 */
      modifiedBy?: string | null;
    }[];
  };
  message: string;
}

export interface AdminMedipalAIControllerFindDiscountPoliciesResponse {
  code: number;
  data: {
    /** 전체 할인 정책 수 */
    totalCount: number;
    /** 할인 정책 목록 */
    items: {
      /** 할인 정책 ID */
      id: string;
      /** 병원 ID */
      hospitalID?: string | null;
      /** 앱 ID */
      appID: string;
      /** 앱 코드명 */
      appCodeName?: string | null;
      /** 우선순위 (낮을수록 우선) */
      priority: number;
      /** 비고 */
      description?: string | null;
      /** 최대 할인 금액 (원) */
      amountOff: number;
      /** 할인율 (%) */
      percentOff: number;
      /** 체험판 여부 */
      isTrial: boolean;
      /** 샘플(템플릿) 데이터 여부 */
      isSample?: boolean;
      /** 할인 시작일 */
      effectiveStartAt?: string | null;
      /** 할인 종료일 */
      effectiveEndAt?: string | null;
      /** 할인 소진일 */
      depletedAt?: string | null;
      /** 삭제일 */
      removedAt?: string | null;
      /** 생성일 */
      createdAt?: string | null;
      /** 수정일 */
      updatedAt?: string | null;
      /** 수정자 */
      modifiedBy?: string | null;
      /** 할인 종료일 */
      expiredAt?: string | null;
    }[];
  };
  message: string;
}

export interface AdminMedipalAIControllerCreateDiscountPolicyBodyRequest {
  /** 병원 ID */
  hospitalID?: string | null;
  /** 앱 ID */
  appID: string;
  /**
   * 우선순위 (낮을수록 우선)
   * @min 0
   * @default 9999
   */
  priority: number;
  /** 비고 */
  description?: string | null;
  /**
   * 최대 할인 금액 (원)
   * @min 0
   * @default 0
   */
  amountOff: number;
  /**
   * 할인율 (%)
   * @min 0
   * @max 100
   * @default 0
   */
  percentOff: number;
  /**
   * 체험판 여부
   * @default false
   */
  isTrial: boolean;
  /**
   * 샘플(템플릿) 데이터 여부
   * @default false
   */
  isSample: boolean;
  /** 할인 시작일 (ISO 8601) */
  effectiveStartAt?: string | null;
  /** 할인 종료일 (ISO 8601) */
  effectiveEndAt?: string | null;
}

export interface AdminMedipalAIControllerCreateDiscountPolicyResponse {
  code: number;
  data: {
    /** 할인 정책 ID */
    id: string;
    /** 병원 ID */
    hospitalID?: string | null;
    /** 앱 ID */
    appID: string;
    /** 앱 코드명 */
    appCodeName?: string | null;
    /** 우선순위 (낮을수록 우선) */
    priority: number;
    /** 비고 */
    description?: string | null;
    /** 최대 할인 금액 (원) */
    amountOff: number;
    /** 할인율 (%) */
    percentOff: number;
    /** 체험판 여부 */
    isTrial: boolean;
    /** 샘플(템플릿) 데이터 여부 */
    isSample?: boolean;
    /** 할인 시작일 */
    effectiveStartAt?: string | null;
    /** 할인 종료일 */
    effectiveEndAt?: string | null;
    /** 할인 소진일 */
    depletedAt?: string | null;
    /** 삭제일 */
    removedAt?: string | null;
    /** 생성일 */
    createdAt?: string | null;
    /** 수정일 */
    updatedAt?: string | null;
    /** 수정자 */
    modifiedBy?: string | null;
    /** 할인 종료일 */
    expiredAt?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerUpdateDiscountPolicyBodyRequest {
  /** 병원 ID */
  hospitalID?: string | null;
  /** 앱 ID */
  appID?: string;
  /**
   * 우선순위 (낮을수록 우선)
   * @min 0
   */
  priority?: number;
  /** 비고 */
  description?: string | null;
  /**
   * 최대 할인 금액 (원)
   * @min 0
   */
  amountOff?: number;
  /**
   * 할인율 (%)
   * @min 0
   * @max 100
   */
  percentOff?: number;
  /** 체험판 여부 */
  isTrial?: boolean;
  /** 샘플(템플릿) 데이터 여부 */
  isSample?: boolean;
  /** 할인 시작일 (ISO 8601) */
  effectiveStartAt?: string | null;
  /** 할인 종료일 (ISO 8601) */
  effectiveEndAt?: string | null;
}

export interface AdminMedipalAIControllerUpdateDiscountPolicyResponse {
  code: number;
  data: {
    /** 할인 정책 ID */
    id: string;
    /** 병원 ID */
    hospitalID?: string | null;
    /** 앱 ID */
    appID: string;
    /** 앱 코드명 */
    appCodeName?: string | null;
    /** 우선순위 (낮을수록 우선) */
    priority: number;
    /** 비고 */
    description?: string | null;
    /** 최대 할인 금액 (원) */
    amountOff: number;
    /** 할인율 (%) */
    percentOff: number;
    /** 체험판 여부 */
    isTrial: boolean;
    /** 샘플(템플릿) 데이터 여부 */
    isSample?: boolean;
    /** 할인 시작일 */
    effectiveStartAt?: string | null;
    /** 할인 종료일 */
    effectiveEndAt?: string | null;
    /** 할인 소진일 */
    depletedAt?: string | null;
    /** 삭제일 */
    removedAt?: string | null;
    /** 생성일 */
    createdAt?: string | null;
    /** 수정일 */
    updatedAt?: string | null;
    /** 수정자 */
    modifiedBy?: string | null;
    /** 할인 종료일 */
    expiredAt?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerDeleteDiscountPolicyResponse {
  code: number;
  data: {
    /** 삭제 성공 여부 */
    deleted: boolean;
  };
  message: string;
}

export interface AdminMedipalAIControllerFindUsageWeightSettingsResponse {
  code: number;
  data: {
    /** 전체 가중치 설정 수 */
    totalCount: number;
    /** 가중치 설정 목록 */
    items: {
      /** 가중치 설정 ID */
      id: string;
      /** 기능별 가중치 그룹 목록 */
      featureGroups: {
        /** 가중치 그룹명 또는 기능명 */
        displayName: string;
        /** 앱 코드명 */
        appCodeName: string;
        /** 기능별 액션 가중치 목록 */
        actions: {
          /** 가중치가 적용되는 사용량 액션 타입 */
          usageType?:
            | "detect_language"
            | "get_tag_code"
            | "consultation_guide"
            | "consultation_logic"
            | "response_text"
            | "extract_search_tags"
            | "detect_language"
            | "get_tag_code"
            | "consultation_guide"
            | "response_translation"
            | "consultation_logic"
            | "response_text"
            | "call_realtime"
            | "call_summary";
          /** 가중치가 적용되는 사용량 액션 표시명 */
          displayName: string;
          /**
           * 액션별 사용량 가중치
           * @min 0
           */
          weight: number;
        }[];
      }[];
      /** 적용 시작일 (ISO 8601) */
      startDate: string;
      /** 적용 종료일 (ISO 8601, null이면 무제한) */
      endDate?: string | null;
      /** 생성일 */
      createdAt?: string | null;
      /** 수정일 */
      updatedAt?: string | null;
      /** 마지막 수정자 */
      modifiedBy?: string | null;
    }[];
  };
  message: string;
}

export interface AdminMedipalAIControllerCreateUsageWeightSettingBodyRequest {
  /** 기능별 가중치 그룹 목록 */
  featureGroups: {
    /** 가중치를 수정할 그룹명 또는 기능명 */
    displayName: string;
    /** 앱 코드명 */
    appCodeName: string;
    /** 수정할 기능별 액션 가중치 목록 */
    actions: {
      /** 가중치를 변경할 사용량 액션 타입 */
      usageType?:
        | "detect_language"
        | "get_tag_code"
        | "consultation_guide"
        | "consultation_logic"
        | "response_text"
        | "extract_search_tags"
        | "detect_language"
        | "get_tag_code"
        | "consultation_guide"
        | "response_translation"
        | "consultation_logic"
        | "response_text"
        | "call_realtime"
        | "call_summary";
      /**
       * 변경할 액션별 사용량 가중치
       * @min 0
       */
      weight: number;
    }[];
  }[];
  /** 적용 시작일 (ISO 8601) */
  startDate: string;
  /** 적용 종료일 (ISO 8601, null이면 무제한) */
  endDate?: string | null;
}

export interface AdminMedipalAIControllerCreateUsageWeightSettingResponse {
  code: number;
  data: {
    /** 가중치 설정 ID */
    id: string;
    /** 기능별 가중치 그룹 목록 */
    featureGroups: {
      /** 가중치 그룹명 또는 기능명 */
      displayName: string;
      /** 앱 코드명 */
      appCodeName: string;
      /** 기능별 액션 가중치 목록 */
      actions: {
        /** 가중치가 적용되는 사용량 액션 타입 */
        usageType?:
          | "detect_language"
          | "get_tag_code"
          | "consultation_guide"
          | "consultation_logic"
          | "response_text"
          | "extract_search_tags"
          | "detect_language"
          | "get_tag_code"
          | "consultation_guide"
          | "response_translation"
          | "consultation_logic"
          | "response_text"
          | "call_realtime"
          | "call_summary";
        /** 가중치가 적용되는 사용량 액션 표시명 */
        displayName: string;
        /**
         * 액션별 사용량 가중치
         * @min 0
         */
        weight: number;
      }[];
    }[];
    /** 적용 시작일 (ISO 8601) */
    startDate: string;
    /** 적용 종료일 (ISO 8601, null이면 무제한) */
    endDate?: string | null;
    /** 생성일 */
    createdAt?: string | null;
    /** 수정일 */
    updatedAt?: string | null;
    /** 마지막 수정자 */
    modifiedBy?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerFindCurrentUsageWeightSettingResponse {
  code: number;
  /** 현재 적용 중인 AI 사용량 가중치 설정 (없으면 null) */
  data: {
    /** 가중치 설정 ID */
    id: string;
    /** 기능별 가중치 그룹 목록 */
    featureGroups: {
      /** 가중치 그룹명 또는 기능명 */
      displayName: string;
      /** 앱 코드명 */
      appCodeName: string;
      /** 기능별 액션 가중치 목록 */
      actions: {
        /** 가중치가 적용되는 사용량 액션 타입 */
        usageType?:
          | "detect_language"
          | "get_tag_code"
          | "consultation_guide"
          | "consultation_logic"
          | "response_text"
          | "extract_search_tags"
          | "detect_language"
          | "get_tag_code"
          | "consultation_guide"
          | "response_translation"
          | "consultation_logic"
          | "response_text"
          | "call_realtime"
          | "call_summary";
        /** 가중치가 적용되는 사용량 액션 표시명 */
        displayName: string;
        /**
         * 액션별 사용량 가중치
         * @min 0
         */
        weight: number;
      }[];
    }[];
    /** 적용 시작일 (ISO 8601) */
    startDate: string;
    /** 적용 종료일 (ISO 8601, null이면 무제한) */
    endDate?: string | null;
    /** 생성일 */
    createdAt?: string | null;
    /** 수정일 */
    updatedAt?: string | null;
    /** 마지막 수정자 */
    modifiedBy?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerUpdateUsageWeightSettingBodyRequest {
  /** 기능별 가중치 그룹 목록 */
  featureGroups?: {
    /** 가중치를 수정할 그룹명 또는 기능명 */
    displayName: string;
    /** 앱 코드명 */
    appCodeName: string;
    /** 수정할 기능별 액션 가중치 목록 */
    actions: {
      /** 가중치를 변경할 사용량 액션 타입 */
      usageType?:
        | "detect_language"
        | "get_tag_code"
        | "consultation_guide"
        | "consultation_logic"
        | "response_text"
        | "extract_search_tags"
        | "detect_language"
        | "get_tag_code"
        | "consultation_guide"
        | "response_translation"
        | "consultation_logic"
        | "response_text"
        | "call_realtime"
        | "call_summary";
      /**
       * 변경할 액션별 사용량 가중치
       * @min 0
       */
      weight: number;
    }[];
  }[];
  /** 적용 시작일 (ISO 8601) */
  startDate?: string;
  /** 적용 종료일 (ISO 8601, null이면 무제한) */
  endDate?: string | null;
}

export interface AdminMedipalAIControllerUpdateUsageWeightSettingResponse {
  code: number;
  data: {
    /** 가중치 설정 ID */
    id: string;
    /** 기능별 가중치 그룹 목록 */
    featureGroups: {
      /** 가중치 그룹명 또는 기능명 */
      displayName: string;
      /** 앱 코드명 */
      appCodeName: string;
      /** 기능별 액션 가중치 목록 */
      actions: {
        /** 가중치가 적용되는 사용량 액션 타입 */
        usageType?:
          | "detect_language"
          | "get_tag_code"
          | "consultation_guide"
          | "consultation_logic"
          | "response_text"
          | "extract_search_tags"
          | "detect_language"
          | "get_tag_code"
          | "consultation_guide"
          | "response_translation"
          | "consultation_logic"
          | "response_text"
          | "call_realtime"
          | "call_summary";
        /** 가중치가 적용되는 사용량 액션 표시명 */
        displayName: string;
        /**
         * 액션별 사용량 가중치
         * @min 0
         */
        weight: number;
      }[];
    }[];
    /** 적용 시작일 (ISO 8601) */
    startDate: string;
    /** 적용 종료일 (ISO 8601, null이면 무제한) */
    endDate?: string | null;
    /** 생성일 */
    createdAt?: string | null;
    /** 수정일 */
    updatedAt?: string | null;
    /** 마지막 수정자 */
    modifiedBy?: string | null;
  };
  message: string;
}

export interface AdminMedipalAIControllerDeleteUsageWeightSettingResponse {
  code: number;
  data: {
    /** 삭제 성공 여부 */
    deleted: boolean;
  };
  message: string;
}

export interface AdminMSOGroupControllerCountResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: number;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerFindResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name?: string;
    isTest?: boolean;
    /** 서비스 상태: pending(대기), run(진행), closed(종료) */
    serviceStatus?: "pending" | "run" | "closed" | null;
    /** 연결된 병원 수 (hospitalIDs 배열 길이) */
    hospitalCount?: number;
    /** 연결 병원 소속 직원 계정 수 합계 (isLeave:false, type HWorker~ANurse) */
    accountCount?: number;
    /** 연결 병원의 활성 메시징 채널 연동 수 합계 (각 채널별 isRemoved/removed:false) */
    channelCount?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerFindOneResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    name?: string;
    isTest?: boolean;
    /** 서비스 상태: pending(대기), run(진행), closed(종료) */
    serviceStatus?: "pending" | "run" | "closed" | null;
    hospitalIDs?: ({
      _id?: string;
      name?: string;
      shortName?: string;
      msoHospitalName?: string;
      /** @format date */
      createdAt?: string;
    } | null)[];
    /** 연결 병원 소속 직원 계정 수 합계 (isLeave:false, type HWorker~ANurse) */
    accountCount?: number;
    /** 연결 병원의 활성 메시징 채널 연동 수 합계 (각 채널별 isRemoved/removed:false) */
    channelCount?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerCreateBodyRequest {
  /** 다중 병원 그룹 관리명 (필수, 최대 30자) */
  name: string;
  isTest?: boolean;
}

export interface AdminMSOGroupControllerCreateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 다중 병원 그룹 관리명 (최대 30자) */
    name: string;
    /** 실가비(false) / 테스트(true) 구분 */
    isTest?: boolean;
    /** 서비스 상태: pending(대기 — 서비스 미시작/병원 생성됨), run(진행 — 서비스 시작), closed(종료 — 서비스 종료) */
    serviceStatus?: "pending" | "run" | "closed" | null;
    /** 그룹에 연결된 병원 ID 배열 */
    hospitalIDs: string[];
    /** 그룹 전용 공유 권한 문서 ID (ref AuthorizationType) */
    authorizationTypeID?: string;
    isDeleted?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
    /** @format date */
    deletedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerUpdateBodyRequest {
  _id: string;
  name?: string;
  isTest?: boolean;
}

export interface AdminMSOGroupControllerUpdateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 다중 병원 그룹 관리명 (최대 30자) */
    name: string;
    /** 실가비(false) / 테스트(true) 구분 */
    isTest?: boolean;
    /** 서비스 상태: pending(대기 — 서비스 미시작/병원 생성됨), run(진행 — 서비스 시작), closed(종료 — 서비스 종료) */
    serviceStatus?: "pending" | "run" | "closed" | null;
    /** 그룹에 연결된 병원 ID 배열 */
    hospitalIDs: string[];
    /** 그룹 전용 공유 권한 문서 ID (ref AuthorizationType) */
    authorizationTypeID?: string;
    isDeleted?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
    /** @format date */
    deletedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerConnectHospitalsBodyRequest {
  _id: string;
  hospitalIDs: string[];
}

export interface AdminMSOGroupControllerConnectHospitalsResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 다중 병원 그룹 관리명 (최대 30자) */
    name: string;
    /** 실가비(false) / 테스트(true) 구분 */
    isTest?: boolean;
    /** 서비스 상태: pending(대기 — 서비스 미시작/병원 생성됨), run(진행 — 서비스 시작), closed(종료 — 서비스 종료) */
    serviceStatus?: "pending" | "run" | "closed" | null;
    /** 그룹에 연결된 병원 ID 배열 */
    hospitalIDs: string[];
    /** 그룹 전용 공유 권한 문서 ID (ref AuthorizationType) */
    authorizationTypeID?: string;
    isDeleted?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
    /** @format date */
    deletedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerDisconnectHospitalsBodyRequest {
  _id: string;
  hospitalIDs: string[];
}

export interface AdminMSOGroupControllerDisconnectHospitalsResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 다중 병원 그룹 관리명 (최대 30자) */
    name: string;
    /** 실가비(false) / 테스트(true) 구분 */
    isTest?: boolean;
    /** 서비스 상태: pending(대기 — 서비스 미시작/병원 생성됨), run(진행 — 서비스 시작), closed(종료 — 서비스 종료) */
    serviceStatus?: "pending" | "run" | "closed" | null;
    /** 그룹에 연결된 병원 ID 배열 */
    hospitalIDs: string[];
    /** 그룹 전용 공유 권한 문서 ID (ref AuthorizationType) */
    authorizationTypeID?: string;
    isDeleted?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
    /** @format date */
    deletedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerPreflightDisconnectHospitalResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 병원 ID */
    _id: string;
    /** 병원명 */
    name: string;
    /** 이번 제거로 빠지는 현재 활성(isLeave:false) 기본 상담사 목록 */
    defaultCounselors: {
      /** 상담사 계정 ID */
      _id: string;
      /** 상담사 이름(realName) */
      name?: string;
    }[];
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerPreflightRemoveGroupResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 병원 ID */
    _id: string;
    /** 병원명 */
    name: string;
    /** 이번 제거로 빠지는 현재 활성(isLeave:false) 기본 상담사 목록 */
    defaultCounselors: {
      /** 상담사 계정 ID */
      _id: string;
      /** 상담사 이름(realName) */
      name?: string;
    }[];
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerPreflightRemoveAccountResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 병원 ID */
    _id: string;
    /** 병원명 */
    name: string;
    /** 이번 제거로 빠지는 현재 활성(isLeave:false) 기본 상담사 목록 */
    defaultCounselors: {
      /** 상담사 계정 ID */
      _id: string;
      /** 상담사 이름(realName) */
      name?: string;
    }[];
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerRemoveResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 다중 병원 그룹 관리명 (최대 30자) */
    name: string;
    /** 실가비(false) / 테스트(true) 구분 */
    isTest?: boolean;
    /** 서비스 상태: pending(대기 — 서비스 미시작/병원 생성됨), run(진행 — 서비스 시작), closed(종료 — 서비스 종료) */
    serviceStatus?: "pending" | "run" | "closed" | null;
    /** 그룹에 연결된 병원 ID 배열 */
    hospitalIDs: string[];
    /** 그룹 전용 공유 권한 문서 ID (ref AuthorizationType) */
    authorizationTypeID?: string;
    isDeleted?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
    /** @format date */
    deletedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerAccountCreateBodyRequest {
  /** MSO 그룹 ID */
  _id: string;
  realName: string;
  id: string;
  password: string;
  phone?: string;
  jobType: string;
  isDoctor?: boolean;
}

export interface AdminMSOGroupControllerAccountCreateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    hospitalID?: string[] | null;
    realName?: string;
    id?: string;
    password?: string;
    type?: number | null;
    phone?: string;
    jobType?: string;
    authorizationTypeID?: string;
    isDoctor?: boolean;
    photo?: {
      _id?: string;
      paths?: string[] | null;
      aws?: any[] | null;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerAccountUpdateBodyRequest {
  /** 계정 User _id */
  _id: string;
  realName: string;
  id: string;
  password: string;
  phone?: string;
  type?: number;
  jobType: string;
  isDoctor?: boolean;
}

export interface AdminMSOGroupControllerAccountUpdateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    hospitalID?: string[] | null;
    realName?: string;
    id?: string;
    password?: string;
    type?: number;
    jobType?: string;
    authorizationTypeID?: string;
    isDoctor?: boolean;
    photo?: {
      _id?: string;
      paths?: string[] | null;
      aws?: any[] | null;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerAccountFindResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    id?: string;
    name?: string;
    realName?: string;
    phone?: string;
    authorizationTypeID?: any;
    jobType?: string;
    photo?: {
      _id?: string;
      paths?: string[] | null;
      aws?: any[] | null;
    };
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerAccountRemoveResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    hospitalID?: string[] | null;
    realName?: string;
    id?: string;
    password?: string;
    type?: number;
    jobType?: string;
    authorizationTypeID?: string;
    isDoctor?: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerAuthorizationTypeFindResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    isSample?: boolean;
    hospitalID?: string;
    name?: string;
    canModifyService?: boolean;
    canSuspendService?: boolean;
    canManageReservation?: boolean;
    canManageSchedule?: boolean;
    canUpdateHospital?: boolean;
    canControlPatientChatting?: boolean;
    canUpsertPatientInformation?: boolean;
    canBanPatientToService?: boolean;
    canControlReservationAndWorkingScheduleSetting?: boolean;
    canUpsertWorkingSchedule?: boolean;
    canReadReservationHistory?: boolean;
    canUpdatePatientInformationWithinReservation?: boolean;
    canUpsertAutomation?: boolean;
    canDeleteAutomation?: boolean;
    canReadAutomationDashboard?: boolean;
    canUpsertContent?: boolean;
    canDeleteContent?: boolean;
    canControlManualFolderAndTagStatus?: boolean;
    canCreateManual?: boolean;
    canAccessHospitalInformation?: boolean;
    canAccessHospitalService?: boolean;
    canAccessHospitalAccount?: boolean;
    canDownloadPatientData?: boolean;
    canAccessPaymentManagement?: boolean;
    canCreatePayment?: boolean;
    canUpsertMarketingAutomation?: boolean;
    canDeleteMarketingAutomation?: boolean;
    canReadMarketingAutomationDashboard?: boolean;
    canReadPaymentRecords?: boolean;
    canDownloadMarketingHistory?: boolean;
    canDownloadConsultationHistory?: boolean;
    canReadMedipalAIUsage?: boolean;
    canAdjustMedipalAITask?: boolean;
    canReadMedipalAIReservation?: boolean;
    canReadMedipalAICall?: boolean;
    canControlMedipalAICall?: boolean;
    sections?: any;
    createdAt?: string | null;
    updatedAt?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerAuthorizationTypeUpdateBodyRequest {
  /** MSO 그룹 ID */
  _id: string;
  canModifyService?: boolean;
  canSuspendService?: boolean;
  canManageReservation?: boolean;
  canManageSchedule?: boolean;
  canUpdateHospital?: boolean;
  canControlPatientChatting?: boolean;
  canUpsertPatientInformation?: boolean;
  canBanPatientToService?: boolean;
  canControlReservationAndWorkingScheduleSetting?: boolean;
  canUpsertWorkingSchedule?: boolean;
  canReadReservationHistory?: boolean;
  canUpdatePatientInformationWithinReservation?: boolean;
  canUpsertAutomation?: boolean;
  canDeleteAutomation?: boolean;
  canReadAutomationDashboard?: boolean;
  canUpsertContent?: boolean;
  canDeleteContent?: boolean;
  canControlManualFolderAndTagStatus?: boolean;
  canCreateManual?: boolean;
  canAccessHospitalInformation?: boolean;
  canAccessHospitalService?: boolean;
  canAccessHospitalAccount?: boolean;
  canDownloadPatientData?: boolean;
  canAccessPaymentManagement?: boolean;
  canCreatePayment?: boolean;
  canUpsertMarketingAutomation?: boolean;
  canDeleteMarketingAutomation?: boolean;
  canReadMarketingAutomationDashboard?: boolean;
  canReadPaymentRecords?: boolean;
  canDownloadMarketingHistory?: boolean;
  canDownloadConsultationHistory?: boolean;
  canReadMedipalAIUsage?: boolean;
  canAdjustMedipalAITask?: boolean;
  canReadMedipalAIReservation?: boolean;
  canReadMedipalAICall?: boolean;
  canControlMedipalAICall?: boolean;
}

export interface AdminMSOGroupControllerAuthorizationTypeUpdateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    isSample?: boolean;
    hospitalID?: string;
    name?: string;
    canModifyService?: boolean;
    canSuspendService?: boolean;
    canManageReservation?: boolean;
    canManageSchedule?: boolean;
    canUpdateHospital?: boolean;
    canControlPatientChatting?: boolean;
    canUpsertPatientInformation?: boolean;
    canBanPatientToService?: boolean;
    canControlReservationAndWorkingScheduleSetting?: boolean;
    canUpsertWorkingSchedule?: boolean;
    canReadReservationHistory?: boolean;
    canUpdatePatientInformationWithinReservation?: boolean;
    canUpsertAutomation?: boolean;
    canDeleteAutomation?: boolean;
    canReadAutomationDashboard?: boolean;
    canUpsertContent?: boolean;
    canDeleteContent?: boolean;
    canControlManualFolderAndTagStatus?: boolean;
    canCreateManual?: boolean;
    canAccessHospitalInformation?: boolean;
    canAccessHospitalService?: boolean;
    canAccessHospitalAccount?: boolean;
    canDownloadPatientData?: boolean;
    canAccessPaymentManagement?: boolean;
    canCreatePayment?: boolean;
    canUpsertMarketingAutomation?: boolean;
    canDeleteMarketingAutomation?: boolean;
    canReadMarketingAutomationDashboard?: boolean;
    canReadPaymentRecords?: boolean;
    canDownloadMarketingHistory?: boolean;
    canDownloadConsultationHistory?: boolean;
    canReadMedipalAIUsage?: boolean;
    canAdjustMedipalAITask?: boolean;
    canReadMedipalAIReservation?: boolean;
    canReadMedipalAICall?: boolean;
    canControlMedipalAICall?: boolean;
    sections?: any;
    createdAt?: string | null;
    updatedAt?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminMSOGroupControllerUpdateServiceStatusBodyRequest {
  _id: string;
  serviceStatus: "pending" | "run" | "closed";
}

export interface AdminMSOGroupControllerUpdateServiceStatusResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 다중 병원 그룹 관리명 (최대 30자) */
    name: string;
    /** 실가비(false) / 테스트(true) 구분 */
    isTest?: boolean;
    /** 서비스 상태: pending(대기 — 서비스 미시작/병원 생성됨), run(진행 — 서비스 시작), closed(종료 — 서비스 종료) */
    serviceStatus?: "pending" | "run" | "closed" | null;
    /** 그룹에 연결된 병원 ID 배열 */
    hospitalIDs: string[];
    /** 그룹 전용 공유 권한 문서 ID (ref AuthorizationType) */
    authorizationTypeID?: string;
    isDeleted?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
    /** @format date */
    deletedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: number;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name?: string;
    shortName?: string;
    msoHospitalName?: string;
    nurseID?: {
      _id: string;
      id?: string;
      name?: string;
      realName?: string;
    } | null;
    /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
    locale?: string;
    /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
    timezone?: string;
    isSMSSendingBlocked?: boolean;
    manualCount?: number;
    algorithmCount?: number;
    userCount?: number;
    usingVideoContent?: boolean;
    usingHospitalEvent?: boolean;
    serviceSetting?: {
      _id: string;
      isSample?: boolean;
      name?: string;
      treatmentCategories?: {
        _id?: string;
        categoryName?: string;
        hospitalID?: string;
        shortNum?: number;
        paletteIndex?: number;
        treatmentCautionID?: {
          hospitalID?: string;
          fileIDs?: {
            /** MongoDB Identifier */
            _id: string;
            paths: string[];
            aws?: {
              ETag: string;
              Location: string;
              Key: string;
              key: string;
              size?: {
                width?: number;
                height?: number;
              } | null;
              fileSize: number;
              fileName: string;
            }[];
          }[];
          writerID?: string;
          modifierID?: string;
          isRemoved?: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
          /** @format date */
          removedAt?: string;
        };
        folderID?: {
          _id?: string;
          name?: string;
          sortNum?: string;
          hospitalID?: string;
          isActive?: string;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        } | null;
        isUsingCustomColor?: boolean;
        customColor?: string;
        manualContent?: string;
        isActive?: boolean;
        writerID?: string;
        modifierID?: string;
        isRemoved?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        removedAt?: string;
      }[];
      usingChartNumber?: boolean;
      usingFirstVisitStartDate?: boolean;
      automationPolicy?: "SINGLE" | "MULTIPLE" | null;
      usingCountryCode?: boolean;
      usingBirthDay?: boolean;
      usingGender?: boolean;
      usingTreatmentTag?: boolean;
      usingNationality?: boolean;
      autoSendVideo?: boolean;
      usingAutoSendVideo?: {
        _id?: string;
        categoryName?: string;
        hospitalID?: string;
        sortNum?: number;
        parentCategoryIDs?: string[] | null;
        isTop?: boolean;
        isParent?: boolean;
        isHidden?: boolean;
        isBasic?: boolean;
        description?: string;
        typeName?: string;
        isConditioning?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
      }[];
      videoContentDuration?:
        | {
            categoryID?: string;
            duration?: number;
            doPerWeek?: number;
          }[]
        | null;
      defaultVCMessage?: string;
      defaultVCSMSMessage?: string;
      hospitalID?: string;
      selectedFirstVCH?: string;
      selectedSecondVCH?: string;
      firstVCUMessage?: string;
      secondVCUMessage?: string;
      /** @format date */
      sendVCInterval?: string;
      vcuBadge?: number;
      isRemoved?: boolean;
      topVCCategories?:
        | {
            categoryID?: string;
            sortNum?: number;
            isSelected?: boolean;
            categoryName?: string;
          }[]
        | null;
      colorPalette?: string;
      treatmentCautionMessage?: string;
      eventChatMessage?: string;
      aftercareChatMessage?: string;
      usingUserTag?: boolean;
      chatResponseRequiredTime?:
        | {
            dayIndex?: number;
            /** @format date */
            startedAt?: string;
            /** @format date */
            endedAt?: string;
          }[]
        | null;
      chatResponseRequiredUsers?: string;
      usingChatResponseRequired?: boolean;
      defaultCounselorId?: string;
      defaultCounselorIds?: string[] | null;
      usingChatTranslate?: boolean;
      /** 대기, 진행, 종료 세가지 */
      status?: string;
      /** 병원에서 생성 가능한 병원 직원 계정 최대 개수 */
      maximumCreatableAccountCount?: number;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      initialChats?: any[] | null;
      smsBasicMessage?: string;
      smsReservation?: string;
      smsResendMessage?: string;
      usingAutoReservedSMS?: boolean;
      autoReservedSMSMessage?: string;
      autoReservedSMSDelayDay?: number;
      autoReservedSMSHour?: number;
      usingKakaoAlimAndFriendTalkLinkage?: boolean;
      hasKakaoAlimAndFriendTalkLinkage?: boolean;
      /** @format date */
      kakaoAlimAndFriendTalkLinkedAt?: string;
      /** @format date */
      kakaoAlimAndFriendTalkUnlinkedAt?: string;
      hasKakaoConsultationTalkLinkage?: boolean;
      /** @format date */
      kakaoConsultationTalkLinkedAt?: string;
      /** @format date */
      kakaoConsultationTalkUnlinkedAt?: string;
      isReadyForKakaoAlimAndFriendTalkLinkage?: boolean;
      kakaoAlimAndFriendTalkReadyAt?: boolean;
      kakaoProfileSenderKeyAtReady?: string;
      hasTalkTalkLinkage?: boolean;
      /** @format date */
      talkTalkLinkedAt?: string;
      /** @format date */
      talkTalkUnlinkedAt?: string;
      maximumTalkTalkAccountCount?: number;
      hasLineLinkage?: boolean;
      /** @format date */
      lineLinkedAt?: string;
      /** @format date */
      lineUnlinkedAt?: string;
      maximumLineAccountCount?: number;
      accountCount?: number;
      usingRegisterSMSSend?: boolean;
      usingAdSMSConsent?: boolean;
      wechatLinkageInfo?: {
        enabled: boolean;
        maxCount: number;
      } | null;
      kakaoLinkageInfo?: {
        brandMessage: {
          enabled: boolean;
        };
      } | null;
      registAlimTalkTemplateCodeForKorean?: string;
      registAlimTalkTemplateNameForKorean?: string;
      registAlimTalkContentForKorean?: string;
    };
    integrationSetting?: {
      hospitalID: string;
      clientToken?: string;
      integrationType?: string;
      customObject?: {
        defaultLabelID?: string[];
        defaultCancelID?: string[];
      };
      usingRegist?: boolean;
      usingReservation?: boolean;
      usingDashboard?: boolean;
      isRemoved: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    };
    kakaoConsult?: {
      _id?: string;
      hospitalID?: string;
      pf_id?: string;
      accesskey?: string;
      isRemoved?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    } | null;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedA?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    shortName: string;
    businessName?: string;
    /** MSO(2501) 계정 로그인 시 좌측 병원 선택 목록에 표시되는 다중 병원명 (선택, 최대 15자) */
    msoHospitalName?: string;
    address?: string;
    addressInfo?: Record<string, string>;
    addressInfoNaver?: Record<string, string>;
    department?: string[];
    introduction?: string;
    representImage?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    representUser: string;
    homepageURL?: string;
    phone?: string;
    smsPhone?: string;
    isSMSSendingBlocked?: boolean;
    /** @format date */
    smsSendingBlockedAt?: string;
    /** @format date */
    smsSendingUnblockedAt?: string;
    smsSendingBlockedBy?: string;
    smsSendingBlockReason?: string;
    isHiddenPhoneNumber?: boolean;
    usingHomepage?: boolean;
    initialChat?: string;
    initialChats?: {
      chatType?: number;
      content?: string;
      fileIDs?: any[] | null;
    }[];
    defaultFlag: string;
    therapyList?: string[];
    additionalInfo?: {
      stringInfo?: string;
    };
    isBasicMessage?: boolean;
    smsMessage?: string;
    smsMessageA?: string;
    smsMessageB?: string;
    smsChatMessage?: string;
    smsChatMessageA?: string;
    smsChatMessageB?: string;
    usingBasicMessage?: boolean;
    smsBasicMessage?: string;
    smsBasicMessageEdit?: string;
    usingReservationMessage?: boolean;
    smsReservation?: string;
    smsReservationEdit?: string;
    usingResendMessage?: boolean;
    smsResendMessage?: string;
    smsResendMessageEdit?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    chatReservationGuide?: string;
    careSchedule?: {
      dayIndex?: number;
      /** @format date */
      startedAt?: string;
      /** @format date */
      endedAt?: string;
    }[];
    careScheduleDescription?: string;
    smsLogoImage?:
      | string
      | {
          _id?: string;
          paths?: string[] | null;
          aws?: any[] | null;
        };
    isUsingLogo?: boolean;
    nurseID?: {
      _id?: string;
      name?: string;
      id?: string;
    } | null;
    nurseIDs?: string[];
    hospitalType?: "single" | "multi";
    usingRegistUser?: boolean;
    isClosed: boolean;
    serviceSetting: string;
    hasActiveSheet?: boolean;
    isSecondEdition?: boolean;
    usingVideoContent: boolean;
    usingHospitalEvent?: boolean;
    healthContentCategory?: string[];
    usingHealthContent: boolean;
    usingHospitalContent?: boolean;
    integrationSetting?: string;
    usingAfterhoursPopup?: boolean;
    afterhoursPopupContent?: string;
    usingV2ReservationSheet?: boolean;
    usingSaaSReservation?: boolean;
    isEnabledSaaS?: boolean;
    isTest?: boolean;
    /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
    locale?: string;
    /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
    timezone?: string;
    unsubscriptionPhone?: string;
    unsubscriptionNumber?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalUpdateHandlerBodyRequest {
  _id: string;
  isTest?: boolean;
  shortName?: string;
  /** MSO(2501) 계정 로그인 시 좌측 병원 선택 목록에 표시되는 다중 병원명 (선택, 최대 15자) */
  msoHospitalName?: string;
  usingHealthContent?: boolean;
  healthContentCategory?: string;
  usingHospitalContent?: boolean;
  isUsingLogo?: boolean;
  representImage?: string;
  initialChats?: {
    chatType?: number;
    content?: string;
    fileIDs?: string[] | null;
  }[];
  smsBasicMessage?: string;
  smsReservation?: string;
  smsResendMessage?: string;
  usingAutoReservedSMS?: boolean;
  autoReservedSMSMessage?: string;
  autoReservedSMSDelayDay?: number;
  autoReservedSMSHour?: number;
  usingVideoContent?: boolean;
  usingHospitalEvent?: boolean;
  nurseID?: string;
  usingAfterhoursPopup?: boolean;
  afterhoursPopupContent?: string;
  usingSaaSReservation?: boolean;
  /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
  locale?: string;
  /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
  timezone?: string;
}

export interface AdminHospitalUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    shortName: string;
    businessName?: string;
    /** MSO(2501) 계정 로그인 시 좌측 병원 선택 목록에 표시되는 다중 병원명 (선택, 최대 15자) */
    msoHospitalName?: string;
    address?: string;
    addressInfo?: Record<string, string>;
    addressInfoNaver?: Record<string, string>;
    department?: string[];
    introduction?: string;
    representImage?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    representUser: string;
    homepageURL?: string;
    phone?: string;
    smsPhone?: string;
    isSMSSendingBlocked?: boolean;
    /** @format date */
    smsSendingBlockedAt?: string;
    /** @format date */
    smsSendingUnblockedAt?: string;
    smsSendingBlockedBy?: string;
    smsSendingBlockReason?: string;
    isHiddenPhoneNumber?: boolean;
    usingHomepage?: boolean;
    initialChat?: string;
    initialChats?: {
      chatType?: number;
      content?: string;
      fileIDs?: any[] | null;
    }[];
    defaultFlag: string;
    therapyList?: string[];
    additionalInfo?: {
      stringInfo?: string;
    };
    isBasicMessage?: boolean;
    smsMessage?: string;
    smsMessageA?: string;
    smsMessageB?: string;
    smsChatMessage?: string;
    smsChatMessageA?: string;
    smsChatMessageB?: string;
    usingBasicMessage?: boolean;
    smsBasicMessage?: string;
    smsBasicMessageEdit?: string;
    usingReservationMessage?: boolean;
    smsReservation?: string;
    smsReservationEdit?: string;
    usingResendMessage?: boolean;
    smsResendMessage?: string;
    smsResendMessageEdit?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    chatReservationGuide?: string;
    careSchedule?: {
      dayIndex?: number;
      /** @format date */
      startedAt?: string;
      /** @format date */
      endedAt?: string;
    }[];
    careScheduleDescription?: string;
    smsLogoImage?:
      | string
      | {
          _id?: string;
          paths?: string[] | null;
          aws?: any[] | null;
        };
    isUsingLogo?: boolean;
    nurseID?: {
      _id?: string;
      name?: string;
      id?: string;
    } | null;
    nurseIDs?: string[];
    hospitalType?: "single" | "multi";
    usingRegistUser?: boolean;
    isClosed: boolean;
    serviceSetting: string;
    hasActiveSheet?: boolean;
    isSecondEdition?: boolean;
    usingVideoContent: boolean;
    usingHospitalEvent?: boolean;
    healthContentCategory?: string[];
    usingHealthContent: boolean;
    usingHospitalContent?: boolean;
    integrationSetting?: string;
    usingAfterhoursPopup?: boolean;
    afterhoursPopupContent?: string;
    usingV2ReservationSheet?: boolean;
    usingSaaSReservation?: boolean;
    isEnabledSaaS?: boolean;
    isTest?: boolean;
    /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
    locale?: string;
    /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
    timezone?: string;
    unsubscriptionPhone?: string;
    unsubscriptionNumber?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalCreateHandlerBodyRequest {
  isEnabledSaaS?: boolean;
  isTest?: boolean;
  shortName?: string;
  /** MSO(2501) 계정 로그인 시 좌측 병원 선택 목록에 표시되는 다중 병원명 (선택, 최대 15자) */
  msoHospitalName?: string;
  usingHealthContent?: boolean;
  healthContentCategory?: string;
  usingHospitalContent?: boolean;
  isUsingLogo?: boolean;
  representImage?: string;
  initialChats?: {
    chatType?: number;
    content?: string;
    fileIDs?: string[] | null;
  }[];
  smsBasicMessage?: string;
  smsReservation?: string;
  smsResendMessage?: string;
  usingAutoReservedSMS?: boolean;
  autoReservedSMSMessage?: string;
  autoReservedSMSDelayDay?: number;
  autoReservedSMSHour?: number;
  usingVideoContent?: boolean;
  usingHospitalEvent?: boolean;
  nurseID?: string;
  careSchedule?: ({
    dayIndex?: number;
    /** @format date */
    startedAt?: string;
    /** @format date */
    endedAt?: string;
    isActive?: boolean;
  } | null)[];
  /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
  locale?: string;
  /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
  timezone?: string;
}

export interface AdminHospitalCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    shortName: string;
    businessName?: string;
    /** MSO(2501) 계정 로그인 시 좌측 병원 선택 목록에 표시되는 다중 병원명 (선택, 최대 15자) */
    msoHospitalName?: string;
    address?: string;
    addressInfo?: Record<string, string>;
    addressInfoNaver?: Record<string, string>;
    department?: string[];
    introduction?: string;
    representImage?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    representUser: string;
    homepageURL?: string;
    phone?: string;
    smsPhone?: string;
    isSMSSendingBlocked?: boolean;
    /** @format date */
    smsSendingBlockedAt?: string;
    /** @format date */
    smsSendingUnblockedAt?: string;
    smsSendingBlockedBy?: string;
    smsSendingBlockReason?: string;
    isHiddenPhoneNumber?: boolean;
    usingHomepage?: boolean;
    initialChat?: string;
    initialChats?: {
      chatType?: number;
      content?: string;
      fileIDs?: any[] | null;
    }[];
    defaultFlag: string;
    therapyList?: string[];
    additionalInfo?: {
      stringInfo?: string;
    };
    isBasicMessage?: boolean;
    smsMessage?: string;
    smsMessageA?: string;
    smsMessageB?: string;
    smsChatMessage?: string;
    smsChatMessageA?: string;
    smsChatMessageB?: string;
    usingBasicMessage?: boolean;
    smsBasicMessage?: string;
    smsBasicMessageEdit?: string;
    usingReservationMessage?: boolean;
    smsReservation?: string;
    smsReservationEdit?: string;
    usingResendMessage?: boolean;
    smsResendMessage?: string;
    smsResendMessageEdit?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    chatReservationGuide?: string;
    careSchedule?: {
      dayIndex?: number;
      /** @format date */
      startedAt?: string;
      /** @format date */
      endedAt?: string;
    }[];
    careScheduleDescription?: string;
    smsLogoImage?:
      | string
      | {
          _id?: string;
          paths?: string[] | null;
          aws?: any[] | null;
        };
    isUsingLogo?: boolean;
    nurseID?: {
      _id?: string;
      name?: string;
      id?: string;
    } | null;
    nurseIDs?: string[];
    hospitalType?: "single" | "multi";
    usingRegistUser?: boolean;
    isClosed: boolean;
    serviceSetting: string;
    hasActiveSheet?: boolean;
    isSecondEdition?: boolean;
    usingVideoContent: boolean;
    usingHospitalEvent?: boolean;
    healthContentCategory?: string[];
    usingHealthContent: boolean;
    usingHospitalContent?: boolean;
    integrationSetting?: string;
    usingAfterhoursPopup?: boolean;
    afterhoursPopupContent?: string;
    usingV2ReservationSheet?: boolean;
    usingSaaSReservation?: boolean;
    isEnabledSaaS?: boolean;
    isTest?: boolean;
    /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
    locale?: string;
    /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
    timezone?: string;
    unsubscriptionPhone?: string;
    unsubscriptionNumber?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalUpdateNameHandlerBodyRequest {
  _id: string;
  businessName: string;
}

export interface AdminHospitalUpdateNameHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    shortName: string;
    businessName?: string;
    /** MSO(2501) 계정 로그인 시 좌측 병원 선택 목록에 표시되는 다중 병원명 (선택, 최대 15자) */
    msoHospitalName?: string;
    address?: string;
    addressInfo?: Record<string, string>;
    addressInfoNaver?: Record<string, string>;
    department?: string[];
    introduction?: string;
    representImage?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    representUser: string;
    homepageURL?: string;
    phone?: string;
    smsPhone?: string;
    isSMSSendingBlocked?: boolean;
    /** @format date */
    smsSendingBlockedAt?: string;
    /** @format date */
    smsSendingUnblockedAt?: string;
    smsSendingBlockedBy?: string;
    smsSendingBlockReason?: string;
    isHiddenPhoneNumber?: boolean;
    usingHomepage?: boolean;
    initialChat?: string;
    initialChats?: {
      chatType?: number;
      content?: string;
      fileIDs?: any[] | null;
    }[];
    defaultFlag: string;
    therapyList?: string[];
    additionalInfo?: {
      stringInfo?: string;
    };
    isBasicMessage?: boolean;
    smsMessage?: string;
    smsMessageA?: string;
    smsMessageB?: string;
    smsChatMessage?: string;
    smsChatMessageA?: string;
    smsChatMessageB?: string;
    usingBasicMessage?: boolean;
    smsBasicMessage?: string;
    smsBasicMessageEdit?: string;
    usingReservationMessage?: boolean;
    smsReservation?: string;
    smsReservationEdit?: string;
    usingResendMessage?: boolean;
    smsResendMessage?: string;
    smsResendMessageEdit?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    chatReservationGuide?: string;
    careSchedule?: {
      dayIndex?: number;
      /** @format date */
      startedAt?: string;
      /** @format date */
      endedAt?: string;
    }[];
    careScheduleDescription?: string;
    smsLogoImage?:
      | string
      | {
          _id?: string;
          paths?: string[] | null;
          aws?: any[] | null;
        };
    isUsingLogo?: boolean;
    nurseID?: {
      _id?: string;
      name?: string;
      id?: string;
    } | null;
    nurseIDs?: string[];
    hospitalType?: "single" | "multi";
    usingRegistUser?: boolean;
    isClosed: boolean;
    serviceSetting: string;
    hasActiveSheet?: boolean;
    isSecondEdition?: boolean;
    usingVideoContent: boolean;
    usingHospitalEvent?: boolean;
    healthContentCategory?: string[];
    usingHealthContent: boolean;
    usingHospitalContent?: boolean;
    integrationSetting?: string;
    usingAfterhoursPopup?: boolean;
    afterhoursPopupContent?: string;
    usingV2ReservationSheet?: boolean;
    usingSaaSReservation?: boolean;
    isEnabledSaaS?: boolean;
    isTest?: boolean;
    /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
    locale?: string;
    /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
    timezone?: string;
    unsubscriptionPhone?: string;
    unsubscriptionNumber?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalUpdateSMSPhoneHandlerBodyRequest {
  _id: string;
  smsPhone: string;
}

export interface AdminHospitalUpdateSMSPhoneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    shortName: string;
    businessName?: string;
    /** MSO(2501) 계정 로그인 시 좌측 병원 선택 목록에 표시되는 다중 병원명 (선택, 최대 15자) */
    msoHospitalName?: string;
    address?: string;
    addressInfo?: Record<string, string>;
    addressInfoNaver?: Record<string, string>;
    department?: string[];
    introduction?: string;
    representImage?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    representUser: string;
    homepageURL?: string;
    phone?: string;
    smsPhone?: string;
    isSMSSendingBlocked?: boolean;
    /** @format date */
    smsSendingBlockedAt?: string;
    /** @format date */
    smsSendingUnblockedAt?: string;
    smsSendingBlockedBy?: string;
    smsSendingBlockReason?: string;
    isHiddenPhoneNumber?: boolean;
    usingHomepage?: boolean;
    initialChat?: string;
    initialChats?: {
      chatType?: number;
      content?: string;
      fileIDs?: any[] | null;
    }[];
    defaultFlag: string;
    therapyList?: string[];
    additionalInfo?: {
      stringInfo?: string;
    };
    isBasicMessage?: boolean;
    smsMessage?: string;
    smsMessageA?: string;
    smsMessageB?: string;
    smsChatMessage?: string;
    smsChatMessageA?: string;
    smsChatMessageB?: string;
    usingBasicMessage?: boolean;
    smsBasicMessage?: string;
    smsBasicMessageEdit?: string;
    usingReservationMessage?: boolean;
    smsReservation?: string;
    smsReservationEdit?: string;
    usingResendMessage?: boolean;
    smsResendMessage?: string;
    smsResendMessageEdit?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    chatReservationGuide?: string;
    careSchedule?: {
      dayIndex?: number;
      /** @format date */
      startedAt?: string;
      /** @format date */
      endedAt?: string;
    }[];
    careScheduleDescription?: string;
    smsLogoImage?:
      | string
      | {
          _id?: string;
          paths?: string[] | null;
          aws?: any[] | null;
        };
    isUsingLogo?: boolean;
    nurseID?: {
      _id?: string;
      name?: string;
      id?: string;
    } | null;
    nurseIDs?: string[];
    hospitalType?: "single" | "multi";
    usingRegistUser?: boolean;
    isClosed: boolean;
    serviceSetting: string;
    hasActiveSheet?: boolean;
    isSecondEdition?: boolean;
    usingVideoContent: boolean;
    usingHospitalEvent?: boolean;
    healthContentCategory?: string[];
    usingHealthContent: boolean;
    usingHospitalContent?: boolean;
    integrationSetting?: string;
    usingAfterhoursPopup?: boolean;
    afterhoursPopupContent?: string;
    usingV2ReservationSheet?: boolean;
    usingSaaSReservation?: boolean;
    isEnabledSaaS?: boolean;
    isTest?: boolean;
    /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
    locale?: string;
    /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
    timezone?: string;
    unsubscriptionPhone?: string;
    unsubscriptionNumber?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalTestHServiceSMSFlowHandlerBodyRequest {
  _id: string;
}

export interface AdminHospitalTestHServiceSMSFlowHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    isCreatedSuccess?: boolean;
    isSMSSendingBlocked?: boolean;
    smsSendingBlockedMessage?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalSMSStatusFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 필터 조건에 해당하는 전체 병원 수 */
    totalCount: number;
    /** 전체 페이지 수 */
    totalPages: number;
    /** 현재 페이지 (1부터 시작) */
    currentPage: number;
    /** 페이지 당 조회 수 */
    limit: number;
    /** 다음 페이지 존재 여부 */
    hasNextPage?: boolean;
    /** 병원별 문자 발송 현황 목록 */
    list: {
      _id: string;
      name?: string;
      shortName?: string;
      isTest?: boolean;
      timezone?: string;
      smsPhone?: string;
      isSMSSendingBlocked?: boolean;
      /** @format date */
      smsSendingBlockedAt?: string;
      /** @format date */
      smsSendingUnblockedAt?: string;
      smsSendingBlockedBy?: string;
      smsSendingBlockReason?: string;
      usingRegisterSMSSend?: boolean;
      usingAutoReservedSMS?: boolean;
      hasKakaoAlimTalkLinkage?: boolean;
      /** @format date */
      createdAt?: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalSMSStatusCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: number;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalUpdateSMSBlockHandlerBodyRequest {
  hospitalID: string;
  isSMSSendingBlocked: boolean;
  reason?: string;
}

export interface AdminHospitalUpdateSMSBlockHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    shortName?: string;
    isSMSSendingBlocked?: boolean;
    /** @format date */
    smsSendingBlockedAt?: string;
    /** @format date */
    smsSendingUnblockedAt?: string;
    smsSendingBlockedBy?: string;
    smsSendingBlockReason?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminServiceSettingCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: number;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminServiceSettingFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    isSample?: boolean;
    name?: string;
    treatmentCategories?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      shortNum?: number;
      paletteIndex?: number;
      treatmentCautionID?: {
        hospitalID?: string;
        fileIDs?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        }[];
        writerID?: string;
        modifierID?: string;
        isRemoved?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        removedAt?: string;
      };
      folderID?: {
        _id?: string;
        name?: string;
        sortNum?: string;
        hospitalID?: string;
        isActive?: string;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
      } | null;
      isUsingCustomColor?: boolean;
      customColor?: string;
      manualContent?: string;
      isActive?: boolean;
      writerID?: string;
      modifierID?: string;
      isRemoved?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    }[];
    usingChartNumber?: boolean;
    usingFirstVisitStartDate?: boolean;
    automationPolicy?: "SINGLE" | "MULTIPLE" | null;
    usingCountryCode?: boolean;
    usingBirthDay?: boolean;
    usingGender?: boolean;
    usingTreatmentTag?: boolean;
    usingNationality?: boolean;
    autoSendVideo?: boolean;
    usingAutoSendVideo?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      sortNum?: number;
      parentCategoryIDs?: string[] | null;
      isTop?: boolean;
      isParent?: boolean;
      isHidden?: boolean;
      isBasic?: boolean;
      description?: string;
      typeName?: string;
      isConditioning?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    }[];
    videoContentDuration?:
      | {
          categoryID?: string;
          duration?: number;
          doPerWeek?: number;
        }[]
      | null;
    defaultVCMessage?: string;
    defaultVCSMSMessage?: string;
    hospitalID?: string;
    selectedFirstVCH?: string;
    selectedSecondVCH?: string;
    firstVCUMessage?: string;
    secondVCUMessage?: string;
    /** @format date */
    sendVCInterval?: string;
    vcuBadge?: number;
    isRemoved?: boolean;
    topVCCategories?:
      | {
          categoryID?: string;
          sortNum?: number;
          isSelected?: boolean;
          categoryName?: string;
        }[]
      | null;
    colorPalette?: string;
    treatmentCautionMessage?: string;
    eventChatMessage?: string;
    aftercareChatMessage?: string;
    usingUserTag?: boolean;
    chatResponseRequiredTime?:
      | {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[]
      | null;
    chatResponseRequiredUsers?: string;
    usingChatResponseRequired?: boolean;
    defaultCounselorId?: string;
    defaultCounselorIds?: string[] | null;
    usingChatTranslate?: boolean;
    /** 대기, 진행, 종료 세가지 */
    status?: string;
    /** 병원에서 생성 가능한 병원 직원 계정 최대 개수 */
    maximumCreatableAccountCount?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    initialChats?: any[] | null;
    smsBasicMessage?: string;
    smsReservation?: string;
    smsResendMessage?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    usingKakaoAlimAndFriendTalkLinkage?: boolean;
    hasKakaoAlimAndFriendTalkLinkage?: boolean;
    /** @format date */
    kakaoAlimAndFriendTalkLinkedAt?: string;
    /** @format date */
    kakaoAlimAndFriendTalkUnlinkedAt?: string;
    hasKakaoConsultationTalkLinkage?: boolean;
    /** @format date */
    kakaoConsultationTalkLinkedAt?: string;
    /** @format date */
    kakaoConsultationTalkUnlinkedAt?: string;
    isReadyForKakaoAlimAndFriendTalkLinkage?: boolean;
    kakaoAlimAndFriendTalkReadyAt?: boolean;
    kakaoProfileSenderKeyAtReady?: string;
    hasTalkTalkLinkage?: boolean;
    /** @format date */
    talkTalkLinkedAt?: string;
    /** @format date */
    talkTalkUnlinkedAt?: string;
    maximumTalkTalkAccountCount?: number;
    hasLineLinkage?: boolean;
    /** @format date */
    lineLinkedAt?: string;
    /** @format date */
    lineUnlinkedAt?: string;
    maximumLineAccountCount?: number;
    accountCount?: number;
    usingRegisterSMSSend?: boolean;
    usingAdSMSConsent?: boolean;
    wechatLinkageInfo?: {
      enabled: boolean;
      maxCount: number;
    } | null;
    kakaoLinkageInfo?: {
      brandMessage: {
        enabled: boolean;
      };
    } | null;
    registAlimTalkTemplateCodeForKorean?: string;
    registAlimTalkTemplateNameForKorean?: string;
    registAlimTalkContentForKorean?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminServiceSettingFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    isSample?: boolean;
    name?: string;
    treatmentCategories?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      shortNum?: number;
      paletteIndex?: number;
      treatmentCautionID?: {
        hospitalID?: string;
        fileIDs?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        }[];
        writerID?: string;
        modifierID?: string;
        isRemoved?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        removedAt?: string;
      };
      folderID?: {
        _id?: string;
        name?: string;
        sortNum?: string;
        hospitalID?: string;
        isActive?: string;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
      } | null;
      isUsingCustomColor?: boolean;
      customColor?: string;
      manualContent?: string;
      isActive?: boolean;
      writerID?: string;
      modifierID?: string;
      isRemoved?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    }[];
    usingChartNumber?: boolean;
    usingFirstVisitStartDate?: boolean;
    automationPolicy?: "SINGLE" | "MULTIPLE" | null;
    usingCountryCode?: boolean;
    usingBirthDay?: boolean;
    usingGender?: boolean;
    usingTreatmentTag?: boolean;
    usingNationality?: boolean;
    autoSendVideo?: boolean;
    usingAutoSendVideo?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      sortNum?: number;
      parentCategoryIDs?: string[] | null;
      isTop?: boolean;
      isParent?: boolean;
      isHidden?: boolean;
      isBasic?: boolean;
      description?: string;
      typeName?: string;
      isConditioning?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    }[];
    videoContentDuration?:
      | {
          categoryID?: string;
          duration?: number;
          doPerWeek?: number;
        }[]
      | null;
    defaultVCMessage?: string;
    defaultVCSMSMessage?: string;
    hospitalID?: string;
    selectedFirstVCH?: string;
    selectedSecondVCH?: string;
    firstVCUMessage?: string;
    secondVCUMessage?: string;
    /** @format date */
    sendVCInterval?: string;
    vcuBadge?: number;
    isRemoved?: boolean;
    topVCCategories?:
      | {
          categoryID?: string;
          sortNum?: number;
          isSelected?: boolean;
          categoryName?: string;
        }[]
      | null;
    colorPalette?: string;
    treatmentCautionMessage?: string;
    eventChatMessage?: string;
    aftercareChatMessage?: string;
    usingUserTag?: boolean;
    chatResponseRequiredTime?:
      | {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[]
      | null;
    chatResponseRequiredUsers?: string;
    usingChatResponseRequired?: boolean;
    defaultCounselorId?: string;
    defaultCounselorIds?: string[] | null;
    usingChatTranslate?: boolean;
    /** 대기, 진행, 종료 세가지 */
    status?: string;
    /** 병원에서 생성 가능한 병원 직원 계정 최대 개수 */
    maximumCreatableAccountCount?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    initialChats?: any[] | null;
    smsBasicMessage?: string;
    smsReservation?: string;
    smsResendMessage?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    usingKakaoAlimAndFriendTalkLinkage?: boolean;
    hasKakaoAlimAndFriendTalkLinkage?: boolean;
    /** @format date */
    kakaoAlimAndFriendTalkLinkedAt?: string;
    /** @format date */
    kakaoAlimAndFriendTalkUnlinkedAt?: string;
    hasKakaoConsultationTalkLinkage?: boolean;
    /** @format date */
    kakaoConsultationTalkLinkedAt?: string;
    /** @format date */
    kakaoConsultationTalkUnlinkedAt?: string;
    isReadyForKakaoAlimAndFriendTalkLinkage?: boolean;
    kakaoAlimAndFriendTalkReadyAt?: boolean;
    kakaoProfileSenderKeyAtReady?: string;
    hasTalkTalkLinkage?: boolean;
    /** @format date */
    talkTalkLinkedAt?: string;
    /** @format date */
    talkTalkUnlinkedAt?: string;
    maximumTalkTalkAccountCount?: number;
    hasLineLinkage?: boolean;
    /** @format date */
    lineLinkedAt?: string;
    /** @format date */
    lineUnlinkedAt?: string;
    maximumLineAccountCount?: number;
    accountCount?: number;
    usingRegisterSMSSend?: boolean;
    usingAdSMSConsent?: boolean;
    wechatLinkageInfo?: {
      enabled: boolean;
      maxCount: number;
    } | null;
    kakaoLinkageInfo?: {
      brandMessage: {
        enabled: boolean;
      };
    } | null;
    registAlimTalkTemplateCodeForKorean?: string;
    registAlimTalkTemplateNameForKorean?: string;
    registAlimTalkContentForKorean?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminServiceSettingCreateHandlerBodyRequest {
  hospitalID: string;
  isSample?: boolean;
  isEnabledSaaS?: boolean;
  name?: string;
  defaultVCMessage?: string;
  defaultVCSMSMessage?: string;
  usingChatTranslate?: boolean;
  automationPolicy?: "SINGLE" | "MULTIPLE" | null;
  usingHealthContent?: boolean;
  initialChats?: Record<string, any>[] | null;
  smsBasicMessage?: string;
  smsReservation?: string;
  smsResendMessage?: string;
  usingAutoReservedSMS?: boolean;
  autoReservedSMSMessage?: string;
  usingTreatmentTag?: boolean;
  usingBizPpurioMessageService?: boolean;
  usingRegisterSMSSend?: boolean;
  usingAdSMSConsent?: boolean;
  registAlimTalkTemplateCodeForKorean?: string;
  registAlimTalkTemplateNameForKorean?: string;
  registAlimTalkContentForKorean?: string;
}

export interface AdminServiceSettingCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    isSample?: boolean;
    name?: string;
    treatmentCategories?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      shortNum?: number;
      paletteIndex?: number;
      treatmentCautionID?: {
        hospitalID?: string;
        fileIDs?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        }[];
        writerID?: string;
        modifierID?: string;
        isRemoved?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        removedAt?: string;
      };
      folderID?: {
        _id?: string;
        name?: string;
        sortNum?: string;
        hospitalID?: string;
        isActive?: string;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
      } | null;
      isUsingCustomColor?: boolean;
      customColor?: string;
      manualContent?: string;
      isActive?: boolean;
      writerID?: string;
      modifierID?: string;
      isRemoved?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    }[];
    usingChartNumber?: boolean;
    usingFirstVisitStartDate?: boolean;
    automationPolicy?: "SINGLE" | "MULTIPLE" | null;
    usingCountryCode?: boolean;
    usingBirthDay?: boolean;
    usingGender?: boolean;
    usingTreatmentTag?: boolean;
    usingNationality?: boolean;
    autoSendVideo?: boolean;
    usingAutoSendVideo?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      sortNum?: number;
      parentCategoryIDs?: string[] | null;
      isTop?: boolean;
      isParent?: boolean;
      isHidden?: boolean;
      isBasic?: boolean;
      description?: string;
      typeName?: string;
      isConditioning?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    }[];
    videoContentDuration?:
      | {
          categoryID?: string;
          duration?: number;
          doPerWeek?: number;
        }[]
      | null;
    defaultVCMessage?: string;
    defaultVCSMSMessage?: string;
    hospitalID?: string;
    selectedFirstVCH?: string;
    selectedSecondVCH?: string;
    firstVCUMessage?: string;
    secondVCUMessage?: string;
    /** @format date */
    sendVCInterval?: string;
    vcuBadge?: number;
    isRemoved?: boolean;
    topVCCategories?:
      | {
          categoryID?: string;
          sortNum?: number;
          isSelected?: boolean;
          categoryName?: string;
        }[]
      | null;
    colorPalette?: string;
    treatmentCautionMessage?: string;
    eventChatMessage?: string;
    aftercareChatMessage?: string;
    usingUserTag?: boolean;
    chatResponseRequiredTime?:
      | {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[]
      | null;
    chatResponseRequiredUsers?: string;
    usingChatResponseRequired?: boolean;
    defaultCounselorId?: string;
    defaultCounselorIds?: string[] | null;
    usingChatTranslate?: boolean;
    /** 대기, 진행, 종료 세가지 */
    status?: string;
    /** 병원에서 생성 가능한 병원 직원 계정 최대 개수 */
    maximumCreatableAccountCount?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    initialChats?: any[] | null;
    smsBasicMessage?: string;
    smsReservation?: string;
    smsResendMessage?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    usingKakaoAlimAndFriendTalkLinkage?: boolean;
    hasKakaoAlimAndFriendTalkLinkage?: boolean;
    /** @format date */
    kakaoAlimAndFriendTalkLinkedAt?: string;
    /** @format date */
    kakaoAlimAndFriendTalkUnlinkedAt?: string;
    hasKakaoConsultationTalkLinkage?: boolean;
    /** @format date */
    kakaoConsultationTalkLinkedAt?: string;
    /** @format date */
    kakaoConsultationTalkUnlinkedAt?: string;
    isReadyForKakaoAlimAndFriendTalkLinkage?: boolean;
    kakaoAlimAndFriendTalkReadyAt?: boolean;
    kakaoProfileSenderKeyAtReady?: string;
    hasTalkTalkLinkage?: boolean;
    /** @format date */
    talkTalkLinkedAt?: string;
    /** @format date */
    talkTalkUnlinkedAt?: string;
    maximumTalkTalkAccountCount?: number;
    hasLineLinkage?: boolean;
    /** @format date */
    lineLinkedAt?: string;
    /** @format date */
    lineUnlinkedAt?: string;
    maximumLineAccountCount?: number;
    accountCount?: number;
    usingRegisterSMSSend?: boolean;
    usingAdSMSConsent?: boolean;
    wechatLinkageInfo?: {
      enabled: boolean;
      maxCount: number;
    } | null;
    kakaoLinkageInfo?: {
      brandMessage: {
        enabled: boolean;
      };
    } | null;
    registAlimTalkTemplateCodeForKorean?: string;
    registAlimTalkTemplateNameForKorean?: string;
    registAlimTalkContentForKorean?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminServiceSettingUpdateHandlerBodyRequest {
  _id: string;
  defaultVCMessage?: string;
  defaultVCSMSMessage?: string;
  usingChatTranslate?: boolean;
  autoSendVideo?: boolean;
  /** 배열을 string으로 파싱하여 전달할 것 */
  usingAutoSendVideo?: string;
  automationPolicy?: "SINGLE" | "MULTIPLE" | null;
  initialChats?: {
    chatType?: number;
    content?: string;
    fileIDs?: any[] | null;
  }[];
  smsBasicMessage?: string;
  smsReservation?: string;
  smsResendMessage?: string;
  usingAutoReservedSMS?: boolean;
  autoReservedSMSMessage?: string;
  autoReservedSMSDelayDay?: number;
  autoReservedSMSHour?: number;
  usingRegisterSMSSend?: boolean;
  usingAdSMSConsent?: boolean;
  usingBizPpurioMessageService?: boolean;
  registAlimTalkTemplateCodeForKorean?: string;
  registAlimTalkTemplateNameForKorean?: string;
  registAlimTalkContentForKorean?: string;
}

export interface AdminServiceSettingUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    isSample?: boolean;
    name?: string;
    treatmentCategories?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      shortNum?: number;
      paletteIndex?: number;
      treatmentCautionID?: {
        hospitalID?: string;
        fileIDs?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        }[];
        writerID?: string;
        modifierID?: string;
        isRemoved?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        removedAt?: string;
      };
      folderID?: {
        _id?: string;
        name?: string;
        sortNum?: string;
        hospitalID?: string;
        isActive?: string;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
      } | null;
      isUsingCustomColor?: boolean;
      customColor?: string;
      manualContent?: string;
      isActive?: boolean;
      writerID?: string;
      modifierID?: string;
      isRemoved?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    }[];
    usingChartNumber?: boolean;
    usingFirstVisitStartDate?: boolean;
    automationPolicy?: "SINGLE" | "MULTIPLE" | null;
    usingCountryCode?: boolean;
    usingBirthDay?: boolean;
    usingGender?: boolean;
    usingTreatmentTag?: boolean;
    usingNationality?: boolean;
    autoSendVideo?: boolean;
    usingAutoSendVideo?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      sortNum?: number;
      parentCategoryIDs?: string[] | null;
      isTop?: boolean;
      isParent?: boolean;
      isHidden?: boolean;
      isBasic?: boolean;
      description?: string;
      typeName?: string;
      isConditioning?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    }[];
    videoContentDuration?:
      | {
          categoryID?: string;
          duration?: number;
          doPerWeek?: number;
        }[]
      | null;
    defaultVCMessage?: string;
    defaultVCSMSMessage?: string;
    hospitalID?: string;
    selectedFirstVCH?: string;
    selectedSecondVCH?: string;
    firstVCUMessage?: string;
    secondVCUMessage?: string;
    /** @format date */
    sendVCInterval?: string;
    vcuBadge?: number;
    isRemoved?: boolean;
    topVCCategories?:
      | {
          categoryID?: string;
          sortNum?: number;
          isSelected?: boolean;
          categoryName?: string;
        }[]
      | null;
    colorPalette?: string;
    treatmentCautionMessage?: string;
    eventChatMessage?: string;
    aftercareChatMessage?: string;
    usingUserTag?: boolean;
    chatResponseRequiredTime?:
      | {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[]
      | null;
    chatResponseRequiredUsers?: string;
    usingChatResponseRequired?: boolean;
    defaultCounselorId?: string;
    defaultCounselorIds?: string[] | null;
    usingChatTranslate?: boolean;
    /** 대기, 진행, 종료 세가지 */
    status?: string;
    /** 병원에서 생성 가능한 병원 직원 계정 최대 개수 */
    maximumCreatableAccountCount?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    initialChats?: any[] | null;
    smsBasicMessage?: string;
    smsReservation?: string;
    smsResendMessage?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    usingKakaoAlimAndFriendTalkLinkage?: boolean;
    hasKakaoAlimAndFriendTalkLinkage?: boolean;
    /** @format date */
    kakaoAlimAndFriendTalkLinkedAt?: string;
    /** @format date */
    kakaoAlimAndFriendTalkUnlinkedAt?: string;
    hasKakaoConsultationTalkLinkage?: boolean;
    /** @format date */
    kakaoConsultationTalkLinkedAt?: string;
    /** @format date */
    kakaoConsultationTalkUnlinkedAt?: string;
    isReadyForKakaoAlimAndFriendTalkLinkage?: boolean;
    kakaoAlimAndFriendTalkReadyAt?: boolean;
    kakaoProfileSenderKeyAtReady?: string;
    hasTalkTalkLinkage?: boolean;
    /** @format date */
    talkTalkLinkedAt?: string;
    /** @format date */
    talkTalkUnlinkedAt?: string;
    maximumTalkTalkAccountCount?: number;
    hasLineLinkage?: boolean;
    /** @format date */
    lineLinkedAt?: string;
    /** @format date */
    lineUnlinkedAt?: string;
    maximumLineAccountCount?: number;
    accountCount?: number;
    usingRegisterSMSSend?: boolean;
    usingAdSMSConsent?: boolean;
    wechatLinkageInfo?: {
      enabled: boolean;
      maxCount: number;
    } | null;
    kakaoLinkageInfo?: {
      brandMessage: {
        enabled: boolean;
      };
    } | null;
    registAlimTalkTemplateCodeForKorean?: string;
    registAlimTalkTemplateNameForKorean?: string;
    registAlimTalkContentForKorean?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminServiceSettingRemoveHandlerBodyRequest {
  _id: string;
}

export interface AdminServiceSettingRemoveHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    isSample?: boolean;
    name?: string;
    treatmentCategories?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      shortNum?: number;
      paletteIndex?: number;
      treatmentCautionID?: {
        hospitalID?: string;
        fileIDs?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        }[];
        writerID?: string;
        modifierID?: string;
        isRemoved?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        removedAt?: string;
      };
      folderID?: {
        _id?: string;
        name?: string;
        sortNum?: string;
        hospitalID?: string;
        isActive?: string;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
      } | null;
      isUsingCustomColor?: boolean;
      customColor?: string;
      manualContent?: string;
      isActive?: boolean;
      writerID?: string;
      modifierID?: string;
      isRemoved?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    }[];
    usingChartNumber?: boolean;
    usingFirstVisitStartDate?: boolean;
    automationPolicy?: "SINGLE" | "MULTIPLE" | null;
    usingCountryCode?: boolean;
    usingBirthDay?: boolean;
    usingGender?: boolean;
    usingTreatmentTag?: boolean;
    usingNationality?: boolean;
    autoSendVideo?: boolean;
    usingAutoSendVideo?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      sortNum?: number;
      parentCategoryIDs?: string[] | null;
      isTop?: boolean;
      isParent?: boolean;
      isHidden?: boolean;
      isBasic?: boolean;
      description?: string;
      typeName?: string;
      isConditioning?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    }[];
    videoContentDuration?:
      | {
          categoryID?: string;
          duration?: number;
          doPerWeek?: number;
        }[]
      | null;
    defaultVCMessage?: string;
    defaultVCSMSMessage?: string;
    hospitalID?: string;
    selectedFirstVCH?: string;
    selectedSecondVCH?: string;
    firstVCUMessage?: string;
    secondVCUMessage?: string;
    /** @format date */
    sendVCInterval?: string;
    vcuBadge?: number;
    isRemoved?: boolean;
    topVCCategories?:
      | {
          categoryID?: string;
          sortNum?: number;
          isSelected?: boolean;
          categoryName?: string;
        }[]
      | null;
    colorPalette?: string;
    treatmentCautionMessage?: string;
    eventChatMessage?: string;
    aftercareChatMessage?: string;
    usingUserTag?: boolean;
    chatResponseRequiredTime?:
      | {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[]
      | null;
    chatResponseRequiredUsers?: string;
    usingChatResponseRequired?: boolean;
    defaultCounselorId?: string;
    defaultCounselorIds?: string[] | null;
    usingChatTranslate?: boolean;
    /** 대기, 진행, 종료 세가지 */
    status?: string;
    /** 병원에서 생성 가능한 병원 직원 계정 최대 개수 */
    maximumCreatableAccountCount?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    initialChats?: any[] | null;
    smsBasicMessage?: string;
    smsReservation?: string;
    smsResendMessage?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    usingKakaoAlimAndFriendTalkLinkage?: boolean;
    hasKakaoAlimAndFriendTalkLinkage?: boolean;
    /** @format date */
    kakaoAlimAndFriendTalkLinkedAt?: string;
    /** @format date */
    kakaoAlimAndFriendTalkUnlinkedAt?: string;
    hasKakaoConsultationTalkLinkage?: boolean;
    /** @format date */
    kakaoConsultationTalkLinkedAt?: string;
    /** @format date */
    kakaoConsultationTalkUnlinkedAt?: string;
    isReadyForKakaoAlimAndFriendTalkLinkage?: boolean;
    kakaoAlimAndFriendTalkReadyAt?: boolean;
    kakaoProfileSenderKeyAtReady?: string;
    hasTalkTalkLinkage?: boolean;
    /** @format date */
    talkTalkLinkedAt?: string;
    /** @format date */
    talkTalkUnlinkedAt?: string;
    maximumTalkTalkAccountCount?: number;
    hasLineLinkage?: boolean;
    /** @format date */
    lineLinkedAt?: string;
    /** @format date */
    lineUnlinkedAt?: string;
    maximumLineAccountCount?: number;
    accountCount?: number;
    usingRegisterSMSSend?: boolean;
    usingAdSMSConsent?: boolean;
    wechatLinkageInfo?: {
      enabled: boolean;
      maxCount: number;
    } | null;
    kakaoLinkageInfo?: {
      brandMessage: {
        enabled: boolean;
      };
    } | null;
    registAlimTalkTemplateCodeForKorean?: string;
    registAlimTalkTemplateNameForKorean?: string;
    registAlimTalkContentForKorean?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminServiceSettingAccountUpdateHandlerBodyRequest {
  hospitalID: string;
  count: number;
  reason: string;
  customTuningReason?: string;
  userName: string;
}

export interface AdminServiceSettingAccountUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    isSample?: boolean;
    name?: string;
    treatmentCategories?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      shortNum?: number;
      paletteIndex?: number;
      treatmentCautionID?: {
        hospitalID?: string;
        fileIDs?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        }[];
        writerID?: string;
        modifierID?: string;
        isRemoved?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        removedAt?: string;
      };
      folderID?: {
        _id?: string;
        name?: string;
        sortNum?: string;
        hospitalID?: string;
        isActive?: string;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
      } | null;
      isUsingCustomColor?: boolean;
      customColor?: string;
      manualContent?: string;
      isActive?: boolean;
      writerID?: string;
      modifierID?: string;
      isRemoved?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    }[];
    usingChartNumber?: boolean;
    usingFirstVisitStartDate?: boolean;
    automationPolicy?: "SINGLE" | "MULTIPLE" | null;
    usingCountryCode?: boolean;
    usingBirthDay?: boolean;
    usingGender?: boolean;
    usingTreatmentTag?: boolean;
    usingNationality?: boolean;
    autoSendVideo?: boolean;
    usingAutoSendVideo?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      sortNum?: number;
      parentCategoryIDs?: string[] | null;
      isTop?: boolean;
      isParent?: boolean;
      isHidden?: boolean;
      isBasic?: boolean;
      description?: string;
      typeName?: string;
      isConditioning?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    }[];
    videoContentDuration?:
      | {
          categoryID?: string;
          duration?: number;
          doPerWeek?: number;
        }[]
      | null;
    defaultVCMessage?: string;
    defaultVCSMSMessage?: string;
    hospitalID?: string;
    selectedFirstVCH?: string;
    selectedSecondVCH?: string;
    firstVCUMessage?: string;
    secondVCUMessage?: string;
    /** @format date */
    sendVCInterval?: string;
    vcuBadge?: number;
    isRemoved?: boolean;
    topVCCategories?:
      | {
          categoryID?: string;
          sortNum?: number;
          isSelected?: boolean;
          categoryName?: string;
        }[]
      | null;
    colorPalette?: string;
    treatmentCautionMessage?: string;
    eventChatMessage?: string;
    aftercareChatMessage?: string;
    usingUserTag?: boolean;
    chatResponseRequiredTime?:
      | {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[]
      | null;
    chatResponseRequiredUsers?: string;
    usingChatResponseRequired?: boolean;
    defaultCounselorId?: string;
    defaultCounselorIds?: string[] | null;
    usingChatTranslate?: boolean;
    /** 대기, 진행, 종료 세가지 */
    status?: string;
    /** 병원에서 생성 가능한 병원 직원 계정 최대 개수 */
    maximumCreatableAccountCount?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    initialChats?: any[] | null;
    smsBasicMessage?: string;
    smsReservation?: string;
    smsResendMessage?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    usingKakaoAlimAndFriendTalkLinkage?: boolean;
    hasKakaoAlimAndFriendTalkLinkage?: boolean;
    /** @format date */
    kakaoAlimAndFriendTalkLinkedAt?: string;
    /** @format date */
    kakaoAlimAndFriendTalkUnlinkedAt?: string;
    hasKakaoConsultationTalkLinkage?: boolean;
    /** @format date */
    kakaoConsultationTalkLinkedAt?: string;
    /** @format date */
    kakaoConsultationTalkUnlinkedAt?: string;
    isReadyForKakaoAlimAndFriendTalkLinkage?: boolean;
    kakaoAlimAndFriendTalkReadyAt?: boolean;
    kakaoProfileSenderKeyAtReady?: string;
    hasTalkTalkLinkage?: boolean;
    /** @format date */
    talkTalkLinkedAt?: string;
    /** @format date */
    talkTalkUnlinkedAt?: string;
    maximumTalkTalkAccountCount?: number;
    hasLineLinkage?: boolean;
    /** @format date */
    lineLinkedAt?: string;
    /** @format date */
    lineUnlinkedAt?: string;
    maximumLineAccountCount?: number;
    accountCount?: number;
    usingRegisterSMSSend?: boolean;
    usingAdSMSConsent?: boolean;
    wechatLinkageInfo?: {
      enabled: boolean;
      maxCount: number;
    } | null;
    kakaoLinkageInfo?: {
      brandMessage: {
        enabled: boolean;
      };
    } | null;
    registAlimTalkTemplateCodeForKorean?: string;
    registAlimTalkTemplateNameForKorean?: string;
    registAlimTalkContentForKorean?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminServiceSettingDefaultCounselorUpdateHandlerBodyRequest {
  _id: string;
  defaultCounselorIds: string[];
}

export interface AdminServiceSettingDefaultCounselorUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    isSample?: boolean;
    name?: string;
    treatmentCategories?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      shortNum?: number;
      paletteIndex?: number;
      treatmentCautionID?: {
        hospitalID?: string;
        fileIDs?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        }[];
        writerID?: string;
        modifierID?: string;
        isRemoved?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        removedAt?: string;
      };
      folderID?: {
        _id?: string;
        name?: string;
        sortNum?: string;
        hospitalID?: string;
        isActive?: string;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
      } | null;
      isUsingCustomColor?: boolean;
      customColor?: string;
      manualContent?: string;
      isActive?: boolean;
      writerID?: string;
      modifierID?: string;
      isRemoved?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    }[];
    usingChartNumber?: boolean;
    usingFirstVisitStartDate?: boolean;
    automationPolicy?: "SINGLE" | "MULTIPLE" | null;
    usingCountryCode?: boolean;
    usingBirthDay?: boolean;
    usingGender?: boolean;
    usingTreatmentTag?: boolean;
    usingNationality?: boolean;
    autoSendVideo?: boolean;
    usingAutoSendVideo?: {
      _id?: string;
      categoryName?: string;
      hospitalID?: string;
      sortNum?: number;
      parentCategoryIDs?: string[] | null;
      isTop?: boolean;
      isParent?: boolean;
      isHidden?: boolean;
      isBasic?: boolean;
      description?: string;
      typeName?: string;
      isConditioning?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    }[];
    videoContentDuration?:
      | {
          categoryID?: string;
          duration?: number;
          doPerWeek?: number;
        }[]
      | null;
    defaultVCMessage?: string;
    defaultVCSMSMessage?: string;
    hospitalID?: string;
    selectedFirstVCH?: string;
    selectedSecondVCH?: string;
    firstVCUMessage?: string;
    secondVCUMessage?: string;
    /** @format date */
    sendVCInterval?: string;
    vcuBadge?: number;
    isRemoved?: boolean;
    topVCCategories?:
      | {
          categoryID?: string;
          sortNum?: number;
          isSelected?: boolean;
          categoryName?: string;
        }[]
      | null;
    colorPalette?: string;
    treatmentCautionMessage?: string;
    eventChatMessage?: string;
    aftercareChatMessage?: string;
    usingUserTag?: boolean;
    chatResponseRequiredTime?:
      | {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[]
      | null;
    chatResponseRequiredUsers?: string;
    usingChatResponseRequired?: boolean;
    defaultCounselorId?: string;
    defaultCounselorIds?: string[] | null;
    usingChatTranslate?: boolean;
    /** 대기, 진행, 종료 세가지 */
    status?: string;
    /** 병원에서 생성 가능한 병원 직원 계정 최대 개수 */
    maximumCreatableAccountCount?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    initialChats?: any[] | null;
    smsBasicMessage?: string;
    smsReservation?: string;
    smsResendMessage?: string;
    usingAutoReservedSMS?: boolean;
    autoReservedSMSMessage?: string;
    autoReservedSMSDelayDay?: number;
    autoReservedSMSHour?: number;
    usingKakaoAlimAndFriendTalkLinkage?: boolean;
    hasKakaoAlimAndFriendTalkLinkage?: boolean;
    /** @format date */
    kakaoAlimAndFriendTalkLinkedAt?: string;
    /** @format date */
    kakaoAlimAndFriendTalkUnlinkedAt?: string;
    hasKakaoConsultationTalkLinkage?: boolean;
    /** @format date */
    kakaoConsultationTalkLinkedAt?: string;
    /** @format date */
    kakaoConsultationTalkUnlinkedAt?: string;
    isReadyForKakaoAlimAndFriendTalkLinkage?: boolean;
    kakaoAlimAndFriendTalkReadyAt?: boolean;
    kakaoProfileSenderKeyAtReady?: string;
    hasTalkTalkLinkage?: boolean;
    /** @format date */
    talkTalkLinkedAt?: string;
    /** @format date */
    talkTalkUnlinkedAt?: string;
    maximumTalkTalkAccountCount?: number;
    hasLineLinkage?: boolean;
    /** @format date */
    lineLinkedAt?: string;
    /** @format date */
    lineUnlinkedAt?: string;
    maximumLineAccountCount?: number;
    accountCount?: number;
    usingRegisterSMSSend?: boolean;
    usingAdSMSConsent?: boolean;
    wechatLinkageInfo?: {
      enabled: boolean;
      maxCount: number;
    } | null;
    kakaoLinkageInfo?: {
      brandMessage: {
        enabled: boolean;
      };
    } | null;
    registAlimTalkTemplateCodeForKorean?: string;
    registAlimTalkTemplateNameForKorean?: string;
    registAlimTalkContentForKorean?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHealthContentCategoryFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    name?: string;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedA?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminUserNurseFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    /** 사용자가 진행중인 HService ID 배열 */
    hservices?: string[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminUserCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: number;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminUserFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: | {
        _id: string;
        id: string;
        name: string;
        realName: string;
        type: number;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
      }[]
    | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminUserCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    id: string;
    name: string;
    realName: string;
    type: number;
    jobType: string;
    photo?: any;
    adminAuthorization?: {
      /** 관리자 권한 설정 ID */
      _id: string;
      /** 권한이 연결된 관리자 사용자 ID */
      userID: string;
      /** 병원 관리 메뉴 조회 권한 여부 */
      hospitalManagement_v?: boolean;
      /** 병원 관리 메뉴 수정 권한 여부 */
      hospitalManagement_w?: boolean;
      /** 병원 현황 메뉴 조회 권한 여부 */
      hospitalState_v?: boolean;
      /** 병원 현황 메뉴 수정 권한 여부 */
      hospitalState_w?: boolean;
      /** v2 병원 관리 메뉴 조회 권한 여부 */
      v2HospitalManagement_v?: boolean;
      /** v2 병원 관리 메뉴 수정 권한 여부 */
      v2HospitalManagement_w?: boolean;
      /** v2 병원 현황 메뉴 조회 권한 여부 */
      v2HospitalState_v?: boolean;
      /** v2 병원 현황 메뉴 수정 권한 여부 */
      v2HospitalState_w?: boolean;
      /** v2 병원 연동 메뉴 조회 권한 여부 */
      v2HospitalIntegration_v?: boolean;
      /** v2 병원 연동 메뉴 수정 권한 여부 */
      v2HospitalIntegration_w?: boolean;
      /** 서비스 관리자 메뉴 조회 권한 여부 */
      serviceManager_v?: boolean;
      /** 서비스 관리자 메뉴 수정 권한 여부 */
      serviceManager_w?: boolean;
      /** 동영상 콘텐츠 메뉴 조회 권한 여부 */
      videoContent_v?: boolean;
      /** 동영상 콘텐츠 메뉴 수정 권한 여부 */
      videoContent_w?: boolean;
      /** 온보딩 메뉴 조회 권한 여부 */
      onboarding_v?: boolean;
      /** 온보딩 메뉴 수정 권한 여부 */
      onboarding_w?: boolean;
      /** 앱 메뉴 조회 권한 여부 */
      app_v?: boolean;
      /** 앱 메뉴 수정 권한 여부 */
      app_w?: boolean;
      /** 일렉트론 메뉴 조회 권한 여부 */
      electron_v?: boolean;
      /** 일렉트론 메뉴 수정 권한 여부 */
      electron_w?: boolean;
      /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 조회 권한 여부 */
      electronAIFeatureUsageCorrection_v?: boolean;
      /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 수정 권한 여부 */
      electronAIFeatureUsageCorrection_w?: boolean;
      /** 연동 메뉴 조회 권한 여부 */
      integration_v?: boolean;
      /** 연동 메뉴 수정 권한 여부 */
      integration_w?: boolean;
      /** 모니터링 메뉴 조회 권한 여부 */
      monitoring_v?: boolean;
      /** 모니터링 메뉴 수정 권한 여부 */
      monitoring_w?: boolean;
      /** 이벤트 관리 메뉴 조회 권한 여부 */
      eventManagement_v?: boolean;
      /** 이벤트 관리 메뉴 수정 권한 여부 */
      eventManagement_w?: boolean;
      /** 예약 채팅 메뉴 조회 권한 여부 */
      reservedChat_v?: boolean;
      /** 예약 채팅 메뉴 수정 권한 여부 */
      reservedChat_w?: boolean;
      /** 치료 카테고리 메뉴 조회 권한 여부 */
      treatmentCategory_v?: boolean;
      /** 치료 카테고리 메뉴 수정 권한 여부 */
      treatmentCategory_w?: boolean;
      /** 알고리즘 메뉴 조회 권한 여부 */
      algorithm_v?: boolean;
      /** 알고리즘 메뉴 수정 권한 여부 */
      algorithm_w?: boolean;
      /** 알림톡 메뉴 조회 권한 여부 */
      alrimtalk_v?: boolean;
      /** 알림톡 메뉴 수정 권한 여부 */
      alrimtalk_w?: boolean;
      /** 관리자 계정 메뉴 조회 권한 여부 */
      adminAccount_v?: boolean;
      /** 관리자 계정 메뉴 수정 권한 여부 */
      adminAccount_w?: boolean;
      /** 개발자 메뉴 조회 권한 여부 */
      developer_v?: boolean;
      /** 개발자 메뉴 수정 권한 여부 */
      developer_w?: boolean;
      /**
       * 권한 설정 생성 일시
       * @format date
       */
      createdAt?: string;
      /**
       * 권한 설정 마지막 수정 일시
       * @format date
       */
      updatedAt?: string;
    } | null;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminUserUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    id: string;
    name: string;
    realName: string;
    type: number;
    jobType: string;
    photo?: any;
    adminAuthorization?: {
      /** 관리자 권한 설정 ID */
      _id: string;
      /** 권한이 연결된 관리자 사용자 ID */
      userID: string;
      /** 병원 관리 메뉴 조회 권한 여부 */
      hospitalManagement_v?: boolean;
      /** 병원 관리 메뉴 수정 권한 여부 */
      hospitalManagement_w?: boolean;
      /** 병원 현황 메뉴 조회 권한 여부 */
      hospitalState_v?: boolean;
      /** 병원 현황 메뉴 수정 권한 여부 */
      hospitalState_w?: boolean;
      /** v2 병원 관리 메뉴 조회 권한 여부 */
      v2HospitalManagement_v?: boolean;
      /** v2 병원 관리 메뉴 수정 권한 여부 */
      v2HospitalManagement_w?: boolean;
      /** v2 병원 현황 메뉴 조회 권한 여부 */
      v2HospitalState_v?: boolean;
      /** v2 병원 현황 메뉴 수정 권한 여부 */
      v2HospitalState_w?: boolean;
      /** v2 병원 연동 메뉴 조회 권한 여부 */
      v2HospitalIntegration_v?: boolean;
      /** v2 병원 연동 메뉴 수정 권한 여부 */
      v2HospitalIntegration_w?: boolean;
      /** 서비스 관리자 메뉴 조회 권한 여부 */
      serviceManager_v?: boolean;
      /** 서비스 관리자 메뉴 수정 권한 여부 */
      serviceManager_w?: boolean;
      /** 동영상 콘텐츠 메뉴 조회 권한 여부 */
      videoContent_v?: boolean;
      /** 동영상 콘텐츠 메뉴 수정 권한 여부 */
      videoContent_w?: boolean;
      /** 온보딩 메뉴 조회 권한 여부 */
      onboarding_v?: boolean;
      /** 온보딩 메뉴 수정 권한 여부 */
      onboarding_w?: boolean;
      /** 앱 메뉴 조회 권한 여부 */
      app_v?: boolean;
      /** 앱 메뉴 수정 권한 여부 */
      app_w?: boolean;
      /** 일렉트론 메뉴 조회 권한 여부 */
      electron_v?: boolean;
      /** 일렉트론 메뉴 수정 권한 여부 */
      electron_w?: boolean;
      /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 조회 권한 여부 */
      electronAIFeatureUsageCorrection_v?: boolean;
      /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 수정 권한 여부 */
      electronAIFeatureUsageCorrection_w?: boolean;
      /** 연동 메뉴 조회 권한 여부 */
      integration_v?: boolean;
      /** 연동 메뉴 수정 권한 여부 */
      integration_w?: boolean;
      /** 모니터링 메뉴 조회 권한 여부 */
      monitoring_v?: boolean;
      /** 모니터링 메뉴 수정 권한 여부 */
      monitoring_w?: boolean;
      /** 이벤트 관리 메뉴 조회 권한 여부 */
      eventManagement_v?: boolean;
      /** 이벤트 관리 메뉴 수정 권한 여부 */
      eventManagement_w?: boolean;
      /** 예약 채팅 메뉴 조회 권한 여부 */
      reservedChat_v?: boolean;
      /** 예약 채팅 메뉴 수정 권한 여부 */
      reservedChat_w?: boolean;
      /** 치료 카테고리 메뉴 조회 권한 여부 */
      treatmentCategory_v?: boolean;
      /** 치료 카테고리 메뉴 수정 권한 여부 */
      treatmentCategory_w?: boolean;
      /** 알고리즘 메뉴 조회 권한 여부 */
      algorithm_v?: boolean;
      /** 알고리즘 메뉴 수정 권한 여부 */
      algorithm_w?: boolean;
      /** 알림톡 메뉴 조회 권한 여부 */
      alrimtalk_v?: boolean;
      /** 알림톡 메뉴 수정 권한 여부 */
      alrimtalk_w?: boolean;
      /** 관리자 계정 메뉴 조회 권한 여부 */
      adminAccount_v?: boolean;
      /** 관리자 계정 메뉴 수정 권한 여부 */
      adminAccount_w?: boolean;
      /** 개발자 메뉴 조회 권한 여부 */
      developer_v?: boolean;
      /** 개발자 메뉴 수정 권한 여부 */
      developer_w?: boolean;
      /**
       * 권한 설정 생성 일시
       * @format date
       */
      createdAt?: string;
      /**
       * 권한 설정 마지막 수정 일시
       * @format date
       */
      updatedAt?: string;
    } | null;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminUserRemoveHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    id: string;
    name: string;
    realName: string;
    type: number;
    jobType: string;
    photo?: any;
    adminAuthorization?: {
      /** 관리자 권한 설정 ID */
      _id: string;
      /** 권한이 연결된 관리자 사용자 ID */
      userID: string;
      /** 병원 관리 메뉴 조회 권한 여부 */
      hospitalManagement_v?: boolean;
      /** 병원 관리 메뉴 수정 권한 여부 */
      hospitalManagement_w?: boolean;
      /** 병원 현황 메뉴 조회 권한 여부 */
      hospitalState_v?: boolean;
      /** 병원 현황 메뉴 수정 권한 여부 */
      hospitalState_w?: boolean;
      /** v2 병원 관리 메뉴 조회 권한 여부 */
      v2HospitalManagement_v?: boolean;
      /** v2 병원 관리 메뉴 수정 권한 여부 */
      v2HospitalManagement_w?: boolean;
      /** v2 병원 현황 메뉴 조회 권한 여부 */
      v2HospitalState_v?: boolean;
      /** v2 병원 현황 메뉴 수정 권한 여부 */
      v2HospitalState_w?: boolean;
      /** v2 병원 연동 메뉴 조회 권한 여부 */
      v2HospitalIntegration_v?: boolean;
      /** v2 병원 연동 메뉴 수정 권한 여부 */
      v2HospitalIntegration_w?: boolean;
      /** 서비스 관리자 메뉴 조회 권한 여부 */
      serviceManager_v?: boolean;
      /** 서비스 관리자 메뉴 수정 권한 여부 */
      serviceManager_w?: boolean;
      /** 동영상 콘텐츠 메뉴 조회 권한 여부 */
      videoContent_v?: boolean;
      /** 동영상 콘텐츠 메뉴 수정 권한 여부 */
      videoContent_w?: boolean;
      /** 온보딩 메뉴 조회 권한 여부 */
      onboarding_v?: boolean;
      /** 온보딩 메뉴 수정 권한 여부 */
      onboarding_w?: boolean;
      /** 앱 메뉴 조회 권한 여부 */
      app_v?: boolean;
      /** 앱 메뉴 수정 권한 여부 */
      app_w?: boolean;
      /** 일렉트론 메뉴 조회 권한 여부 */
      electron_v?: boolean;
      /** 일렉트론 메뉴 수정 권한 여부 */
      electron_w?: boolean;
      /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 조회 권한 여부 */
      electronAIFeatureUsageCorrection_v?: boolean;
      /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 수정 권한 여부 */
      electronAIFeatureUsageCorrection_w?: boolean;
      /** 연동 메뉴 조회 권한 여부 */
      integration_v?: boolean;
      /** 연동 메뉴 수정 권한 여부 */
      integration_w?: boolean;
      /** 모니터링 메뉴 조회 권한 여부 */
      monitoring_v?: boolean;
      /** 모니터링 메뉴 수정 권한 여부 */
      monitoring_w?: boolean;
      /** 이벤트 관리 메뉴 조회 권한 여부 */
      eventManagement_v?: boolean;
      /** 이벤트 관리 메뉴 수정 권한 여부 */
      eventManagement_w?: boolean;
      /** 예약 채팅 메뉴 조회 권한 여부 */
      reservedChat_v?: boolean;
      /** 예약 채팅 메뉴 수정 권한 여부 */
      reservedChat_w?: boolean;
      /** 치료 카테고리 메뉴 조회 권한 여부 */
      treatmentCategory_v?: boolean;
      /** 치료 카테고리 메뉴 수정 권한 여부 */
      treatmentCategory_w?: boolean;
      /** 알고리즘 메뉴 조회 권한 여부 */
      algorithm_v?: boolean;
      /** 알고리즘 메뉴 수정 권한 여부 */
      algorithm_w?: boolean;
      /** 알림톡 메뉴 조회 권한 여부 */
      alrimtalk_v?: boolean;
      /** 알림톡 메뉴 수정 권한 여부 */
      alrimtalk_w?: boolean;
      /** 관리자 계정 메뉴 조회 권한 여부 */
      adminAccount_v?: boolean;
      /** 관리자 계정 메뉴 수정 권한 여부 */
      adminAccount_w?: boolean;
      /** 개발자 메뉴 조회 권한 여부 */
      developer_v?: boolean;
      /** 개발자 메뉴 수정 권한 여부 */
      developer_w?: boolean;
      /**
       * 권한 설정 생성 일시
       * @format date
       */
      createdAt?: string;
      /**
       * 권한 설정 마지막 수정 일시
       * @format date
       */
      updatedAt?: string;
    } | null;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminUserFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    id: string;
    name: string;
    realName: string;
    type: number;
    jobType: string;
    photo?: any;
    adminAuthorization?: {
      /** 관리자 권한 설정 ID */
      _id: string;
      /** 권한이 연결된 관리자 사용자 ID */
      userID: string;
      /** 병원 관리 메뉴 조회 권한 여부 */
      hospitalManagement_v?: boolean;
      /** 병원 관리 메뉴 수정 권한 여부 */
      hospitalManagement_w?: boolean;
      /** 병원 현황 메뉴 조회 권한 여부 */
      hospitalState_v?: boolean;
      /** 병원 현황 메뉴 수정 권한 여부 */
      hospitalState_w?: boolean;
      /** v2 병원 관리 메뉴 조회 권한 여부 */
      v2HospitalManagement_v?: boolean;
      /** v2 병원 관리 메뉴 수정 권한 여부 */
      v2HospitalManagement_w?: boolean;
      /** v2 병원 현황 메뉴 조회 권한 여부 */
      v2HospitalState_v?: boolean;
      /** v2 병원 현황 메뉴 수정 권한 여부 */
      v2HospitalState_w?: boolean;
      /** v2 병원 연동 메뉴 조회 권한 여부 */
      v2HospitalIntegration_v?: boolean;
      /** v2 병원 연동 메뉴 수정 권한 여부 */
      v2HospitalIntegration_w?: boolean;
      /** 서비스 관리자 메뉴 조회 권한 여부 */
      serviceManager_v?: boolean;
      /** 서비스 관리자 메뉴 수정 권한 여부 */
      serviceManager_w?: boolean;
      /** 동영상 콘텐츠 메뉴 조회 권한 여부 */
      videoContent_v?: boolean;
      /** 동영상 콘텐츠 메뉴 수정 권한 여부 */
      videoContent_w?: boolean;
      /** 온보딩 메뉴 조회 권한 여부 */
      onboarding_v?: boolean;
      /** 온보딩 메뉴 수정 권한 여부 */
      onboarding_w?: boolean;
      /** 앱 메뉴 조회 권한 여부 */
      app_v?: boolean;
      /** 앱 메뉴 수정 권한 여부 */
      app_w?: boolean;
      /** 일렉트론 메뉴 조회 권한 여부 */
      electron_v?: boolean;
      /** 일렉트론 메뉴 수정 권한 여부 */
      electron_w?: boolean;
      /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 조회 권한 여부 */
      electronAIFeatureUsageCorrection_v?: boolean;
      /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 수정 권한 여부 */
      electronAIFeatureUsageCorrection_w?: boolean;
      /** 연동 메뉴 조회 권한 여부 */
      integration_v?: boolean;
      /** 연동 메뉴 수정 권한 여부 */
      integration_w?: boolean;
      /** 모니터링 메뉴 조회 권한 여부 */
      monitoring_v?: boolean;
      /** 모니터링 메뉴 수정 권한 여부 */
      monitoring_w?: boolean;
      /** 이벤트 관리 메뉴 조회 권한 여부 */
      eventManagement_v?: boolean;
      /** 이벤트 관리 메뉴 수정 권한 여부 */
      eventManagement_w?: boolean;
      /** 예약 채팅 메뉴 조회 권한 여부 */
      reservedChat_v?: boolean;
      /** 예약 채팅 메뉴 수정 권한 여부 */
      reservedChat_w?: boolean;
      /** 치료 카테고리 메뉴 조회 권한 여부 */
      treatmentCategory_v?: boolean;
      /** 치료 카테고리 메뉴 수정 권한 여부 */
      treatmentCategory_w?: boolean;
      /** 알고리즘 메뉴 조회 권한 여부 */
      algorithm_v?: boolean;
      /** 알고리즘 메뉴 수정 권한 여부 */
      algorithm_w?: boolean;
      /** 알림톡 메뉴 조회 권한 여부 */
      alrimtalk_v?: boolean;
      /** 알림톡 메뉴 수정 권한 여부 */
      alrimtalk_w?: boolean;
      /** 관리자 계정 메뉴 조회 권한 여부 */
      adminAccount_v?: boolean;
      /** 관리자 계정 메뉴 수정 권한 여부 */
      adminAccount_w?: boolean;
      /** 개발자 메뉴 조회 권한 여부 */
      developer_v?: boolean;
      /** 개발자 메뉴 수정 권한 여부 */
      developer_w?: boolean;
      /**
       * 권한 설정 생성 일시
       * @format date
       */
      createdAt?: string;
      /**
       * 권한 설정 마지막 수정 일시
       * @format date
       */
      updatedAt?: string;
    } | null;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAnsweringChatSettingCreateHandlerBodyRequest {
  hospitalID: string;
}

export interface AdminAnsweringChatSettingCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    hospitalID: string;
    usingAnsweringChat?: boolean;
    usingGeneralChat?: boolean;
    careSchedule?:
      | {
          dayIndex: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[]
      | null;
    businessHourInterval?: number;
    nonBusinessHourInterval?: number;
    usingBusinessHourMessage?: boolean;
    usingNonBusinessHourMessage?: boolean;
    businessHourMessage?: string;
    nonBusinessHourMessage?: string;
    interval?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAnsweringChatSettingUpdateHandlerBodyRequest {
  _id: string;
  usingAnsweringChat?: boolean;
  usingGeneralChat?: boolean;
  usingBusinessHourMessage?: boolean;
  usingNonBusinessHourMessage?: boolean;
  businessHourMessage?: string;
  nonBusinessHourMessage?: string;
  interval?: number;
  careSchedule: {
    dayIndex?: number;
    startedAt?: string;
    endedAt?: string;
  }[];
}

export interface AdminAnsweringChatSettingUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    hospitalID: string;
    usingAnsweringChat?: boolean;
    usingGeneralChat?: boolean;
    careSchedule?:
      | {
          dayIndex: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[]
      | null;
    businessHourInterval?: number;
    nonBusinessHourInterval?: number;
    usingBusinessHourMessage?: boolean;
    usingNonBusinessHourMessage?: boolean;
    businessHourMessage?: string;
    nonBusinessHourMessage?: string;
    interval?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAnsweringChatSettingFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    hospitalID: string;
    usingAnsweringChat?: boolean;
    usingGeneralChat?: boolean;
    careSchedule?:
      | {
          dayIndex: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[]
      | null;
    businessHourInterval?: number;
    nonBusinessHourInterval?: number;
    usingBusinessHourMessage?: boolean;
    usingNonBusinessHourMessage?: boolean;
    businessHourMessage?: string;
    nonBusinessHourMessage?: string;
    interval?: number;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminVideoContentCategoryFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    categoryName?: string;
    hospitalID?: string;
    sortNum?: number;
    parentCategoryIDs?: string[] | null;
    isTop?: boolean;
    isParent?: boolean;
    isHidden?: boolean;
    isBasic?: boolean;
    description?: string;
    typeName?: string;
    isConditioning?: string;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminVideoContentCategoryFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    categoryName?: string;
    hospitalID?: string;
    sortNum?: number;
    isTop?: boolean;
    isParent?: boolean;
    isHidden?: boolean;
    isBasic?: boolean;
    description?: string;
    typeName?: string;
    isConditioning?: string;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminIntegrationSettingFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hospitalID?: string;
    clientToken?: string;
    integrationType?: string;
    customObject?: any;
    usingRegist?: boolean;
    usingReservation?: boolean;
    usingDashboard?: boolean;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  } | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminIntegrationSettingUpsertHandlerBodyRequest {
  _id?: string;
  hospitalID: string;
  clientToken?: string;
  integrationType?: string;
  customObject?: any;
  usingRegist?: boolean;
  usingReservation?: boolean;
  usingDashboard?: boolean;
  isRemoved?: boolean;
}

export interface AdminIntegrationSettingUpsertHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hospitalID?: string;
    clientToken?: string;
    integrationType?: string;
    customObject?: any;
    usingRegist?: boolean;
    usingReservation?: boolean;
    usingDashboard?: boolean;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  } | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalAccountCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: number;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalDoctorFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    id?: string;
    name?: string;
    realName?: string;
    phone?: string;
    detachedPhone?: string;
    authorizationTypeID?: any;
    jobType?: string;
    photo?: {
      _id?: string;
      paths?: string[] | null;
      aws?: any[] | null;
    };
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalAccountCreateHandlerBodyRequest {
  hospitalID: string;
  realName: string;
  id: string;
  password: string;
  type?: number;
  phone?: string;
  jobType: string;
  authorizationTypeID: string;
  isDoctor?: boolean;
}

export interface AdminHospitalAccountCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    hospitalID?: string;
    realName?: string;
    id?: string;
    password?: string;
    type?: number;
    phone?: string;
    jobType?: string;
    authorizationTypeID?: string;
    isDoctor?: boolean;
    photo?: {
      _id?: string;
      paths?: string[] | null;
      aws?: any[] | null;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalAccountUpdateHandlerBodyRequest {
  _id: string;
  hospitalID: string;
  realName: string;
  id: string;
  password: string;
  phone?: string;
  type?: number;
  jobType: string;
  authorizationTypeID: string;
  isDoctor?: boolean;
  forceChange?: boolean;
}

export interface AdminHospitalAccountUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    hospitalID?: string;
    realName?: string;
    id?: string;
    password?: string;
    type?: number;
    jobType?: string;
    authorizationTypeID?: string;
    isDoctor?: boolean;
    photo?: {
      _id?: string;
      paths?: string[] | null;
      aws?: any[] | null;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalAccountRemoveHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    hospitalID?: string;
    realName?: string;
    id?: string;
    password?: string;
    type?: number;
    jobType?: string;
    authorizationTypeID?: string;
    isDoctor?: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalAccountSettingHistoryCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: number;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminHospitalAccountSettingHistoryFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: | {
        hospitalID?: string;
        curruentMaximumCreatableAccountCount?: number;
        requestedAccountCount?: number;
        accountCountTuningRequesterID?: string;
        accountCountTuningRequesterName?: string;
        accountCountTuningRequesterContact?: string;
        /** @format date */
        finalAccountCountTunedAt?: string;
        finalAccountCountTunerID?: string;
        tuningReason?: string;
        customTuningReason?: string;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
      }[]
    | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminTreatmentCategoryCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: number;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminTreatmentCategoryCreateHandlerBodyRequest {
  hospitalID?: string;
  categoryName: string;
  description?: string;
  isCommon?: boolean;
  paletteIndex?: number;
  folderID?: string;
  isUsingCustomColor?: boolean;
  customColor?: string;
  manualContent?: string;
  fileID?: string;
  /** 치료시 주의사항 발송여부 */
  usingCautionMessage?: boolean;
  /** 애프터닥 채팅 혹은 카카오 템플릿으로 보내질 치료시 주의사항 텍스트 */
  cautionMessage?: string;
  /** 카카오 템플릿 기록을 위한 senderKey */
  kakao_senderKey?: string;
  /** 카카오 템플릿 기록을 위한 senderType */
  kakao_senderKeyType?: string;
  /** 카카오 템플릿 기록을 위한 templateCode * client에서는 사용하지 말 것. */
  kakao_templateCode?: string;
}

export interface AdminTreatmentCategoryCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    categoryName?: string;
    description?: string;
    isCommon?: boolean;
    hospitalID?: string;
    sortNum?: number;
    paletteIndex?: number;
    folderID?: string;
    isUsingCustomColor?: boolean;
    customColor?: string;
    manualContent?: string;
    fileID?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    isActive?: boolean;
    /** 치료시 주의사항 발송여부 */
    usingCautionMessage?: boolean;
    /** 애프터닥 채팅 혹은 카카오 템플릿으로 보내질 치료시 주의사항 텍스트 */
    cautionMessage?: string;
    /** 카카오 템플릿 기록을 위한 senderKey */
    kakao_senderKey?: string;
    /** 카카오 템플릿 기록을 위한 senderType */
    kakao_senderKeyType?: string;
    /** 카카오 템플릿 기록을 위한 templateCode */
    kakao_templateCode?: string;
    kakaoTemplateInfo?: {
      /** 발신프로필 키 */
      senderKey?: string | null;
      /** 발신프로필 키 타입 */
      senderKeyType?: string | null;
      /** 템플릿 코드 */
      templateCode?: string | null;
      /** 템플릿 이름 */
      templateName?: string | null;
      /** 템플릿 카테고리 코드 */
      categoryCode?: string | null;
      /** 템플릿 상태 (REG: 등록, REQ: 검수요청, REJ: 반려, STP: 차단, RDY: 발송전, ACT: 정상, DMT: 휴면, BLK: 차단) */
      serviceStatus?: string | null;
      /** 등록일 */
      createdAt?: string | null;
      /** 수정일 */
      modifiedAt: string;
      /** 템플릿 메시지 유형 */
      templateMessageType?: string | null;
      /** 템플릿 강조 유형 */
      templateEmphasizeType?: string | null;
      /** 템플릿 내용 */
      templateContent?: string | null;
      /** 부가정보 */
      templateExtra?: string | null;
      /** 광고성 메시지 */
      templateAd?: string | null;
      /** 템플릿 이미지 파일명 */
      templateImageName?: string | null;
      /** 템플릿 이미지 링크 */
      templateImageUrl?: string | null;
      /** 템플릿 내용 중 강조 표기할 핵심 정보 */
      templateTitle?: string | null;
      /** 강조 표기 보조 문구 */
      templateSubtitle?: string | null;
      /** 헤더 */
      templateHeader?: string | null;
      /** 보안 템플릿 여부 */
      securityFlag?: boolean | null;
      /** 검수 상태 */
      inspectionStatus?: "REG" | "REQ" | "REJ" | "STP" | "RDY" | "ACT" | "DMT" | "BLK" | "APR" | null;
      /** 템플릿 상태 (S:중지 - STP(or BLK), A:정상 - ACT, R:대기(발송전) - RDY), list의 serviceStatus와 대응 */
      status?: string | null;
      /** 차단 여부 */
      block?: boolean | null;
      /** 휴면상태 */
      dormant?: boolean | null;
      /** 버튼 정보 */
      buttons?: {
        /** 버튼명 */
        name: string;
        /** 버튼 링크타입 */
        linkType: string;
        /** 버튼 순서 */
        ordering?: number | null;
        /** Android 앱 링크 주소 */
        linkAnd?: string | null;
        /** IOS 앱 링크 주소 */
        linkIos?: string | null;
        /** 모바일 웹 링크 주소 */
        linkMo?: string | null;
        /** PC 웹 링크 주소 */
        linkPc?: string | null;
        /** 플러그인 ID */
        pluginId?: string | null;
        /** 비즈폼 ID */
        bizFormId?: string | null;
      }[];
      /** 바로연결 정보 */
      quickReplies?:
        | {
            /** 바로연결명 */
            name: string;
            /** 바로연결 링크타입 */
            linkType: string;
            /** Android 앱 링크 주소 */
            linkAnd?: string;
            /** IOS 앱 링크 주소 */
            linkIos?: string;
            /** 모바일 웹 링크 주소 */
            linkMo?: string;
            /** PC 웹 링크 주소 */
            linkPc?: string;
          }[]
        | null;
      /** 댓글 목록 */
      comments?: {
        /** 댓글 본문 */
        content?: string | null;
        /** 댓글 생성일 */
        createdAt: string;
        /** 댓글 상태 */
        status: string;
        /** 댓글 작성자 */
        userName: string;
        /** 첨부파일 */
        attachment?: {
          /** 업로드한 파일 이름 */
          originalFileName: string;
          /** 파일 다운로드 경로 */
          filePath: string;
        }[];
      }[];
    };
    writerID?: string;
    modifierID?: string;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminTreatmentCategoryFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    categoryName?: string;
    description?: string;
    isCommon?: boolean;
    hospitalID?: string;
    sortNum?: number;
    paletteIndex?: number;
    folderID?: {
      _id?: string;
      hospitalID?: string;
      name?: string;
      sortNum?: string;
    } | null;
    isUsingCustomColor?: boolean;
    customColor?: string;
    manualContent?: string;
    fileID?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    cautionMessage?: string;
    kakao_senderKey?: string;
    kakao_senderKeyType?: string;
    kakao_templateCode?: string;
    kakaoTemplateInfo?: {
      /** 발신프로필 키 */
      senderKey?: string | null;
      /** 발신프로필 키 타입 */
      senderKeyType?: string | null;
      /** 템플릿 코드 */
      templateCode?: string | null;
      /** 템플릿 이름 */
      templateName?: string | null;
      /** 템플릿 카테고리 코드 */
      categoryCode?: string | null;
      /** 템플릿 상태 (REG: 등록, REQ: 검수요청, REJ: 반려, STP: 차단, RDY: 발송전, ACT: 정상, DMT: 휴면, BLK: 차단) */
      serviceStatus?: string | null;
      /** 등록일 */
      createdAt?: string | null;
      /** 수정일 */
      modifiedAt: string;
      /** 템플릿 메시지 유형 */
      templateMessageType?: string | null;
      /** 템플릿 강조 유형 */
      templateEmphasizeType?: string | null;
      /** 템플릿 내용 */
      templateContent?: string | null;
      /** 부가정보 */
      templateExtra?: string | null;
      /** 광고성 메시지 */
      templateAd?: string | null;
      /** 템플릿 이미지 파일명 */
      templateImageName?: string | null;
      /** 템플릿 이미지 링크 */
      templateImageUrl?: string | null;
      /** 템플릿 내용 중 강조 표기할 핵심 정보 */
      templateTitle?: string | null;
      /** 강조 표기 보조 문구 */
      templateSubtitle?: string | null;
      /** 헤더 */
      templateHeader?: string | null;
      /** 보안 템플릿 여부 */
      securityFlag?: boolean | null;
      /** 검수 상태 */
      inspectionStatus?: "REG" | "REQ" | "REJ" | "STP" | "RDY" | "ACT" | "DMT" | "BLK" | "APR" | null;
      /** 템플릿 상태 (S:중지 - STP(or BLK), A:정상 - ACT, R:대기(발송전) - RDY), list의 serviceStatus와 대응 */
      status?: string | null;
      /** 차단 여부 */
      block?: boolean | null;
      /** 휴면상태 */
      dormant?: boolean | null;
      /** 버튼 정보 */
      buttons?: {
        /** 버튼명 */
        name: string;
        /** 버튼 링크타입 */
        linkType: string;
        /** 버튼 순서 */
        ordering?: number | null;
        /** Android 앱 링크 주소 */
        linkAnd?: string | null;
        /** IOS 앱 링크 주소 */
        linkIos?: string | null;
        /** 모바일 웹 링크 주소 */
        linkMo?: string | null;
        /** PC 웹 링크 주소 */
        linkPc?: string | null;
        /** 플러그인 ID */
        pluginId?: string | null;
        /** 비즈폼 ID */
        bizFormId?: string | null;
      }[];
      /** 바로연결 정보 */
      quickReplies?:
        | {
            /** 바로연결명 */
            name: string;
            /** 바로연결 링크타입 */
            linkType: string;
            /** Android 앱 링크 주소 */
            linkAnd?: string;
            /** IOS 앱 링크 주소 */
            linkIos?: string;
            /** 모바일 웹 링크 주소 */
            linkMo?: string;
            /** PC 웹 링크 주소 */
            linkPc?: string;
          }[]
        | null;
      /** 댓글 목록 */
      comments?: {
        /** 댓글 본문 */
        content?: string | null;
        /** 댓글 생성일 */
        createdAt: string;
        /** 댓글 상태 */
        status: string;
        /** 댓글 작성자 */
        userName: string;
        /** 첨부파일 */
        attachment?: {
          /** 업로드한 파일 이름 */
          originalFileName: string;
          /** 파일 다운로드 경로 */
          filePath: string;
        }[];
      }[];
    };
    isEditable?: boolean;
    mappedDiagnosisCode?: string;
    isActive?: boolean;
    writerID?: string;
    modifierID?: string;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    removedAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminTreatmentCategoryFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    categoryName?: string;
    description?: string;
    isCommon?: boolean;
    hospitalID?: string;
    sortNum?: number;
    paletteIndex?: number;
    folderID?: string;
    isUsingCustomColor?: boolean;
    customColor?: string;
    manualContent?: string;
    fileID?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    cautionMessage?: string;
    kakao_senderKey?: string;
    kakao_senderKeyType?: string;
    kakao_templateCode?: string;
    kakaoTemplateInfo?: {
      /** 발신프로필 키 */
      senderKey?: string | null;
      /** 발신프로필 키 타입 */
      senderKeyType?: string | null;
      /** 템플릿 코드 */
      templateCode?: string | null;
      /** 템플릿 이름 */
      templateName?: string | null;
      /** 템플릿 카테고리 코드 */
      categoryCode?: string | null;
      /** 템플릿 상태 (REG: 등록, REQ: 검수요청, REJ: 반려, STP: 차단, RDY: 발송전, ACT: 정상, DMT: 휴면, BLK: 차단) */
      serviceStatus?: string | null;
      /** 등록일 */
      createdAt?: string | null;
      /** 수정일 */
      modifiedAt: string;
      /** 템플릿 메시지 유형 */
      templateMessageType?: string | null;
      /** 템플릿 강조 유형 */
      templateEmphasizeType?: string | null;
      /** 템플릿 내용 */
      templateContent?: string | null;
      /** 부가정보 */
      templateExtra?: string | null;
      /** 광고성 메시지 */
      templateAd?: string | null;
      /** 템플릿 이미지 파일명 */
      templateImageName?: string | null;
      /** 템플릿 이미지 링크 */
      templateImageUrl?: string | null;
      /** 템플릿 내용 중 강조 표기할 핵심 정보 */
      templateTitle?: string | null;
      /** 강조 표기 보조 문구 */
      templateSubtitle?: string | null;
      /** 헤더 */
      templateHeader?: string | null;
      /** 보안 템플릿 여부 */
      securityFlag?: boolean | null;
      /** 검수 상태 */
      inspectionStatus?: "REG" | "REQ" | "REJ" | "STP" | "RDY" | "ACT" | "DMT" | "BLK" | "APR" | null;
      /** 템플릿 상태 (S:중지 - STP(or BLK), A:정상 - ACT, R:대기(발송전) - RDY), list의 serviceStatus와 대응 */
      status?: string | null;
      /** 차단 여부 */
      block?: boolean | null;
      /** 휴면상태 */
      dormant?: boolean | null;
      /** 버튼 정보 */
      buttons?: {
        /** 버튼명 */
        name: string;
        /** 버튼 링크타입 */
        linkType: string;
        /** 버튼 순서 */
        ordering?: number | null;
        /** Android 앱 링크 주소 */
        linkAnd?: string | null;
        /** IOS 앱 링크 주소 */
        linkIos?: string | null;
        /** 모바일 웹 링크 주소 */
        linkMo?: string | null;
        /** PC 웹 링크 주소 */
        linkPc?: string | null;
        /** 플러그인 ID */
        pluginId?: string | null;
        /** 비즈폼 ID */
        bizFormId?: string | null;
      }[];
      /** 바로연결 정보 */
      quickReplies?:
        | {
            /** 바로연결명 */
            name: string;
            /** 바로연결 링크타입 */
            linkType: string;
            /** Android 앱 링크 주소 */
            linkAnd?: string;
            /** IOS 앱 링크 주소 */
            linkIos?: string;
            /** 모바일 웹 링크 주소 */
            linkMo?: string;
            /** PC 웹 링크 주소 */
            linkPc?: string;
          }[]
        | null;
      /** 댓글 목록 */
      comments?: {
        /** 댓글 본문 */
        content?: string | null;
        /** 댓글 생성일 */
        createdAt: string;
        /** 댓글 상태 */
        status: string;
        /** 댓글 작성자 */
        userName: string;
        /** 첨부파일 */
        attachment?: {
          /** 업로드한 파일 이름 */
          originalFileName: string;
          /** 파일 다운로드 경로 */
          filePath: string;
        }[];
      }[];
    };
    isActive?: boolean;
    writerID?: string;
    modifierID?: string;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminTreatmentCategoryRemoveHandlerBodyRequest {
  _id: string;
}

export interface AdminTreatmentCategoryRemoveHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    categoryName?: string;
    isCommon?: boolean;
    hospitalID?: string;
    sortNum?: number;
    paletteIndex?: number;
    treatmentCautionID?: string;
    folderID?: string;
    isUsingCustomColor?: boolean;
    customColor?: string;
    manualContent?: string;
    fileID?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    isActive?: boolean;
    writerID?: string;
    modifierID?: string;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminTreatmentCategoryUpdateHandlerBodyRequest {
  _id: string;
  categoryName: string;
  isCommon?: boolean;
  paletteIndex?: number;
  treatmentCautionID?: string[] | null;
  folderID?: string;
  isUsingCustomColor?: boolean;
  customColor?: string;
  manualContent?: string;
  fileID?: string;
  /** 치료시 주의사항 발송여부 */
  usingCautionMessage?: boolean;
  /** 애프터닥 채팅 혹은 카카오 템플릿으로 보내질 치료시 주의사항 텍스트 */
  cautionMessage?: string;
  /** 카카오 템플릿 기록을 위한 senderKey */
  kakao_senderKey?: string;
  /** 카카오 템플릿 기록을 위한 senderType */
  kakao_senderKeyType?: string;
  /** 카카오 템플릿 기록을 위한 templateCode * client에서는 사용하지 말 것. */
  kakao_templateCode?: string;
}

export interface AdminTreatmentCategoryUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    categoryName?: string;
    isCommon?: boolean;
    hospitalID?: string;
    sortNum?: number;
    paletteIndex?: number;
    treatmentCautionID?: string;
    folderID?: string;
    isUsingCustomColor?: boolean;
    customColor?: string;
    manualContent?: string;
    fileID?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    isActive?: boolean;
    writerID?: string;
    modifierID?: string;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminTreatmentCategoryCopyHandlerBodyRequest {
  hospitalID?: string;
  treatmentCategoryID?: string;
}

export interface AdminTreatmentCategoryCopyHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    categoryName?: string;
    description?: string;
    isCommon?: boolean;
    hospitalID?: string;
    sortNum?: number;
    paletteIndex?: number;
    folderID?: string;
    isUsingCustomColor?: boolean;
    customColor?: string;
    manualContent?: string;
    fileID?: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    isActive?: boolean;
    /** 치료시 주의사항 발송여부 */
    usingCautionMessage?: boolean;
    /** 애프터닥 채팅 혹은 카카오 템플릿으로 보내질 치료시 주의사항 텍스트 */
    cautionMessage?: string;
    /** 카카오 템플릿 기록을 위한 senderKey */
    kakao_senderKey?: string;
    /** 카카오 템플릿 기록을 위한 senderType */
    kakao_senderKeyType?: string;
    /** 카카오 템플릿 기록을 위한 templateCode */
    kakao_templateCode?: string;
    kakaoTemplateInfo?: {
      /** 발신프로필 키 */
      senderKey?: string | null;
      /** 발신프로필 키 타입 */
      senderKeyType?: string | null;
      /** 템플릿 코드 */
      templateCode?: string | null;
      /** 템플릿 이름 */
      templateName?: string | null;
      /** 템플릿 카테고리 코드 */
      categoryCode?: string | null;
      /** 템플릿 상태 (REG: 등록, REQ: 검수요청, REJ: 반려, STP: 차단, RDY: 발송전, ACT: 정상, DMT: 휴면, BLK: 차단) */
      serviceStatus?: string | null;
      /** 등록일 */
      createdAt?: string | null;
      /** 수정일 */
      modifiedAt: string;
      /** 템플릿 메시지 유형 */
      templateMessageType?: string | null;
      /** 템플릿 강조 유형 */
      templateEmphasizeType?: string | null;
      /** 템플릿 내용 */
      templateContent?: string | null;
      /** 부가정보 */
      templateExtra?: string | null;
      /** 광고성 메시지 */
      templateAd?: string | null;
      /** 템플릿 이미지 파일명 */
      templateImageName?: string | null;
      /** 템플릿 이미지 링크 */
      templateImageUrl?: string | null;
      /** 템플릿 내용 중 강조 표기할 핵심 정보 */
      templateTitle?: string | null;
      /** 강조 표기 보조 문구 */
      templateSubtitle?: string | null;
      /** 헤더 */
      templateHeader?: string | null;
      /** 보안 템플릿 여부 */
      securityFlag?: boolean | null;
      /** 검수 상태 */
      inspectionStatus?: "REG" | "REQ" | "REJ" | "STP" | "RDY" | "ACT" | "DMT" | "BLK" | "APR" | null;
      /** 템플릿 상태 (S:중지 - STP(or BLK), A:정상 - ACT, R:대기(발송전) - RDY), list의 serviceStatus와 대응 */
      status?: string | null;
      /** 차단 여부 */
      block?: boolean | null;
      /** 휴면상태 */
      dormant?: boolean | null;
      /** 버튼 정보 */
      buttons?: {
        /** 버튼명 */
        name: string;
        /** 버튼 링크타입 */
        linkType: string;
        /** 버튼 순서 */
        ordering?: number | null;
        /** Android 앱 링크 주소 */
        linkAnd?: string | null;
        /** IOS 앱 링크 주소 */
        linkIos?: string | null;
        /** 모바일 웹 링크 주소 */
        linkMo?: string | null;
        /** PC 웹 링크 주소 */
        linkPc?: string | null;
        /** 플러그인 ID */
        pluginId?: string | null;
        /** 비즈폼 ID */
        bizFormId?: string | null;
      }[];
      /** 바로연결 정보 */
      quickReplies?:
        | {
            /** 바로연결명 */
            name: string;
            /** 바로연결 링크타입 */
            linkType: string;
            /** Android 앱 링크 주소 */
            linkAnd?: string;
            /** IOS 앱 링크 주소 */
            linkIos?: string;
            /** 모바일 웹 링크 주소 */
            linkMo?: string;
            /** PC 웹 링크 주소 */
            linkPc?: string;
          }[]
        | null;
      /** 댓글 목록 */
      comments?: {
        /** 댓글 본문 */
        content?: string | null;
        /** 댓글 생성일 */
        createdAt: string;
        /** 댓글 상태 */
        status: string;
        /** 댓글 작성자 */
        userName: string;
        /** 첨부파일 */
        attachment?: {
          /** 업로드한 파일 이름 */
          originalFileName: string;
          /** 파일 다운로드 경로 */
          filePath: string;
        }[];
      }[];
    };
    writerID?: string;
    modifierID?: string;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminFileCreateHandlerBodyRequest {
  type?: number;
  paths?: string[] | null;
  aws?: Record<string, string>[] | null;
}

export interface AdminFileCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    userID?: string;
    type?: number;
    paths?: string[] | null;
    aws?: Record<string, string>[] | null;
    /** @format date */
    expiredAt?: string;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminFileUpdateHandlerBodyRequest {
  _id: string;
  type?: number;
  paths?: string[] | null;
  aws?: Record<string, string>[] | null;
}

export interface AdminFileUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    paths: string[];
    aws?: {
      ETag: string;
      Location: string;
      Key: string;
      key: string;
      size?: {
        width?: number;
        height?: number;
      } | null;
      fileSize: number;
      fileName: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminFileFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    userID?: string;
    type?: number;
    paths?: string[] | null;
    aws?: Record<string, string>[] | null;
    /** @format date */
    expiredAt?: string;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminCountryFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: | {
        _id?: string;
        koreanCountryName?: string;
        internationalDialingCodes?: string;
        countryCodeISOAlpha2?: string;
        countryCodeISOAlpha3?: string;
        englishCountryName?: string;
        hasDefaultMessage?: boolean;
        defaultMessage?: string;
        firstMessage?: string;
        secondMessage?: string;
        thirdMessage?: string;
        registAlimTalkTemplateCode?: string;
        registAlimTalkTemplateName?: string;
        registAlimTalkContent?: string;
      }[]
    | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminCountryUpdateHandlerBodyRequest {
  _id?: string;
  koreanCountryName?: string;
  internationalDialingCodes?: string;
  countryCodeISOAlpha2?: string;
  countryCodeISOAlpha3?: string;
  englishCountryName?: string;
  hasDefaultMessage?: boolean;
  defaultMessage?: string;
  firstMessage?: string;
  secondMessage?: string;
  thirdMessage?: string;
  registAlimTalkTemplateCode?: string;
  registAlimTalkTemplateName?: string;
  registAlimTalkContent?: string;
}

export interface AdminCountryUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    koreanCountryName?: string;
    internationalDialingCodes?: string;
    countryCodeISOAlpha2?: string;
    countryCodeISOAlpha3?: string;
    englishCountryName?: string;
    hasDefaultMessage?: boolean;
    defaultMessage?: string;
    firstMessage?: string;
    secondMessage?: string;
    thirdMessage?: string;
    registAlimTalkTemplateCode?: string;
    registAlimTalkTemplateName?: string;
    registAlimTalkContent?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoLinkageHistoryCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: number;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoLinkageHistoryFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    hospitalID?: {
      _id?: string;
      shortName?: string;
    } | null;
    hospitalName?: string;
    tempHospitalName?: string;
    requesterID?: {
      _id?: string;
      id?: string;
      realName?: string;
    } | null;
    requesterContact?: string;
    isRequestForAlimAndFriendTalkLinkage?: boolean;
    isRequestForConsultationTalkLinkage?: boolean;
    /** @format date */
    toBeStartedAt?: string;
    searchableChannelId?: string;
    channelAdminPhone?: string;
    categoryInformation?: {
      broadCategory?: string;
      mediumCategory?: string;
      smallCategory?: string;
      categoryCode?: string;
    } | null;
    consultationInformation?: {
      /** @format date */
      consultationStartTime?: string;
      /** @format date */
      consultationEndTime?: string;
      sundayAvailable?: boolean;
      mondayAvailable?: boolean;
      tuesdayAvailable?: boolean;
      wednesdayAvailable?: boolean;
      thursdayAvailable?: boolean;
      fridayAvailable?: boolean;
      saturdayAvailable?: boolean;
    } | null;
    /**
     * 상담 가능 요일 및 시간 정보
     * @example [{"dayIndex":1,"startedAt":"2025-01-01T09:00:00.000+0900","endedAt":"2025-01-01T18:00:00.000+0900"}]
     */
    careSchedule?:
      | {
          /**
           * 요일 인덱스
           * @example 0
           */
          dayIndex: number;
          /**
           * 상담 시작 시간
           * @format date
           * @example "2025-01-01T09:00:00.000+0900"
           */
          startedAt: string;
          /**
           * 상담 종료 시간
           * @format date
           * @example "2025-01-01T18:00:00.000+0900"
           */
          endedAt: string;
        }[]
      | null;
    isLinked?: boolean;
    isActivate?: boolean;
    /** @format date */
    activatedAt?: string;
    /** @format date */
    deactivatedAt?: string;
    modifierID?: string;
    accessKey?: string;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoLinkageHistoryDetailHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    hospitalID?: {
      _id?: string;
      shortName?: string;
    } | null;
    hospitalName?: string;
    tempHospitalName?: string;
    requesterID?: {
      _id?: string;
      id?: string;
      realName?: string;
    } | null;
    requesterContact?: string;
    isRequestForAlimAndFriendTalkLinkage?: boolean;
    isRequestForConsultationTalkLinkage?: boolean;
    /** @format date */
    toBeStartedAt?: string;
    searchableChannelId?: string;
    channelAdminPhone?: string;
    categoryInformation?: {
      broadCategory?: string;
      mediumCategory?: string;
      smallCategory?: string;
      categoryCode?: string;
    } | null;
    consultationInformation?: {
      /** @format date */
      consultationStartTime?: string;
      /** @format date */
      consultationEndTime?: string;
      sundayAvailable?: boolean;
      mondayAvailable?: boolean;
      tuesdayAvailable?: boolean;
      wednesdayAvailable?: boolean;
      thursdayAvailable?: boolean;
      fridayAvailable?: boolean;
      saturdayAvailable?: boolean;
    } | null;
    /**
     * 상담 가능 요일 및 시간 정보
     * @example [{"dayIndex":1,"startedAt":"2025-01-01T09:00:00.000+0900","endedAt":"2025-01-01T18:00:00.000+0900"}]
     */
    careSchedule?:
      | {
          /**
           * 요일 인덱스
           * @example 0
           */
          dayIndex: number;
          /**
           * 상담 시작 시간
           * @format date
           * @example "2025-01-01T09:00:00.000+0900"
           */
          startedAt: string;
          /**
           * 상담 종료 시간
           * @format date
           * @example "2025-01-01T18:00:00.000+0900"
           */
          endedAt: string;
        }[]
      | null;
    isLinked?: boolean;
    isActivate?: boolean;
    /** @format date */
    activatedAt?: string;
    /** @format date */
    deactivatedAt?: string;
    modifierID?: string;
    accessKey?: string;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    detailInfo?: {
      uuid?: string;
      senderKey?: string;
      name?: string;
      groups?:
        | {
            groupKey?: string;
            name?: string;
            createdAt?: string;
          }[]
        | null;
      /** 발신프로필 상태 */
      status?: string;
      /** 카카오톡 채널 상태 */
      profileStatus?: string;
      /** 발신프로필 휴면 여부 */
      dormant?: boolean;
      /** 발신프로필 차단 여부 */
      block?: boolean;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoLinkageHistoryUpdateHandlerBodyRequest {
  _id?: string;
  hospitalID?: string;
  hospitalName?: string;
  tempHospitalName?: string;
  requesterID?: {
    _id?: string;
    id?: string;
    realName?: string;
  } | null;
  requesterContact?: string;
  isRequestForAlimAndFriendTalkLinkage?: boolean;
  isRequestForConsultationTalkLinkage?: boolean;
  /** @format date */
  toBeStartedAt?: string;
  searchableChannelId?: string;
  channelAdminPhone?: string;
  categoryInformation?: {
    broadCategory?: string;
    mediumCategory?: string;
    smallCategory?: string;
    categoryCode?: string;
  } | null;
  consultationInformation?: {
    /** @format date */
    consultationStartTime?: string;
    /** @format date */
    consultationEndTime?: string;
    sundayAvailable?: boolean;
    mondayAvailable?: boolean;
    tuesdayAvailable?: boolean;
    wednesdayAvailable?: boolean;
    thursdayAvailable?: boolean;
    fridayAvailable?: boolean;
    saturdayAvailable?: boolean;
  } | null;
  /**
   * 상담 가능 요일 및 시간 정보
   * @example [{"dayIndex":1,"startedAt":"2025-01-01T09:00:00.000+0900","endedAt":"2025-01-01T18:00:00.000+0900"}]
   */
  careSchedule?:
    | {
        /**
         * 요일 인덱스
         * @example 0
         */
        dayIndex: number;
        /**
         * 상담 시작 시간
         * @format date
         * @example "2025-01-01T09:00:00.000+0900"
         */
        startedAt: string;
        /**
         * 상담 종료 시간
         * @format date
         * @example "2025-01-01T18:00:00.000+0900"
         */
        endedAt: string;
      }[]
    | null;
  isLinked?: boolean;
  isActivate?: boolean;
  /** @format date */
  activatedAt?: string;
  /** @format date */
  deactivatedAt?: string;
  modifierID?: string;
  accessKey?: string;
  /** @format date */
  createdAt?: string;
  /** @format date */
  updatedAt?: string;
  usingKakaoAlimAndFriendTalkLinkage?: boolean;
}

export interface KakaoLinkageHistoryUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    hospitalID?: {
      _id?: string;
      shortName?: string;
    } | null;
    hospitalName?: string;
    tempHospitalName?: string;
    requesterID?: {
      _id?: string;
      id?: string;
      realName?: string;
    } | null;
    requesterContact?: string;
    isRequestForAlimAndFriendTalkLinkage?: boolean;
    isRequestForConsultationTalkLinkage?: boolean;
    /** @format date */
    toBeStartedAt?: string;
    searchableChannelId?: string;
    channelAdminPhone?: string;
    categoryInformation?: {
      broadCategory?: string;
      mediumCategory?: string;
      smallCategory?: string;
      categoryCode?: string;
    } | null;
    consultationInformation?: {
      /** @format date */
      consultationStartTime?: string;
      /** @format date */
      consultationEndTime?: string;
      sundayAvailable?: boolean;
      mondayAvailable?: boolean;
      tuesdayAvailable?: boolean;
      wednesdayAvailable?: boolean;
      thursdayAvailable?: boolean;
      fridayAvailable?: boolean;
      saturdayAvailable?: boolean;
    } | null;
    /**
     * 상담 가능 요일 및 시간 정보
     * @example [{"dayIndex":1,"startedAt":"2025-01-01T09:00:00.000+0900","endedAt":"2025-01-01T18:00:00.000+0900"}]
     */
    careSchedule?:
      | {
          /**
           * 요일 인덱스
           * @example 0
           */
          dayIndex: number;
          /**
           * 상담 시작 시간
           * @format date
           * @example "2025-01-01T09:00:00.000+0900"
           */
          startedAt: string;
          /**
           * 상담 종료 시간
           * @format date
           * @example "2025-01-01T18:00:00.000+0900"
           */
          endedAt: string;
        }[]
      | null;
    isLinked?: boolean;
    isActivate?: boolean;
    /** @format date */
    activatedAt?: string;
    /** @format date */
    deactivatedAt?: string;
    modifierID?: string;
    accessKey?: string;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoLinkageHistoryClearHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    hospitalID?: {
      _id?: string;
      shortName?: string;
    } | null;
    hospitalName?: string;
    tempHospitalName?: string;
    requesterID?: {
      _id?: string;
      id?: string;
      realName?: string;
    } | null;
    requesterContact?: string;
    isRequestForAlimAndFriendTalkLinkage?: boolean;
    isRequestForConsultationTalkLinkage?: boolean;
    /** @format date */
    toBeStartedAt?: string;
    searchableChannelId?: string;
    channelAdminPhone?: string;
    categoryInformation?: {
      broadCategory?: string;
      mediumCategory?: string;
      smallCategory?: string;
      categoryCode?: string;
    } | null;
    consultationInformation?: {
      /** @format date */
      consultationStartTime?: string;
      /** @format date */
      consultationEndTime?: string;
      sundayAvailable?: boolean;
      mondayAvailable?: boolean;
      tuesdayAvailable?: boolean;
      wednesdayAvailable?: boolean;
      thursdayAvailable?: boolean;
      fridayAvailable?: boolean;
      saturdayAvailable?: boolean;
    } | null;
    /**
     * 상담 가능 요일 및 시간 정보
     * @example [{"dayIndex":1,"startedAt":"2025-01-01T09:00:00.000+0900","endedAt":"2025-01-01T18:00:00.000+0900"}]
     */
    careSchedule?:
      | {
          /**
           * 요일 인덱스
           * @example 0
           */
          dayIndex: number;
          /**
           * 상담 시작 시간
           * @format date
           * @example "2025-01-01T09:00:00.000+0900"
           */
          startedAt: string;
          /**
           * 상담 종료 시간
           * @format date
           * @example "2025-01-01T18:00:00.000+0900"
           */
          endedAt: string;
        }[]
      | null;
    isLinked?: boolean;
    isActivate?: boolean;
    /** @format date */
    activatedAt?: string;
    /** @format date */
    deactivatedAt?: string;
    modifierID?: string;
    accessKey?: string;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoLinkageHistoryActivateHandlerBodyRequest {
  /** 병원 ID */
  hospitalID: string;
  /** 카카오 채널 ID */
  searchableChannelId: string;
  /** 인포뱅크로 부터 발급받은 API 키 */
  accessKey: string;
  /** 카카오 연동 활성화 여부 */
  isActivate: boolean;
  /**
   * 상담 가능 요일 및 시간 정보
   * @example [{"dayIndex":1,"startedAt":"2025-01-01T09:00:00.000+0900","endedAt":"2025-01-01T18:00:00.000+0900"}]
   */
  careSchedule?:
    | {
        /**
         * 요일 인덱스
         * @example 0
         */
        dayIndex: number;
        /**
         * 상담 시작 시간
         * @format date
         * @example "2025-01-01T09:00:00.000+0900"
         */
        startedAt: string;
        /**
         * 상담 종료 시간
         * @format date
         * @example "2025-01-01T18:00:00.000+0900"
         */
        endedAt: string;
      }[]
    | null;
}

export interface KakaoLinkageHistoryActivateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 인포뱅크 처리 결과 코드 - 0은 정상, 나머지 오류 */
    code: number;
    /** 오류 메시지 */
    message?: string | null;
    /** 요일별 상담 시간 목록 처리 결과 */
    week_timetable?: {
      /** 카카오톡 측 처리 결과 코드 - 200은 정상, 나머지 오류 */
      code: string;
      /** 카카오로부터 전달받은 요일별 상담 시간 목록 저장 시각 */
      time: string;
      /** 오류 메시지 */
      message?: string | null;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateFindGroupHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    groupKey?: string;
    name?: string;
    /** @format date */
    createdAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateAddProfileToGroupHandlerBodyRequest {
  /** 발신프로필 키 (우선 사용) */
  senderKey?: string;
  /** 검색용 아이디 (senderKey 미지정 시 해석에 사용) */
  searchableChannelId?: string;
  /** 추가할 그룹 명 - 메디팔, 애프터닥 (미지정 시 애프터닥) */
  groupName?: string;
}

export interface KakaoTemplateAddProfileToGroupHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    groupKey?: string;
    name?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateRemoveProfileFromGroupHandlerBodyRequest {
  /** 발신프로필 키 (우선 사용) */
  senderKey?: string;
  /** 검색용 아이디 (senderKey 미지정 시 해석에 사용) */
  searchableChannelId?: string;
  /** 제거할 그룹 명 - 메디팔, 애프터닥 */
  groupName?: string;
}

export interface KakaoTemplateRemoveProfileFromGroupHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    groupKey?: string;
    name?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateFindAllProfileHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    senderKey?: string;
    uuid?: string;
    name?: string;
    profileStatus?: string;
    groups?:
      | {
          name?: string;
          groupKey?: string;
          /** YYYY-MM-DD */
          createdAt?: string;
        }[]
      | null;
    /** YYYY-MM-DD HH:mm:ss */
    createdAt?: string;
    /** YYYY-MM-DD HH:mm:ss */
    modifiedAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateFindProfileHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    senderKey?: string;
    uuid?: string;
    name?: string;
    profileStatus?: string;
    groups?:
      | {
          name?: string;
          groupKey?: string;
          /** YYYY-MM-DD */
          createdAt?: string;
        }[]
      | null;
    /** YYYY-MM-DD HH:mm:ss */
    createdAt?: string;
    /** YYYY-MM-DD HH:mm:ss */
    modifiedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateFindCategoryHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    code?: string;
    name?: string;
    groupName?: string;
    inclusion?: string;
    exclusion?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    code?: string;
    message?: string;
    totalCount?: number;
    currentPage?: number;
    totalPage?: number;
    list?:
      | {
          senderKey?: string;
          senderKeyType?: string;
          serviceStatus?: string;
          templateCode?: string;
          templateName?: string;
          categoryCode?: string;
          /** @format date */
          createdAt?: string;
          /** @format date */
          modifiedAt?: string;
        }[]
      | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateCreateHandlerBodyRequest {
  senderKey: string;
  senderKeyType: string;
  templateCode: string;
  templateName: string;
  templateMessageType: string;
  templateEmphasizeType: string;
  templateContent: string;
  categoryCode: string;
}

export interface KakaoTemplateCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    status?: string;
    senderKey?: string;
    senderKeyType?: string;
    templateCode?: string;
    templateName?: string;
    templateMessageType?: string;
    templateContent?: string;
    templateTitle?: string;
    templateSubTitle?: string;
    categoryCode?: string;
    securityFlag?: boolean;
    /** 검수 상태 */
    inspectionStatus?: "REG" | "REQ" | "REJ" | "STP" | "RDY" | "ACT" | "DMT" | "BLK" | "APR" | null;
    dormant?: boolean;
    createdAt?: string;
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateUpdateHandlerBodyRequest {
  senderKey?: string;
  senderKeyType?: string;
  newTemplateCode?: string;
  templateName?: string;
  templateMessageType?: string;
  templateEmphasizeType?: string;
  templateContent?: string;
  categoryCode?: string;
}

export interface KakaoTemplateUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    status?: string;
    senderKey?: string;
    senderKeyType?: string;
    templateCode?: string;
    templateName?: string;
    templateMessageType?: string;
    templateContent?: string;
    templateTitle?: string;
    templateSubTitle?: string;
    categoryCode?: string;
    securityFlag?: boolean;
    /** 검수 상태 */
    inspectionStatus?: "REG" | "REQ" | "REJ" | "STP" | "RDY" | "ACT" | "DMT" | "BLK" | "APR" | null;
    dormant?: boolean;
    createdAt?: string;
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateDeleteHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    code?: string;
    message?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateDetailHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    status?: string;
    senderKey?: string;
    senderKeyType?: string;
    templateCode?: string;
    templateName?: string;
    templateMessageType?: string;
    templateContent?: string;
    templateTitle?: string;
    templateSubTitle?: string;
    categoryCode?: string;
    securityFlag?: boolean;
    /** 검수 상태 */
    inspectionStatus?: "REG" | "REQ" | "REJ" | "STP" | "RDY" | "ACT" | "DMT" | "BLK" | "APR" | null;
    dormant?: boolean;
    createdAt?: string;
    updatedAt?: string;
    comments?: {
      attachment?:
        | {
            originalFileName?: string;
            filePath?: string;
          }[]
        | null;
      content?: string;
      /** @format date */
      createdAt?: string;
      status?: string;
      userName?: string;
    }[];
    buttons?:
      | {
          name?: string;
          linkType?: string;
          ordering?: number;
          linkAnd?: string;
          linkIos?: string;
          linkMo?: string;
          linkPc?: string;
          pluginId?: string;
          bizFormId?: string;
        }[]
      | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateDetailParsedHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    templateCode?: string;
    templateName?: string;
    templateParsedContent?: {
      message?: string;
      button?:
        | {
            name?: string;
            type?: string;
            scheme_android?: string;
            scheme_ios?: string;
            url_mobile?: string;
            url_pc?: string;
            plugin_id?: string;
            biz_form_id?: number;
          }[]
        | null;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateRequestHandlerBodyRequest {
  senderKey: string;
  senderKeyType: string;
  templateCode: string;
}

export interface KakaoTemplateRequestHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    code?: string;
    messaging?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateInspectIfNeededHandlerBodyRequest {
  senderKey: string;
  templateCode: string;
}

export interface KakaoTemplateInspectIfNeededHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    result?: string;
    status?: string;
    message?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateRegisterAndInspectHandlerBodyRequest {
  senderKey: string;
  messageId: string;
  replaceGroupTemplate?: boolean | null;
}

export interface KakaoTemplateRegisterAndInspectHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    result?: string;
    reason?: string;
    message?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateRequestCancelHandlerBodyRequest {
  senderKey: string;
  senderKeyType: string;
  templateCode: string;
}

export interface KakaoTemplateRequestCancelHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    code?: string;
    messaging?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateStopHandlerBodyRequest {
  senderKey: string;
  senderKeyType: string;
  templateCode: string;
}

export interface KakaoTemplateStopHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    code?: string;
    messaging?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateReuseHandlerBodyRequest {
  senderKey: string;
  senderKeyType: string;
  templateCode: string;
}

export interface KakaoTemplateReuseHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    code?: string;
    messaging?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateCancelApprovalHandlerBodyRequest {
  senderKey: string;
  senderKeyType: string;
  templateCode: string;
}

export interface KakaoTemplateCancelApprovalHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    code?: string;
    messaging?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateReleaseHandlerBodyRequest {
  senderKey: string;
  senderKeyType: string;
  templateCode: string;
}

export interface KakaoTemplateReleaseHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    code?: string;
    messaging?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoTemplateHistoryFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    templateCode?: string;
    templateName?: string;
    templateMessageType?: string;
    templateEmphasizeType?: string;
    templateContent?: string;
    categoryCode?: string;
    templateStatus?: string;
    serviceStatus?: string;
    block?: boolean;
    dormant?: boolean;
    comments?: {
      content?: string;
      /** @format date */
      createdAt?: string;
      status?: string;
      userName?: string;
      attachment?: {
        originalFileName?: string;
        filePath?: string;
      } | null;
    }[];
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    modifiedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAutomationCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: number;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAutomationFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    memo?: string;
    type: string;
    isActive?: boolean;
    messages?: {
      _id?: string;
      sendingType: string;
      contentType: string;
      name: string;
      content: {
        text?: string;
        image?: string;
        video?: string;
        workoutVideo?: string;
        homecareContent?: string;
        event?: string;
        survey?: {
          question?: string;
          answers?: string[] | null;
        };
      };
      daysAfter?: number;
      timeOfDay?: string;
      showConsultationGuide?: boolean;
      consultationGuide?: string;
      kakaoTemplateHistoryId?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
      /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
      registKakaoTemplate?: boolean;
      kakaoTemplate?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
    }[];
    targetTreatmentTags?:
      | {
          _id?: string;
          hospitalID?: string;
          categoryName?: string;
          isActive?: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        }[]
      | null;
    appliedNationalities?:
      | {
          _id?: string;
          koreanCountryName?: string;
          internationalDialingCodes?: string;
          englishCountryName: string;
        }[]
      | null;
    statistics: {
      targetCount?: number;
      readCount?: number;
      responseCount?: number;
    };
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAutomationCreateHandlerBodyRequest {
  isTemplate: boolean;
  name: string;
  memo?: string;
  type: string;
  isActive?: boolean;
  messages?: {
    _id?: string;
    sendingType: string;
    contentType: string;
    name: string;
    content: {
      text?: string;
      image?: string;
      video?: string;
      workoutVideo?: string;
      homecareContent?: string;
      event?: string;
      survey?: {
        question?: string;
        answers?: string[] | null;
      };
    };
    daysAfter?: number;
    timeOfDay?: string;
    showConsultationGuide?: boolean;
    consultationGuide?: string;
    kakaoTemplateHistoryId?: {
      _id?: string;
      hospitalID?: string;
      algorithmId?: string;
      kakaoTemplateHistoryId?: string;
      templateCode?: string;
      senderKey?: string;
      senderKeyType?: string;
      templateName?: string;
      templateMessageType?: string;
      templateEmphasizeType?: string;
      templateContent?: string;
      serviceStatus?: string;
      inspectionStatus?: string;
      categoryCode?: string;
      isGroupTemplate?: boolean;
    } | null;
    /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
    registKakaoTemplate?: boolean;
    kakaoTemplate?: {
      _id?: string;
      hospitalID?: string;
      algorithmId?: string;
      kakaoTemplateHistoryId?: string;
      templateCode?: string;
      senderKey?: string;
      senderKeyType?: string;
      templateName?: string;
      templateMessageType?: string;
      templateEmphasizeType?: string;
      templateContent?: string;
      serviceStatus?: string;
      inspectionStatus?: string;
      categoryCode?: string;
      isGroupTemplate?: boolean;
    } | null;
  }[];
}

export interface AdminAutomationCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    memo?: string;
    type: string;
    isActive?: boolean;
    messages?: {
      _id?: string;
      sendingType: string;
      contentType: string;
      name: string;
      content: {
        text?: string;
        image?: string;
        video?: string;
        workoutVideo?: string;
        homecareContent?: string;
        event?: string;
        survey?: {
          question?: string;
          answers?: string[] | null;
        };
      };
      daysAfter?: number;
      timeOfDay?: string;
      showConsultationGuide?: boolean;
      consultationGuide?: string;
      kakaoTemplateHistoryId?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
      /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
      registKakaoTemplate?: boolean;
      kakaoTemplate?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
    }[];
    targetTreatmentTags?:
      | {
          _id?: string;
          hospitalID?: string;
          categoryName?: string;
          isActive?: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        }[]
      | null;
    appliedNationalities?:
      | {
          _id?: string;
          koreanCountryName?: string;
          internationalDialingCodes?: string;
          englishCountryName: string;
        }[]
      | null;
    statistics: {
      targetCount?: number;
      readCount?: number;
      responseCount?: number;
    };
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAutomationUpdateHandlerBodyRequest {
  _id: string;
  isTemplate: boolean;
  name: string;
  memo?: string;
  type: string;
  isActive?: boolean;
  messages?: {
    _id?: string;
    sendingType: string;
    contentType: string;
    name: string;
    content: {
      text?: string;
      image?: string;
      video?: string;
      workoutVideo?: string;
      homecareContent?: string;
      event?: string;
      survey?: {
        question?: string;
        answers?: string[] | null;
      };
    };
    daysAfter?: number;
    timeOfDay?: string;
    showConsultationGuide?: boolean;
    consultationGuide?: string;
    kakaoTemplateHistoryId?: {
      _id?: string;
      hospitalID?: string;
      algorithmId?: string;
      kakaoTemplateHistoryId?: string;
      templateCode?: string;
      senderKey?: string;
      senderKeyType?: string;
      templateName?: string;
      templateMessageType?: string;
      templateEmphasizeType?: string;
      templateContent?: string;
      serviceStatus?: string;
      inspectionStatus?: string;
      categoryCode?: string;
      isGroupTemplate?: boolean;
    } | null;
    /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
    registKakaoTemplate?: boolean;
    kakaoTemplate?: {
      _id?: string;
      hospitalID?: string;
      algorithmId?: string;
      kakaoTemplateHistoryId?: string;
      templateCode?: string;
      senderKey?: string;
      senderKeyType?: string;
      templateName?: string;
      templateMessageType?: string;
      templateEmphasizeType?: string;
      templateContent?: string;
      serviceStatus?: string;
      inspectionStatus?: string;
      categoryCode?: string;
      isGroupTemplate?: boolean;
    } | null;
  }[];
}

export interface AdminAutomationUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    memo?: string;
    type: string;
    isActive?: boolean;
    messages?: {
      _id?: string;
      sendingType: string;
      contentType: string;
      name: string;
      content: {
        text?: string;
        image?: string;
        video?: string;
        workoutVideo?: string;
        homecareContent?: string;
        event?: string;
        survey?: {
          question?: string;
          answers?: string[] | null;
        };
      };
      daysAfter?: number;
      timeOfDay?: string;
      showConsultationGuide?: boolean;
      consultationGuide?: string;
      kakaoTemplateHistoryId?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
      /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
      registKakaoTemplate?: boolean;
      kakaoTemplate?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
    }[];
    targetTreatmentTags?:
      | {
          _id?: string;
          hospitalID?: string;
          categoryName?: string;
          isActive?: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        }[]
      | null;
    appliedNationalities?:
      | {
          _id?: string;
          koreanCountryName?: string;
          internationalDialingCodes?: string;
          englishCountryName: string;
        }[]
      | null;
    statistics: {
      targetCount?: number;
      readCount?: number;
      responseCount?: number;
    };
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAutomationDeleteHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    memo?: string;
    type: string;
    isActive?: boolean;
    messages?: {
      _id?: string;
      sendingType: string;
      contentType: string;
      name: string;
      content: {
        text?: string;
        image?: string;
        video?: string;
        workoutVideo?: string;
        homecareContent?: string;
        event?: string;
        survey?: {
          question?: string;
          answers?: string[] | null;
        };
      };
      daysAfter?: number;
      timeOfDay?: string;
      showConsultationGuide?: boolean;
      consultationGuide?: string;
      kakaoTemplateHistoryId?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
      /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
      registKakaoTemplate?: boolean;
      kakaoTemplate?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
    }[];
    targetTreatmentTags?:
      | {
          _id?: string;
          hospitalID?: string;
          categoryName?: string;
          isActive?: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        }[]
      | null;
    appliedNationalities?:
      | {
          _id?: string;
          koreanCountryName?: string;
          internationalDialingCodes?: string;
          englishCountryName: string;
        }[]
      | null;
    statistics: {
      targetCount?: number;
      readCount?: number;
      responseCount?: number;
    };
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAuomtaionHospitalFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    memo?: string;
    type: string;
    isActive?: boolean;
    messages?: {
      _id?: string;
      sendingType: string;
      contentType: string;
      name: string;
      content: {
        text?: string;
        image?: string;
        video?: string;
        workoutVideo?: string;
        homecareContent?: string;
        event?: string;
        survey?: {
          question?: string;
          answers?: string[] | null;
        };
      };
      daysAfter?: number;
      timeOfDay?: string;
      showConsultationGuide?: boolean;
      consultationGuide?: string;
      kakaoTemplateHistoryId?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
      /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
      registKakaoTemplate?: boolean;
      kakaoTemplate?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
    }[];
    targetTreatmentTags?:
      | {
          _id?: string;
          hospitalID?: string;
          categoryName?: string;
          isActive?: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        }[]
      | null;
    appliedNationalities?:
      | {
          _id?: string;
          koreanCountryName?: string;
          internationalDialingCodes?: string;
          englishCountryName: string;
        }[]
      | null;
    statistics: {
      targetCount?: number;
      readCount?: number;
      responseCount?: number;
    };
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAutomationHospitalCreateHandlerBodyRequest {
  hospitalID: string;
  name: string;
  memo?: string;
  targetTreatmentTags?: string[] | null;
  appliedNationalities?: string[] | null;
  type: string;
  isActive?: boolean;
  messages?: {
    _id?: string;
    sendingType: string;
    contentType: string;
    name: string;
    content: {
      text?: string;
      image?: string;
      video?: string;
      workoutVideo?: string;
      homecareContent?: string;
      event?: string;
      survey?: {
        question?: string;
        answers?: string[] | null;
      };
    };
    daysAfter?: number;
    timeOfDay?: string;
    showConsultationGuide?: boolean;
    consultationGuide?: string;
    kakaoTemplateHistoryId?: {
      _id?: string;
      hospitalID?: string;
      algorithmId?: string;
      kakaoTemplateHistoryId?: string;
      templateCode?: string;
      senderKey?: string;
      senderKeyType?: string;
      templateName?: string;
      templateMessageType?: string;
      templateEmphasizeType?: string;
      templateContent?: string;
      serviceStatus?: string;
      inspectionStatus?: string;
      categoryCode?: string;
      isGroupTemplate?: boolean;
    } | null;
    /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
    registKakaoTemplate?: boolean;
    kakaoTemplate?: {
      _id?: string;
      hospitalID?: string;
      algorithmId?: string;
      kakaoTemplateHistoryId?: string;
      templateCode?: string;
      senderKey?: string;
      senderKeyType?: string;
      templateName?: string;
      templateMessageType?: string;
      templateEmphasizeType?: string;
      templateContent?: string;
      serviceStatus?: string;
      inspectionStatus?: string;
      categoryCode?: string;
      isGroupTemplate?: boolean;
    } | null;
  }[];
}

export interface AdminAutomationHospitalCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    memo?: string;
    type: string;
    isActive?: boolean;
    messages?: {
      _id?: string;
      sendingType: string;
      contentType: string;
      name: string;
      content: {
        text?: string;
        image?: string;
        video?: string;
        workoutVideo?: string;
        homecareContent?: string;
        event?: string;
        survey?: {
          question?: string;
          answers?: string[] | null;
        };
      };
      daysAfter?: number;
      timeOfDay?: string;
      showConsultationGuide?: boolean;
      consultationGuide?: string;
      kakaoTemplateHistoryId?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
      /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
      registKakaoTemplate?: boolean;
      kakaoTemplate?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
    }[];
    targetTreatmentTags?:
      | {
          _id?: string;
          hospitalID?: string;
          categoryName?: string;
          isActive?: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        }[]
      | null;
    appliedNationalities?:
      | {
          _id?: string;
          koreanCountryName?: string;
          internationalDialingCodes?: string;
          englishCountryName: string;
        }[]
      | null;
    statistics: {
      targetCount?: number;
      readCount?: number;
      responseCount?: number;
    };
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAutomationHospitalUpdateHandlerBodyRequest {
  _id: string;
  isActive?: boolean;
}

export interface AdminAutomationHospitalUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    memo?: string;
    type: string;
    isActive?: boolean;
    messages?: {
      _id?: string;
      sendingType: string;
      contentType: string;
      name: string;
      content: {
        text?: string;
        image?: string;
        video?: string;
        workoutVideo?: string;
        homecareContent?: string;
        event?: string;
        survey?: {
          question?: string;
          answers?: string[] | null;
        };
      };
      daysAfter?: number;
      timeOfDay?: string;
      showConsultationGuide?: boolean;
      consultationGuide?: string;
      kakaoTemplateHistoryId?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
      /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
      registKakaoTemplate?: boolean;
      kakaoTemplate?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
    }[];
    targetTreatmentTags?:
      | {
          _id?: string;
          hospitalID?: string;
          categoryName?: string;
          isActive?: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        }[]
      | null;
    appliedNationalities?:
      | {
          _id?: string;
          koreanCountryName?: string;
          internationalDialingCodes?: string;
          englishCountryName: string;
        }[]
      | null;
    statistics: {
      targetCount?: number;
      readCount?: number;
      responseCount?: number;
    };
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAutomationHospitalDeleteHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    name: string;
    memo?: string;
    type: string;
    isActive?: boolean;
    messages?: {
      _id?: string;
      sendingType: string;
      contentType: string;
      name: string;
      content: {
        text?: string;
        image?: string;
        video?: string;
        workoutVideo?: string;
        homecareContent?: string;
        event?: string;
        survey?: {
          question?: string;
          answers?: string[] | null;
        };
      };
      daysAfter?: number;
      timeOfDay?: string;
      showConsultationGuide?: boolean;
      consultationGuide?: string;
      kakaoTemplateHistoryId?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
      /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
      registKakaoTemplate?: boolean;
      kakaoTemplate?: {
        _id?: string;
        hospitalID?: string;
        algorithmId?: string;
        kakaoTemplateHistoryId?: string;
        templateCode?: string;
        senderKey?: string;
        senderKeyType?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        serviceStatus?: string;
        inspectionStatus?: string;
        categoryCode?: string;
        isGroupTemplate?: boolean;
      } | null;
    }[];
    targetTreatmentTags?:
      | {
          _id?: string;
          hospitalID?: string;
          categoryName?: string;
          isActive?: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        }[]
      | null;
    appliedNationalities?:
      | {
          _id?: string;
          koreanCountryName?: string;
          internationalDialingCodes?: string;
          englishCountryName: string;
        }[]
      | null;
    statistics: {
      targetCount?: number;
      readCount?: number;
      responseCount?: number;
    };
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAutomationHospitalUpdateMessageHandlerBodyRequest {
  _id: string;
  name?: string;
  sendingType?: string;
  contentType?: string;
  content?: {
    text?: string;
    image?: string;
    video?: string;
    workoutVideo?: string;
    homecareContent?: string;
    event?: string;
    survey?: {
      question?: string;
      answers?: string[] | null;
    };
  };
  daysAfter?: number;
  timeOfDay?: string;
  showConsultationGuide?: boolean;
  consultationGuide?: string;
}

export interface AdminAutomationHospitalUpdateMessageHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    sendingType: string;
    contentType: string;
    name: string;
    content?: {
      text?: string;
      image?: string;
      video?: string;
      workoutVideo?: string;
      homecareContent?: string;
      event?: string;
      survey?: {
        question?: string;
        answers?: string[] | null;
      };
    };
    daysAfter?: number;
    timeOfDay?: string;
    showConsultationGuide?: boolean;
    consultationGuide?: string;
    kakaoTemplateHistoryId?: {
      _id?: string;
      hospitalID?: string;
      algorithmId?: string;
      kakaoTemplateHistoryId?: string;
      templateCode?: string;
      senderKey?: string;
      senderKeyType?: string;
      templateName?: string;
      templateMessageType?: string;
      templateEmphasizeType?: string;
      templateContent?: string;
      serviceStatus?: string;
      inspectionStatus?: string;
      categoryCode?: string;
      isGroupTemplate?: boolean;
    } | null;
    /** 생성/수정시, 카카오 템플릿 등록을 원하는 경우 true */
    registKakaoTemplate?: boolean;
    kakaoTemplate?: {
      _id?: string;
      hospitalID?: string;
      algorithmId?: string;
      kakaoTemplateHistoryId?: string;
      templateCode?: string;
      senderKey?: string;
      senderKeyType?: string;
      templateName?: string;
      templateMessageType?: string;
      templateEmphasizeType?: string;
      templateContent?: string;
      serviceStatus?: string;
      inspectionStatus?: string;
      categoryCode?: string;
      isGroupTemplate?: boolean;
    } | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAuomtaionHospitalFindVideoContentHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    title?: string;
  } | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAuomtaionHospitalFindHomecareHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    title?: string;
  } | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAuomtaionHospitalFindEventHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    title?: string;
  } | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoServiceNotificationMessageFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    type: string;
    /** @format date */
    sendTime?: string;
    senderKey: string;
    senderKeyType: string;
    templateCode: string;
  } | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoServiceNotificationMessageUpdateHandlerBodyRequest {
  _id?: string;
  /** @format date */
  sendTime?: string;
  senderKey: string;
  senderKeyType: string;
  templateCode: string;
}

export interface KakaoServiceNotificationMessageUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    type: string;
    /** @format date */
    sendTime?: string;
    senderKey: string;
    senderKeyType: string;
    templateCode: string;
  } | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TalkTalkLinkageAccountsStatesHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hospitalID?: string;
    requesterName?: string;
    requesterPhone?: string;
    isRequested?: boolean;
    isApproved?: boolean;
    talktalkBusinessCenterID?: string;
    authorization?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TalkTalkLinkagePatchAccountsStatesHandlerBodyRequest {
  hospitalID?: string;
  isApproved?: boolean;
}

export interface TalkTalkLinkagePatchAccountsStatesHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    isApprovedSuccess?: boolean;
    hospitalID?: string;
    requesterName?: string;
    requesterPhone?: string;
    isApproved?: boolean;
    talktalkBusinessCenterID?: string;
    authorization?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAuthorizationTypeCreateHandlerBodyRequest {
  /** 권한을 부여할 관리자 사용자 ID */
  userID: string;
  /** 병원 관리 메뉴 조회 권한 여부 */
  hospitalManagement_v?: boolean;
  /** 병원 관리 메뉴 수정 권한 여부 */
  hospitalManagement_w?: boolean;
  /** 병원 현황 메뉴 조회 권한 여부 */
  hospitalState_v?: boolean;
  /** 병원 현황 메뉴 수정 권한 여부 */
  hospitalState_w?: boolean;
  /** v2 병원 관리 메뉴 조회 권한 여부 */
  v2HospitalManagement_v?: boolean;
  /** v2 병원 관리 메뉴 수정 권한 여부 */
  v2HospitalManagement_w?: boolean;
  /** v2 병원 현황 메뉴 조회 권한 여부 */
  v2HospitalState_v?: boolean;
  /** v2 병원 현황 메뉴 수정 권한 여부 */
  v2HospitalState_w?: boolean;
  /** v2 병원 연동 메뉴 조회 권한 여부 */
  v2HospitalIntegration_v?: boolean;
  /** v2 병원 연동 메뉴 수정 권한 여부 */
  v2HospitalIntegration_w?: boolean;
  /** 서비스 관리자 메뉴 조회 권한 여부 */
  serviceManager_v?: boolean;
  /** 서비스 관리자 메뉴 수정 권한 여부 */
  serviceManager_w?: boolean;
  /** 동영상 콘텐츠 메뉴 조회 권한 여부 */
  videoContent_v?: boolean;
  /** 동영상 콘텐츠 메뉴 수정 권한 여부 */
  videoContent_w?: boolean;
  /** 온보딩 메뉴 조회 권한 여부 */
  onboarding_v?: boolean;
  /** 온보딩 메뉴 수정 권한 여부 */
  onboarding_w?: boolean;
  /** 앱 메뉴 조회 권한 여부 */
  app_v?: boolean;
  /** 앱 메뉴 수정 권한 여부 */
  app_w?: boolean;
  /** 일렉트론 메뉴 조회 권한 여부 */
  electron_v?: boolean;
  /** 일렉트론 메뉴 수정 권한 여부 */
  electron_w?: boolean;
  /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 조회 권한 여부 */
  electronAIFeatureUsageCorrection_v?: boolean;
  /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 수정 권한 여부 */
  electronAIFeatureUsageCorrection_w?: boolean;
  /** 연동 메뉴 조회 권한 여부 */
  integration_v?: boolean;
  /** 연동 메뉴 수정 권한 여부 */
  integration_w?: boolean;
  /** 모니터링 메뉴 조회 권한 여부 */
  monitoring_v?: boolean;
  /** 모니터링 메뉴 수정 권한 여부 */
  monitoring_w?: boolean;
  /** 이벤트 관리 메뉴 조회 권한 여부 */
  eventManagement_v?: boolean;
  /** 이벤트 관리 메뉴 수정 권한 여부 */
  eventManagement_w?: boolean;
  /** 예약 채팅 메뉴 조회 권한 여부 */
  reservedChat_v?: boolean;
  /** 예약 채팅 메뉴 수정 권한 여부 */
  reservedChat_w?: boolean;
  /** 치료 카테고리 메뉴 조회 권한 여부 */
  treatmentCategory_v?: boolean;
  /** 치료 카테고리 메뉴 수정 권한 여부 */
  treatmentCategory_w?: boolean;
  /** 알고리즘 메뉴 조회 권한 여부 */
  algorithm_v?: boolean;
  /** 알고리즘 메뉴 수정 권한 여부 */
  algorithm_w?: boolean;
  /** 알림톡 메뉴 조회 권한 여부 */
  alrimtalk_v?: boolean;
  /** 알림톡 메뉴 수정 권한 여부 */
  alrimtalk_w?: boolean;
  /** 관리자 계정 메뉴 조회 권한 여부 */
  adminAccount_v?: boolean;
  /** 관리자 계정 메뉴 수정 권한 여부 */
  adminAccount_w?: boolean;
  /** 개발자 메뉴 조회 권한 여부 */
  developer_v?: boolean;
  /** 개발자 메뉴 수정 권한 여부 */
  developer_w?: boolean;
}

export interface AdminAuthorizationTypeCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 관리자 권한 설정 ID */
    _id: string;
    /** 권한이 연결된 관리자 사용자 ID */
    userID: string;
    /** 병원 관리 메뉴 조회 권한 여부 */
    hospitalManagement_v?: boolean;
    /** 병원 관리 메뉴 수정 권한 여부 */
    hospitalManagement_w?: boolean;
    /** 병원 현황 메뉴 조회 권한 여부 */
    hospitalState_v?: boolean;
    /** 병원 현황 메뉴 수정 권한 여부 */
    hospitalState_w?: boolean;
    /** v2 병원 관리 메뉴 조회 권한 여부 */
    v2HospitalManagement_v?: boolean;
    /** v2 병원 관리 메뉴 수정 권한 여부 */
    v2HospitalManagement_w?: boolean;
    /** v2 병원 현황 메뉴 조회 권한 여부 */
    v2HospitalState_v?: boolean;
    /** v2 병원 현황 메뉴 수정 권한 여부 */
    v2HospitalState_w?: boolean;
    /** v2 병원 연동 메뉴 조회 권한 여부 */
    v2HospitalIntegration_v?: boolean;
    /** v2 병원 연동 메뉴 수정 권한 여부 */
    v2HospitalIntegration_w?: boolean;
    /** 서비스 관리자 메뉴 조회 권한 여부 */
    serviceManager_v?: boolean;
    /** 서비스 관리자 메뉴 수정 권한 여부 */
    serviceManager_w?: boolean;
    /** 동영상 콘텐츠 메뉴 조회 권한 여부 */
    videoContent_v?: boolean;
    /** 동영상 콘텐츠 메뉴 수정 권한 여부 */
    videoContent_w?: boolean;
    /** 온보딩 메뉴 조회 권한 여부 */
    onboarding_v?: boolean;
    /** 온보딩 메뉴 수정 권한 여부 */
    onboarding_w?: boolean;
    /** 앱 메뉴 조회 권한 여부 */
    app_v?: boolean;
    /** 앱 메뉴 수정 권한 여부 */
    app_w?: boolean;
    /** 일렉트론 메뉴 조회 권한 여부 */
    electron_v?: boolean;
    /** 일렉트론 메뉴 수정 권한 여부 */
    electron_w?: boolean;
    /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 조회 권한 여부 */
    electronAIFeatureUsageCorrection_v?: boolean;
    /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 수정 권한 여부 */
    electronAIFeatureUsageCorrection_w?: boolean;
    /** 연동 메뉴 조회 권한 여부 */
    integration_v?: boolean;
    /** 연동 메뉴 수정 권한 여부 */
    integration_w?: boolean;
    /** 모니터링 메뉴 조회 권한 여부 */
    monitoring_v?: boolean;
    /** 모니터링 메뉴 수정 권한 여부 */
    monitoring_w?: boolean;
    /** 이벤트 관리 메뉴 조회 권한 여부 */
    eventManagement_v?: boolean;
    /** 이벤트 관리 메뉴 수정 권한 여부 */
    eventManagement_w?: boolean;
    /** 예약 채팅 메뉴 조회 권한 여부 */
    reservedChat_v?: boolean;
    /** 예약 채팅 메뉴 수정 권한 여부 */
    reservedChat_w?: boolean;
    /** 치료 카테고리 메뉴 조회 권한 여부 */
    treatmentCategory_v?: boolean;
    /** 치료 카테고리 메뉴 수정 권한 여부 */
    treatmentCategory_w?: boolean;
    /** 알고리즘 메뉴 조회 권한 여부 */
    algorithm_v?: boolean;
    /** 알고리즘 메뉴 수정 권한 여부 */
    algorithm_w?: boolean;
    /** 알림톡 메뉴 조회 권한 여부 */
    alrimtalk_v?: boolean;
    /** 알림톡 메뉴 수정 권한 여부 */
    alrimtalk_w?: boolean;
    /** 관리자 계정 메뉴 조회 권한 여부 */
    adminAccount_v?: boolean;
    /** 관리자 계정 메뉴 수정 권한 여부 */
    adminAccount_w?: boolean;
    /** 개발자 메뉴 조회 권한 여부 */
    developer_v?: boolean;
    /** 개발자 메뉴 수정 권한 여부 */
    developer_w?: boolean;
    /**
     * 권한 설정 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 권한 설정 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAuthorizationTypeUpdateHandlerBodyRequest {
  /** 수정할 관리자 권한 설정 ID */
  _id: string;
  /** 권한을 수정할 관리자 사용자 ID */
  userID: string;
  /** 병원 관리 메뉴 조회 권한 여부 */
  hospitalManagement_v?: boolean;
  /** 병원 관리 메뉴 수정 권한 여부 */
  hospitalManagement_w?: boolean;
  /** 병원 현황 메뉴 조회 권한 여부 */
  hospitalState_v?: boolean;
  /** 병원 현황 메뉴 수정 권한 여부 */
  hospitalState_w?: boolean;
  /** v2 병원 관리 메뉴 조회 권한 여부 */
  v2HospitalManagement_v?: boolean;
  /** v2 병원 관리 메뉴 수정 권한 여부 */
  v2HospitalManagement_w?: boolean;
  /** v2 병원 현황 메뉴 조회 권한 여부 */
  v2HospitalState_v?: boolean;
  /** v2 병원 현황 메뉴 수정 권한 여부 */
  v2HospitalState_w?: boolean;
  /** v2 병원 연동 메뉴 조회 권한 여부 */
  v2HospitalIntegration_v?: boolean;
  /** v2 병원 연동 메뉴 수정 권한 여부 */
  v2HospitalIntegration_w?: boolean;
  /** 서비스 관리자 메뉴 조회 권한 여부 */
  serviceManager_v?: boolean;
  /** 서비스 관리자 메뉴 수정 권한 여부 */
  serviceManager_w?: boolean;
  /** 동영상 콘텐츠 메뉴 조회 권한 여부 */
  videoContent_v?: boolean;
  /** 동영상 콘텐츠 메뉴 수정 권한 여부 */
  videoContent_w?: boolean;
  /** 온보딩 메뉴 조회 권한 여부 */
  onboarding_v?: boolean;
  /** 온보딩 메뉴 수정 권한 여부 */
  onboarding_w?: boolean;
  /** 앱 메뉴 조회 권한 여부 */
  app_v?: boolean;
  /** 앱 메뉴 수정 권한 여부 */
  app_w?: boolean;
  /** 일렉트론 메뉴 조회 권한 여부 */
  electron_v?: boolean;
  /** 일렉트론 메뉴 수정 권한 여부 */
  electron_w?: boolean;
  /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 조회 권한 여부 */
  electronAIFeatureUsageCorrection_v?: boolean;
  /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 수정 권한 여부 */
  electronAIFeatureUsageCorrection_w?: boolean;
  /** 연동 메뉴 조회 권한 여부 */
  integration_v?: boolean;
  /** 연동 메뉴 수정 권한 여부 */
  integration_w?: boolean;
  /** 모니터링 메뉴 조회 권한 여부 */
  monitoring_v?: boolean;
  /** 모니터링 메뉴 수정 권한 여부 */
  monitoring_w?: boolean;
  /** 이벤트 관리 메뉴 조회 권한 여부 */
  eventManagement_v?: boolean;
  /** 이벤트 관리 메뉴 수정 권한 여부 */
  eventManagement_w?: boolean;
  /** 예약 채팅 메뉴 조회 권한 여부 */
  reservedChat_v?: boolean;
  /** 예약 채팅 메뉴 수정 권한 여부 */
  reservedChat_w?: boolean;
  /** 치료 카테고리 메뉴 조회 권한 여부 */
  treatmentCategory_v?: boolean;
  /** 치료 카테고리 메뉴 수정 권한 여부 */
  treatmentCategory_w?: boolean;
  /** 알고리즘 메뉴 조회 권한 여부 */
  algorithm_v?: boolean;
  /** 알고리즘 메뉴 수정 권한 여부 */
  algorithm_w?: boolean;
  /** 알림톡 메뉴 조회 권한 여부 */
  alrimtalk_v?: boolean;
  /** 알림톡 메뉴 수정 권한 여부 */
  alrimtalk_w?: boolean;
  /** 관리자 계정 메뉴 조회 권한 여부 */
  adminAccount_v?: boolean;
  /** 관리자 계정 메뉴 수정 권한 여부 */
  adminAccount_w?: boolean;
  /** 개발자 메뉴 조회 권한 여부 */
  developer_v?: boolean;
  /** 개발자 메뉴 수정 권한 여부 */
  developer_w?: boolean;
}

export interface AdminAuthorizationTypeUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 관리자 권한 설정 ID */
    _id: string;
    /** 권한이 연결된 관리자 사용자 ID */
    userID: string;
    /** 병원 관리 메뉴 조회 권한 여부 */
    hospitalManagement_v?: boolean;
    /** 병원 관리 메뉴 수정 권한 여부 */
    hospitalManagement_w?: boolean;
    /** 병원 현황 메뉴 조회 권한 여부 */
    hospitalState_v?: boolean;
    /** 병원 현황 메뉴 수정 권한 여부 */
    hospitalState_w?: boolean;
    /** v2 병원 관리 메뉴 조회 권한 여부 */
    v2HospitalManagement_v?: boolean;
    /** v2 병원 관리 메뉴 수정 권한 여부 */
    v2HospitalManagement_w?: boolean;
    /** v2 병원 현황 메뉴 조회 권한 여부 */
    v2HospitalState_v?: boolean;
    /** v2 병원 현황 메뉴 수정 권한 여부 */
    v2HospitalState_w?: boolean;
    /** v2 병원 연동 메뉴 조회 권한 여부 */
    v2HospitalIntegration_v?: boolean;
    /** v2 병원 연동 메뉴 수정 권한 여부 */
    v2HospitalIntegration_w?: boolean;
    /** 서비스 관리자 메뉴 조회 권한 여부 */
    serviceManager_v?: boolean;
    /** 서비스 관리자 메뉴 수정 권한 여부 */
    serviceManager_w?: boolean;
    /** 동영상 콘텐츠 메뉴 조회 권한 여부 */
    videoContent_v?: boolean;
    /** 동영상 콘텐츠 메뉴 수정 권한 여부 */
    videoContent_w?: boolean;
    /** 온보딩 메뉴 조회 권한 여부 */
    onboarding_v?: boolean;
    /** 온보딩 메뉴 수정 권한 여부 */
    onboarding_w?: boolean;
    /** 앱 메뉴 조회 권한 여부 */
    app_v?: boolean;
    /** 앱 메뉴 수정 권한 여부 */
    app_w?: boolean;
    /** 일렉트론 메뉴 조회 권한 여부 */
    electron_v?: boolean;
    /** 일렉트론 메뉴 수정 권한 여부 */
    electron_w?: boolean;
    /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 조회 권한 여부 */
    electronAIFeatureUsageCorrection_v?: boolean;
    /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 수정 권한 여부 */
    electronAIFeatureUsageCorrection_w?: boolean;
    /** 연동 메뉴 조회 권한 여부 */
    integration_v?: boolean;
    /** 연동 메뉴 수정 권한 여부 */
    integration_w?: boolean;
    /** 모니터링 메뉴 조회 권한 여부 */
    monitoring_v?: boolean;
    /** 모니터링 메뉴 수정 권한 여부 */
    monitoring_w?: boolean;
    /** 이벤트 관리 메뉴 조회 권한 여부 */
    eventManagement_v?: boolean;
    /** 이벤트 관리 메뉴 수정 권한 여부 */
    eventManagement_w?: boolean;
    /** 예약 채팅 메뉴 조회 권한 여부 */
    reservedChat_v?: boolean;
    /** 예약 채팅 메뉴 수정 권한 여부 */
    reservedChat_w?: boolean;
    /** 치료 카테고리 메뉴 조회 권한 여부 */
    treatmentCategory_v?: boolean;
    /** 치료 카테고리 메뉴 수정 권한 여부 */
    treatmentCategory_w?: boolean;
    /** 알고리즘 메뉴 조회 권한 여부 */
    algorithm_v?: boolean;
    /** 알고리즘 메뉴 수정 권한 여부 */
    algorithm_w?: boolean;
    /** 알림톡 메뉴 조회 권한 여부 */
    alrimtalk_v?: boolean;
    /** 알림톡 메뉴 수정 권한 여부 */
    alrimtalk_w?: boolean;
    /** 관리자 계정 메뉴 조회 권한 여부 */
    adminAccount_v?: boolean;
    /** 관리자 계정 메뉴 수정 권한 여부 */
    adminAccount_w?: boolean;
    /** 개발자 메뉴 조회 권한 여부 */
    developer_v?: boolean;
    /** 개발자 메뉴 수정 권한 여부 */
    developer_w?: boolean;
    /**
     * 권한 설정 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 권한 설정 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAuthorizationTypeFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 관리자 권한 설정 ID */
    _id: string;
    /** 권한이 연결된 관리자 사용자 ID */
    userID: string;
    /** 병원 관리 메뉴 조회 권한 여부 */
    hospitalManagement_v?: boolean;
    /** 병원 관리 메뉴 수정 권한 여부 */
    hospitalManagement_w?: boolean;
    /** 병원 현황 메뉴 조회 권한 여부 */
    hospitalState_v?: boolean;
    /** 병원 현황 메뉴 수정 권한 여부 */
    hospitalState_w?: boolean;
    /** v2 병원 관리 메뉴 조회 권한 여부 */
    v2HospitalManagement_v?: boolean;
    /** v2 병원 관리 메뉴 수정 권한 여부 */
    v2HospitalManagement_w?: boolean;
    /** v2 병원 현황 메뉴 조회 권한 여부 */
    v2HospitalState_v?: boolean;
    /** v2 병원 현황 메뉴 수정 권한 여부 */
    v2HospitalState_w?: boolean;
    /** v2 병원 연동 메뉴 조회 권한 여부 */
    v2HospitalIntegration_v?: boolean;
    /** v2 병원 연동 메뉴 수정 권한 여부 */
    v2HospitalIntegration_w?: boolean;
    /** 서비스 관리자 메뉴 조회 권한 여부 */
    serviceManager_v?: boolean;
    /** 서비스 관리자 메뉴 수정 권한 여부 */
    serviceManager_w?: boolean;
    /** 동영상 콘텐츠 메뉴 조회 권한 여부 */
    videoContent_v?: boolean;
    /** 동영상 콘텐츠 메뉴 수정 권한 여부 */
    videoContent_w?: boolean;
    /** 온보딩 메뉴 조회 권한 여부 */
    onboarding_v?: boolean;
    /** 온보딩 메뉴 수정 권한 여부 */
    onboarding_w?: boolean;
    /** 앱 메뉴 조회 권한 여부 */
    app_v?: boolean;
    /** 앱 메뉴 수정 권한 여부 */
    app_w?: boolean;
    /** 일렉트론 메뉴 조회 권한 여부 */
    electron_v?: boolean;
    /** 일렉트론 메뉴 수정 권한 여부 */
    electron_w?: boolean;
    /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 조회 권한 여부 */
    electronAIFeatureUsageCorrection_v?: boolean;
    /** 일렉트론 AI 기능 동작 횟수 보정 메뉴 수정 권한 여부 */
    electronAIFeatureUsageCorrection_w?: boolean;
    /** 연동 메뉴 조회 권한 여부 */
    integration_v?: boolean;
    /** 연동 메뉴 수정 권한 여부 */
    integration_w?: boolean;
    /** 모니터링 메뉴 조회 권한 여부 */
    monitoring_v?: boolean;
    /** 모니터링 메뉴 수정 권한 여부 */
    monitoring_w?: boolean;
    /** 이벤트 관리 메뉴 조회 권한 여부 */
    eventManagement_v?: boolean;
    /** 이벤트 관리 메뉴 수정 권한 여부 */
    eventManagement_w?: boolean;
    /** 예약 채팅 메뉴 조회 권한 여부 */
    reservedChat_v?: boolean;
    /** 예약 채팅 메뉴 수정 권한 여부 */
    reservedChat_w?: boolean;
    /** 치료 카테고리 메뉴 조회 권한 여부 */
    treatmentCategory_v?: boolean;
    /** 치료 카테고리 메뉴 수정 권한 여부 */
    treatmentCategory_w?: boolean;
    /** 알고리즘 메뉴 조회 권한 여부 */
    algorithm_v?: boolean;
    /** 알고리즘 메뉴 수정 권한 여부 */
    algorithm_w?: boolean;
    /** 알림톡 메뉴 조회 권한 여부 */
    alrimtalk_v?: boolean;
    /** 알림톡 메뉴 수정 권한 여부 */
    alrimtalk_w?: boolean;
    /** 관리자 계정 메뉴 조회 권한 여부 */
    adminAccount_v?: boolean;
    /** 관리자 계정 메뉴 수정 권한 여부 */
    adminAccount_w?: boolean;
    /** 개발자 메뉴 조회 권한 여부 */
    developer_v?: boolean;
    /** 개발자 메뉴 수정 권한 여부 */
    developer_w?: boolean;
    /**
     * 권한 설정 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 권한 설정 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface CurrentInstagramAccountsStatesHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 인스타그램 연동 여부
     * @example true
     */
    hasInstagramLinkage?: boolean;
    /**
     * 연동 가능한 최대 개수
     * @example 5
     */
    maximumConnectableCount?: number;
    /** 인스타그램 연동 계정 정보 목록 */
    instagramAccounts?: {
      /**
       * 인스타그램 로그인 ID
       * @example "@afterdoc.medipal"
       */
      userName: string;
      /**
       * 인스타그램 사용자 이름
       * @example "홍길동"
       */
      fullName?: string;
      /**
       * 인스타그램 계정 타입 - BUSINESS / Media_Creator
       * @example "BUSINESS"
       */
      accountType?: string;
      /**
       * 재연동 사유 유형 - 로그인 만료, 비밀번호 변경, 권한 삭제, 유실된 계정, 재인가 필요
       * @example "EXPIRED_AUTHORIZATION_CODE"
       */
      reAuthorizationType?:
        | "EXPIRED_AUTHORIZATION_CODE"
        | "PASSWORD_CHANGED"
        | "REMOVED_AUTHORIZATION"
        | "DISCONNECTED_ACCOUNT"
        | "REAUTHORIZATION_REQUIRED";
      /**
       * 재연동 사유
       * @example "인증 코드 만료"
       */
      reAuthorizationReason?: string;
      /**
       * 인증 만료 잔여 일 수 - 최대 60일
       * @example 3
       */
      authorizationRemainingDays?: number;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApprovedInstagramAccountsHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  /** 승인된 인스타그램 계정 목록 */
  data: {
    /**
     * 승인한 총 계정 개수
     * @example 5
     */
    totalCount?: number;
    /**
     * 승인한 메디팔 직원 ID
     * @example "63d7bafc1374672f7c407efd"
     */
    userID?: string;
    /**
     * 승인한 메디팔 직원 이름
     * @example "장유진"
     */
    userName?: string;
    /**
     * 승인 사유
     * @example "정상 계정"
     */
    reason?: string;
    /**
     * 승인 일시
     * @format date
     * @example "2025-06-01T00:00:00.000Z"
     */
    createdAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApprovingInstagramLinkageHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 승인한 총 계정 개수
   * @example 5
   */
  totalCount: number;
  /**
   * 메디팔 직원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  userID: string;
  /**
   * 메디팔 직원 이름
   * @example "장유진"
   */
  userName: string;
  /**
   * 승인 사유
   * @example "정상 계정"
   */
  reason: string;
}

export interface ApprovingInstagramLinkageHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 승인 성공 여부
     * @example true
     */
    isApprovedSuccess?: boolean;
    /**
     * 승인한 총 계정 개수
     * @example 5
     */
    totalCount: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface RenewingInstagramLinkageStatusHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 승인 여부
   * @example true
   */
  approved?: boolean;
  /**
   * 연동 해제할 인스타그램 사용자 이름 목록
   * @example ["@afterdoc.medipal","@tstt.stac"]
   */
  unlinkedTargetUserNames?: string[];
}

export interface RenewingInstagramLinkageStatusHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 연동 상태 갱신 성공 여부
     * @example true
     */
    isLinkageStatusUpdated?: boolean;
    /**
     * 연동 해제된 인스타그램 사용자 이름 목록
     * @example ["@afterdoc.medipal","@tstt.stac"]
     */
    unlinkedUserNames?: string[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LineLinkagePatchAccountsStatesHandlerBodyRequest {
  hospitalID: string;
  isApproved: boolean;
  maxChannelCount?: number;
  reason?: string;
  userID?: string;
  userName?: string;
  unlinkedTargetID: string[];
}

export interface LineLinkagePatchAccountsStatesHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hospitalID?: string;
    requesterName?: string;
    requesterPhone?: string;
    isRequested?: boolean;
    isApproved?: boolean;
    maxChannelCount?: number;
    linkedTargetIDs: string[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApprovedLineLinkageHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hospitalID?: string;
    lineEnrollRequestID?: string;
    userID?: string;
    userName?: string;
    count?: number;
    reason?: string;
    createdAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminEndOfServiceChatSendHandlerBodyRequest {
  /** 메시지를 발송할 병원 ID */
  hospitalID: string;
  /** 발송할 메시지 내용 (선택사항, 미입력시 기본 템플릿 사용) */
  content?: string;
}

export interface AdminEndOfServiceChatSendHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    success: boolean;
    message: string;
    sentCount?: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoDefaultTemplateFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    type?: string;
    kakaoTemplateHistoryID?: {
      _id?: string;
      hospitalID?: string;
      algorithmId?: string;
      kakaoTemplateHistoryId?: string;
      templateCode?: string;
      senderKeyType?: string;
      senderKey?: string;
      templateName?: string;
      templateMessageType?: string;
      templateEmphasizeType?: string;
      templateContent?: string;
      serviceStatus?: string;
      categoryCode?: string;
      isGroupTemplate?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    } | null;
    groupName?: string;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    removedAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoDefaultTemplateCreateHandlerBodyRequest {
  /**
   * 템플릿 유형
   * @example "messageImmediateCreate"
   */
  type?: string;
  /**
   * 카카오 템플릿 히스토리 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  kakaoTemplateHistoryID?: string;
  /**
   * 발신프로필 그룹명 - 애프터닥, 메디팔
   * @example "애프터닥"
   */
  groupName?: string;
}

export interface KakaoDefaultTemplateCreateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    type?: string;
    kakaoTemplateHistoryID?: {
      _id?: string;
      hospitalID?: string;
      algorithmId?: string;
      kakaoTemplateHistoryId?: string;
      templateCode?: string;
      senderKeyType?: string;
      senderKey?: string;
      templateName?: string;
      templateMessageType?: string;
      templateEmphasizeType?: string;
      templateContent?: string;
      serviceStatus?: string;
      categoryCode?: string;
      isGroupTemplate?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    } | null;
    groupName?: string;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoDefaultTemplateUpdateHandlerBodyRequest {
  /**
   * 기본 템플릿 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  _id?: string;
  /**
   * 템플릿 유형
   * @example "messageImmediateCreate"
   */
  type?: string;
  /**
   * 카카오 템플릿 히스토리 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  kakaoTemplateHistoryID?: string;
  /**
   * 발신프로필 그룹명 - 애프터닥, 메디팔
   * @example "애프터닥"
   */
  groupName?: string;
}

export interface KakaoDefaultTemplateUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id?: string;
    type?: string;
    kakaoTemplateHistoryID?: {
      _id?: string;
      hospitalID?: string;
      algorithmId?: string;
      kakaoTemplateHistoryId?: string;
      templateCode?: string;
      senderKeyType?: string;
      senderKey?: string;
      templateName?: string;
      templateMessageType?: string;
      templateEmphasizeType?: string;
      templateContent?: string;
      serviceStatus?: string;
      categoryCode?: string;
      isGroupTemplate?: boolean;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    } | null;
    groupName?: string;
    isRemoved?: boolean;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface CurrentSejongHospitalLinkageStatesHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 세종병원 연동 여부
     * @example true
     */
    approvedLinkage?: boolean;
    /**
     * 최근 연동 일시
     * @format date
     * @example "2025-06-01T00:00:00.000Z"
     */
    latestLinkageDate?: string;
    /**
     * 자동화 승인 여부
     * @example true
     */
    approvedAutomation?: boolean;
    /**
     * 최근 자동화 옵션 업데이트 일시
     * @format date
     * @example "2025-06-01T00:00:00.000Z"
     */
    latestAutomationOptionUpdatedAt?: string;
    /**
     * 세종병원 기관 코드
     * @example "201"
     */
    organizationCode?: string;
    /**
     * 대상 치료태그 목록
     * @example [{"treatmentTagID":"63d7bafc1374672f7c407efd","treatmentTagName":"고혈압"}]
     */
    targetTreatmentTags: {
      /**
       * 치료태그 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      treatmentTagID?: string;
      /**
       * 치료태그 이름
       * @example "고혈압"
       */
      treatmentTagName?: string;
    }[];
    /**
     * 매핑된 치료태그 목록
     * @example [{"diagnosisCode":"I109","diagnosisName":"고혈압","isMapped":true,"mappedTreatmentTagID":"63d7bafc1374672f7c407efd"}]
     */
    mappedTreatmentTags: {
      /**
       * 진단 코드 (지원 코드 레지스트리 기준)
       * @example "I109"
       */
      diagnosisCode:
        | "I109"
        | "TFCA"
        | "2day TFCA"
        | "Stent"
        | "1day CATH (D1)"
        | "2day CATH (D1)"
        | "3day CATH (D1)"
        | "[당일 수술] CABG 7Days"
        | "[당일 수술] CABG 9Days"
        | "RFCA"
        | "PFA"
        | "Cryo"
        | "Pacemaker"
        | "ICD"
        | "S-ICD"
        | "CRT-D"
        | "CRT-P"
        | "심부전첫진단"
        | "심부전퇴원"
        | "조영제CT(D-1)"
        | "조영제CT(D-day)"
        | "조영제CT(D+1)";
      /**
       * 진단 코드 이름
       * @example "고혈압"
       */
      diagnosisName?: string;
      /**
       * 매핑 여부
       * @example true
       */
      isMapped?: boolean;
      /**
       * 진단코드와 매핑된 치료태그 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      mappedTreatmentTagID?: string;
      /**
       * 진단코드와 매핑된 치료태그명
       * @example "고혈압"
       */
      mappedTreatmentTagName?: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface MappingSejongHospitalDiagnosisCodeWithTreatmentTagHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 진단 코드와 매핑할 치료태그 목록
   * @example [{"diagnosisCode":"I109","treatmentTagID":"63d7bafc1374672f7c407efd"}]
   */
  targetTreatmentTagsWithDiagnosisCodes: {
    /**
     * 진단 코드 (지원 코드 레지스트리 기준)
     * @example "I109"
     */
    diagnosisCode:
      | "I109"
      | "TFCA"
      | "2day TFCA"
      | "Stent"
      | "1day CATH (D1)"
      | "2day CATH (D1)"
      | "3day CATH (D1)"
      | "[당일 수술] CABG 7Days"
      | "[당일 수술] CABG 9Days"
      | "RFCA"
      | "PFA"
      | "Cryo"
      | "Pacemaker"
      | "ICD"
      | "S-ICD"
      | "CRT-D"
      | "CRT-P"
      | "심부전첫진단"
      | "심부전퇴원"
      | "조영제CT(D-1)"
      | "조영제CT(D-day)"
      | "조영제CT(D+1)";
    /**
     * 치료태그 ID (없으면 해당 진단코드 매핑 해제)
     * @example "63d7bafc1374672f7c407efd"
     */
    treatmentTagID?: string;
  }[];
}

export interface MappingSejongHospitalDiagnosisCodeWithTreatmentTagHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 처리가 완료된 치료태그 목록
     * @example [{"diagnosisCode":"I109","diagnosisName":"고혈압","treatmentTagID":"63d7bafc1374672f7c407efd","treatmentTagName":"고혈압"}]
     */
    mappedTreatmentTags: {
      /**
       * 진단 코드 (지원 코드 레지스트리 기준)
       * @example "I109"
       */
      diagnosisCode:
        | "I109"
        | "TFCA"
        | "2day TFCA"
        | "Stent"
        | "1day CATH (D1)"
        | "2day CATH (D1)"
        | "3day CATH (D1)"
        | "[당일 수술] CABG 7Days"
        | "[당일 수술] CABG 9Days"
        | "RFCA"
        | "PFA"
        | "Cryo"
        | "Pacemaker"
        | "ICD"
        | "S-ICD"
        | "CRT-D"
        | "CRT-P"
        | "심부전첫진단"
        | "심부전퇴원"
        | "조영제CT(D-1)"
        | "조영제CT(D-day)"
        | "조영제CT(D+1)";
      /**
       * 진단 코드 이름
       * @example "고혈압"
       */
      diagnosisName?: string;
      /**
       * 매핑 여부
       * @example true
       */
      isMapped?: boolean;
      /**
       * 진단코드와 매핑된 치료태그 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      treatmentTagID?: string;
      /**
       * 진단코드와 매핑된 치료태그명
       * @example "고혈압"
       */
      treatmentTagName?: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface RenewingSejongHospitalLinkageStatusHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 연동 승인 여부
   * @example true
   */
  approvedLinkage?: boolean;
  /**
   * 자동화 승인 여부
   * @example true
   */
  approvedAutomation?: boolean;
  /**
   * 세종병원 기관 코드 - 부천: 201, 인천: 202
   * @example "201"
   */
  organizationCode?: "201" | "202";
}

export interface RenewingSejongHospitalLinkageStatusHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 처리 성공 여부
     * @example true
     */
    isProcessed?: boolean;
    /**
     * 세종병원 연동 여부
     * @example true
     */
    approvedLinkage?: boolean;
    /**
     * 최근 연동/해제 변경 일시
     * @format date
     * @example "2025-06-01T00:00:00.000Z"
     */
    latestLinkageDate?: string;
    /**
     * 자동화 승인 여부
     * @example true
     */
    approvedAutomation?: boolean;
    /**
     * 최근 자동화 옵션 업데이트 일시
     * @format date
     * @example "2025-06-01T00:00:00.000Z"
     */
    latestAutomationOptionUpdatedAt?: string;
    /**
     * 세종병원 기관 코드
     * @example "201"
     */
    organizationCode?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAfterDocNoticeControllerFindAfterDocNoticeListResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    list: {
      _id: string;
      category: "update" | "error" | "marketing";
      /**
       * 발송 타입
       * @example "instant"
       */
      type: "instant" | "scheduled";
      title: string;
      startDate: string;
      endDate: string;
      createdAt: string;
      updatedAt: string;
      content: string;
      moreInfoLink?: string | null;
    }[];
    count: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAfterDocNoticeControllerCreateAfterDocNoticeBodyRequest {
  /**
   * 공지사항 카테고리
   * @example "update"
   */
  category: "update" | "error" | "marketing";
  /**
   * 발송 타입
   * @example "instant"
   */
  type: "instant" | "scheduled";
  /**
   * 공지사항 제목
   * @example "새로운 기능 업데이트 안내"
   */
  title: string;
  /**
   * 공지사항 시작일
   * @example "2024-01-01T00:00:00.000Z"
   */
  startDate: string | null;
  /**
   * 공지사항 종료일
   * @example "2024-12-31T23:59:59.999Z"
   */
  endDate: string | null;
  /**
   * 공지사항 내용
   * @example "애프터닥 시스템 업데이트가 예정되어 있습니다."
   */
  content: string;
  /**
   * 상세 정보 링크
   * @example "https://afterdoc.co.kr/notice/123"
   */
  moreInfoLink?: string | null;
}

export interface AdminAfterDocNoticeControllerCreateAfterDocNoticeResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    category: "update" | "error" | "marketing";
    /**
     * 발송 타입
     * @example "instant"
     */
    type: "instant" | "scheduled";
    title: string;
    startDate: string;
    endDate: string;
    createdAt: string;
    updatedAt: string;
    content: string;
    moreInfoLink?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAfterDocNoticeControllerFindAfterDocNoticeDetailResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    category: "update" | "error" | "marketing";
    /**
     * 발송 타입
     * @example "instant"
     */
    type: "instant" | "scheduled";
    title: string;
    startDate: string;
    endDate: string;
    createdAt: string;
    updatedAt: string;
    content: string;
    moreInfoLink?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAfterDocNoticeControllerUpdateAfterDocNoticeBodyRequest {
  /**
   * 공지사항 카테고리
   * @example "update"
   */
  category: "update" | "error" | "marketing";
  /**
   * 공지사항 제목
   * @example "새로운 기능 업데이트 안내"
   */
  title: string;
  /**
   * 발송 타입
   * @example "instant"
   */
  type: "instant" | "scheduled";
  /**
   * 공지사항 시작일
   * @example "2024-01-01T00:00:00.000Z"
   */
  startDate: string | null;
  /**
   * 공지사항 종료일
   * @example "2024-12-31T23:59:59.999Z"
   */
  endDate: string | null;
  /**
   * 공지사항 내용
   * @example "애프터닥 시스템 업데이트가 예정되어 있습니다."
   */
  content: string;
  /**
   * 상세 정보 링크
   * @example "https://afterdoc.co.kr/notice/123"
   */
  moreInfoLink?: string | null;
}

export interface AdminAfterDocNoticeControllerUpdateAfterDocNoticeResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    category: "update" | "error" | "marketing";
    /**
     * 발송 타입
     * @example "instant"
     */
    type: "instant" | "scheduled";
    title: string;
    startDate: string;
    endDate: string;
    createdAt: string;
    updatedAt: string;
    content: string;
    moreInfoLink?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AdminAfterDocNoticeControllerDeleteAfterDocNoticeResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface BizPpurioHistoryControllerFindBizPpurioHistoryParams {
  /** 병원 이름 */
  hospitalName?: string | null;
  /** 수신자 번호 */
  to?: string | null;
  /** 발신자 번호 */
  from?: string | null;
  /** 환자 이름 */
  patientName?: string | null;
  /** 템플릿 코드 */
  templateCode?: string | null;
  /** 검색 시작 날짜 */
  startedAt?: string | null;
  /** 검색 종료 날짜 */
  endedAt?: string | null;
  /**
   * 페이지당 결과 수
   * @default "20"
   */
  countPerPage?: string;
  /**
   * 요청 페이지
   * @default "1"
   */
  currentPage?: string;
  /** 요청 타입 목록 */
  requestTypes?:
    | (
        | "JOIN"
        | "JOIN-RESEND"
        | "TREATMENT-CAUTION"
        | "AUTOMATION-CONSULTATION"
        | "AUTOMATION-MARKETING"
        | "RESERVATION-IMMEDIATE"
        | "RESERVATION-MODIFIED"
        | "RESERVATION-CANCELLED"
        | "RESERVATION-BEFORE-0"
        | "RESERVATION-BEFORE-1"
        | "RESERVATION-BEFORE-3"
        | "DAILY-CUSTOMER-SUMMARY"
        | "BRAND-MESSAGE-CREDIT-SHORTAGE"
        | "AI-RESERVATION-IMMEDIATE"
        | "AI-RESERVATION-MODIFIED"
        | "AI-RESERVATION-CANCELLED"
        | "APPSTORE-USAGE-LIMIT-EXCEEDED"
        | "APPSTORE-FREE-TRIAL-ENDED-BY-MAX-AMOUNT"
        | "APPSTORE-FREE-TRIAL-ENDING-3-DAYS"
        | "APPSTORE-FREE-TRIAL-ENDED-BY-PERIOD"
        | "APPSTORE-DISCOUNT-ENDING-3-DAYS"
        | "APPSTORE-DISCOUNT-ENDED"
        | "APPSTORE-BILL-PAYMENT-FAILED"
        | "APPSTORE-APP-APPROVED"
      )[]
    | null;
  /** 성공 여부 */
  success?: boolean | null;
  /** 재시도 성공 여부 */
  retrySuccess?: boolean | null;
  /** 이통사/카카오/RCS /결과 코드 */
  rs_result?: string | null;
}

export type BizPpurioHistoryControllerFindBizPpurioHistoryData = BizPpurioHistoryControllerFindBizPpurioHistoryResponse;

export type KakaoTemplateTransferControllerRunBatchData = KakaoTemplateTransferControllerRunBatchResponse;

export type KakaoTemplateTransferControllerSkipTemplateData = KakaoTemplateTransferControllerSkipTemplateResponse;

export type KakaoTemplateTransferControllerRefreshTemplateStatusData =
  KakaoTemplateTransferControllerRefreshTemplateStatusResponse;

export interface KakaoTemplateTransferControllerFindHospitalsParams {
  /** 이관 진행 상태 (복수 가능) */
  status?: string[] | null;
  /** 병원 이름 검색(name/shortName 부분 일치) */
  hospitalName?: string | null;
  /**
   * 페이지당 결과 수
   * @default "20"
   */
  limit?: string;
  /**
   * 오프셋
   * @default "0"
   */
  offset?: string;
}

export type KakaoTemplateTransferControllerFindHospitalsData = KakaoTemplateTransferControllerFindHospitalsResponse;

export interface KakaoTemplateTransferControllerFindTemplatesParams {
  /** 병원 ID (미지정 시 전체) */
  hospitalID?: string | null;
  /** 템플릿 상태 (복수 가능) */
  status?: string[] | null;
  /**
   * 페이지당 결과 수
   * @default "50"
   */
  limit?: string;
  /**
   * 오프셋
   * @default "0"
   */
  offset?: string;
}

export type KakaoTemplateTransferControllerFindTemplatesData = KakaoTemplateTransferControllerFindTemplatesResponse;

export interface AdminAutomationHospitalControllerFindWithKakaoTemplateStatusParams {
  /**
   * 병원 ID. 미지정 시 전체 병원 대상 조회 (이 경우 limit 필수)
   * @minLength 1
   */
  hospitalID?: string;
  /** 자동화 유형 필터. 미지정 시 전체 */
  type?: "CONSULTATION" | "MARKETING";
  /** 해당 serviceStatus 템플릿을 1건 이상 가진 자동화만 조회 */
  filterServiceStatus?: "REG" | "REQ" | "REJ" | "STP" | "RDY" | "ACT" | "DMT" | "BLK" | "UNKNOWN";
  /** 해당 serviceStatus 카운트 기준 정렬. 동률은 createdAt 내림차순 유지 */
  sortServiceStatus?: "REG" | "REQ" | "REJ" | "STP" | "RDY" | "ACT" | "DMT" | "BLK" | "UNKNOWN";
  /** 정렬 방향. 1 오름차순, -1 내림차순(기본). sortServiceStatus 지정 시에만 적용 */
  sortWay?: number;
  /**
   * 스킵할 데이터 개수. 필터/정렬 적용 후 기준 (기본 0)
   * @min 0
   */
  skip?: number | null;
  /**
   * 조회할 데이터 개수. 미지정 또는 0이면 전체 조회 (전체 병원 대상 조회 시 필수)
   * @min 0
   */
  limit?: number | null;
}

export type AdminAutomationHospitalControllerFindWithKakaoTemplateStatusData =
  AdminAutomationHospitalControllerFindWithKakaoTemplateStatusResponse;

export type AdminAutomationHospitalControllerCreateWithKakaoTemplateData =
  AdminAutomationHospitalControllerCreateWithKakaoTemplateResponse;

export interface AdminChatChannelLinkageControllerFindParams {
  /**
   * 건너뛸 병원 수 (기본 0)
   * @min 0
   * @default 0
   */
  skip?: number | null;
  /**
   * 조회할 병원 수 (기본 20, 최대 100)
   * @min 1
   * @max 100
   * @default 20
   */
  limit: number;
  /** 병원명(shortName) 부분 일치 검색어 */
  keyword?: string;
  /**
   * 해제된 채널 계정 포함 여부. false(기본) 면 연동 중인 계정만, true 면 해제된 계정도 포함하고 isLinked 로 구분한다
   * @default "false"
   */
  includeUnlinked?: "true" | "false" | "1" | "0";
}

export type AdminChatChannelLinkageControllerFindData = AdminChatChannelLinkageControllerFindResponse;

export interface AdminChatChannelLinkageControllerCountParams {
  /** 병원명(shortName) 부분 일치 검색어. find 와 동일 조건 */
  keyword?: string;
}

export type AdminChatChannelLinkageControllerCountData = AdminChatChannelLinkageControllerCountResponse;

export type AdminBillingControllerGetInvoiceData = any;

export type AdminBillingControllerGetInvoiceDetailData = any;

export type AdminBillingControllerGetOrderData = any;

export type AdminBillingControllerGetOrderDetailData = any;

export interface AdminKakaoControllerFindLinkageInfoParams {
  hospitalID: string;
}

export type AdminKakaoControllerFindLinkageInfoData = AdminKakaoControllerFindLinkageInfoResponse;

export type AdminKakaoControllerUpdateLinkageInfoData = any;

export interface AdminKakaoControllerUnlinkParams {
  _id: string;
}

export type AdminKakaoControllerUnlinkData = any;

export type AdminKakaoControllerApproveBrandMessageLinkageData = any;

export interface AdminWechatControllerFindLinkageInfoParams {
  hospitalID: string;
}

export type AdminWechatControllerFindLinkageInfoData = AdminWechatControllerFindLinkageInfoResponse;

export type AdminWechatControllerUpdateLinkageInfoData = any;

export interface AdminWhatsappControllerFindLinkageInfoParams {
  hospitalID: string;
}

export type AdminWhatsappControllerFindLinkageInfoData = AdminWhatsappControllerFindLinkageInfoResponse;

export type AdminWhatsappControllerUpdateLinkageInfoData = any;

export interface AdminWhatsappControllerFindSetupUpdateHistoryParams {
  hospitalID: string;
}

export type AdminWhatsappControllerFindSetupUpdateHistoryData = AdminWhatsappControllerFindSetupUpdateHistoryResponse;

export type AdminLineControllerUpdateLinkageInfoData = AdminLineControllerUpdateLinkageInfoResponse;

export interface LineLinkageAccountsStatesHandlerParams {
  hospitalID?: string;
}

export type LineLinkageAccountsStatesHandlerData = LineLinkageAccountsStatesHandlerResponse;

export interface AdminBrandMessagePointControllerGetBrandMessagePointParams {
  /**
   * 페이지당 결과 수
   * @default "20"
   */
  limit?: string;
  /**
   * 시작 위치
   * @default "0"
   */
  offset?: string;
  /** 병원명 검색 */
  hospitalName?: string | null;
  /** 어드민 추가/차감만 조회 (true/false) */
  onlyAdmin?: string;
}

export type AdminBrandMessagePointControllerGetBrandMessagePointData =
  AdminBrandMessagePointControllerGetBrandMessagePointListResponse;

export interface AdminBrandMessagePointControllerGetBrandMessagePriceParams {
  /** 병원 ID (생략 시 기본 단가 반환) */
  hospitalID?: string;
}

export type AdminBrandMessagePointControllerGetBrandMessagePriceData =
  AdminBrandMessagePointControllerGetBrandMessagePriceResponse;

export type AdminBrandMessagePointControllerGetBrandMessagePointDetailData =
  AdminBrandMessagePointControllerGetBrandMessagePointDetailResponse;

export type AdminBrandMessagePointControllerGetHospitalPointData =
  AdminBrandMessagePointControllerGetHospitalPointResponse;

export type AdminBrandMessagePointControllerAddBrandMessagePointData =
  AdminBrandMessagePointControllerAddBrandMessagePointResponse;

export type AdminBrandMessagePointControllerRemoveBrandMessagePointData =
  AdminBrandMessagePointControllerRemoveBrandMessagePointResponse;

export interface AdminBrandMessageProductControllerGetProductParams {
  /**
   * 페이지당 결과 수
   * @default "20"
   */
  limit?: string;
  /**
   * 시작 위치
   * @default "0"
   */
  offset?: string;
  /** 활성 상품만 조회 (true/false) */
  onlyActive?: string;
}

export type AdminBrandMessageProductControllerGetProductData = AdminBrandMessageProductControllerGetProductListResponse;

export type AdminBrandMessageProductControllerCreateProductData =
  AdminBrandMessageProductControllerCreateProductResponse;

export interface AdminBrandMessageProductControllerPreviewProductParams {
  /** 결제 금액(원) */
  amount: string;
  /** 보너스 비율(%) - 미입력시 0 */
  bonusRate?: string;
}

export type AdminBrandMessageProductControllerPreviewProductData =
  AdminBrandMessageProductControllerPreviewProductResponse;

export type AdminBrandMessageProductControllerGetProductDetailData =
  AdminBrandMessageProductControllerGetProductDetailResponse;

export type AdminBrandMessageProductControllerUpdateProductData =
  AdminBrandMessageProductControllerUpdateProductResponse;

export type AdminBrandMessageProductControllerDeactivateProductData =
  AdminBrandMessageProductControllerDeactivateProductResponse;

export type AdminBrandMessageProductControllerGetProductHistoryData =
  AdminBrandMessageProductControllerGetProductHistoryResponse;

export interface AdminNicePaymentsCardBenefitControllerGetCardBenefitParams {
  /**
   * 페이지당 결과 수
   * @default "20"
   */
  limit?: string;
  /**
   * 시작 위치
   * @default "0"
   */
  offset?: string;
  /** YYYY-MM 형식 필터 */
  yearMonth?: string;
}

export type AdminNicePaymentsCardBenefitControllerGetCardBenefitData =
  AdminNicePaymentsCardBenefitControllerGetCardBenefitListResponse;

export type AdminNicePaymentsCardBenefitControllerCreateCardBenefitData =
  AdminNicePaymentsCardBenefitControllerCreateCardBenefitResponse;

export type AdminNicePaymentsCardBenefitControllerGetCardBenefitDetailData =
  AdminNicePaymentsCardBenefitControllerGetCardBenefitDetailResponse;

export type AdminNicePaymentsCardBenefitControllerUpdateCardBenefitData =
  AdminNicePaymentsCardBenefitControllerUpdateCardBenefitResponse;

export interface AdminCallManagerControllerFindCallManagerIncomingPhoneNumbersParams {
  /**
   * 페이지당 리소스 수
   * @default "1000"
   */
  limit: string;
  /**
   * 페이지 번호
   * @default "0"
   */
  offset: string;
}

export type AdminCallManagerControllerFindCallManagerIncomingPhoneNumbersData =
  AdminCallManagerControllerFindCallManagerIncomingPhoneNumbersResponse;

export interface AdminCallManagerControllerFindHospitalPhoneNumberMappingsParams {
  /** 병원 ID */
  hospitalId: string;
}

export type AdminCallManagerControllerFindHospitalPhoneNumberMappingsData =
  AdminCallManagerControllerFindHospitalPhoneNumberMappingsResponse;

export type AdminCallManagerControllerCreateHospitalPhoneNumberMappingData =
  AdminCallManagerControllerCreateHospitalPhoneNumberMappingResponse;

export type AdminCallManagerControllerUpdateHospitalPhoneNumberMappingData =
  AdminCallManagerControllerUpdateHospitalPhoneNumberMappingResponse;

export type AdminCallManagerControllerDeleteHospitalPhoneNumberMappingData =
  AdminCallManagerControllerDeleteHospitalPhoneNumberMappingResponse;

export type AdminMedipalAiControllerGetHospitalSettingsData = AdminMedipalAIControllerGetHospitalSettingsResponse;

export type AdminMedipalAiControllerGetAiReservationStatusData = AdminMedipalAIControllerGetAIReservationStatusResponse;

export type AdminMedipalAiControllerGetSubscriptionHistoriesData =
  AdminMedipalAIControllerGetSubscriptionHistoriesResponse;

export type AdminMedipalAiControllerPatchHospitalSettingsData = AdminMedipalAIControllerPatchHospitalSettingsResponse;

export type AdminMedipalAiControllerGetHospitalCallManagerGreetingData =
  AdminMedipalAIControllerGetHospitalCallManagerGreetingResponse;

export type AdminMedipalAiControllerPutHospitalCallManagerGreetingData =
  AdminMedipalAIControllerPutHospitalCallManagerGreetingResponse;

export type AdminMedipalAiControllerGetHospitalCallManagerPhonesData =
  AdminMedipalAIControllerGetHospitalCallManagerPhonesResponse;

export type AdminMedipalAiControllerCreateHospitalCallManagerPhoneData =
  AdminMedipalAIControllerCreateHospitalCallManagerPhoneResponse;

export type AdminMedipalAiControllerUpdateHospitalCallManagerPhoneData =
  AdminMedipalAIControllerUpdateHospitalCallManagerPhoneResponse;

export type AdminMedipalAiControllerDeleteHospitalCallManagerPhoneData =
  AdminMedipalAIControllerDeleteHospitalCallManagerPhoneResponse;

export interface AdminMedipalAiControllerFindStoreBannersParams {
  /**
   * 조회할 배너 개수
   * @default "10"
   */
  limit?: string;
  /**
   * 조회 시작 오프셋
   * @default "0"
   */
  offset?: string;
}

export type AdminMedipalAiControllerFindStoreBannersData = AdminMedipalAIControllerFindStoreBannersResponse;

export type AdminMedipalAiControllerCreateStoreBannerData = AdminMedipalAIControllerCreateStoreBannerResponse;

export type AdminMedipalAiControllerFindStoreBannerData = AdminMedipalAIControllerFindStoreBannerResponse;

export type AdminMedipalAiControllerUpdateStoreBannerData = AdminMedipalAIControllerUpdateStoreBannerResponse;

export type AdminMedipalAiControllerDeleteStoreBannerData = AdminMedipalAIControllerDeleteStoreBannerResponse;

export interface AdminMedipalAiControllerGetUsageWeightsParams {
  /**
   * 조회할 개수
   * @default "20"
   */
  limit?: string;
  /**
   * 조회 시작 오프셋
   * @default "0"
   */
  offset?: string;
  /**
   * 삭제된 항목 포함 여부
   * @default "false"
   */
  includeRemoved?: string;
}

export type AdminMedipalAiControllerGetUsageWeightsData = AdminMedipalAIControllerGetUsageWeightsResponse;

export type AdminMedipalAiControllerUpdateUsageWeightsData = AdminMedipalAIControllerUpdateUsageWeightsResponse;

export interface AdminMedipalAiControllerFindDiscountPoliciesParams {
  /** 병원 ID */
  hospitalID: string;
  /**
   * 조회할 개수
   * @default "20"
   */
  limit?: string;
  /**
   * 조회 시작 오프셋
   * @default "0"
   */
  offset?: string;
}

export type AdminMedipalAiControllerFindDiscountPoliciesData = AdminMedipalAIControllerFindDiscountPoliciesResponse;

export type AdminMedipalAiControllerCreateDiscountPolicyData = AdminMedipalAIControllerCreateDiscountPolicyResponse;

export type AdminMedipalAiControllerUpdateDiscountPolicyData = AdminMedipalAIControllerUpdateDiscountPolicyResponse;

export type AdminMedipalAiControllerDeleteDiscountPolicyData = AdminMedipalAIControllerDeleteDiscountPolicyResponse;

export interface AdminMedipalAiControllerFindUsageWeightSettingsParams {
  /**
   * 조회할 개수
   * @default "20"
   */
  limit?: string;
  /**
   * 조회 시작 오프셋
   * @default "0"
   */
  offset?: string;
  /**
   * 삭제된 항목 포함 여부
   * @default "false"
   */
  includeRemoved?: string;
}

export type AdminMedipalAiControllerFindUsageWeightSettingsData =
  AdminMedipalAIControllerFindUsageWeightSettingsResponse;

export type AdminMedipalAiControllerCreateUsageWeightSettingData =
  AdminMedipalAIControllerCreateUsageWeightSettingResponse;

export type AdminMedipalAiControllerFindCurrentUsageWeightSettingData =
  AdminMedipalAIControllerFindCurrentUsageWeightSettingResponse;

export type AdminMedipalAiControllerUpdateUsageWeightSettingData =
  AdminMedipalAIControllerUpdateUsageWeightSettingResponse;

export type AdminMedipalAiControllerDeleteUsageWeightSettingData =
  AdminMedipalAIControllerDeleteUsageWeightSettingResponse;

export interface AdminMsoGroupControllerCountParams {
  keyword?: string;
  isTest?: boolean;
}

export type AdminMsoGroupControllerCountData = AdminMSOGroupControllerCountResponse;

export interface AdminMsoGroupControllerFindParams {
  keyword?: string;
  isTest?: boolean;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type AdminMsoGroupControllerFindData = AdminMSOGroupControllerFindResponse;

export interface AdminMsoGroupControllerFindOneParams {
  _id?: string;
}

export type AdminMsoGroupControllerFindOneData = AdminMSOGroupControllerFindOneResponse;

export type AdminMsoGroupControllerData = AdminMSOGroupControllerCreateResponse;

export type AdminMsoGroupControllerUpdateData = AdminMSOGroupControllerUpdateResponse;

export type AdminMsoGroupControllerConnectHospitalsData = AdminMSOGroupControllerConnectHospitalsResponse;

export type AdminMsoGroupControllerDisconnectHospitalsData = AdminMSOGroupControllerDisconnectHospitalsResponse;

export interface AdminMsoGroupControllerPreflightDisconnectHospitalParams {
  /** MSO 그룹 ID */
  _id: string;
  /** 연결 해제할 병원 ID */
  hospitalID: string;
}

export type AdminMsoGroupControllerPreflightDisconnectHospitalData =
  AdminMSOGroupControllerPreflightDisconnectHospitalResponse;

export interface AdminMsoGroupControllerPreflightRemoveGroupParams {
  /** MSO 그룹 ID */
  _id: string;
}

export type AdminMsoGroupControllerPreflightRemoveGroupData = AdminMSOGroupControllerPreflightRemoveGroupResponse;

export interface AdminMsoGroupControllerPreflightRemoveAccountParams {
  /** 계정 User _id */
  _id: string;
}

export type AdminMsoGroupControllerPreflightRemoveAccountData = AdminMSOGroupControllerPreflightRemoveAccountResponse;

export interface AdminMsoGroupControllerRemoveParams {
  _id: string;
}

export type AdminMsoGroupControllerRemoveData = AdminMSOGroupControllerRemoveResponse;

export type AdminMsoGroupControllerAccountData = AdminMSOGroupControllerAccountCreateResponse;

export type AdminMsoGroupControllerAccountUpdateData = AdminMSOGroupControllerAccountUpdateResponse;

export interface AdminMsoGroupControllerAccountFindParams {
  /** MSO 그룹 ID */
  _id: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type AdminMsoGroupControllerAccountFindData = AdminMSOGroupControllerAccountFindResponse;

export interface AdminMsoGroupControllerAccountRemoveParams {
  /** 계정 User _id */
  _id: string;
}

export type AdminMsoGroupControllerAccountRemoveData = AdminMSOGroupControllerAccountRemoveResponse;

export interface AdminMsoGroupControllerAuthorizationTypeFindParams {
  /** MSO 그룹 ID */
  _id: string;
}

export type AdminMsoGroupControllerAuthorizationTypeFindData = AdminMSOGroupControllerAuthorizationTypeFindResponse;

export type AdminMsoGroupControllerAuthorizationTypeUpdateData = AdminMSOGroupControllerAuthorizationTypeUpdateResponse;

export type AdminMsoGroupControllerUpdateServiceStatusData = AdminMSOGroupControllerUpdateServiceStatusResponse;

export type AdminPatientBatchCancelControllerCancelBulkRegistrationData = any;

export interface AdminHospitalCountHandlerParams {
  keyword?: string;
  isTest?: boolean;
  isEnabledSaaS?: boolean;
  excludeHospitalIDs?: string;
}

export type AdminHospitalCountHandlerData = AdminHospitalCountHandlerResponse;

export interface AdminHospitalFindHandlerParams {
  keyword?: string;
  isTest?: boolean;
  isEnabledSaaS?: boolean;
  excludeHospitalIDs?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type AdminHospitalFindHandlerData = AdminHospitalFindHandlerResponse;

export interface AdminHospitalFindOneHandlerParams {
  _id?: string;
}

export type AdminHospitalFindOneHandlerData = AdminHospitalFindOneHandlerResponse;

export type AdminHospitalUpdateHandlerData = AdminHospitalUpdateHandlerResponse;

export type AdminHospitalCreateHandlerData = AdminHospitalCreateHandlerResponse;

export type AdminHospitalUpdateNameHandlerData = AdminHospitalUpdateNameHandlerResponse;

export type AdminHospitalUpdateSmsPhoneHandlerData = AdminHospitalUpdateSMSPhoneHandlerResponse;

export type AdminHospitalTestHServiceSmsFlowHandlerData = AdminHospitalTestHServiceSMSFlowHandlerResponse;

export interface AdminHospitalSmsStatusFindHandlerParams {
  keyword?: string;
  isTest?: boolean;
  isSMSSendingBlocked?: boolean;
  page?: number;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type AdminHospitalSmsStatusFindHandlerData = AdminHospitalSMSStatusFindHandlerResponse;

export interface AdminHospitalSmsStatusCountHandlerParams {
  keyword?: string;
  isTest?: boolean;
  isSMSSendingBlocked?: boolean;
}

export type AdminHospitalSmsStatusCountHandlerData = AdminHospitalSMSStatusCountHandlerResponse;

export type AdminHospitalUpdateSmsBlockHandlerData = AdminHospitalUpdateSMSBlockHandlerResponse;

export interface AdminServiceSettingCountHandlerParams {
  isSample?: boolean;
}

export type AdminServiceSettingCountHandlerData = AdminServiceSettingCountHandlerResponse;

export interface AdminServiceSettingFindHandlerParams {
  isSample?: boolean | null;
  isEnabledSaaS?: boolean;
  hospitalID?: string;
  isRemoved?: boolean;
}

export type AdminServiceSettingFindHandlerData = AdminServiceSettingFindHandlerResponse;

export interface AdminServiceSettingFindOneHandlerParams {
  _id?: string;
  hospitalID?: string;
}

export type AdminServiceSettingFindOneHandlerData = AdminServiceSettingFindOneHandlerResponse;

export type AdminServiceSettingCreateHandlerData = AdminServiceSettingCreateHandlerResponse;

export type AdminServiceSettingUpdateHandlerData = AdminServiceSettingUpdateHandlerResponse;

export type AdminServiceSettingRemoveHandlerData = AdminServiceSettingRemoveHandlerResponse;

export type AdminServiceSettingAccountUpdateHandlerData = AdminServiceSettingAccountUpdateHandlerResponse;

export type AdminServiceSettingDefaultCounselorUpdateHandlerData =
  AdminServiceSettingDefaultCounselorUpdateHandlerResponse;

export type AdminHealthContentCategoryFindHandlerData = AdminHealthContentCategoryFindHandlerResponse;

export interface AdminUserNurseFindHandlerParams {
  _id?: string;
}

export type AdminUserNurseFindHandlerData = AdminUserNurseFindHandlerResponse;

export interface AdminUserCountHandlerParams {
  keyword?: string;
}

export type AdminUserCountHandlerData = AdminUserCountHandlerResponse;

export interface AdminUserFindHandlerParams {
  keyword?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type AdminUserFindHandlerData = AdminUserFindHandlerResponse;

export interface AdminUserCreateHandlerParams {
  _id: string;
  id: string;
  name: string;
  realName: string;
  type?: number;
  jobType: string;
  photo?: string;
}

export type AdminUserCreateHandlerData = AdminUserCreateHandlerResponse;

export interface AdminUserUpdateHandlerParams {
  _id: string;
  id: string;
  password?: string;
  name: string;
  realName: string;
  type?: number;
  jobType: string;
  photo?: string;
}

export type AdminUserUpdateHandlerData = AdminUserUpdateHandlerResponse;

export interface AdminUserRemoveHandlerParams {
  _id: string;
}

export type AdminUserRemoveHandlerData = AdminUserRemoveHandlerResponse;

export interface AdminUserFindOneHandlerParams {
  _id: string;
}

export type AdminUserFindOneHandlerData = AdminUserFindOneHandlerResponse;

export type AdminAnsweringChatSettingCreateHandlerData = AdminAnsweringChatSettingCreateHandlerResponse;

export type AdminAnsweringChatSettingUpdateHandlerData = AdminAnsweringChatSettingUpdateHandlerResponse;

export interface AdminAnsweringChatSettingFindOneHandlerParams {
  _id: string;
}

export type AdminAnsweringChatSettingFindOneHandlerData = AdminAnsweringChatSettingFindOneHandlerResponse;

export interface AdminVideoContentCategoryFindHandlerParams {
  _id?: string;
  /** 문자열 형태의 JSON Object를 전달할 것 - ex) {$in: [ObjectId]} */
  parentCategoryIDs?: string;
  hospitalID?: string;
  isTop?: boolean;
  isParent?: boolean;
}

export type AdminVideoContentCategoryFindHandlerData = AdminVideoContentCategoryFindHandlerResponse;

export interface AdminVideoContentCategoryFindOneHandlerParams {
  _id?: string;
}

export type AdminVideoContentCategoryFindOneHandlerData = AdminVideoContentCategoryFindOneHandlerResponse;

export interface AdminIntegrationSettingFindOneHandlerParams {
  hospitalID?: string;
}

export type AdminIntegrationSettingFindOneHandlerData = AdminIntegrationSettingFindOneHandlerResponse;

export type AdminIntegrationSettingUpsertHandlerData = AdminIntegrationSettingUpsertHandlerResponse;

export interface AdminHospitalAccountCountHandlerParams {
  hospitalID?: string;
}

export type AdminHospitalAccountCountHandlerData = AdminHospitalAccountCountHandlerResponse;

export interface AdminHospitalDoctorFindHandlerParams {
  hospitalID?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type AdminHospitalDoctorFindHandlerData = AdminHospitalDoctorFindHandlerResponse;

export type AdminHospitalAccountCreateHandlerData = AdminHospitalAccountCreateHandlerResponse;

export type AdminHospitalAccountUpdateHandlerData = AdminHospitalAccountUpdateHandlerResponse;

export interface AdminHospitalAccountRemoveHandlerParams {
  _id: string;
  hospitalID: string;
}

export type AdminHospitalAccountRemoveHandlerData = AdminHospitalAccountRemoveHandlerResponse;

export interface AdminHospitalAccountSettingHistoryCountHandlerParams {
  hospitalID?: string;
}

export type AdminHospitalAccountSettingHistoryCountHandlerData = AdminHospitalAccountSettingHistoryCountHandlerResponse;

export interface AdminHospitalAccountSettingHistoryFindHandlerParams {
  hospitalID?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type AdminHospitalAccountSettingHistoryFindHandlerData = AdminHospitalAccountSettingHistoryFindHandlerResponse;

export interface AdminTreatmentCategoryCountHandlerParams {
  keyword?: string;
  descriptionKeyword?: string;
  isCommon?: boolean;
  isRemoved?: boolean;
}

export type AdminTreatmentCategoryCountHandlerData = AdminTreatmentCategoryCountHandlerResponse;

export type AdminTreatmentCategoryCreateHandlerData = AdminTreatmentCategoryCreateHandlerResponse;

export interface AdminTreatmentCategoryFindHandlerParams {
  keyword?: string;
  descriptionKeyword?: string;
  isCommon?: boolean;
  isRemoved?: boolean;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type AdminTreatmentCategoryFindHandlerData = AdminTreatmentCategoryFindHandlerResponse;

export interface AdminTreatmentCategoryFindOneHandlerParams {
  _id?: string;
}

export type AdminTreatmentCategoryFindOneHandlerData = AdminTreatmentCategoryFindOneHandlerResponse;

export type AdminTreatmentCategoryRemoveHandlerData = AdminTreatmentCategoryRemoveHandlerResponse;

export type AdminTreatmentCategoryUpdateHandlerData = AdminTreatmentCategoryUpdateHandlerResponse;

export type AdminTreatmentCategoryCopyHandlerData = AdminTreatmentCategoryCopyHandlerResponse;

export type AdminFileCreateHandlerData = AdminFileCreateHandlerResponse;

export type AdminFileUpdateHandlerData = AdminFileUpdateHandlerResponse;

export interface AdminFileFindOneHandlerParams {
  _id: string;
}

export type AdminFileFindOneHandlerData = AdminFileFindOneHandlerResponse;

export interface AdminCountryFindHandlerParams {
  hasDefaultMessage?: boolean;
}

export type AdminCountryFindHandlerData = AdminCountryFindHandlerResponse;

export type AdminCountryUpdateHandlerData = AdminCountryUpdateHandlerResponse;

export interface KakaoLinkageHistoryCountHandlerParams {
  keyword?: string;
  isRequestForAlimAndFriendTalkLinkage?: boolean;
  isRequestForConsultationTalkLinkage?: boolean;
}

export type KakaoLinkageHistoryCountHandlerData = KakaoLinkageHistoryCountHandlerResponse;

export interface KakaoLinkageHistoryFindHandlerParams {
  hospitalID?: string;
  keyword?: string;
  isRequestForAlimAndFriendTalkLinkage?: boolean;
  isRequestForConsultationTalkLinkage?: boolean;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type KakaoLinkageHistoryFindHandlerData = KakaoLinkageHistoryFindHandlerResponse;

export interface KakaoLinkageHistoryDetailHandlerParams {
  _id?: string;
  hospitalID?: string;
  isRequestForAlimAndFriendTalkLinkage?: boolean;
  isRequestForConsultationTalkLinkage?: boolean;
  isLinked?: boolean;
}

export type KakaoLinkageHistoryDetailHandlerData = KakaoLinkageHistoryDetailHandlerResponse;

export type KakaoLinkageHistoryUpdateHandlerData = KakaoLinkageHistoryUpdateHandlerResponse;

export interface KakaoLinkageHistoryClearHandlerParams {
  _id?: string;
  hospitalID?: string;
  isRequestForAlimAndFriendTalkLinkage?: boolean;
  isRequestForConsultationTalkLinkage?: boolean;
}

export type KakaoLinkageHistoryClearHandlerData = KakaoLinkageHistoryClearHandlerResponse;

export type KakaoLinkageHistoryActivateHandlerData = KakaoLinkageHistoryActivateHandlerResponse;

export type KakaoTemplateFindGroupHandlerData = KakaoTemplateFindGroupHandlerResponse;

export type KakaoTemplateAddProfileToGroupHandlerData = KakaoTemplateAddProfileToGroupHandlerResponse;

export type KakaoTemplateRemoveProfileFromGroupHandlerData = KakaoTemplateRemoveProfileFromGroupHandlerResponse;

export type KakaoTemplateFindAllProfileHandlerData = KakaoTemplateFindAllProfileHandlerResponse;

export interface KakaoTemplateFindProfileHandlerParams {
  senderKey?: string;
}

export type KakaoTemplateFindProfileHandlerData = KakaoTemplateFindProfileHandlerResponse;

export type KakaoTemplateFindCategoryHandlerData = KakaoTemplateFindCategoryHandlerResponse;

export interface KakaoTemplateFindHandlerParams {
  senderKey: string;
  senderKeyType?: string;
  templateStatus?: string;
  keyword?: string;
  page?: string;
  count?: string;
  startDate?: string;
  endDate?: string;
  categoryCodeList?: string[] | null;
}

export type KakaoTemplateFindHandlerData = KakaoTemplateFindHandlerResponse;

export type KakaoTemplateCreateHandlerData = KakaoTemplateCreateHandlerResponse;

export type KakaoTemplateUpdateHandlerData = KakaoTemplateUpdateHandlerResponse;

export interface KakaoTemplateDeleteHandlerParams {
  senderKey: string;
  senderKeyType: string;
  templateCode: string;
}

export type KakaoTemplateDeleteHandlerData = KakaoTemplateDeleteHandlerResponse;

export interface KakaoTemplateDetailHandlerParams {
  senderKey: string;
  senderKeyType: string;
  templateCode: string;
}

export type KakaoTemplateDetailHandlerData = KakaoTemplateDetailHandlerResponse;

export interface KakaoTemplateDetailParsedHandlerParams {
  senderKey: string;
  senderKeyType: string;
  templateCode: string;
}

export type KakaoTemplateDetailParsedHandlerData = KakaoTemplateDetailParsedHandlerResponse;

export type KakaoTemplateRequestHandlerData = KakaoTemplateRequestHandlerResponse;

export type KakaoTemplateInspectIfNeededHandlerData = KakaoTemplateInspectIfNeededHandlerResponse;

export type KakaoTemplateRegisterAndInspectHandlerData = KakaoTemplateRegisterAndInspectHandlerResponse;

export type KakaoTemplateRequestCancelHandlerData = KakaoTemplateRequestCancelHandlerResponse;

export type KakaoTemplateStopHandlerData = KakaoTemplateStopHandlerResponse;

export type KakaoTemplateReuseHandlerData = KakaoTemplateReuseHandlerResponse;

export type KakaoTemplateCancelApprovalHandlerData = KakaoTemplateCancelApprovalHandlerResponse;

export type KakaoTemplateReleaseHandlerData = KakaoTemplateReleaseHandlerResponse;

export interface KakaoTemplateHistoryFindHandlerParams {
  templateCode: string;
}

export type KakaoTemplateHistoryFindHandlerData = KakaoTemplateHistoryFindHandlerResponse;

export interface AdminAutomationCountHandlerParams {
  keyType?: string;
  keyword?: string;
}

export type AdminAutomationCountHandlerData = AdminAutomationCountHandlerResponse;

export interface AdminAutomationFindHandlerParams {
  keyType?: string;
  keyword?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type AdminAutomationFindHandlerData = AdminAutomationFindHandlerResponse;

export type AdminAutomationCreateHandlerData = AdminAutomationCreateHandlerResponse;

export type AdminAutomationUpdateHandlerData = AdminAutomationUpdateHandlerResponse;

export interface AdminAutomationDeleteHandlerParams {
  _id: string;
}

export type AdminAutomationDeleteHandlerData = AdminAutomationDeleteHandlerResponse;

export interface AdminAuomtaionHospitalFindHandlerParams {
  hospitalID?: string;
  type?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type AdminAuomtaionHospitalFindHandlerData = AdminAuomtaionHospitalFindHandlerResponse;

export type AdminAutomationHospitalCreateHandlerData = AdminAutomationHospitalCreateHandlerResponse;

export type AdminAutomationHospitalUpdateHandlerData = AdminAutomationHospitalUpdateHandlerResponse;

export interface AdminAutomationHospitalDeleteHandlerParams {
  _id?: string;
}

export type AdminAutomationHospitalDeleteHandlerData = AdminAutomationHospitalDeleteHandlerResponse;

export type AdminAutomationHospitalUpdateMessageHandlerData = AdminAutomationHospitalUpdateMessageHandlerResponse;

export interface AdminAuomtaionHospitalFindVideoContentHandlerParams {
  _id: string;
}

export type AdminAuomtaionHospitalFindVideoContentHandlerData = AdminAuomtaionHospitalFindVideoContentHandlerResponse;

export interface AdminAuomtaionHospitalFindHomecareHandlerParams {
  _id: string;
}

export type AdminAuomtaionHospitalFindHomecareHandlerData = AdminAuomtaionHospitalFindHomecareHandlerResponse;

export interface AdminAuomtaionHospitalFindEventHandlerParams {
  _id: string;
}

export type AdminAuomtaionHospitalFindEventHandlerData = AdminAuomtaionHospitalFindEventHandlerResponse;

export interface KakaoServiceNotificationMessageFindOneHandlerParams {
  _id?: string;
  hospitalID?: string;
  type?: string;
}

export type KakaoServiceNotificationMessageFindOneHandlerData = KakaoServiceNotificationMessageFindOneHandlerResponse;

export type KakaoServiceNotificationMessageUpdateHandlerData = KakaoServiceNotificationMessageUpdateHandlerResponse;

export interface TalkTalkLinkageAccountsStatesHandlerParams {
  hospitalID?: string;
}

export type TalkTalkLinkageAccountsStatesHandlerData = TalkTalkLinkageAccountsStatesHandlerResponse;

export type TalkTalkLinkagePatchAccountsStatesHandlerData = TalkTalkLinkagePatchAccountsStatesHandlerResponse;

export type AdminAuthorizationTypeCreateHandlerData = AdminAuthorizationTypeCreateHandlerResponse;

export type AdminAuthorizationTypeUpdateHandlerData = AdminAuthorizationTypeUpdateHandlerResponse;

export interface AdminAuthorizationTypeFindOneHandlerParams {
  /** 조회할 관리자 사용자 ID */
  userID: string;
}

export type AdminAuthorizationTypeFindOneHandlerData = AdminAuthorizationTypeFindOneHandlerResponse;

export interface CurrentInstagramAccountsStatesHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type CurrentInstagramAccountsStatesHandlerData = CurrentInstagramAccountsStatesHandlerResponse;

export interface ApprovedInstagramAccountsHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type ApprovedInstagramAccountsHandlerData = ApprovedInstagramAccountsHandlerResponse;

export type ApprovingInstagramLinkageHandlerData = ApprovingInstagramLinkageHandlerResponse;

export type RenewingInstagramLinkageStatusHandlerData = RenewingInstagramLinkageStatusHandlerResponse;

export type LineLinkagePatchAccountsStatesHandlerData = LineLinkagePatchAccountsStatesHandlerResponse;

export interface ApprovedLineLinkageHandlerParams {
  hospitalID?: string;
}

export type ApprovedLineLinkageHandlerData = ApprovedLineLinkageHandlerResponse;

export type AdminEndOfServiceChatSendHandlerData = AdminEndOfServiceChatSendHandlerResponse;

export interface KakaoDefaultTemplateFindHandlerParams {
  /**
   * 템플릿 유형
   * @example "messageImmediateCreate"
   */
  type?: string;
  /**
   * 카카오 템플릿 히스토리 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  kakaoTemplateHistoryID?: string;
  /**
   * 발신프로필 그룹명 - 애프터닥, 메디팔
   * @example "애프터닥"
   */
  groupName?: string;
  /**
   * 삭제 여부
   * @example false
   */
  isRemoved?: boolean;
  /**
   * 정렬 키
   * @example "createdAt"
   */
  sortKey?: string;
  /**
   * 정렬 방향
   * @example "1"
   */
  sortWay?: string;
  /**
   * 건너뛸 건수
   * @example 0
   */
  skip?: number;
  /**
   * 조회 건수
   * @example 10
   */
  limit?: number;
}

export type KakaoDefaultTemplateFindHandlerData = KakaoDefaultTemplateFindHandlerResponse;

export type KakaoDefaultTemplateCreateHandlerData = KakaoDefaultTemplateCreateHandlerResponse;

export type KakaoDefaultTemplateUpdateHandlerData = KakaoDefaultTemplateUpdateHandlerResponse;

export interface CurrentSejongHospitalLinkageStatesHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type CurrentSejongHospitalLinkageStatesHandlerData = CurrentSejongHospitalLinkageStatesHandlerResponse;

export type MappingSejongHospitalDiagnosisCodeWithTreatmentTagHandlerData =
  MappingSejongHospitalDiagnosisCodeWithTreatmentTagHandlerResponse;

export type RenewingSejongHospitalLinkageStatusHandlerData = RenewingSejongHospitalLinkageStatusHandlerResponse;

export interface AdminAfterDocNoticeControllerFindAfterDocNoticeParams {
  /**
   * 한 페이지당 공지사항 수
   * @default "10"
   * @example "10"
   */
  limit?: string;
  /**
   * 건너뛸 문서 수 (페이지네이션)
   * @default "0"
   * @example "0"
   */
  offset?: string;
  /**
   * 검색어
   * @example "애프터닥"
   */
  query?: string;
}

export type AdminAfterDocNoticeControllerFindAfterDocNoticeData =
  AdminAfterDocNoticeControllerFindAfterDocNoticeListResponse;

export type AdminAfterDocNoticeControllerCreateAfterDocNoticeData =
  AdminAfterDocNoticeControllerCreateAfterDocNoticeResponse;

export type AdminAfterDocNoticeControllerFindAfterDocNoticeDetailData =
  AdminAfterDocNoticeControllerFindAfterDocNoticeDetailResponse;

export type AdminAfterDocNoticeControllerUpdateAfterDocNoticeData =
  AdminAfterDocNoticeControllerUpdateAfterDocNoticeResponse;

export type AdminAfterDocNoticeControllerDeleteAfterDocNoticeData =
  AdminAfterDocNoticeControllerDeleteAfterDocNoticeResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description BizPpurio 발송 히스토리 조회
     *
     * @tags V3-Admin-BizPpurioHistory
     * @name BizPpurioHistoryControllerFindBizPpurioHistory
     * @summary BizPpurio 발송 히스토리 조회
     * @request GET:/v3/admin/bizppurio-history
     * @secure
     * @response `200` `BizPpurioHistoryControllerFindBizPpurioHistoryData` success
     */
    bizPpurioHistoryControllerFindBizPpurioHistory: (
      query: BizPpurioHistoryControllerFindBizPpurioHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<BizPpurioHistoryControllerFindBizPpurioHistoryData, any>({
        path: `/v3/admin/bizppurio-history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 그룹 템플릿 이관 batch 실행 (검수 확인 → 교체)
     *
     * @tags V3-Admin-KakaoTemplateTransfer
     * @name KakaoTemplateTransferControllerRunBatch
     * @summary 카카오 그룹 템플릿 이관 batch
     * @request POST:/v3/admin/kakao-template-transfer/batch
     * @secure
     * @response `200` `KakaoTemplateTransferControllerRunBatchData` success
     */
    kakaoTemplateTransferControllerRunBatch: (
      data: KakaoTemplateTransferControllerRunBatchBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateTransferControllerRunBatchData, any>({
        path: `/v3/admin/kakao-template-transfer/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 그룹 템플릿 이관 - 템플릿 skip 전환 (newTemplateCode 기준, skip 사유 기록)
     *
     * @tags V3-Admin-KakaoTemplateTransfer
     * @name KakaoTemplateTransferControllerSkipTemplate
     * @summary 이관 템플릿 skip 전환
     * @request POST:/v3/admin/kakao-template-transfer/templates/skip
     * @secure
     * @response `200` `KakaoTemplateTransferControllerSkipTemplateData` success
     */
    kakaoTemplateTransferControllerSkipTemplate: (
      data: KakaoTemplateTransferControllerSkipTemplateBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateTransferControllerSkipTemplateData, any>({
        path: `/v3/admin/kakao-template-transfer/templates/skip`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 그룹 템플릿 이관 - 템플릿 상태 재동기화 (newTemplateCode 기준, 히스토리 값으로 갱신)
     *
     * @tags V3-Admin-KakaoTemplateTransfer
     * @name KakaoTemplateTransferControllerRefreshTemplateStatus
     * @summary 이관 템플릿 상태 재동기화
     * @request POST:/v3/admin/kakao-template-transfer/templates/refresh-status
     * @secure
     * @response `200` `KakaoTemplateTransferControllerRefreshTemplateStatusData` success
     */
    kakaoTemplateTransferControllerRefreshTemplateStatus: (
      data: KakaoTemplateTransferControllerRefreshTemplateStatusBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateTransferControllerRefreshTemplateStatusData, any>({
        path: `/v3/admin/kakao-template-transfer/templates/refresh-status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 그룹 템플릿 이관 - 병원 목록 (진행중/완료/미시작)
     *
     * @tags V3-Admin-KakaoTemplateTransfer
     * @name KakaoTemplateTransferControllerFindHospitals
     * @summary 이관 병원 목록
     * @request GET:/v3/admin/kakao-template-transfer/hospitals
     * @secure
     * @response `200` `KakaoTemplateTransferControllerFindHospitalsData` success
     */
    kakaoTemplateTransferControllerFindHospitals: (
      query: KakaoTemplateTransferControllerFindHospitalsParams,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateTransferControllerFindHospitalsData, any>({
        path: `/v3/admin/kakao-template-transfer/hospitals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 그룹 템플릿 이관 - 병원별 템플릿 목록 (검수중/반려/완료)
     *
     * @tags V3-Admin-KakaoTemplateTransfer
     * @name KakaoTemplateTransferControllerFindTemplates
     * @summary 이관 템플릿 목록
     * @request GET:/v3/admin/kakao-template-transfer/templates
     * @secure
     * @response `200` `KakaoTemplateTransferControllerFindTemplatesData` success
     */
    kakaoTemplateTransferControllerFindTemplates: (
      query: KakaoTemplateTransferControllerFindTemplatesParams,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateTransferControllerFindTemplatesData, any>({
        path: `/v3/admin/kakao-template-transfer/templates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 상담자동화 목록을 각 자동화가 참조하는 카카오 템플릿의 serviceStatus 별 카운트와 함께 조회한다. hospitalID 지정 시 해당 병원, 미지정 시 전체 병원 대상 조회(이 경우 limit 필수). filterServiceStatus 로 해당 상태 템플릿을 1건 이상 가진 자동화만 필터링하고, sortServiceStatus/sortWay 로 해당 상태 카운트 기준으로 정렬한다(동률은 createdAt 내림차순). 그룹 템플릿처럼 여러 병원이 공유하는 템플릿도 참조하는 병원마다 각각 카운트된다.
     *
     * @tags V3-Admin-Automation-Hospital
     * @name AdminAutomationHospitalControllerFindWithKakaoTemplateStatus
     * @summary 상담자동화 + 카카오 템플릿 상태 카운트 조회 (병원별/전체 병원)
     * @request GET:/v3/admin/automation/hospital/with-kakao-template-status
     * @secure
     * @response `200` `AdminAutomationHospitalControllerFindWithKakaoTemplateStatusData` success
     */
    adminAutomationHospitalControllerFindWithKakaoTemplateStatus: (
      query: AdminAutomationHospitalControllerFindWithKakaoTemplateStatusParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminAutomationHospitalControllerFindWithKakaoTemplateStatusData, any>({
        path: `/v3/admin/automation/hospital/with-kakao-template-status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 상담자동화 생성 + 카카오 알림톡 single 템플릿 자동 등록. 병원이 카카오 알림톡 미연동이면 알고리즘은 생성하고 템플릿 등록만 건너뛴다. 템플릿은 등록/검수요청까지만 수행하며 승인은 카카오 검수 후 별도 배치가 반영한다.
     *
     * @tags V3-Admin-Automation-Hospital
     * @name AdminAutomationHospitalControllerCreateWithKakaoTemplate
     * @summary 병원별 상담자동화 생성 + 카카오 템플릿 등록
     * @request POST:/v3/admin/automation/hospital/with-kakao-template
     * @secure
     * @response `200` `AdminAutomationHospitalControllerCreateWithKakaoTemplateData` success
     */
    adminAutomationHospitalControllerCreateWithKakaoTemplate: (
      data: AdminAutomationHospitalControllerCreateWithKakaoTemplateBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminAutomationHospitalControllerCreateWithKakaoTemplateData, any>({
        path: `/v3/admin/automation/hospital/with-kakao-template`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 채팅 채널(카카오 상담톡·위챗·네이버 톡톡·라인·인스타그램·왓츠앱) 연동 현황 목록. 병원 1행 · 채널 6열 테이블용. enabled 는 ServiceSetting 의 연동 허용 여부이고, accounts 는 실제 연동된 채널 계정 목록이다. includeUnlinked=true 면 해제된 계정도 함께 내려주고 isLinked 로 구분한다.
     *
     * @tags V3-Admin-ChatChannelLinkage
     * @name AdminChatChannelLinkageControllerFind
     * @summary 채팅 채널 연동 현황 목록
     * @request GET:/v3/admin/chat-channel-linkages
     * @secure
     * @response `200` `AdminChatChannelLinkageControllerFindData` success
     */
    adminChatChannelLinkageControllerFind: (
      query: AdminChatChannelLinkageControllerFindParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminChatChannelLinkageControllerFindData, any>({
        path: `/v3/admin/chat-channel-linkages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅 채널 연동 현황 목록의 총 병원 수. 목록(find)과 같은 keyword 조건을 쓴다.
     *
     * @tags V3-Admin-ChatChannelLinkage
     * @name AdminChatChannelLinkageControllerCount
     * @summary 채팅 채널 연동 현황 총 병원 수
     * @request GET:/v3/admin/chat-channel-linkages/count
     * @secure
     * @response `200` `AdminChatChannelLinkageControllerCountData` success
     */
    adminChatChannelLinkageControllerCount: (
      query: AdminChatChannelLinkageControllerCountParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminChatChannelLinkageControllerCountData, any>({
        path: `/v3/admin/chat-channel-linkages/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 인보이스 리스트 조회
     *
     * @tags V3-Admin-Billing
     * @name AdminBillingControllerGetInvoice
     * @summary 인보이스 리스트 조회
     * @request GET:/v3/admin/billing/invoice
     * @secure
     * @response `200` `AdminBillingControllerGetInvoiceData` 成功响应
     */
    adminBillingControllerGetInvoice: (params: RequestParams = {}) =>
      this.request<AdminBillingControllerGetInvoiceData, any>({
        path: `/v3/admin/billing/invoice`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description 인보이스 상세조회
     *
     * @tags V3-Admin-Billing
     * @name AdminBillingControllerGetInvoiceDetail
     * @summary 인보이스 상세조회
     * @request GET:/v3/admin/billing/invoice/{invoiceID}
     * @secure
     * @response `200` `AdminBillingControllerGetInvoiceDetailData` 成功响应
     */
    adminBillingControllerGetInvoiceDetail: (invoiceId: string, params: RequestParams = {}) =>
      this.request<AdminBillingControllerGetInvoiceDetailData, any>({
        path: `/v3/admin/billing/invoice/${invoiceId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description 주문 리스트 조회
     *
     * @tags V3-Admin-Billing
     * @name AdminBillingControllerGetOrder
     * @summary 주문 리스트 조회
     * @request GET:/v3/admin/billing/order
     * @secure
     * @response `200` `AdminBillingControllerGetOrderData` 成功响应
     */
    adminBillingControllerGetOrder: (params: RequestParams = {}) =>
      this.request<AdminBillingControllerGetOrderData, any>({
        path: `/v3/admin/billing/order`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description 주문 상세조회
     *
     * @tags V3-Admin-Billing
     * @name AdminBillingControllerGetOrderDetail
     * @summary 주문 상세조회
     * @request GET:/v3/admin/billing/order/{orderID}
     * @secure
     * @response `200` `AdminBillingControllerGetOrderDetailData` 成功响应
     */
    adminBillingControllerGetOrderDetail: (orderId: string, params: RequestParams = {}) =>
      this.request<AdminBillingControllerGetOrderDetailData, any>({
        path: `/v3/admin/billing/order/${orderId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description 카카오 연동 정보 조회
     *
     * @tags V3-Admin-KakaoLinkage
     * @name AdminKakaoControllerFindLinkageInfo
     * @summary 카카오 연동 정보 조회
     * @request GET:/v3/admin/kakaolinkage
     * @secure
     * @response `200` `AdminKakaoControllerFindLinkageInfoData` success
     */
    adminKakaoControllerFindLinkageInfo: (
      query: AdminKakaoControllerFindLinkageInfoParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminKakaoControllerFindLinkageInfoData, any>({
        path: `/v3/admin/kakaolinkage`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 정보 수정
     *
     * @tags V3-Admin-KakaoLinkage
     * @name AdminKakaoControllerUpdateLinkageInfo
     * @summary 카카오 연동 정보 수정
     * @request PATCH:/v3/admin/kakaolinkage
     * @secure
     * @response `200` `AdminKakaoControllerUpdateLinkageInfoData` 成功响应
     */
    adminKakaoControllerUpdateLinkageInfo: (
      data: AdminKakaoControllerUpdateLinkageInfoBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminKakaoControllerUpdateLinkageInfoData, any>({
        path: `/v3/admin/kakaolinkage`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 카카오 연동 해제
     *
     * @tags V3-Admin-KakaoLinkage
     * @name AdminKakaoControllerUnlink
     * @summary 카카오 연동 해제
     * @request DELETE:/v3/admin/kakaolinkage
     * @secure
     * @response `200` `AdminKakaoControllerUnlinkData` 成功响应
     */
    adminKakaoControllerUnlink: (query: AdminKakaoControllerUnlinkParams, params: RequestParams = {}) =>
      this.request<AdminKakaoControllerUnlinkData, any>({
        path: `/v3/admin/kakaolinkage`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 카카오 브랜드 메시지 최종 승인
     *
     * @tags V3-Admin-KakaoLinkage
     * @name AdminKakaoControllerApproveBrandMessageLinkage
     * @summary 카카오 브랜드 메시지 최종 승인
     * @request POST:/v3/admin/kakaolinkage/brandmessage/approve
     * @secure
     * @response `200` `AdminKakaoControllerApproveBrandMessageLinkageData` 成功响应
     */
    adminKakaoControllerApproveBrandMessageLinkage: (
      data: AdminKakaoControllerApproveBrandMessageLinkageBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminKakaoControllerApproveBrandMessageLinkageData, any>({
        path: `/v3/admin/kakaolinkage/brandmessage/approve`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 위챗 연동 정보 조회
     *
     * @tags V3-Admin-WechatLinkage
     * @name AdminWechatControllerFindLinkageInfo
     * @summary 위챗 연동 정보 조회
     * @request GET:/v3/admin/wechatlinkage
     * @secure
     * @response `200` `AdminWechatControllerFindLinkageInfoData` success
     */
    adminWechatControllerFindLinkageInfo: (
      query: AdminWechatControllerFindLinkageInfoParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminWechatControllerFindLinkageInfoData, any>({
        path: `/v3/admin/wechatlinkage`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 위챗 연동 정보 수정
     *
     * @tags V3-Admin-WechatLinkage
     * @name AdminWechatControllerUpdateLinkageInfo
     * @summary 위챗 연동 정보 수정
     * @request PATCH:/v3/admin/wechatlinkage
     * @secure
     * @response `200` `AdminWechatControllerUpdateLinkageInfoData` 成功响应
     */
    adminWechatControllerUpdateLinkageInfo: (
      data: AdminWechatControllerUpdateLinkageInfoBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminWechatControllerUpdateLinkageInfoData, any>({
        path: `/v3/admin/wechatlinkage`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 왓츠앱 연동 정보 조회
     *
     * @tags V3-Admin-WhasappLinkage
     * @name AdminWhatsappControllerFindLinkageInfo
     * @summary 왓츠앱 연동 정보 조회
     * @request GET:/v3/admin/whatsapplinkage
     * @secure
     * @response `200` `AdminWhatsappControllerFindLinkageInfoData` success
     */
    adminWhatsappControllerFindLinkageInfo: (
      query: AdminWhatsappControllerFindLinkageInfoParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminWhatsappControllerFindLinkageInfoData, any>({
        path: `/v3/admin/whatsapplinkage`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 왓츠앱 연동 정보 수정
     *
     * @tags V3-Admin-WhatsappLinkage
     * @name AdminWhatsappControllerUpdateLinkageInfo
     * @summary 왓츠앱 연동 정보 수정
     * @request PATCH:/v3/admin/whatsapplinkage/linkage-status
     * @secure
     * @response `200` `AdminWhatsappControllerUpdateLinkageInfoData` 成功响应
     */
    adminWhatsappControllerUpdateLinkageInfo: (
      data: AdminWhatsappControllerUpdateLinkageInfoBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminWhatsappControllerUpdateLinkageInfoData, any>({
        path: `/v3/admin/whatsapplinkage/linkage-status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 왓츠앱 세팅 변경 내역 조회
     *
     * @tags V3-Admin-WhatsappLinkage
     * @name AdminWhatsappControllerFindSetupUpdateHistory
     * @summary 왓츠앱 세팅 변경 내역 조회
     * @request GET:/v3/admin/whatsapplinkage/approved-by-employee
     * @secure
     * @response `200` `AdminWhatsappControllerFindSetupUpdateHistoryData` success
     */
    adminWhatsappControllerFindSetupUpdateHistory: (
      query: AdminWhatsappControllerFindSetupUpdateHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminWhatsappControllerFindSetupUpdateHistoryData, any>({
        path: `/v3/admin/whatsapplinkage/approved-by-employee`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별 라인 연동 정보 수정
     *
     * @tags V3-Admin-LineLinkage
     * @name AdminLineControllerUpdateLinkageInfo
     * @summary 병원 별 라인 연동 정보 수정
     * @request PATCH:/v3/admin/linelinkage
     * @secure
     * @response `200` `AdminLineControllerUpdateLinkageInfoData` success
     */
    adminLineControllerUpdateLinkageInfo: (
      data: AdminLineControllerUpdateLinkageInfoBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminLineControllerUpdateLinkageInfoData, any>({
        path: `/v3/admin/linelinkage`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별 라인 연동 현황
     *
     * @tags V3-Admin-LineLinkage
     * @name LineLinkageAccountsStatesHandler
     * @summary 병원 별 라인 연동 현황
     * @request GET:/v3/admin/linelinkage
     * @secure
     * @response `200` `LineLinkageAccountsStatesHandlerData` success
     */
    lineLinkageAccountsStatesHandler: (query: LineLinkageAccountsStatesHandlerParams, params: RequestParams = {}) =>
      this.request<LineLinkageAccountsStatesHandlerData, any>({
        path: `/v3/admin/linelinkage`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메세지 포인트 리스트 (검색, 페이지네이션)
     *
     * @tags V3-Admin-BrandMessagePoint
     * @name AdminBrandMessagePointControllerGetBrandMessagePoint
     * @summary 브랜드메세지 포인트 리스트 (검색, 페이지네이션)
     * @request GET:/v3/admin/brandmessage-point
     * @secure
     * @response `200` `AdminBrandMessagePointControllerGetBrandMessagePointData` success
     */
    adminBrandMessagePointControllerGetBrandMessagePoint: (
      query: AdminBrandMessagePointControllerGetBrandMessagePointParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminBrandMessagePointControllerGetBrandMessagePointData, any>({
        path: `/v3/admin/brandmessage-point`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메세지 단가 조회
     *
     * @tags V3-Admin-BrandMessagePoint
     * @name AdminBrandMessagePointControllerGetBrandMessagePrice
     * @summary 브랜드메세지 단가 조회
     * @request GET:/v3/admin/brandmessage-point/price
     * @secure
     * @response `200` `AdminBrandMessagePointControllerGetBrandMessagePriceData` success
     */
    adminBrandMessagePointControllerGetBrandMessagePrice: (
      query: AdminBrandMessagePointControllerGetBrandMessagePriceParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminBrandMessagePointControllerGetBrandMessagePriceData, any>({
        path: `/v3/admin/brandmessage-point/price`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메세지 이용권 상세조회
     *
     * @tags V3-Admin-BrandMessagePoint
     * @name AdminBrandMessagePointControllerGetBrandMessagePointDetail
     * @summary 브랜드메세지 이용권 상세조회
     * @request GET:/v3/admin/brandmessage-point/:id
     * @secure
     * @response `200` `AdminBrandMessagePointControllerGetBrandMessagePointDetailData` success
     */
    adminBrandMessagePointControllerGetBrandMessagePointDetail: (id: any, params: RequestParams = {}) =>
      this.request<AdminBrandMessagePointControllerGetBrandMessagePointDetailData, any>({
        path: `/v3/admin/brandmessage-point/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 현재 이용권 조회
     *
     * @tags V3-Admin-BrandMessagePoint
     * @name AdminBrandMessagePointControllerGetHospitalPoint
     * @summary 병원별 현재 이용권 조회
     * @request GET:/v3/admin/brandmessage-point/hospital/:hospitalID
     * @secure
     * @response `200` `AdminBrandMessagePointControllerGetHospitalPointData` success
     */
    adminBrandMessagePointControllerGetHospitalPoint: (hospitalId: any, params: RequestParams = {}) =>
      this.request<AdminBrandMessagePointControllerGetHospitalPointData, any>({
        path: `/v3/admin/brandmessage-point/hospital/${hospitalId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메세지 이용권 추가
     *
     * @tags V3-Admin-BrandMessagePoint
     * @name AdminBrandMessagePointControllerAddBrandMessagePoint
     * @summary 브랜드메세지 이용권 추가
     * @request POST:/v3/admin/brandmessage-point/add
     * @secure
     * @response `200` `AdminBrandMessagePointControllerAddBrandMessagePointData` success
     */
    adminBrandMessagePointControllerAddBrandMessagePoint: (params: RequestParams = {}) =>
      this.request<AdminBrandMessagePointControllerAddBrandMessagePointData, any>({
        path: `/v3/admin/brandmessage-point/add`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메세지 이용권 차감
     *
     * @tags V3-Admin-BrandMessagePoint
     * @name AdminBrandMessagePointControllerRemoveBrandMessagePoint
     * @summary 브랜드메세지 이용권 차감
     * @request POST:/v3/admin/brandmessage-point/remove
     * @secure
     * @response `200` `AdminBrandMessagePointControllerRemoveBrandMessagePointData` success
     */
    adminBrandMessagePointControllerRemoveBrandMessagePoint: (params: RequestParams = {}) =>
      this.request<AdminBrandMessagePointControllerRemoveBrandMessagePointData, any>({
        path: `/v3/admin/brandmessage-point/remove`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메시지 상품 목록 조회
     *
     * @tags V3-Admin-BrandMessageProduct
     * @name AdminBrandMessageProductControllerGetProduct
     * @summary 브랜드메시지 상품 목록 조회
     * @request GET:/v3/admin/brandmessage-product
     * @secure
     * @response `200` `AdminBrandMessageProductControllerGetProductData` success
     */
    adminBrandMessageProductControllerGetProduct: (
      query: AdminBrandMessageProductControllerGetProductParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminBrandMessageProductControllerGetProductData, any>({
        path: `/v3/admin/brandmessage-product`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메시지 상품 생성
     *
     * @tags V3-Admin-BrandMessageProduct
     * @name AdminBrandMessageProductControllerCreateProduct
     * @summary 브랜드메시지 상품 생성
     * @request POST:/v3/admin/brandmessage-product
     * @secure
     * @response `200` `AdminBrandMessageProductControllerCreateProductData` success
     */
    adminBrandMessageProductControllerCreateProduct: (params: RequestParams = {}) =>
      this.request<AdminBrandMessageProductControllerCreateProductData, any>({
        path: `/v3/admin/brandmessage-product`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메시지 상품 미리보기 환산 (amount, bonusRate → credit/bonusCredit)
     *
     * @tags V3-Admin-BrandMessageProduct
     * @name AdminBrandMessageProductControllerPreviewProduct
     * @summary 브랜드메시지 상품 미리보기
     * @request GET:/v3/admin/brandmessage-product/preview
     * @secure
     * @response `200` `AdminBrandMessageProductControllerPreviewProductData` success
     */
    adminBrandMessageProductControllerPreviewProduct: (
      query: AdminBrandMessageProductControllerPreviewProductParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminBrandMessageProductControllerPreviewProductData, any>({
        path: `/v3/admin/brandmessage-product/preview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메시지 상품 상세 조회
     *
     * @tags V3-Admin-BrandMessageProduct
     * @name AdminBrandMessageProductControllerGetProductDetail
     * @summary 브랜드메시지 상품 상세 조회
     * @request GET:/v3/admin/brandmessage-product/:id
     * @secure
     * @response `200` `AdminBrandMessageProductControllerGetProductDetailData` success
     */
    adminBrandMessageProductControllerGetProductDetail: (id: any, params: RequestParams = {}) =>
      this.request<AdminBrandMessageProductControllerGetProductDetailData, any>({
        path: `/v3/admin/brandmessage-product/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메시지 상품 수정
     *
     * @tags V3-Admin-BrandMessageProduct
     * @name AdminBrandMessageProductControllerUpdateProduct
     * @summary 브랜드메시지 상품 수정
     * @request PATCH:/v3/admin/brandmessage-product/:id
     * @secure
     * @response `200` `AdminBrandMessageProductControllerUpdateProductData` success
     */
    adminBrandMessageProductControllerUpdateProduct: (id: any, params: RequestParams = {}) =>
      this.request<AdminBrandMessageProductControllerUpdateProductData, any>({
        path: `/v3/admin/brandmessage-product/${id}`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메시지 상품 비활성화
     *
     * @tags V3-Admin-BrandMessageProduct
     * @name AdminBrandMessageProductControllerDeactivateProduct
     * @summary 브랜드메시지 상품 비활성화
     * @request POST:/v3/admin/brandmessage-product/:id/deactivate
     * @secure
     * @response `200` `AdminBrandMessageProductControllerDeactivateProductData` success
     */
    adminBrandMessageProductControllerDeactivateProduct: (id: any, params: RequestParams = {}) =>
      this.request<AdminBrandMessageProductControllerDeactivateProductData, any>({
        path: `/v3/admin/brandmessage-product/${id}/deactivate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메시지 상품 변경 이력 조회
     *
     * @tags V3-Admin-BrandMessageProduct
     * @name AdminBrandMessageProductControllerGetProductHistory
     * @summary 브랜드메시지 상품 변경 이력 조회
     * @request GET:/v3/admin/brandmessage-product/:id/history
     * @secure
     * @response `200` `AdminBrandMessageProductControllerGetProductHistoryData` success
     */
    adminBrandMessageProductControllerGetProductHistory: (id: any, params: RequestParams = {}) =>
      this.request<AdminBrandMessageProductControllerGetProductHistoryData, any>({
        path: `/v3/admin/brandmessage-product/${id}/history`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 나이스페이 무이자할부 정보 목록 조회
     *
     * @tags V3-Admin-NicePayments-CardBenefit
     * @name AdminNicePaymentsCardBenefitControllerGetCardBenefit
     * @summary 나이스페이 무이자할부 정보 목록 조회
     * @request GET:/v3/admin/nicepayments/card-benefit
     * @secure
     * @response `200` `AdminNicePaymentsCardBenefitControllerGetCardBenefitData` success
     */
    adminNicePaymentsCardBenefitControllerGetCardBenefit: (
      query: AdminNicePaymentsCardBenefitControllerGetCardBenefitParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminNicePaymentsCardBenefitControllerGetCardBenefitData, any>({
        path: `/v3/admin/nicepayments/card-benefit`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 나이스페이 무이자할부 정보 신규 등록 (yearMonth 중복 시 에러)
     *
     * @tags V3-Admin-NicePayments-CardBenefit
     * @name AdminNicePaymentsCardBenefitControllerCreateCardBenefit
     * @summary 나이스페이 무이자할부 정보 신규 등록
     * @request POST:/v3/admin/nicepayments/card-benefit
     * @secure
     * @response `200` `AdminNicePaymentsCardBenefitControllerCreateCardBenefitData` success
     */
    adminNicePaymentsCardBenefitControllerCreateCardBenefit: (params: RequestParams = {}) =>
      this.request<AdminNicePaymentsCardBenefitControllerCreateCardBenefitData, any>({
        path: `/v3/admin/nicepayments/card-benefit`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 나이스페이 무이자할부 정보 상세 조회
     *
     * @tags V3-Admin-NicePayments-CardBenefit
     * @name AdminNicePaymentsCardBenefitControllerGetCardBenefitDetail
     * @summary 나이스페이 무이자할부 정보 상세 조회
     * @request GET:/v3/admin/nicepayments/card-benefit/:id
     * @secure
     * @response `200` `AdminNicePaymentsCardBenefitControllerGetCardBenefitDetailData` success
     */
    adminNicePaymentsCardBenefitControllerGetCardBenefitDetail: (id: any, params: RequestParams = {}) =>
      this.request<AdminNicePaymentsCardBenefitControllerGetCardBenefitDetailData, any>({
        path: `/v3/admin/nicepayments/card-benefit/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 나이스페이 무이자할부 정보 수정 (content 만 변경, yearMonth 변경 불가)
     *
     * @tags V3-Admin-NicePayments-CardBenefit
     * @name AdminNicePaymentsCardBenefitControllerUpdateCardBenefit
     * @summary 나이스페이 무이자할부 정보 수정
     * @request PATCH:/v3/admin/nicepayments/card-benefit/:id
     * @secure
     * @response `200` `AdminNicePaymentsCardBenefitControllerUpdateCardBenefitData` success
     */
    adminNicePaymentsCardBenefitControllerUpdateCardBenefit: (id: any, params: RequestParams = {}) =>
      this.request<AdminNicePaymentsCardBenefitControllerUpdateCardBenefitData, any>({
        path: `/v3/admin/nicepayments/card-benefit/${id}`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Call Manager 트윌리오 수신 번호 리스트 조회 (AppSettings.phoneNumberMappings 기반)
     *
     * @tags V3-Admin-CallManager
     * @name AdminCallManagerControllerFindCallManagerIncomingPhoneNumbers
     * @summary 트윌리오 수신 번호 리스트
     * @request GET:/v3/admin/call-manager/incoming-phone-numbers
     * @secure
     * @response `200` `AdminCallManagerControllerFindCallManagerIncomingPhoneNumbersData` success
     */
    adminCallManagerControllerFindCallManagerIncomingPhoneNumbers: (
      query: AdminCallManagerControllerFindCallManagerIncomingPhoneNumbersParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminCallManagerControllerFindCallManagerIncomingPhoneNumbersData, any>({
        path: `/v3/admin/call-manager/incoming-phone-numbers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 번호 매핑 리스트 조회 (AppSettings.phoneNumberMappings)
     *
     * @tags V3-Admin-CallManager
     * @name AdminCallManagerControllerFindHospitalPhoneNumberMappings
     * @summary 병원 번호 매핑 리스트
     * @request GET:/v3/admin/hospital/phone-number-mappings
     * @secure
     * @response `200` `AdminCallManagerControllerFindHospitalPhoneNumberMappingsData` success
     */
    adminCallManagerControllerFindHospitalPhoneNumberMappings: (
      query: AdminCallManagerControllerFindHospitalPhoneNumberMappingsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminCallManagerControllerFindHospitalPhoneNumberMappingsData, any>({
        path: `/v3/admin/hospital/phone-number-mappings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 번호 매핑 생성 (AppSettings.phoneNumberMappings에 추가)
     *
     * @tags V3-Admin-CallManager
     * @name AdminCallManagerControllerCreateHospitalPhoneNumberMapping
     * @summary 병원 번호 매핑 생성
     * @request POST:/v3/admin/hospital/phone-number-mappings
     * @secure
     * @response `200` `AdminCallManagerControllerCreateHospitalPhoneNumberMappingData` success
     */
    adminCallManagerControllerCreateHospitalPhoneNumberMapping: (
      data: AdminCallManagerControllerCreateHospitalPhoneNumberMappingBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminCallManagerControllerCreateHospitalPhoneNumberMappingData, any>({
        path: `/v3/admin/hospital/phone-number-mappings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 번호 매핑 수정 (AppSettings.phoneNumberMappings 내 항목 수정)
     *
     * @tags V3-Admin-CallManager
     * @name AdminCallManagerControllerUpdateHospitalPhoneNumberMapping
     * @summary 병원 번호 매핑 수정
     * @request PUT:/v3/admin/hospital/phone-number-mappings
     * @secure
     * @response `200` `AdminCallManagerControllerUpdateHospitalPhoneNumberMappingData` success
     */
    adminCallManagerControllerUpdateHospitalPhoneNumberMapping: (
      data: AdminCallManagerControllerUpdateHospitalPhoneNumberMappingBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminCallManagerControllerUpdateHospitalPhoneNumberMappingData, any>({
        path: `/v3/admin/hospital/phone-number-mappings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 번호 매핑 삭제 (AppSettings.phoneNumberMappings에서 제거)
     *
     * @tags V3-Admin-CallManager
     * @name AdminCallManagerControllerDeleteHospitalPhoneNumberMapping
     * @summary 병원 번호 매핑 삭제
     * @request DELETE:/v3/admin/hospital/phone-number-mappings
     * @secure
     * @response `200` `AdminCallManagerControllerDeleteHospitalPhoneNumberMappingData` success
     */
    adminCallManagerControllerDeleteHospitalPhoneNumberMapping: (
      data: AdminCallManagerControllerDeleteHospitalPhoneNumberMappingBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminCallManagerControllerDeleteHospitalPhoneNumberMappingData, any>({
        path: `/v3/admin/hospital/phone-number-mappings`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 메디팔 AI 기능 설정 조회
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerGetHospitalSettings
     * @summary 병원별 메디팔 AI 기능 설정 조회
     * @request GET:/v3/admin/hospitals/:hospitalId/medipal-ai/settings
     * @secure
     * @response `200` `AdminMedipalAiControllerGetHospitalSettingsData` success
     */
    adminMedipalAiControllerGetHospitalSettings: (hospitalId: any, params: RequestParams = {}) =>
      this.request<AdminMedipalAiControllerGetHospitalSettingsData, any>({
        path: `/v3/admin/hospitals/${hospitalId}/medipal-ai/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 AI 예약 기능 사용 여부 조회
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerGetAiReservationStatus
     * @summary 병원별 AI 예약 기능 사용 여부 조회
     * @request GET:/v3/admin/hospitals/:hospitalId/medipal-ai/reservation-status
     * @secure
     * @response `200` `AdminMedipalAiControllerGetAiReservationStatusData` success
     */
    adminMedipalAiControllerGetAiReservationStatus: (hospitalId: any, params: RequestParams = {}) =>
      this.request<AdminMedipalAiControllerGetAiReservationStatusData, any>({
        path: `/v3/admin/hospitals/${hospitalId}/medipal-ai/reservation-status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 앱 구독 신청 이력 조회 (앱별 최신 1건)
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerGetSubscriptionHistories
     * @summary 병원별 앱 구독 신청 이력 조회
     * @request GET:/v3/admin/hospitals/:hospitalId/medipal-ai/subscription-histories
     * @secure
     * @response `200` `AdminMedipalAiControllerGetSubscriptionHistoriesData` success
     */
    adminMedipalAiControllerGetSubscriptionHistories: (hospitalId: any, params: RequestParams = {}) =>
      this.request<AdminMedipalAiControllerGetSubscriptionHistoriesData, any>({
        path: `/v3/admin/hospitals/${hospitalId}/medipal-ai/subscription-histories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 메디팔 AI 기능 사용 여부 저장
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerPatchHospitalSettings
     * @summary 병원별 메디팔 AI 기능 사용 여부 저장
     * @request PATCH:/v3/admin/hospitals/:hospitalId/medipal-ai/settings/:featureCode
     * @secure
     * @response `200` `AdminMedipalAiControllerPatchHospitalSettingsData` success
     */
    adminMedipalAiControllerPatchHospitalSettings: (
      hospitalId: any,
      featureCode: any,
      data: AdminMedipalAIControllerPatchHospitalSettingsBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerPatchHospitalSettingsData, any>({
        path: `/v3/admin/hospitals/${hospitalId}/medipal-ai/settings/${featureCode}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 AI 콜 매니저 인사말 설정 조회
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerGetHospitalCallManagerGreeting
     * @summary 병원별 AI 콜 매니저 인사말 설정 조회
     * @request GET:/v3/admin/hospitals/:hospitalId/medipal-ai/call-manager/greeting
     * @secure
     * @response `200` `AdminMedipalAiControllerGetHospitalCallManagerGreetingData` success
     */
    adminMedipalAiControllerGetHospitalCallManagerGreeting: (hospitalId: any, params: RequestParams = {}) =>
      this.request<AdminMedipalAiControllerGetHospitalCallManagerGreetingData, any>({
        path: `/v3/admin/hospitals/${hospitalId}/medipal-ai/call-manager/greeting`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 AI 콜 매니저 인사말 설정 저장
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerPutHospitalCallManagerGreeting
     * @summary 병원별 AI 콜 매니저 인사말 설정 저장
     * @request PUT:/v3/admin/hospitals/:hospitalId/medipal-ai/call-manager/greeting
     * @secure
     * @response `200` `AdminMedipalAiControllerPutHospitalCallManagerGreetingData` success
     */
    adminMedipalAiControllerPutHospitalCallManagerGreeting: (
      hospitalId: any,
      data: AdminMedipalAIControllerPutHospitalCallManagerGreetingBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerPutHospitalCallManagerGreetingData, any>({
        path: `/v3/admin/hospitals/${hospitalId}/medipal-ai/call-manager/greeting`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 AI 콜 매니저 번호 목록 조회
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerGetHospitalCallManagerPhones
     * @summary 병원별 AI 콜 매니저 번호 목록 조회
     * @request GET:/v3/admin/hospitals/:hospitalId/medipal-ai/call-manager/phones
     * @secure
     * @response `200` `AdminMedipalAiControllerGetHospitalCallManagerPhonesData` success
     */
    adminMedipalAiControllerGetHospitalCallManagerPhones: (hospitalId: any, params: RequestParams = {}) =>
      this.request<AdminMedipalAiControllerGetHospitalCallManagerPhonesData, any>({
        path: `/v3/admin/hospitals/${hospitalId}/medipal-ai/call-manager/phones`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 AI 콜 매니저 번호 생성
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerCreateHospitalCallManagerPhone
     * @summary 병원별 AI 콜 매니저 번호 생성
     * @request POST:/v3/admin/hospitals/:hospitalId/medipal-ai/call-manager/phones
     * @secure
     * @response `200` `AdminMedipalAiControllerCreateHospitalCallManagerPhoneData` success
     */
    adminMedipalAiControllerCreateHospitalCallManagerPhone: (
      hospitalId: any,
      data: AdminMedipalAIControllerCreateHospitalCallManagerPhoneBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerCreateHospitalCallManagerPhoneData, any>({
        path: `/v3/admin/hospitals/${hospitalId}/medipal-ai/call-manager/phones`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 AI 콜 매니저 번호 수정
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerUpdateHospitalCallManagerPhone
     * @summary 병원별 AI 콜 매니저 번호 수정
     * @request PUT:/v3/admin/hospitals/:hospitalId/medipal-ai/call-manager/phones/:mappingId
     * @secure
     * @response `200` `AdminMedipalAiControllerUpdateHospitalCallManagerPhoneData` success
     */
    adminMedipalAiControllerUpdateHospitalCallManagerPhone: (
      hospitalId: any,
      mappingId: any,
      data: AdminMedipalAIControllerUpdateHospitalCallManagerPhoneBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerUpdateHospitalCallManagerPhoneData, any>({
        path: `/v3/admin/hospitals/${hospitalId}/medipal-ai/call-manager/phones/${mappingId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 AI 콜 매니저 번호 삭제
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerDeleteHospitalCallManagerPhone
     * @summary 병원별 AI 콜 매니저 번호 삭제
     * @request DELETE:/v3/admin/hospitals/:hospitalId/medipal-ai/call-manager/phones/:mappingId
     * @secure
     * @response `200` `AdminMedipalAiControllerDeleteHospitalCallManagerPhoneData` success
     */
    adminMedipalAiControllerDeleteHospitalCallManagerPhone: (
      hospitalId: any,
      mappingId: any,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerDeleteHospitalCallManagerPhoneData, any>({
        path: `/v3/admin/hospitals/${hospitalId}/medipal-ai/call-manager/phones/${mappingId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 메디팔 AI 스토어 배너 목록 조회
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerFindStoreBanners
     * @summary 메디팔 AI 스토어 배너 목록 조회
     * @request GET:/v3/admin/medipal-ai/store-banners
     * @secure
     * @response `200` `AdminMedipalAiControllerFindStoreBannersData` success
     */
    adminMedipalAiControllerFindStoreBanners: (
      query: AdminMedipalAiControllerFindStoreBannersParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerFindStoreBannersData, any>({
        path: `/v3/admin/medipal-ai/store-banners`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 메디팔 AI 스토어 배너 생성
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerCreateStoreBanner
     * @summary 메디팔 AI 스토어 배너 생성
     * @request POST:/v3/admin/medipal-ai/store-banners
     * @secure
     * @response `200` `AdminMedipalAiControllerCreateStoreBannerData` success
     */
    adminMedipalAiControllerCreateStoreBanner: (
      data: AdminMedipalAIControllerCreateStoreBannerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerCreateStoreBannerData, any>({
        path: `/v3/admin/medipal-ai/store-banners`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 메디팔 AI 스토어 배너 상세 조회
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerFindStoreBanner
     * @summary 메디팔 AI 스토어 배너 상세 조회
     * @request GET:/v3/admin/medipal-ai/store-banners/:bannerId
     * @secure
     * @response `200` `AdminMedipalAiControllerFindStoreBannerData` success
     */
    adminMedipalAiControllerFindStoreBanner: (bannerId: any, params: RequestParams = {}) =>
      this.request<AdminMedipalAiControllerFindStoreBannerData, any>({
        path: `/v3/admin/medipal-ai/store-banners/${bannerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 메디팔 AI 스토어 배너 수정
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerUpdateStoreBanner
     * @summary 메디팔 AI 스토어 배너 수정
     * @request PUT:/v3/admin/medipal-ai/store-banners/:bannerId
     * @secure
     * @response `200` `AdminMedipalAiControllerUpdateStoreBannerData` success
     */
    adminMedipalAiControllerUpdateStoreBanner: (
      bannerId: any,
      data: AdminMedipalAIControllerUpdateStoreBannerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerUpdateStoreBannerData, any>({
        path: `/v3/admin/medipal-ai/store-banners/${bannerId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 메디팔 AI 스토어 배너 삭제
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerDeleteStoreBanner
     * @summary 메디팔 AI 스토어 배너 삭제
     * @request DELETE:/v3/admin/medipal-ai/store-banners/:bannerId
     * @secure
     * @response `200` `AdminMedipalAiControllerDeleteStoreBannerData` success
     */
    adminMedipalAiControllerDeleteStoreBanner: (bannerId: any, params: RequestParams = {}) =>
      this.request<AdminMedipalAiControllerDeleteStoreBannerData, any>({
        path: `/v3/admin/medipal-ai/store-banners/${bannerId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 기능 동작 횟수 보정 목록 조회
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerGetUsageWeights
     * @summary AI 기능 동작 횟수 보정 목록 조회
     * @request GET:/v3/admin/medipal-ai/usage-weights
     * @secure
     * @response `200` `AdminMedipalAiControllerGetUsageWeightsData` success
     */
    adminMedipalAiControllerGetUsageWeights: (
      query: AdminMedipalAiControllerGetUsageWeightsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerGetUsageWeightsData, any>({
        path: `/v3/admin/medipal-ai/usage-weights`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 기능 동작 횟수 보정 저장
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerUpdateUsageWeights
     * @summary AI 기능 동작 횟수 보정 저장
     * @request PUT:/v3/admin/medipal-ai/usage-weights
     * @secure
     * @response `200` `AdminMedipalAiControllerUpdateUsageWeightsData` success
     */
    adminMedipalAiControllerUpdateUsageWeights: (
      data: AdminMedipalAIControllerUpdateUsageWeightsBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerUpdateUsageWeightsData, any>({
        path: `/v3/admin/medipal-ai/usage-weights`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 할인 정책 목록 조회
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerFindDiscountPolicies
     * @summary 병원별 할인 정책 목록 조회
     * @request GET:/v3/admin/medipal-ai/discount-policies
     * @secure
     * @response `200` `AdminMedipalAiControllerFindDiscountPoliciesData` success
     */
    adminMedipalAiControllerFindDiscountPolicies: (
      query: AdminMedipalAiControllerFindDiscountPoliciesParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerFindDiscountPoliciesData, any>({
        path: `/v3/admin/medipal-ai/discount-policies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 할인 정책 생성
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerCreateDiscountPolicy
     * @summary 할인 정책 생성
     * @request POST:/v3/admin/medipal-ai/discount-policies
     * @secure
     * @response `200` `AdminMedipalAiControllerCreateDiscountPolicyData` success
     */
    adminMedipalAiControllerCreateDiscountPolicy: (
      data: AdminMedipalAIControllerCreateDiscountPolicyBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerCreateDiscountPolicyData, any>({
        path: `/v3/admin/medipal-ai/discount-policies`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 할인 정책 수정
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerUpdateDiscountPolicy
     * @summary 할인 정책 수정
     * @request PUT:/v3/admin/medipal-ai/discount-policies/:policyId
     * @secure
     * @response `200` `AdminMedipalAiControllerUpdateDiscountPolicyData` success
     */
    adminMedipalAiControllerUpdateDiscountPolicy: (
      policyId: any,
      data: AdminMedipalAIControllerUpdateDiscountPolicyBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerUpdateDiscountPolicyData, any>({
        path: `/v3/admin/medipal-ai/discount-policies/${policyId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 할인 정책 삭제
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerDeleteDiscountPolicy
     * @summary 할인 정책 삭제
     * @request DELETE:/v3/admin/medipal-ai/discount-policies/:policyId
     * @secure
     * @response `200` `AdminMedipalAiControllerDeleteDiscountPolicyData` success
     */
    adminMedipalAiControllerDeleteDiscountPolicy: (policyId: any, params: RequestParams = {}) =>
      this.request<AdminMedipalAiControllerDeleteDiscountPolicyData, any>({
        path: `/v3/admin/medipal-ai/discount-policies/${policyId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 사용량 가중치 설정 목록 조회 (기간별)
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerFindUsageWeightSettings
     * @summary AI 사용량 가중치 설정 목록 조회
     * @request GET:/v3/admin/medipal-ai/usage-weight-settings
     * @secure
     * @response `200` `AdminMedipalAiControllerFindUsageWeightSettingsData` success
     */
    adminMedipalAiControllerFindUsageWeightSettings: (
      query: AdminMedipalAiControllerFindUsageWeightSettingsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerFindUsageWeightSettingsData, any>({
        path: `/v3/admin/medipal-ai/usage-weight-settings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 사용량 가중치 설정 생성
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerCreateUsageWeightSetting
     * @summary AI 사용량 가중치 설정 생성
     * @request POST:/v3/admin/medipal-ai/usage-weight-settings
     * @secure
     * @response `200` `AdminMedipalAiControllerCreateUsageWeightSettingData` success
     */
    adminMedipalAiControllerCreateUsageWeightSetting: (
      data: AdminMedipalAIControllerCreateUsageWeightSettingBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerCreateUsageWeightSettingData, any>({
        path: `/v3/admin/medipal-ai/usage-weight-settings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 현재 시점에 적용 중인 AI 사용량 가중치 설정 조회
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerFindCurrentUsageWeightSetting
     * @summary 현재 적용 중인 AI 사용량 가중치 설정 조회
     * @request GET:/v3/admin/medipal-ai/usage-weight-settings/current
     * @secure
     * @response `200` `AdminMedipalAiControllerFindCurrentUsageWeightSettingData` success
     */
    adminMedipalAiControllerFindCurrentUsageWeightSetting: (params: RequestParams = {}) =>
      this.request<AdminMedipalAiControllerFindCurrentUsageWeightSettingData, any>({
        path: `/v3/admin/medipal-ai/usage-weight-settings/current`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 사용량 가중치 설정 수정
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerUpdateUsageWeightSetting
     * @summary AI 사용량 가중치 설정 수정
     * @request PATCH:/v3/admin/medipal-ai/usage-weight-settings/:settingId
     * @secure
     * @response `200` `AdminMedipalAiControllerUpdateUsageWeightSettingData` success
     */
    adminMedipalAiControllerUpdateUsageWeightSetting: (
      settingId: any,
      data: AdminMedipalAIControllerUpdateUsageWeightSettingBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMedipalAiControllerUpdateUsageWeightSettingData, any>({
        path: `/v3/admin/medipal-ai/usage-weight-settings/${settingId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 사용량 가중치 설정 삭제
     *
     * @tags V3-Admin-MedipalAI
     * @name AdminMedipalAiControllerDeleteUsageWeightSetting
     * @summary AI 사용량 가중치 설정 삭제
     * @request DELETE:/v3/admin/medipal-ai/usage-weight-settings/:settingId
     * @secure
     * @response `200` `AdminMedipalAiControllerDeleteUsageWeightSettingData` success
     */
    adminMedipalAiControllerDeleteUsageWeightSetting: (settingId: any, params: RequestParams = {}) =>
      this.request<AdminMedipalAiControllerDeleteUsageWeightSettingData, any>({
        path: `/v3/admin/medipal-ai/usage-weight-settings/${settingId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹 수
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerCount
     * @summary MSO 그룹 수 ts
     * @request GET:/v3/admin/msogroup/count
     * @secure
     * @response `200` `AdminMsoGroupControllerCountData` success
     */
    adminMsoGroupControllerCount: (query: AdminMsoGroupControllerCountParams, params: RequestParams = {}) =>
      this.request<AdminMsoGroupControllerCountData, any>({
        path: `/v3/admin/msogroup/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹 검색
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerFind
     * @summary MSO 그룹 검색 ts
     * @request GET:/v3/admin/msogroup/find
     * @secure
     * @response `200` `AdminMsoGroupControllerFindData` success
     */
    adminMsoGroupControllerFind: (query: AdminMsoGroupControllerFindParams, params: RequestParams = {}) =>
      this.request<AdminMsoGroupControllerFindData, any>({
        path: `/v3/admin/msogroup/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 MSO 그룹 조회
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerFindOne
     * @summary 단일 MSO 그룹 조회 ts
     * @request GET:/v3/admin/msogroup/find/one
     * @secure
     * @response `200` `AdminMsoGroupControllerFindOneData` success
     */
    adminMsoGroupControllerFindOne: (query: AdminMsoGroupControllerFindOneParams, params: RequestParams = {}) =>
      this.request<AdminMsoGroupControllerFindOneData, any>({
        path: `/v3/admin/msogroup/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 MSO 그룹 생성
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupController
     * @summary 단일 MSO 그룹 생성 ts
     * @request POST:/v3/admin/msogroup/create
     * @secure
     * @response `200` `AdminMsoGroupControllerData` success
     */
    adminMsoGroupController: (data: AdminMSOGroupControllerCreateBodyRequest, params: RequestParams = {}) =>
      this.request<AdminMsoGroupControllerData, any>({
        path: `/v3/admin/msogroup/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹 정보 수정
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerUpdate
     * @summary MSO 그룹 정보 수정 ts
     * @request PATCH:/v3/admin/msogroup/update
     * @secure
     * @response `200` `AdminMsoGroupControllerUpdateData` success
     */
    adminMsoGroupControllerUpdate: (data: AdminMSOGroupControllerUpdateBodyRequest, params: RequestParams = {}) =>
      this.request<AdminMsoGroupControllerUpdateData, any>({
        path: `/v3/admin/msogroup/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹에 병원 연결
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerConnectHospitals
     * @summary MSO 그룹에 병원 연결 ts
     * @request PATCH:/v3/admin/msogroup/connect/hospitals
     * @secure
     * @response `200` `AdminMsoGroupControllerConnectHospitalsData` success
     */
    adminMsoGroupControllerConnectHospitals: (
      data: AdminMSOGroupControllerConnectHospitalsBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMsoGroupControllerConnectHospitalsData, any>({
        path: `/v3/admin/msogroup/connect/hospitals`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹에서 병원 연결 해제
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerDisconnectHospitals
     * @summary MSO 그룹에서 병원 연결 해제 ts
     * @request PATCH:/v3/admin/msogroup/disconnect/hospitals
     * @secure
     * @response `200` `AdminMsoGroupControllerDisconnectHospitalsData` success
     */
    adminMsoGroupControllerDisconnectHospitals: (
      data: AdminMSOGroupControllerDisconnectHospitalsBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMsoGroupControllerDisconnectHospitalsData, any>({
        path: `/v3/admin/msogroup/disconnect/hospitals`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 연결 해제 시 기본 상담사가 0명이 될 병원 조회
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerPreflightDisconnectHospital
     * @summary 병원 연결 해제 예고 조회 ts
     * @request GET:/v3/admin/msogroup/preflight/disconnect-hospital
     * @secure
     * @response `200` `AdminMsoGroupControllerPreflightDisconnectHospitalData` success
     */
    adminMsoGroupControllerPreflightDisconnectHospital: (
      query: AdminMsoGroupControllerPreflightDisconnectHospitalParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminMsoGroupControllerPreflightDisconnectHospitalData, any>({
        path: `/v3/admin/msogroup/preflight/disconnect-hospital`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 그룹 삭제 시 기본 상담사가 0명이 될 병원 조회
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerPreflightRemoveGroup
     * @summary 그룹 삭제 예고 조회 ts
     * @request GET:/v3/admin/msogroup/preflight/remove-group
     * @secure
     * @response `200` `AdminMsoGroupControllerPreflightRemoveGroupData` success
     */
    adminMsoGroupControllerPreflightRemoveGroup: (
      query: AdminMsoGroupControllerPreflightRemoveGroupParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminMsoGroupControllerPreflightRemoveGroupData, any>({
        path: `/v3/admin/msogroup/preflight/remove-group`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 계정 삭제 시 기본 상담사가 0명이 될 병원 조회
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerPreflightRemoveAccount
     * @summary 계정 삭제 예고 조회 ts
     * @request GET:/v3/admin/msogroup/preflight/remove-account
     * @secure
     * @response `200` `AdminMsoGroupControllerPreflightRemoveAccountData` success
     */
    adminMsoGroupControllerPreflightRemoveAccount: (
      query: AdminMsoGroupControllerPreflightRemoveAccountParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminMsoGroupControllerPreflightRemoveAccountData, any>({
        path: `/v3/admin/msogroup/preflight/remove-account`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹 삭제
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerRemove
     * @summary MSO 그룹 삭제 ts
     * @request DELETE:/v3/admin/msogroup
     * @secure
     * @response `200` `AdminMsoGroupControllerRemoveData` success
     */
    adminMsoGroupControllerRemove: (query: AdminMsoGroupControllerRemoveParams, params: RequestParams = {}) =>
      this.request<AdminMsoGroupControllerRemoveData, any>({
        path: `/v3/admin/msogroup`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹 계정 생성
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerAccount
     * @summary MSO 그룹 계정 생성 ts
     * @request POST:/v3/admin/msogroup/account/create
     * @secure
     * @response `200` `AdminMsoGroupControllerAccountData` success
     */
    adminMsoGroupControllerAccount: (
      data: AdminMSOGroupControllerAccountCreateBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMsoGroupControllerAccountData, any>({
        path: `/v3/admin/msogroup/account/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹 계정 수정
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerAccountUpdate
     * @summary MSO 그룹 계정 수정 ts
     * @request PATCH:/v3/admin/msogroup/account/update
     * @secure
     * @response `200` `AdminMsoGroupControllerAccountUpdateData` success
     */
    adminMsoGroupControllerAccountUpdate: (
      data: AdminMSOGroupControllerAccountUpdateBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMsoGroupControllerAccountUpdateData, any>({
        path: `/v3/admin/msogroup/account/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹 계정 목록 조회
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerAccountFind
     * @summary MSO 그룹 계정 목록 조회 ts
     * @request GET:/v3/admin/msogroup/account/find
     * @secure
     * @response `200` `AdminMsoGroupControllerAccountFindData` success
     */
    adminMsoGroupControllerAccountFind: (query: AdminMsoGroupControllerAccountFindParams, params: RequestParams = {}) =>
      this.request<AdminMsoGroupControllerAccountFindData, any>({
        path: `/v3/admin/msogroup/account/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹 계정 삭제
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerAccountRemove
     * @summary MSO 그룹 계정 삭제 ts
     * @request DELETE:/v3/admin/msogroup/account/remove
     * @secure
     * @response `200` `AdminMsoGroupControllerAccountRemoveData` success
     */
    adminMsoGroupControllerAccountRemove: (
      query: AdminMsoGroupControllerAccountRemoveParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminMsoGroupControllerAccountRemoveData, any>({
        path: `/v3/admin/msogroup/account/remove`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹 권한 문서 조회 (없으면 MasterType 기반 지연 생성)
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerAuthorizationTypeFind
     * @summary MSO 그룹 권한 조회 ts
     * @request GET:/v3/admin/msogroup/authorization-type/find
     * @secure
     * @response `200` `AdminMsoGroupControllerAuthorizationTypeFindData` success
     */
    adminMsoGroupControllerAuthorizationTypeFind: (
      query: AdminMsoGroupControllerAuthorizationTypeFindParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminMsoGroupControllerAuthorizationTypeFindData, any>({
        path: `/v3/admin/msogroup/authorization-type/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹 권한 문서 수정 (없으면 MasterType 기반 지연 생성 후 수정)
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerAuthorizationTypeUpdate
     * @summary MSO 그룹 권한 수정 ts
     * @request PATCH:/v3/admin/msogroup/authorization-type/update
     * @secure
     * @response `200` `AdminMsoGroupControllerAuthorizationTypeUpdateData` success
     */
    adminMsoGroupControllerAuthorizationTypeUpdate: (
      data: AdminMSOGroupControllerAuthorizationTypeUpdateBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMsoGroupControllerAuthorizationTypeUpdateData, any>({
        path: `/v3/admin/msogroup/authorization-type/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO 그룹 서비스 상태 수정
     *
     * @tags V3-Admin-MSOGroup
     * @name AdminMsoGroupControllerUpdateServiceStatus
     * @summary MSO 그룹 서비스 상태 수정 ts
     * @request PATCH:/v3/admin/msogroup/update/servicestatus
     * @secure
     * @response `200` `AdminMsoGroupControllerUpdateServiceStatusData` success
     */
    adminMsoGroupControllerUpdateServiceStatus: (
      data: AdminMSOGroupControllerUpdateServiceStatusBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminMsoGroupControllerUpdateServiceStatusData, any>({
        path: `/v3/admin/msogroup/update/servicestatus`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 잘못 트리거된 고객등록 배치를 취소한다 (dev-tools 내부 전용).
     *
     * @tags V3-Admin-Patient
     * @name AdminPatientBatchCancelControllerCancelBulkRegistration
     * @summary 고객등록 배치 취소 (내부 전용)
     * @request POST:/v3/admin/patients/bulk-registration/cancel
     * @secure
     * @response `200` `AdminPatientBatchCancelControllerCancelBulkRegistrationData` 成功响应
     */
    adminPatientBatchCancelControllerCancelBulkRegistration: (params: RequestParams = {}) =>
      this.request<AdminPatientBatchCancelControllerCancelBulkRegistrationData, any>({
        path: `/v3/admin/patients/bulk-registration/cancel`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description 병원 수
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalCountHandler
     * @summary 병원 수 ts
     * @request GET:/v3/admin/hospitals/count
     * @secure
     * @response `200` `AdminHospitalCountHandlerData` success
     */
    adminHospitalCountHandler: (query: AdminHospitalCountHandlerParams, params: RequestParams = {}) =>
      this.request<AdminHospitalCountHandlerData, any>({
        path: `/v3/admin/hospitals/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 검색
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalFindHandler
     * @summary 병원 검색 ts
     * @request GET:/v3/admin/hospitals/find
     * @secure
     * @response `200` `AdminHospitalFindHandlerData` success
     */
    adminHospitalFindHandler: (query: AdminHospitalFindHandlerParams, params: RequestParams = {}) =>
      this.request<AdminHospitalFindHandlerData, any>({
        path: `/v3/admin/hospitals/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 병원 검색
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalFindOneHandler
     * @summary 단일 병원 검색 ts
     * @request GET:/v3/admin/hospitals/find/one
     * @secure
     * @response `200` `AdminHospitalFindOneHandlerData` success
     */
    adminHospitalFindOneHandler: (query: AdminHospitalFindOneHandlerParams, params: RequestParams = {}) =>
      this.request<AdminHospitalFindOneHandlerData, any>({
        path: `/v3/admin/hospitals/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 정보 수정
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalUpdateHandler
     * @summary 병원 정보 수정 ts
     * @request PATCH:/v3/admin/hospitals/update
     * @secure
     * @response `200` `AdminHospitalUpdateHandlerData` success
     */
    adminHospitalUpdateHandler: (data: AdminHospitalUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminHospitalUpdateHandlerData, any>({
        path: `/v3/admin/hospitals/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 병원 생성
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalCreateHandler
     * @summary 단일 병원 생성 ts
     * @request POST:/v3/admin/hospitals/create
     * @secure
     * @response `200` `AdminHospitalCreateHandlerData` success
     */
    adminHospitalCreateHandler: (data: AdminHospitalCreateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminHospitalCreateHandlerData, any>({
        path: `/v3/admin/hospitals/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 정보 - 사업자등록증 내 상호명 수정
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalUpdateNameHandler
     * @summary 병원 정보 - 사업자등록증 내 상호명 수정 ts
     * @request PATCH:/v3/admin/hospitals/update/name
     * @secure
     * @response `200` `AdminHospitalUpdateNameHandlerData` success
     */
    adminHospitalUpdateNameHandler: (data: AdminHospitalUpdateNameHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminHospitalUpdateNameHandlerData, any>({
        path: `/v3/admin/hospitals/update/name`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 정보 - 문자 발송번호 수정 및 문자메시지 비즈뿌리오 발송 적용
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalUpdateSmsPhoneHandler
     * @summary 병원 정보 - 문자 발송번호 수정 및 문자메시지 비즈뿌리오 발송 적용ts
     * @request PATCH:/v3/admin/hospitals/update/smsphone
     * @secure
     * @response `200` `AdminHospitalUpdateSmsPhoneHandlerData` success
     */
    adminHospitalUpdateSmsPhoneHandler: (
      data: AdminHospitalUpdateSMSPhoneHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminHospitalUpdateSmsPhoneHandlerData, any>({
        path: `/v3/admin/hospitals/update/smsphone`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 서비스 생성 및 메시지 발송, 이용중단 테스트
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalTestHServiceSmsFlowHandler
     * @summary 병원 서비스 생성 및 메시지 발송, 이용중단 테스트 ts
     * @request POST:/v3/admin/hospitals/test/hservice-sms-flow
     * @secure
     * @response `200` `AdminHospitalTestHServiceSmsFlowHandlerData` success
     */
    adminHospitalTestHServiceSmsFlowHandler: (
      data: AdminHospitalTestHServiceSMSFlowHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminHospitalTestHServiceSmsFlowHandlerData, any>({
        path: `/v3/admin/hospitals/test/hservice-sms-flow`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 문자 발송 현황 검색
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalSmsStatusFindHandler
     * @summary 병원별 문자 발송 현황 검색 ts
     * @request GET:/v3/admin/hospitals/sms-status/find
     * @secure
     * @response `200` `AdminHospitalSmsStatusFindHandlerData` success
     */
    adminHospitalSmsStatusFindHandler: (query: AdminHospitalSmsStatusFindHandlerParams, params: RequestParams = {}) =>
      this.request<AdminHospitalSmsStatusFindHandlerData, any>({
        path: `/v3/admin/hospitals/sms-status/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 문자 발송 현황 총 개수
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalSmsStatusCountHandler
     * @summary 병원별 문자 발송 현황 총 개수 ts
     * @request GET:/v3/admin/hospitals/sms-status/count
     * @secure
     * @response `200` `AdminHospitalSmsStatusCountHandlerData` success
     */
    adminHospitalSmsStatusCountHandler: (query: AdminHospitalSmsStatusCountHandlerParams, params: RequestParams = {}) =>
      this.request<AdminHospitalSmsStatusCountHandlerData, any>({
        path: `/v3/admin/hospitals/sms-status/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 문자(SMS/LMS/MMS) 발송 차단 / 해제
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalUpdateSmsBlockHandler
     * @summary 병원별 문자 발송 차단 / 해제 ts
     * @request PATCH:/v3/admin/hospitals/sms-block
     * @secure
     * @response `200` `AdminHospitalUpdateSmsBlockHandlerData` success
     */
    adminHospitalUpdateSmsBlockHandler: (
      data: AdminHospitalUpdateSMSBlockHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminHospitalUpdateSmsBlockHandlerData, any>({
        path: `/v3/admin/hospitals/sms-block`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 설정 수
     *
     * @tags V3-Admin-ServiceSetting
     * @name AdminServiceSettingCountHandler
     * @summary 병원 설정 수 ts
     * @request GET:/v3/admin/servicesetting/count
     * @secure
     * @response `200` `AdminServiceSettingCountHandlerData` success
     */
    adminServiceSettingCountHandler: (query: AdminServiceSettingCountHandlerParams, params: RequestParams = {}) =>
      this.request<AdminServiceSettingCountHandlerData, any>({
        path: `/v3/admin/servicesetting/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 설정 검색
     *
     * @tags V3-Admin-ServiceSetting
     * @name AdminServiceSettingFindHandler
     * @summary 병원 설정 검색 ts
     * @request GET:/v3/admin/servicesetting/find
     * @secure
     * @response `200` `AdminServiceSettingFindHandlerData` success
     */
    adminServiceSettingFindHandler: (query: AdminServiceSettingFindHandlerParams, params: RequestParams = {}) =>
      this.request<AdminServiceSettingFindHandlerData, any>({
        path: `/v3/admin/servicesetting/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 설정 검색
     *
     * @tags V3-Admin-ServiceSetting
     * @name AdminServiceSettingFindOneHandler
     * @summary 병원 설정 검색 ts
     * @request GET:/v3/admin/servicesetting/find/one
     * @secure
     * @response `200` `AdminServiceSettingFindOneHandlerData` success
     */
    adminServiceSettingFindOneHandler: (query: AdminServiceSettingFindOneHandlerParams, params: RequestParams = {}) =>
      this.request<AdminServiceSettingFindOneHandlerData, any>({
        path: `/v3/admin/servicesetting/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 서비스 정보 생성
     *
     * @tags V3-Admin-ServiceSetting
     * @name AdminServiceSettingCreateHandler
     * @summary 병원 서비스 정보 생성 ts
     * @request POST:/v3/admin/servicesetting/create
     * @secure
     * @response `200` `AdminServiceSettingCreateHandlerData` success
     */
    adminServiceSettingCreateHandler: (data: AdminServiceSettingCreateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminServiceSettingCreateHandlerData, any>({
        path: `/v3/admin/servicesetting/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 서비스 정보 수정
     *
     * @tags V3-Admin-ServiceSetting
     * @name AdminServiceSettingUpdateHandler
     * @summary 병원 서비스 정보 수정 ts
     * @request PATCH:/v3/admin/servicesetting/update
     * @secure
     * @response `200` `AdminServiceSettingUpdateHandlerData` success
     */
    adminServiceSettingUpdateHandler: (data: AdminServiceSettingUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminServiceSettingUpdateHandlerData, any>({
        path: `/v3/admin/servicesetting/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 서비스 정보 삭제
     *
     * @tags V3-Admin-ServiceSetting
     * @name AdminServiceSettingRemoveHandler
     * @summary 병원 서비스 정보 삭제 ts
     * @request DELETE:/v3/admin/servicesetting/remove
     * @secure
     * @response `200` `AdminServiceSettingRemoveHandlerData` success
     */
    adminServiceSettingRemoveHandler: (data: AdminServiceSettingRemoveHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminServiceSettingRemoveHandlerData, any>({
        path: `/v3/admin/servicesetting/remove`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ServiceSetting 계정 수 변경
     *
     * @tags V3-Admin-ServiceSetting
     * @name AdminServiceSettingAccountUpdateHandler
     * @summary ServiceSetting 계정 수 변경 ts
     * @request PATCH:/v3/admin/servicesetting/account/update
     * @secure
     * @response `200` `AdminServiceSettingAccountUpdateHandlerData` success
     */
    adminServiceSettingAccountUpdateHandler: (
      data: AdminServiceSettingAccountUpdateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminServiceSettingAccountUpdateHandlerData, any>({
        path: `/v3/admin/servicesetting/account/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ServiceSetting 기본 채팅담당자 변경
     *
     * @tags V3-Admin-ServiceSetting
     * @name AdminServiceSettingDefaultCounselorUpdateHandler
     * @summary ServiceSetting 기본 채팅담당자 변경 ts
     * @request PATCH:/v3/admin/servicesetting/defaultcounselor/update
     * @secure
     * @response `200` `AdminServiceSettingDefaultCounselorUpdateHandlerData` success
     */
    adminServiceSettingDefaultCounselorUpdateHandler: (
      data: AdminServiceSettingDefaultCounselorUpdateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminServiceSettingDefaultCounselorUpdateHandlerData, any>({
        path: `/v3/admin/servicesetting/defaultcounselor/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 건강 콘텐츠 카테고리 검색
     *
     * @tags V3-Admin-HealthContent
     * @name AdminHealthContentCategoryFindHandler
     * @summary 건강 콘텐츠 카테고리 검색 ts
     * @request GET:/v3/admin/healthcontent/category/find
     * @secure
     * @response `200` `AdminHealthContentCategoryFindHandlerData` success
     */
    adminHealthContentCategoryFindHandler: (params: RequestParams = {}) =>
      this.request<AdminHealthContentCategoryFindHandlerData, any>({
        path: `/v3/admin/healthcontent/category/find`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 서비스 매니저 조회
     *
     * @tags V3-Admin-User-Nurse
     * @name AdminUserNurseFindHandler
     * @summary 서비스 매니저 조회 ts
     * @request GET:/v3/admin/user/nurse/find
     * @secure
     * @response `200` `AdminUserNurseFindHandlerData` success
     */
    adminUserNurseFindHandler: (query: AdminUserNurseFindHandlerParams, params: RequestParams = {}) =>
      this.request<AdminUserNurseFindHandlerData, any>({
        path: `/v3/admin/user/nurse/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin User 모델 수 조회
     *
     * @tags V3-Admin-AdminUser
     * @name AdminUserCountHandler
     * @summary Admin User 모델 수 조회 ts
     * @request GET:/v3/admin/adminuser/count
     * @secure
     * @response `200` `AdminUserCountHandlerData` success
     */
    adminUserCountHandler: (query: AdminUserCountHandlerParams, params: RequestParams = {}) =>
      this.request<AdminUserCountHandlerData, any>({
        path: `/v3/admin/adminuser/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin User 모델 조회
     *
     * @tags V3-Admin-AdminUser
     * @name AdminUserFindHandler
     * @summary Admin User 모델 조회 ts
     * @request GET:/v3/admin/adminuser
     * @secure
     * @response `200` `AdminUserFindHandlerData` success
     */
    adminUserFindHandler: (query: AdminUserFindHandlerParams, params: RequestParams = {}) =>
      this.request<AdminUserFindHandlerData, any>({
        path: `/v3/admin/adminuser`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin User 단일 모델 생성
     *
     * @tags V3-Admin-AdminUser
     * @name AdminUserCreateHandler
     * @summary Admin User 단일 모델 생성 ts
     * @request POST:/v3/admin/adminuser
     * @secure
     * @response `200` `AdminUserCreateHandlerData` success
     */
    adminUserCreateHandler: (query: AdminUserCreateHandlerParams, params: RequestParams = {}) =>
      this.request<AdminUserCreateHandlerData, any>({
        path: `/v3/admin/adminuser`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin User 단일 모델 수정
     *
     * @tags V3-Admin-AdminUser
     * @name AdminUserUpdateHandler
     * @summary Admin User 단일 모델 수정 ts
     * @request PATCH:/v3/admin/adminuser
     * @secure
     * @response `200` `AdminUserUpdateHandlerData` success
     */
    adminUserUpdateHandler: (query: AdminUserUpdateHandlerParams, params: RequestParams = {}) =>
      this.request<AdminUserUpdateHandlerData, any>({
        path: `/v3/admin/adminuser`,
        method: "PATCH",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin User 단일 모델 삭제
     *
     * @tags V3-Admin-AdminUser
     * @name AdminUserRemoveHandler
     * @summary Admin User 단일 모델 삭제 ts
     * @request DELETE:/v3/admin/adminuser
     * @secure
     * @response `200` `AdminUserRemoveHandlerData` success
     */
    adminUserRemoveHandler: (query: AdminUserRemoveHandlerParams, params: RequestParams = {}) =>
      this.request<AdminUserRemoveHandlerData, any>({
        path: `/v3/admin/adminuser`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin User 단일 모델 조회
     *
     * @tags V3-Admin-AdminUser
     * @name AdminUserFindOneHandler
     * @summary Admin User 단일 모델 조회 ts
     * @request GET:/v3/admin/adminuser/one
     * @secure
     * @response `200` `AdminUserFindOneHandlerData` success
     */
    adminUserFindOneHandler: (query: AdminUserFindOneHandlerParams, params: RequestParams = {}) =>
      this.request<AdminUserFindOneHandlerData, any>({
        path: `/v3/admin/adminuser/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AnsweringChatSetting 모델 생성
     *
     * @tags V3-Admin-AnsweringChatSetting
     * @name AdminAnsweringChatSettingCreateHandler
     * @summary AnsweringChatSetting 모델 생성 ts
     * @request POST:/v3/admin/answeringchatsetting/create
     * @secure
     * @response `200` `AdminAnsweringChatSettingCreateHandlerData` success
     */
    adminAnsweringChatSettingCreateHandler: (
      data: AdminAnsweringChatSettingCreateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminAnsweringChatSettingCreateHandlerData, any>({
        path: `/v3/admin/answeringchatsetting/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description AnsweringChatSetting 모델 수정
     *
     * @tags V3-Admin-AnsweringChatSetting
     * @name AdminAnsweringChatSettingUpdateHandler
     * @summary AnsweringChatSetting 모델 수정 ts
     * @request PATCH:/v3/admin/answeringchatsetting/update
     * @secure
     * @response `200` `AdminAnsweringChatSettingUpdateHandlerData` success
     */
    adminAnsweringChatSettingUpdateHandler: (
      data: AdminAnsweringChatSettingUpdateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminAnsweringChatSettingUpdateHandlerData, any>({
        path: `/v3/admin/answeringchatsetting/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description AnsweringChatSetting 모델 찾기
     *
     * @tags V3-Admin-AnsweringChatSetting
     * @name AdminAnsweringChatSettingFindOneHandler
     * @summary AnsweringChatSetting 모델 찾기 ts
     * @request GET:/v3/admin/answeringchatsetting/find/one
     * @secure
     * @response `200` `AdminAnsweringChatSettingFindOneHandlerData` success
     */
    adminAnsweringChatSettingFindOneHandler: (
      query: AdminAnsweringChatSettingFindOneHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminAnsweringChatSettingFindOneHandlerData, any>({
        path: `/v3/admin/answeringchatsetting/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 비디오 컨텐츠 카테고리 검색
     *
     * @tags V3-Admin-VideoContent
     * @name AdminVideoContentCategoryFindHandler
     * @summary 비디오 컨텐츠 카테고리 검색 ts
     * @request GET:/v3/admin/videocontent/category/find
     * @secure
     * @response `200` `AdminVideoContentCategoryFindHandlerData` success
     */
    adminVideoContentCategoryFindHandler: (
      query: AdminVideoContentCategoryFindHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminVideoContentCategoryFindHandlerData, any>({
        path: `/v3/admin/videocontent/category/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 비디오 컨텐츠 카테고리 단일 검색
     *
     * @tags V3-Admin-VideoContent
     * @name AdminVideoContentCategoryFindOneHandler
     * @summary 비디오 컨텐츠 카테고리 단일 검색 ts
     * @request GET:/v3/admin/videocontent/category/find/one
     * @secure
     * @response `200` `AdminVideoContentCategoryFindOneHandlerData` success
     */
    adminVideoContentCategoryFindOneHandler: (
      query: AdminVideoContentCategoryFindOneHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminVideoContentCategoryFindOneHandlerData, any>({
        path: `/v3/admin/videocontent/category/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 연동 설정 단일 검색
     *
     * @tags V3-Admin-IntegrationSetting
     * @name AdminIntegrationSettingFindOneHandler
     * @summary 병원 연동 설정 단일 검색 ts
     * @request GET:/v3/admin/integrationsetting/find/one
     * @secure
     * @response `200` `AdminIntegrationSettingFindOneHandlerData` success
     */
    adminIntegrationSettingFindOneHandler: (
      query: AdminIntegrationSettingFindOneHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminIntegrationSettingFindOneHandlerData, any>({
        path: `/v3/admin/integrationsetting/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 연동 설정 추가/수정
     *
     * @tags V3-Admin-IntegrationSetting
     * @name AdminIntegrationSettingUpsertHandler
     * @summary 병원 연동 설정 추가/수정 ts
     * @request POST:/v3/admin/integrationsetting/upsert
     * @secure
     * @response `200` `AdminIntegrationSettingUpsertHandlerData` success
     */
    adminIntegrationSettingUpsertHandler: (
      data: AdminIntegrationSettingUpsertHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminIntegrationSettingUpsertHandlerData, any>({
        path: `/v3/admin/integrationsetting/upsert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 내 계정 수
     *
     * @tags V3-Admin-HospitalAccount
     * @name AdminHospitalAccountCountHandler
     * @summary 병원 내 계정 수 ts
     * @request GET:/v3/admin/hospitalaccount/count
     * @secure
     * @response `200` `AdminHospitalAccountCountHandlerData` success
     */
    adminHospitalAccountCountHandler: (query: AdminHospitalAccountCountHandlerParams, params: RequestParams = {}) =>
      this.request<AdminHospitalAccountCountHandlerData, any>({
        path: `/v3/admin/hospitalaccount/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 내 계정 조회
     *
     * @tags V3-Admin-HospitalAccount
     * @name AdminHospitalDoctorFindHandler
     * @summary 병원 내 계정 조회 ts
     * @request GET:/v3/admin/hospitalaccount/find
     * @secure
     * @response `200` `AdminHospitalDoctorFindHandlerData` success
     */
    adminHospitalDoctorFindHandler: (query: AdminHospitalDoctorFindHandlerParams, params: RequestParams = {}) =>
      this.request<AdminHospitalDoctorFindHandlerData, any>({
        path: `/v3/admin/hospitalaccount/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 병원계정 생성
     *
     * @tags V3-Admin-HospitalAccount
     * @name AdminHospitalAccountCreateHandler
     * @summary 단일 병원 생성 ts
     * @request POST:/v3/admin/hospitalaccount/create
     * @secure
     * @response `200` `AdminHospitalAccountCreateHandlerData` success
     */
    adminHospitalAccountCreateHandler: (
      data: AdminHospitalAccountCreateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminHospitalAccountCreateHandlerData, any>({
        path: `/v3/admin/hospitalaccount/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 병원계정 수정
     *
     * @tags V3-Admin-HospitalAccount
     * @name AdminHospitalAccountUpdateHandler
     * @summary 단일 병원 수정 ts
     * @request PATCH:/v3/admin/hospitalaccount/update
     * @secure
     * @response `200` `AdminHospitalAccountUpdateHandlerData` success
     */
    adminHospitalAccountUpdateHandler: (
      data: AdminHospitalAccountUpdateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminHospitalAccountUpdateHandlerData, any>({
        path: `/v3/admin/hospitalaccount/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 병원계정 삭제
     *
     * @tags V3-Admin-HospitalAccount
     * @name AdminHospitalAccountRemoveHandler
     * @summary 단일 병원 삭제 ts
     * @request DELETE:/v3/admin/hospitalaccount/remove
     * @secure
     * @response `200` `AdminHospitalAccountRemoveHandlerData` success
     */
    adminHospitalAccountRemoveHandler: (query: AdminHospitalAccountRemoveHandlerParams, params: RequestParams = {}) =>
      this.request<AdminHospitalAccountRemoveHandlerData, any>({
        path: `/v3/admin/hospitalaccount/remove`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 내 계정 설정 변경내역 수
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalAccountSettingHistoryCountHandler
     * @summary 병원 내 계정 설정 변경내역 수 ts
     * @request GET:/v3/admin/hospitalaccount/history/count
     * @secure
     * @response `200` `AdminHospitalAccountSettingHistoryCountHandlerData` success
     */
    adminHospitalAccountSettingHistoryCountHandler: (
      query: AdminHospitalAccountSettingHistoryCountHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHospitalAccountSettingHistoryCountHandlerData, any>({
        path: `/v3/admin/hospitalaccount/history/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 내 계정 설정 변경내역 조회
     *
     * @tags V3-Admin-Hospital
     * @name AdminHospitalAccountSettingHistoryFindHandler
     * @summary 병원 내 계정 설정 변경내역 조회 ts
     * @request GET:/v3/admin/hospitalaccount/history/find
     * @secure
     * @response `200` `AdminHospitalAccountSettingHistoryFindHandlerData` success
     */
    adminHospitalAccountSettingHistoryFindHandler: (
      query: AdminHospitalAccountSettingHistoryFindHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHospitalAccountSettingHistoryFindHandlerData, any>({
        path: `/v3/admin/hospitalaccount/history/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 치료태그 메뉴얼 수
     *
     * @tags V3-Admin-TreatmentCategory
     * @name AdminTreatmentCategoryCountHandler
     * @summary 치료태그 메뉴얼 수 ts
     * @request GET:/v3/admin/treatmentcategory/count
     * @secure
     * @response `200` `AdminTreatmentCategoryCountHandlerData` success
     */
    adminTreatmentCategoryCountHandler: (query: AdminTreatmentCategoryCountHandlerParams, params: RequestParams = {}) =>
      this.request<AdminTreatmentCategoryCountHandlerData, any>({
        path: `/v3/admin/treatmentcategory/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 치료태그 메뉴얼 생성
     *
     * @tags V3-Admin-TreatmentCategory
     * @name AdminTreatmentCategoryCreateHandler
     * @summary 치료태그 메뉴얼 생성 ts
     * @request POST:/v3/admin/treatmentcategory/Create
     * @secure
     * @response `200` `AdminTreatmentCategoryCreateHandlerData` success
     */
    adminTreatmentCategoryCreateHandler: (
      data: AdminTreatmentCategoryCreateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminTreatmentCategoryCreateHandlerData, any>({
        path: `/v3/admin/treatmentcategory/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 치료태그 메뉴얼 조회
     *
     * @tags V3-Admin-TreatmentCategory
     * @name AdminTreatmentCategoryFindHandler
     * @summary 치료태그 메뉴얼 조회 ts
     * @request GET:/v3/admin/treatmentcategory/find
     * @secure
     * @response `200` `AdminTreatmentCategoryFindHandlerData` success
     */
    adminTreatmentCategoryFindHandler: (query: AdminTreatmentCategoryFindHandlerParams, params: RequestParams = {}) =>
      this.request<AdminTreatmentCategoryFindHandlerData, any>({
        path: `/v3/admin/treatmentcategory/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 치료태그 메뉴얼 조회
     *
     * @tags V3-Admin-TreatmentCategory
     * @name AdminTreatmentCategoryFindOneHandler
     * @summary 치료태그 메뉴얼 조회 ts
     * @request GET:/v3/admin/treatmentcategory/find/one
     * @secure
     * @response `200` `AdminTreatmentCategoryFindOneHandlerData` success
     */
    adminTreatmentCategoryFindOneHandler: (
      query: AdminTreatmentCategoryFindOneHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminTreatmentCategoryFindOneHandlerData, any>({
        path: `/v3/admin/treatmentcategory/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 치료태그 메뉴얼 수정
     *
     * @tags V3-Admin-TreatmentCategory
     * @name AdminTreatmentCategoryRemoveHandler
     * @summary 치료태그 메뉴얼 수정 ts
     * @request PATCH:/v3/admin/treatmentcategory/remove
     * @secure
     * @response `200` `AdminTreatmentCategoryRemoveHandlerData` success
     */
    adminTreatmentCategoryRemoveHandler: (
      data: AdminTreatmentCategoryRemoveHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminTreatmentCategoryRemoveHandlerData, any>({
        path: `/v3/admin/treatmentcategory/remove`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 치료태그 메뉴얼 수정
     *
     * @tags V3-Admin-TreatmentCategory
     * @name AdminTreatmentCategoryUpdateHandler
     * @summary 치료태그 메뉴얼 수정 ts
     * @request PATCH:/v3/admin/treatmentcategory/update
     * @secure
     * @response `200` `AdminTreatmentCategoryUpdateHandlerData` success
     */
    adminTreatmentCategoryUpdateHandler: (
      data: AdminTreatmentCategoryUpdateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminTreatmentCategoryUpdateHandlerData, any>({
        path: `/v3/admin/treatmentcategory/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 치료태그 메뉴얼 복사
     *
     * @tags V3-Admin-TreatmentCategory
     * @name AdminTreatmentCategoryCopyHandler
     * @summary 치료태그 메뉴얼 복사 ts
     * @request POST:/v3/admin/treatmentcategory/copy
     * @secure
     * @response `200` `AdminTreatmentCategoryCopyHandlerData` success
     */
    adminTreatmentCategoryCopyHandler: (
      data: AdminTreatmentCategoryCopyHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminTreatmentCategoryCopyHandlerData, any>({
        path: `/v3/admin/treatmentcategory/copy`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 파일 콘텐츠 정보를 생성합니다.
     *
     * @tags V3-Admin-File
     * @name AdminFileCreateHandler
     * @summary 단일 파일 콘텐츠 정보 생성
     * @request POST:/v3/admin/file
     * @secure
     * @response `200` `AdminFileCreateHandlerData` success
     */
    adminFileCreateHandler: (data: AdminFileCreateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminFileCreateHandlerData, any>({
        path: `/v3/admin/file`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 파일 id 내부 콘텐츠 정보를 부분 수정합니다.
     *
     * @tags V3-Admin-File
     * @name AdminFileUpdateHandler
     * @summary 단일 파일 내부 콘텐츠 정보 부분 수정
     * @request PATCH:/v3/admin/file
     * @secure
     * @response `200` `AdminFileUpdateHandlerData` success
     */
    adminFileUpdateHandler: (data: AdminFileUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminFileUpdateHandlerData, any>({
        path: `/v3/admin/file`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 파일 콘텐츠 정보를 조회합니다.
     *
     * @tags V3-Admin-File
     * @name AdminFileFindOneHandler
     * @summary 단일 파일 콘텐츠 정보 조회 ts
     * @request GET:/v3/admin/file
     * @secure
     * @response `200` `AdminFileFindOneHandlerData` success
     */
    adminFileFindOneHandler: (query: AdminFileFindOneHandlerParams, params: RequestParams = {}) =>
      this.request<AdminFileFindOneHandlerData, any>({
        path: `/v3/admin/file`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 국가코드 콘텐츠 정보를 조회합니다.
     *
     * @tags V3-Admin-Country
     * @name AdminCountryFindHandler
     * @summary 국가코드 콘텐츠 정보 조회
     * @request GET:/v3/admin/country
     * @secure
     * @response `200` `AdminCountryFindHandlerData` success
     */
    adminCountryFindHandler: (query: AdminCountryFindHandlerParams, params: RequestParams = {}) =>
      this.request<AdminCountryFindHandlerData, any>({
        path: `/v3/admin/country`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 국가코드 콘텐츠 정보를 수정합니다.
     *
     * @tags V3-Admin-Country
     * @name AdminCountryUpdateHandler
     * @summary 국가코드 콘텐츠 정보 수정
     * @request PATCH:/v3/admin/country
     * @secure
     * @response `200` `AdminCountryUpdateHandlerData` success
     */
    adminCountryUpdateHandler: (data: AdminCountryUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminCountryUpdateHandlerData, any>({
        path: `/v3/admin/country`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 프로필 수
     *
     * @tags V3-Admin-KakaoLinkageHistory
     * @name KakaoLinkageHistoryCountHandler
     * @summary 카카오 연동 프로필 수 ts
     * @request GET:/v3/admin/kakaolinkagehistory/count
     * @secure
     * @response `200` `KakaoLinkageHistoryCountHandlerData` success
     */
    kakaoLinkageHistoryCountHandler: (query: KakaoLinkageHistoryCountHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoLinkageHistoryCountHandlerData, any>({
        path: `/v3/admin/kakaolinkagehistory/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 프로필 조회
     *
     * @tags V3-Admin-KakaoLinkageHistory
     * @name KakaoLinkageHistoryFindHandler
     * @summary 카카오 연동 프로필 조회 ts
     * @request GET:/v3/admin/kakaolinkagehistory
     * @secure
     * @response `200` `KakaoLinkageHistoryFindHandlerData` success
     */
    kakaoLinkageHistoryFindHandler: (query: KakaoLinkageHistoryFindHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoLinkageHistoryFindHandlerData, any>({
        path: `/v3/admin/kakaolinkagehistory`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 프로필 디테일
     *
     * @tags V3-Admin-KakaoLinkageHistory
     * @name KakaoLinkageHistoryDetailHandler
     * @summary 카카오 연동 프로필 디테일 ts
     * @request GET:/v3/admin/kakaolinkagehistory/detail
     * @secure
     * @response `200` `KakaoLinkageHistoryDetailHandlerData` success
     */
    kakaoLinkageHistoryDetailHandler: (query: KakaoLinkageHistoryDetailHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoLinkageHistoryDetailHandlerData, any>({
        path: `/v3/admin/kakaolinkagehistory/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 프로필 수정
     *
     * @tags V3-Admin-KakaoLinkageHistory
     * @name KakaoLinkageHistoryUpdateHandler
     * @summary 카카오 연동 프로필 수정 ts
     * @request PATCH:/v3/admin/kakaolinkagehistory/update
     * @secure
     * @response `200` `KakaoLinkageHistoryUpdateHandlerData` success
     */
    kakaoLinkageHistoryUpdateHandler: (data: KakaoLinkageHistoryUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<KakaoLinkageHistoryUpdateHandlerData, any>({
        path: `/v3/admin/kakaolinkagehistory/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 프로필 해제
     *
     * @tags V3-Admin-KakaoLinkageHistory
     * @name KakaoLinkageHistoryClearHandler
     * @summary 카카오 연동 프로필 해제 ts
     * @request DELETE:/v3/admin/kakaolinkagehistory/clear
     * @secure
     * @response `200` `KakaoLinkageHistoryClearHandlerData` success
     */
    kakaoLinkageHistoryClearHandler: (query: KakaoLinkageHistoryClearHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoLinkageHistoryClearHandlerData, any>({
        path: `/v3/admin/kakaolinkagehistory/clear`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 활성화
     *
     * @tags V3-Admin-KakaoLinkageHistory
     * @name KakaoLinkageHistoryActivateHandler
     * @summary 카카오 연동 활성화 ts
     * @request POST:/v3/admin/kakaolinkagehistory/activate
     * @secure
     * @response `200` `KakaoLinkageHistoryActivateHandlerData` success
     */
    kakaoLinkageHistoryActivateHandler: (
      data: KakaoLinkageHistoryActivateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoLinkageHistoryActivateHandlerData, any>({
        path: `/v3/admin/kakaolinkagehistory/activate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 프로필 그룹 조회
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateFindGroupHandler
     * @summary 카카오 연동 프로필 그룹 조회 ts
     * @request GET:/v3/admin/kakaotemplate/kakaogroups
     * @secure
     * @response `200` `KakaoTemplateFindGroupHandlerData` success
     */
    kakaoTemplateFindGroupHandler: (params: RequestParams = {}) =>
      this.request<KakaoTemplateFindGroupHandlerData, any>({
        path: `/v3/admin/kakaotemplate/kakaogroups`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 발신프로필키를 그룹에 추가
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateAddProfileToGroupHandler
     * @summary 카카오 발신프로필키 그룹 추가 ts
     * @request POST:/v3/admin/kakaotemplate/kakaogroup/profile/add
     * @secure
     * @response `200` `KakaoTemplateAddProfileToGroupHandlerData` success
     */
    kakaoTemplateAddProfileToGroupHandler: (
      data: KakaoTemplateAddProfileToGroupHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateAddProfileToGroupHandlerData, any>({
        path: `/v3/admin/kakaotemplate/kakaogroup/profile/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 발신프로필키를 그룹에서 제거
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateRemoveProfileFromGroupHandler
     * @summary 카카오 발신프로필키 그룹 제거 ts
     * @request POST:/v3/admin/kakaotemplate/kakaogroup/profile/remove
     * @secure
     * @response `200` `KakaoTemplateRemoveProfileFromGroupHandlerData` success
     */
    kakaoTemplateRemoveProfileFromGroupHandler: (
      data: KakaoTemplateRemoveProfileFromGroupHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateRemoveProfileFromGroupHandlerData, any>({
        path: `/v3/admin/kakaotemplate/kakaogroup/profile/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 프로필 조회
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateFindAllProfileHandler
     * @summary 카카오 연동 프로필 조회 ts
     * @request GET:/v3/admin/kakaotemplate/kakaoprofiles/all
     * @secure
     * @response `200` `KakaoTemplateFindAllProfileHandlerData` success
     */
    kakaoTemplateFindAllProfileHandler: (params: RequestParams = {}) =>
      this.request<KakaoTemplateFindAllProfileHandlerData, any>({
        path: `/v3/admin/kakaotemplate/kakaoprofiles/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 프로필 조회
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateFindProfileHandler
     * @summary 카카오 연동 프로필 조회 ts
     * @request GET:/v3/admin/kakaotemplate/kakaoprofile
     * @secure
     * @response `200` `KakaoTemplateFindProfileHandlerData` success
     */
    kakaoTemplateFindProfileHandler: (query: KakaoTemplateFindProfileHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoTemplateFindProfileHandlerData, any>({
        path: `/v3/admin/kakaotemplate/kakaoprofile`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 비즈뿌리오 카테고리 조회
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateFindCategoryHandler
     * @summary 카카오 비즈뿌리오 카테고리 조회 ts
     * @request GET:/v3/admin/kakaotemplate/kakaocategory
     * @secure
     * @response `200` `KakaoTemplateFindCategoryHandlerData` success
     */
    kakaoTemplateFindCategoryHandler: (params: RequestParams = {}) =>
      this.request<KakaoTemplateFindCategoryHandlerData, any>({
        path: `/v3/admin/kakaotemplate/kakaocategory`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 조회
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateFindHandler
     * @summary 카카오 템플릿 조회 ts
     * @request GET:/v3/admin/kakaotemplate
     * @secure
     * @response `200` `KakaoTemplateFindHandlerData` success
     */
    kakaoTemplateFindHandler: (query: KakaoTemplateFindHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoTemplateFindHandlerData, any>({
        path: `/v3/admin/kakaotemplate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 생성
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateCreateHandler
     * @summary 카카오 템플릿 생성 ts
     * @request POST:/v3/admin/kakaotemplate
     * @secure
     * @response `200` `KakaoTemplateCreateHandlerData` success
     */
    kakaoTemplateCreateHandler: (data: KakaoTemplateCreateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<KakaoTemplateCreateHandlerData, any>({
        path: `/v3/admin/kakaotemplate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 수정
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateUpdateHandler
     * @summary 카카오 템플릿 수정 ts
     * @request PATCH:/v3/admin/kakaotemplate
     * @secure
     * @response `200` `KakaoTemplateUpdateHandlerData` success
     */
    kakaoTemplateUpdateHandler: (data: KakaoTemplateUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<KakaoTemplateUpdateHandlerData, any>({
        path: `/v3/admin/kakaotemplate`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 삭제
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateDeleteHandler
     * @summary 카카오 템플릿 삭제 ts
     * @request DELETE:/v3/admin/kakaotemplate
     * @secure
     * @response `200` `KakaoTemplateDeleteHandlerData` success
     */
    kakaoTemplateDeleteHandler: (query: KakaoTemplateDeleteHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoTemplateDeleteHandlerData, any>({
        path: `/v3/admin/kakaotemplate`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 상세 조회
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateDetailHandler
     * @summary 카카오 템플릿 상세 조회 ts
     * @request GET:/v3/admin/kakaotemplate/detail
     * @secure
     * @response `200` `KakaoTemplateDetailHandlerData` success
     */
    kakaoTemplateDetailHandler: (query: KakaoTemplateDetailHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoTemplateDetailHandlerData, any>({
        path: `/v3/admin/kakaotemplate/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 상세 조회 - 알림톡 저장을 위한 파싱된 템플릿 내용 반환
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateDetailParsedHandler
     * @summary 카카오 템플릿 상세 조회 - 알림톡 저장용 ts
     * @request GET:/v3/admin/kakaotemplate/detail/parsed
     * @secure
     * @response `200` `KakaoTemplateDetailParsedHandlerData` success
     */
    kakaoTemplateDetailParsedHandler: (query: KakaoTemplateDetailParsedHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoTemplateDetailParsedHandlerData, any>({
        path: `/v3/admin/kakaotemplate/detail/parsed`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 검수요청
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateRequestHandler
     * @summary 카카오 템플릿 검수요청 ts
     * @request PATCH:/v3/admin/kakaotemplate/request
     * @secure
     * @response `200` `KakaoTemplateRequestHandlerData` success
     */
    kakaoTemplateRequestHandler: (data: KakaoTemplateRequestHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<KakaoTemplateRequestHandlerData, any>({
        path: `/v3/admin/kakaotemplate/request`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 단일 템플릿 실제 상태 확인 후 REG면 검수요청 (일괄 검수용 단건)
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateInspectIfNeededHandler
     * @summary 카카오 단일 템플릿 상태확인 후 조건부 검수요청 ts
     * @request PATCH:/v3/admin/kakaotemplate/inspect-if-needed
     * @secure
     * @response `200` `KakaoTemplateInspectIfNeededHandlerData` success
     */
    kakaoTemplateInspectIfNeededHandler: (
      data: KakaoTemplateInspectIfNeededHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateInspectIfNeededHandlerData, any>({
        path: `/v3/admin/kakaotemplate/inspect-if-needed`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 미등록 상담자동화 메시지를 병원 단일 프로필 알림톡 템플릿으로 등록 후 검수요청 (일괄 검수용 단건)
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateRegisterAndInspectHandler
     * @summary 미등록 메시지 등록 + 검수요청
     * @request PATCH:/v3/admin/kakaotemplate/register-and-inspect
     * @secure
     * @response `200` `KakaoTemplateRegisterAndInspectHandlerData` success
     */
    kakaoTemplateRegisterAndInspectHandler: (
      data: KakaoTemplateRegisterAndInspectHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateRegisterAndInspectHandlerData, any>({
        path: `/v3/admin/kakaotemplate/register-and-inspect`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 검수요청 취소
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateRequestCancelHandler
     * @summary 카카오 템플릿 검수요청 취소 ts
     * @request PATCH:/v3/admin/kakaotemplate/request/cancel
     * @secure
     * @response `200` `KakaoTemplateRequestCancelHandlerData` success
     */
    kakaoTemplateRequestCancelHandler: (
      data: KakaoTemplateRequestCancelHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateRequestCancelHandlerData, any>({
        path: `/v3/admin/kakaotemplate/request/cancel`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 중지 요청
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateStopHandler
     * @summary 카카오 템플릿 중지 요청 ts
     * @request PATCH:/v3/admin/kakaotemplate/stop
     * @secure
     * @response `200` `KakaoTemplateStopHandlerData` success
     */
    kakaoTemplateStopHandler: (data: KakaoTemplateStopHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<KakaoTemplateStopHandlerData, any>({
        path: `/v3/admin/kakaotemplate/stop`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 중지 해제 요청
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateReuseHandler
     * @summary 카카오 템플릿 중지 해제 요청 ts
     * @request PATCH:/v3/admin/kakaotemplate/reuse
     * @secure
     * @response `200` `KakaoTemplateReuseHandlerData` success
     */
    kakaoTemplateReuseHandler: (data: KakaoTemplateReuseHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<KakaoTemplateReuseHandlerData, any>({
        path: `/v3/admin/kakaotemplate/reuse`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 승인 취소
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateCancelApprovalHandler
     * @summary 카카오 템플릿 승인 취소 ts
     * @request PATCH:/v3/admin/kakaotemplate/cancelapproval
     * @secure
     * @response `200` `KakaoTemplateCancelApprovalHandlerData` success
     */
    kakaoTemplateCancelApprovalHandler: (
      data: KakaoTemplateCancelApprovalHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateCancelApprovalHandlerData, any>({
        path: `/v3/admin/kakaotemplate/cancelapproval`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 템플릿 휴면 해제
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateReleaseHandler
     * @summary 카카오 템플릿 휴면 해제 ts
     * @request PATCH:/v3/admin/kakaotemplate/release
     * @secure
     * @response `200` `KakaoTemplateReleaseHandlerData` success
     */
    kakaoTemplateReleaseHandler: (data: KakaoTemplateReleaseHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<KakaoTemplateReleaseHandlerData, any>({
        path: `/v3/admin/kakaotemplate/release`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description AfterDoc DB 내 카카오 템플릿 조회
     *
     * @tags V3-Admin-KakaoTemplate
     * @name KakaoTemplateHistoryFindHandler
     * @summary AfterDoc DB 내 카카오 템플릿 조회 ts
     * @request GET:/v3/admin/kakaotemplate/history
     * @secure
     * @response `200` `KakaoTemplateHistoryFindHandlerData` success
     */
    kakaoTemplateHistoryFindHandler: (query: KakaoTemplateHistoryFindHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoTemplateHistoryFindHandlerData, any>({
        path: `/v3/admin/kakaotemplate/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 기본 상담자동화 템플릿 수 조회
     *
     * @tags V3-Admin-Automation
     * @name AdminAutomationCountHandler
     * @summary 기본 상담자동화 템플릿 수 조회 ts
     * @request GET:/v3/admin/automation/count
     * @secure
     * @response `200` `AdminAutomationCountHandlerData` success
     */
    adminAutomationCountHandler: (query: AdminAutomationCountHandlerParams, params: RequestParams = {}) =>
      this.request<AdminAutomationCountHandlerData, any>({
        path: `/v3/admin/automation/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 기본 상담자동화 템플릿 조회
     *
     * @tags V3-Admin-Automation
     * @name AdminAutomationFindHandler
     * @summary 기본 상담자동화 템플릿 조회 ts
     * @request GET:/v3/admin/automation
     * @secure
     * @response `200` `AdminAutomationFindHandlerData` success
     */
    adminAutomationFindHandler: (query: AdminAutomationFindHandlerParams, params: RequestParams = {}) =>
      this.request<AdminAutomationFindHandlerData, any>({
        path: `/v3/admin/automation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 기본 상담자동화 템플릿 생성
     *
     * @tags V3-Admin-Automation
     * @name AdminAutomationCreateHandler
     * @summary 기본 상담자동화 템플릿 생성 ts
     * @request POST:/v3/admin/automation
     * @secure
     * @response `200` `AdminAutomationCreateHandlerData` success
     */
    adminAutomationCreateHandler: (data: AdminAutomationCreateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminAutomationCreateHandlerData, any>({
        path: `/v3/admin/automation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 기본 상담자동화 템플릿 수정
     *
     * @tags V3-Admin-Automation
     * @name AdminAutomationUpdateHandler
     * @summary 기본 상담자동화 템플릿 수정 ts
     * @request PATCH:/v3/admin/automation
     * @secure
     * @response `200` `AdminAutomationUpdateHandlerData` success
     */
    adminAutomationUpdateHandler: (data: AdminAutomationUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminAutomationUpdateHandlerData, any>({
        path: `/v3/admin/automation`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 기본 상담자동화 템플릿 삭제
     *
     * @tags V3-Admin-Automation
     * @name AdminAutomationDeleteHandler
     * @summary 기본 상담자동화 템플릿 삭제 ts
     * @request DELETE:/v3/admin/automation
     * @secure
     * @response `200` `AdminAutomationDeleteHandlerData` success
     */
    adminAutomationDeleteHandler: (query: AdminAutomationDeleteHandlerParams, params: RequestParams = {}) =>
      this.request<AdminAutomationDeleteHandlerData, any>({
        path: `/v3/admin/automation`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 기본 상담자동화 템플릿 조회
     *
     * @tags V3-Admin-Automation-Hospital
     * @name AdminAuomtaionHospitalFindHandler
     * @summary 병원별 기본 상담자동화 템플릿 조회 ts
     * @request GET:/v3/admin/automation/hospital
     * @secure
     * @response `200` `AdminAuomtaionHospitalFindHandlerData` success
     */
    adminAuomtaionHospitalFindHandler: (query: AdminAuomtaionHospitalFindHandlerParams, params: RequestParams = {}) =>
      this.request<AdminAuomtaionHospitalFindHandlerData, any>({
        path: `/v3/admin/automation/hospital`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 기본 상담자동화 템플릿 생성
     *
     * @tags V3-Admin-Automation-Hospital
     * @name AdminAutomationHospitalCreateHandler
     * @summary 병원별 기본 상담자동화 템플릿 생성 ts
     * @request POST:/v3/admin/automation/hospital
     * @secure
     * @response `200` `AdminAutomationHospitalCreateHandlerData` success
     */
    adminAutomationHospitalCreateHandler: (
      data: AdminAutomationHospitalCreateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminAutomationHospitalCreateHandlerData, any>({
        path: `/v3/admin/automation/hospital`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 기본 상담자동화 템플릿 수정
     *
     * @tags V3-Admin-Automation-Hospital
     * @name AdminAutomationHospitalUpdateHandler
     * @summary 병원별 기본 상담자동화 템플릿 수정 ts
     * @request PATCH:/v3/admin/automation/hospital
     * @secure
     * @response `200` `AdminAutomationHospitalUpdateHandlerData` success
     */
    adminAutomationHospitalUpdateHandler: (
      data: AdminAutomationHospitalUpdateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminAutomationHospitalUpdateHandlerData, any>({
        path: `/v3/admin/automation/hospital`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 기본 상담자동화 템플릿 삭제
     *
     * @tags V3-Admin-Automation-Hospital
     * @name AdminAutomationHospitalDeleteHandler
     * @summary 병원별 기본 상담자동화 템플릿 삭제 ts
     * @request DELETE:/v3/admin/automation/hospital
     * @secure
     * @response `200` `AdminAutomationHospitalDeleteHandlerData` success
     */
    adminAutomationHospitalDeleteHandler: (
      query: AdminAutomationHospitalDeleteHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminAutomationHospitalDeleteHandlerData, any>({
        path: `/v3/admin/automation/hospital`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 상담자동화 메시지 단건 수정 (로컬 전용 — 카카오 템플릿 미변경)
     *
     * @tags V3-Admin-Automation-Hospital
     * @name AdminAutomationHospitalUpdateMessageHandler
     * @summary 병원별 상담자동화 메시지 수정
     * @request PATCH:/v3/admin/automation/hospital/message
     * @secure
     * @response `200` `AdminAutomationHospitalUpdateMessageHandlerData` success
     */
    adminAutomationHospitalUpdateMessageHandler: (
      data: AdminAutomationHospitalUpdateMessageHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminAutomationHospitalUpdateMessageHandlerData, any>({
        path: `/v3/admin/automation/hospital/message`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 기본 상담자동화 템플릿 내 비디오 콘텐츠 조회
     *
     * @tags V3-Admin-Automation-Hospital
     * @name AdminAuomtaionHospitalFindVideoContentHandler
     * @summary 병원별 기본 상담자동화 템플릿 내 비디오 콘텐츠 조회 ts
     * @request GET:/v3/admin/automation/hospital/videocontent
     * @secure
     * @response `200` `AdminAuomtaionHospitalFindVideoContentHandlerData` success
     */
    adminAuomtaionHospitalFindVideoContentHandler: (
      query: AdminAuomtaionHospitalFindVideoContentHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminAuomtaionHospitalFindVideoContentHandlerData, any>({
        path: `/v3/admin/automation/hospital/videocontent`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 기본 상담자동화 템플릿 내 홈케어 콘텐츠 조회
     *
     * @tags V3-Admin-Automation-Hospital
     * @name AdminAuomtaionHospitalFindHomecareHandler
     * @summary 병원별 기본 상담자동화 템플릿 내 홈케어 콘텐츠 조회 ts
     * @request GET:/v3/admin/automation/hospital/homecare
     * @secure
     * @response `200` `AdminAuomtaionHospitalFindHomecareHandlerData` success
     */
    adminAuomtaionHospitalFindHomecareHandler: (
      query: AdminAuomtaionHospitalFindHomecareHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminAuomtaionHospitalFindHomecareHandlerData, any>({
        path: `/v3/admin/automation/hospital/homecare`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원별 기본 상담자동화 템플릿 내 이벤트 조회
     *
     * @tags V3-Admin-Automation-Hospital
     * @name AdminAuomtaionHospitalFindEventHandler
     * @summary 병원별 기본 상담자동화 템플릿 내 이벤트 조회 ts
     * @request GET:/v3/admin/automation/hospital/event
     * @secure
     * @response `200` `AdminAuomtaionHospitalFindEventHandlerData` success
     */
    adminAuomtaionHospitalFindEventHandler: (
      query: AdminAuomtaionHospitalFindEventHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminAuomtaionHospitalFindEventHandlerData, any>({
        path: `/v3/admin/automation/hospital/event`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 서비스 알림톡 조회
     *
     * @tags V3-Admin-KakaoServiceNotificationMessage
     * @name KakaoServiceNotificationMessageFindOneHandler
     * @summary 서비스 알림톡 조회 ts
     * @request GET:/v3/admin/kakaoservicenotificationmessage/find/one
     * @secure
     * @response `200` `KakaoServiceNotificationMessageFindOneHandlerData` success
     */
    kakaoServiceNotificationMessageFindOneHandler: (
      query: KakaoServiceNotificationMessageFindOneHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<KakaoServiceNotificationMessageFindOneHandlerData, any>({
        path: `/v3/admin/kakaoservicenotificationmessage/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 서비스 알림톡 수정
     *
     * @tags V3-Admin-KakaoServiceNotificationMessage
     * @name KakaoServiceNotificationMessageUpdateHandler
     * @summary 서비스 알림톡 수정 ts
     * @request PATCH:/v3/admin/kakaoservicenotificationmessage/update
     * @secure
     * @response `200` `KakaoServiceNotificationMessageUpdateHandlerData` success
     */
    kakaoServiceNotificationMessageUpdateHandler: (
      data: KakaoServiceNotificationMessageUpdateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoServiceNotificationMessageUpdateHandlerData, any>({
        path: `/v3/admin/kakaoservicenotificationmessage/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별 톡톡 연동 현황
     *
     * @tags V3-Admin-TalkTalkLinkage
     * @name TalkTalkLinkageAccountsStatesHandler
     * @summary 병원 별 톡톡 연동 현황
     * @request GET:/v3/admin/current-linkage-states/talktalk
     * @secure
     * @response `200` `TalkTalkLinkageAccountsStatesHandlerData` success
     */
    talkTalkLinkageAccountsStatesHandler: (
      query: TalkTalkLinkageAccountsStatesHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<TalkTalkLinkageAccountsStatesHandlerData, any>({
        path: `/v3/admin/current-linkage-states/talktalk`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별 톡톡 연동 승인/해제 관리
     *
     * @tags V3-Admin-TalkTalkLinkage
     * @name TalkTalkLinkagePatchAccountsStatesHandler
     * @summary 병원 별 톡톡 연동 승인/해제 관리
     * @request PATCH:/v3/admin/current-linkage-states/talktalk
     * @secure
     * @response `200` `TalkTalkLinkagePatchAccountsStatesHandlerData` success
     */
    talkTalkLinkagePatchAccountsStatesHandler: (
      data: TalkTalkLinkagePatchAccountsStatesHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<TalkTalkLinkagePatchAccountsStatesHandlerData, any>({
        path: `/v3/admin/current-linkage-states/talktalk`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description AdminAuthorizationType 모델 생성
     *
     * @tags V3-Admin-AdminAuthorizationType
     * @name AdminAuthorizationTypeCreateHandler
     * @summary AdminAuthorizationType 모델 생성 ts
     * @request POST:/v3/admin/adminauthorizationtype
     * @secure
     * @response `200` `AdminAuthorizationTypeCreateHandlerData` success
     */
    adminAuthorizationTypeCreateHandler: (
      data: AdminAuthorizationTypeCreateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminAuthorizationTypeCreateHandlerData, any>({
        path: `/v3/admin/adminauthorizationtype`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description AdminAuthorizationType 모델 수정
     *
     * @tags V3-Admin-AdminAuthorizationType
     * @name AdminAuthorizationTypeUpdateHandler
     * @summary AdminAuthorizationType 모델 수정 ts
     * @request PATCH:/v3/admin/adminauthorizationtype
     * @secure
     * @response `200` `AdminAuthorizationTypeUpdateHandlerData` success
     */
    adminAuthorizationTypeUpdateHandler: (
      data: AdminAuthorizationTypeUpdateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminAuthorizationTypeUpdateHandlerData, any>({
        path: `/v3/admin/adminauthorizationtype`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description AdminAuthorizationType 모델 조회
     *
     * @tags V3-Admin-AdminAuthorizationType
     * @name AdminAuthorizationTypeFindOneHandler
     * @summary AdminAuthorizationType 모델 조회 ts
     * @request GET:/v3/admin/adminauthorizationtype/one
     * @secure
     * @response `200` `AdminAuthorizationTypeFindOneHandlerData` success
     */
    adminAuthorizationTypeFindOneHandler: (
      query: AdminAuthorizationTypeFindOneHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminAuthorizationTypeFindOneHandlerData, any>({
        path: `/v3/admin/adminauthorizationtype/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별 인스타그램 연동 현황을 조회합니다.
     *
     * @tags V3-Admin-InstagramLinkage
     * @name CurrentInstagramAccountsStatesHandler
     * @summary 병원 별 인스타그램 연동 현황 조회
     * @request GET:/v3/admin/instagramlinkage
     * @secure
     * @response `200` `CurrentInstagramAccountsStatesHandlerData` success
     */
    currentInstagramAccountsStatesHandler: (
      query: CurrentInstagramAccountsStatesHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<CurrentInstagramAccountsStatesHandlerData, any>({
        path: `/v3/admin/instagramlinkage`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별 인스타그램 연동 승인 이력들을 조회합니다.
     *
     * @tags V3-Admin-InstagramLinkage
     * @name ApprovedInstagramAccountsHandler
     * @summary 병원 별 인스타그램 연동 승인 이력 조회
     * @request GET:/v3/admin/instagramlinkage/approved-by-employee
     * @secure
     * @response `200` `ApprovedInstagramAccountsHandlerData` success
     */
    approvedInstagramAccountsHandler: (query: ApprovedInstagramAccountsHandlerParams, params: RequestParams = {}) =>
      this.request<ApprovedInstagramAccountsHandlerData, any>({
        path: `/v3/admin/instagramlinkage/approved-by-employee`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 인스타그램 최대 연동 계정 수를 변경합니다.
     *
     * @tags V3-Admin-InstagramLinkage
     * @name ApprovingInstagramLinkageHandler
     * @summary 인스타그램 최대 연동 계정 수 변경
     * @request PATCH:/v3/admin/instagramlinkage/approved-by-employee
     * @secure
     * @response `200` `ApprovingInstagramLinkageHandlerData` success
     */
    approvingInstagramLinkageHandler: (data: ApprovingInstagramLinkageHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ApprovingInstagramLinkageHandlerData, any>({
        path: `/v3/admin/instagramlinkage/approved-by-employee`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 인스타그램 연동 상태를 갱신합니다.
     *
     * @tags V3-Admin-InstagramLinkage
     * @name RenewingInstagramLinkageStatusHandler
     * @summary 인스타그램 연동 상태 갱신
     * @request PATCH:/v3/admin/instagramlinkage/linkage-status
     * @secure
     * @response `200` `RenewingInstagramLinkageStatusHandlerData` success
     */
    renewingInstagramLinkageStatusHandler: (
      data: RenewingInstagramLinkageStatusHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<RenewingInstagramLinkageStatusHandlerData, any>({
        path: `/v3/admin/instagramlinkage/linkage-status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별 라인 연동 승인/해제 관리
     *
     * @tags V3-Admin-LineLinkage
     * @name LineLinkagePatchAccountsStatesHandler
     * @summary 이 API는 더 이상 사용되지 않습니다. 대신 /v3/admin/linelinkage를 사용하세요.
     * @request PATCH:/v3/admin/linelinkage/linkage-status
     * @deprecated
     * @secure
     * @response `200` `LineLinkagePatchAccountsStatesHandlerData` success
     */
    lineLinkagePatchAccountsStatesHandler: (
      data: LineLinkagePatchAccountsStatesHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<LineLinkagePatchAccountsStatesHandlerData, any>({
        path: `/v3/admin/linelinkage/linkage-status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별 라인 연동 승인 이력들을 조회합니다.
     *
     * @tags V3-Admin-LineLinkage
     * @name ApprovedLineLinkageHandler
     * @summary 병원 별 라인 연동 승인 이력 조회
     * @request GET:/v3/admin/linelinkage/approved-by-employee
     * @secure
     * @response `200` `ApprovedLineLinkageHandlerData` success
     */
    approvedLineLinkageHandler: (query: ApprovedLineLinkageHandlerParams, params: RequestParams = {}) =>
      this.request<ApprovedLineLinkageHandlerData, any>({
        path: `/v3/admin/linelinkage/approved-by-employee`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 서비스 종료 채팅 메시지 발송
     *
     * @tags V3-Admin-EndOfServiceChat
     * @name AdminEndOfServiceChatSendHandler
     * @summary 서비스 종료 전 가입한 환자들에게 채팅 메시지 발송
     * @request POST:/v3/admin/end-of-service-chat/send
     * @secure
     * @response `200` `AdminEndOfServiceChatSendHandlerData` success
     */
    adminEndOfServiceChatSendHandler: (data: AdminEndOfServiceChatSendHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<AdminEndOfServiceChatSendHandlerData, any>({
        path: `/v3/admin/end-of-service-chat/send`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 기본 템플릿 조회
     *
     * @tags V3-Admin-KakaoDefaultTemplate
     * @name KakaoDefaultTemplateFindHandler
     * @summary 카카오 기본 템플릿 조회 ts
     * @request GET:/v3/admin/kakaodefaulttemplate
     * @secure
     * @response `200` `KakaoDefaultTemplateFindHandlerData` success
     */
    kakaoDefaultTemplateFindHandler: (query: KakaoDefaultTemplateFindHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoDefaultTemplateFindHandlerData, any>({
        path: `/v3/admin/kakaodefaulttemplate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 기본 템플릿 생성
     *
     * @tags V3-Admin-KakaoDefaultTemplate
     * @name KakaoDefaultTemplateCreateHandler
     * @summary 카카오 기본 템플릿 생성 ts
     * @request POST:/v3/admin/kakaodefaulttemplate
     * @secure
     * @response `200` `KakaoDefaultTemplateCreateHandlerData` success
     */
    kakaoDefaultTemplateCreateHandler: (
      data: KakaoDefaultTemplateCreateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoDefaultTemplateCreateHandlerData, any>({
        path: `/v3/admin/kakaodefaulttemplate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 기본 템플릿 수정
     *
     * @tags V3-Admin-KakaoDefaultTemplate
     * @name KakaoDefaultTemplateUpdateHandler
     * @summary 카카오 기본 템플릿 수정 ts
     * @request PUT:/v3/admin/kakaodefaulttemplate
     * @secure
     * @response `200` `KakaoDefaultTemplateUpdateHandlerData` success
     */
    kakaoDefaultTemplateUpdateHandler: (
      data: KakaoDefaultTemplateUpdateHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoDefaultTemplateUpdateHandlerData, any>({
        path: `/v3/admin/kakaodefaulttemplate`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별 세종병원 연동 현황을 조회합니다.
     *
     * @tags V3-Admin-SejongHospitalLinkage
     * @name CurrentSejongHospitalLinkageStatesHandler
     * @summary 병원 별 세종병원 연동 현황 조회
     * @request GET:/v3/admin/sejonghospitallinkage
     * @secure
     * @response `200` `CurrentSejongHospitalLinkageStatesHandlerData` success
     */
    currentSejongHospitalLinkageStatesHandler: (
      query: CurrentSejongHospitalLinkageStatesHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<CurrentSejongHospitalLinkageStatesHandlerData, any>({
        path: `/v3/admin/sejonghospitallinkage`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 세종병원에서 삭제하지 못하는 연동 전용 치료태그를 진단 코드와 매핑합니다.
     *
     * @tags V3-Admin-SejongHospitalLinkage
     * @name MappingSejongHospitalDiagnosisCodeWithTreatmentTagHandler
     * @summary 세종병원 진단 코드와 연동 전용 치료태그 매핑
     * @request PATCH:/v3/admin/sejonghospitallinkage/hospital-diagnosis-code/treatment-tag-mapping
     * @secure
     * @response `200` `MappingSejongHospitalDiagnosisCodeWithTreatmentTagHandlerData` success
     */
    mappingSejongHospitalDiagnosisCodeWithTreatmentTagHandler: (
      data: MappingSejongHospitalDiagnosisCodeWithTreatmentTagHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<MappingSejongHospitalDiagnosisCodeWithTreatmentTagHandlerData, any>({
        path: `/v3/admin/sejonghospitallinkage/hospital-diagnosis-code/treatment-tag-mapping`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 세종병원 연동 상태를 갱신합니다.
     *
     * @tags V3-Admin-SejongHospitalLinkage
     * @name RenewingSejongHospitalLinkageStatusHandler
     * @summary 세종병원 연동 상태 갱신
     * @request PATCH:/v3/admin/sejonghospitallinkage/linkage-status
     * @secure
     * @response `200` `RenewingSejongHospitalLinkageStatusHandlerData` success
     */
    renewingSejongHospitalLinkageStatusHandler: (
      data: RenewingSejongHospitalLinkageStatusHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<RenewingSejongHospitalLinkageStatusHandlerData, any>({
        path: `/v3/admin/sejonghospitallinkage/linkage-status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Admin-AfterDocNotice
     * @name AdminAfterDocNoticeControllerFindAfterDocNotice
     * @summary AfterDocNotice 조회
     * @request GET:/v3/admin/afterdoc-notice/el
     * @secure
     * @response `200` `AdminAfterDocNoticeControllerFindAfterDocNoticeData` success
     */
    adminAfterDocNoticeControllerFindAfterDocNotice: (
      query: AdminAfterDocNoticeControllerFindAfterDocNoticeParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminAfterDocNoticeControllerFindAfterDocNoticeData, any>({
        path: `/v3/admin/afterdoc-notice/el`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Admin-AfterDocNotice
     * @name AdminAfterDocNoticeControllerCreateAfterDocNotice
     * @summary AfterDocNotice 생성
     * @request POST:/v3/admin/afterdoc-notice/el
     * @secure
     * @response `200` `AdminAfterDocNoticeControllerCreateAfterDocNoticeData` success
     */
    adminAfterDocNoticeControllerCreateAfterDocNotice: (
      data: AdminAfterDocNoticeControllerCreateAfterDocNoticeBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminAfterDocNoticeControllerCreateAfterDocNoticeData, any>({
        path: `/v3/admin/afterdoc-notice/el`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Admin-AfterDocNoticeDetail
     * @name AdminAfterDocNoticeControllerFindAfterDocNoticeDetail
     * @summary AfterDocNotice 상세데이터 조회
     * @request GET:/v3/admin/afterdoc-notice/el/:id
     * @secure
     * @response `200` `AdminAfterDocNoticeControllerFindAfterDocNoticeDetailData` success
     */
    adminAfterDocNoticeControllerFindAfterDocNoticeDetail: (id: any, params: RequestParams = {}) =>
      this.request<AdminAfterDocNoticeControllerFindAfterDocNoticeDetailData, any>({
        path: `/v3/admin/afterdoc-notice/el/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Admin-AfterDocNotice
     * @name AdminAfterDocNoticeControllerUpdateAfterDocNotice
     * @summary AfterDocNotice 수정
     * @request PUT:/v3/admin/afterdoc-notice/el/:id
     * @secure
     * @response `200` `AdminAfterDocNoticeControllerUpdateAfterDocNoticeData` success
     */
    adminAfterDocNoticeControllerUpdateAfterDocNotice: (
      id: any,
      data: AdminAfterDocNoticeControllerUpdateAfterDocNoticeBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdminAfterDocNoticeControllerUpdateAfterDocNoticeData, any>({
        path: `/v3/admin/afterdoc-notice/el/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Admin-AfterDocNotice
     * @name AdminAfterDocNoticeControllerDeleteAfterDocNotice
     * @summary AfterDocNotice 삭제
     * @request DELETE:/v3/admin/afterdoc-notice/el/:id
     * @secure
     * @response `200` `AdminAfterDocNoticeControllerDeleteAfterDocNoticeData` success
     */
    adminAfterDocNoticeControllerDeleteAfterDocNotice: (id: any, params: RequestParams = {}) =>
      this.request<AdminAfterDocNoticeControllerDeleteAfterDocNoticeData, any>({
        path: `/v3/admin/afterdoc-notice/el/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
